import type { AppTranslations } from './types'

export const de = {
  amenities: {
    categories: {
      culture: 'Kultur und Unterhaltung',
      dining: 'Essen und Trinken',
      education: 'Bildung',
      grocery: 'Lebensmittel',
      healthcare: 'Gesundheit',
      services: 'Grundversorgung',
      shopping: 'Einkaufen',
      transport: 'Verkehr',
      wellness: 'Wellness',
    },
    categoryCard: {
      clearFilters: 'Filter löschen',
      moreSubcategories: '+{{count}} weitere',
      noAmenities: 'Keine Annehmlichkeiten in dieser Kategorie gefunden',
      noMatchingFilters: 'Keine Annehmlichkeiten entsprechen den aktuellen Filtern',
      showAll: 'Alle {{count}} weiteren anzeigen',
      showingItems: '{{count}} von {{total}} Elementen anzeigen',
      showMore: '10 weitere anzeigen ({{count}} verbleibend)',
    },
    error: {
      retry: 'Wiederholen',
      title: 'Annehmlichkeitsdaten können nicht geladen werden',
    },
    livabilityScore: 'Lebensqualitäts-Score',
    loading: {
      description: 'Analyse nahegelegener Sehenswürdigkeiten und Berechnung des Lebensqualitäts-Scores',
      title: 'Annehmlichkeitsdaten werden geladen...',
    },
    noData: 'Keine Annehmlichkeitsdaten verfügbar',
    pointsOfInterest: 'Sehenswürdigkeiten',
    poiTypes: {
      adult_gaming_centre: 'Spielhalle für Erwachsene',
      alcohol: 'Spirituosengeschäft',
      amusement_arcade: 'Spielhalle',
      anime: 'Anime-Laden',
      antiques: 'Antiquitäten',
      appliance: 'Haushaltsgeräte',
      aquarium: 'Aquarium',
      art: 'Kunstgeschäft',
      art_culture: 'Kunst und Kultur',
      art_music_hobbies: 'Kunst, Musik und Hobbys',
      arts_centre: 'Kulturzentrum',
      atm: 'Geldautomat',
      atv: 'Quad-Geschäft',
      baby_goods: 'Babyartikel',
      bag: 'Taschengeschäft',
      bakery: 'Bäckerei',
      bandstand: 'Musikpavillon',
      bank: 'Bank',
      bar: 'Bar',
      bathroom_furnishing: 'Badausstattung',
      beauty: 'Schönheitssalon',
      bed: 'Bettengeschäft',
      beverages: 'Getränke',
      bicycle: 'Fahrradgeschäft',
      biergarten: 'Biergarten',
      boat: 'Bootsgeschäft',
      boat_stop: 'Schiffsanlegestelle',
      bookmaker: 'Wettbüro',
      books: 'Buchhandlung',
      books_gifts: 'Bücher und Geschenke',
      boutique: 'Boutique',
      bowling_alley: 'Bowlingbahn',
      brewing_supplies: 'Braubedarf',
      bus_stop: 'Bushaltestelle',
      butcher: 'Metzgerei',
      cable_car_stop: 'Seilbahnstation',
      cafe: 'Café',
      camera: 'Fotogeschäft',
      candles: 'Kerzengeschäft',
      cannabis: 'Cannabis-Geschäft',
      car: 'Autohändler',
      car_parts: 'Autoteile',
      car_repair: 'Autowerkstatt',
      carpet: 'Teppichgeschäft',
      casino: 'Casino',
      cheese: 'Käseladen',
      chemist: 'Drogerie',
      chocolate: 'Schokoladengeschäft',
      cinema: 'Kino',
      climbing: 'Klettern',
      clinic: 'Klinik',
      clothes: 'Bekleidungsgeschäft',
      clothing: 'Bekleidung',
      coffee: 'Kaffeegeschäft',
      collector: 'Sammlergeschäft',
      college: 'Hochschule',
      community_centre: 'Gemeindezentrum',
      computer: 'Computergeschäft',
      confectionery: 'Süsswarengeschäft',
      convenience: 'Nahversorger',
      copyshop: 'Copyshop',
      cosmetics: 'Kosmetik',
      craft: 'Bastelgeschäft',
      curtain: 'Gardinengeschäft',
      dairy: 'Molkerei',
      dance: 'Tanz',
      deli: 'Feinkost',
      dentist: 'Zahnarzt',
      department_store: 'Kaufhaus',
      doctor: 'Arzt',
      doityourself: 'Baumarkt',
      doors: 'Türengeschäft',
      dry_cleaning: 'Reinigung',
      'e-cigarette': 'E-Zigaretten-Laden',
      electrical: 'Elektrogeschäft',
      electronics: 'Elektronik',
      energy: 'Energiegeschäft',
      escape_game: 'Escape Room',
      fabric: 'Stoffgeschäft',
      farm: 'Hofladen',
      fashion: 'Mode',
      fast_food: 'Schnellimbiss',
      financial: 'Finanzdienstleistungen',
      fireplace: 'Kamingeschäft',
      fishing: 'Angelgeschäft',
      fitness_centre: 'Fitnesscenter',
      flooring: 'Bodenbeläge',
      florist: 'Blumenladen',
      food_court: 'Food Court',
      frame: 'Rahmengeschäft',
      free_flying: 'Freifliegen',
      frozen_food: 'Tiefkühlkost',
      fuel: 'Tankstelle',
      fuel_station: 'Tankstelle',
      funeral_directors: 'Bestattungsunternehmen',
      furniture: 'Möbelgeschäft',
      gallery: 'Galerie',
      games: 'Spielegeschäft',
      garden_centre: 'Gartencenter',
      garden_furniture: 'Gartenmöbel',
      general: 'Gemischtwarenladen',
      gift: 'Geschenkeladen',
      golf_course: 'Golfplatz',
      greengrocer: 'Gemüseladen',
      hairdresser: 'Friseur',
      hairdresser_supply: 'Friseurbedarf',
      hardware: 'Eisenwarenhandlung',
      health_beauty_store: 'Gesundheits- und Schönheitsgeschäft',
      health_food: 'Bioladen',
      hearing_aids: 'Hörgeräte',
      herbalist: 'Kräuterladen',
      hifi: 'HiFi-Geschäft',
      horse_riding: 'Reiten',
      hospital: 'Krankenhaus',
      hospital_clinic: 'Spital und Klinik',
      houseware: 'Haushaltswaren',
      hunting: 'Jagdgeschäft',
      ice_cream: 'Eisdiele',
      ice_rink: 'Eisbahn',
      interior_decoration: 'Inneneinrichtung',
      jetski: 'Jetski-Geschäft',
      jewelry: 'Juwelier',
      kindergarten: 'Kindergarten',
      kiosk: 'Kiosk',
      kitchen: 'Küchenstudio',
      lamps: 'Lampengeschäft',
      laundry: 'Wäscherei',
      leather: 'Lederwarengeschäft',
      leisure_tourism: 'Freizeit und Tourismus',
      library: 'Bibliothek',
      locksmith: 'Schlüsseldienst',
      lottery: 'Lotterie',
      mall: 'Einkaufszentrum',
      massage: 'Massage',
      medical_supply: 'Medizinbedarf',
      metro_station: 'Metrostation',
      miniature_golf: 'Minigolf',
      mobile_phone: 'Handygeschäft',
      model: 'Modellbaugeschäft',
      money_lender: 'Geldverleiher',
      motorcycle: 'Motorradgeschäft',
      museum: 'Museum',
      music: 'Musikgeschäft',
      music_school: 'Musikschule',
      musical_instrument: 'Musikinstrumente',
      newsagent: 'Zeitungsladen',
      nightclub: 'Nachtclub',
      nutrition_supplements: 'Nahrungsergänzung',
      optician: 'Optiker',
      organic: 'Bioladen',
      other_sport: 'Weitere Sportart',
      outdoor: 'Outdoor-Geschäft',
      outdoors_sport_vehicles: 'Outdoor, Sport und Fahrzeuge',
      paint: 'Farbengeschäft',
      park: 'Park',
      park_forest: 'Park und Wald',
      party: 'Partyartikel',
      pasta: 'Nudelgeschäft',
      pastry: 'Konditorei',
      perfumery: 'Parfümerie',
      pet: 'Tierhandlung',
      pharmacy: 'Apotheke',
      photo: 'Fotogeschäft',
      picnic_site: 'Picknickplatz',
      pitch: 'Sportplatz',
      planetarium: 'Planetarium',
      plant_flower: 'Pflanzen und Blumen',
      playground: 'Spielplatz',
      post_box: 'Briefkasten',
      post_office: 'Postamt',
      pub: 'Pub',
      pyrotechnics: 'Pyrotechnik',
      radiotechnics: 'Funktechnik',
      recycling: 'Recyclingstation',
      religion: 'Religiöse Artikel',
      restaurant: 'Restaurant',
      robot: 'Robotergeschäft',
      running: 'Laufbahn',
      sailing: 'Segeln',
      school: 'Schule',
      scuba_diving: 'Tauchen',
      seafood: 'Fischgeschäft',
      second_hand: 'Second Hand',
      security: 'Sicherheitstechnik',
      sewing: 'Nähgeschäft',
      shoes: 'Schuhgeschäft',
      shooting: 'Schiessstand',
      shopping_others: 'Weitere Geschäfte',
      skateboard: 'Skateboard',
      ski: 'Skigeschäft',
      snowmobile: 'Schneemobil',
      social_centre: 'Sozialzentrum',
      specialty_food: 'Spezialitätengeschäft',
      spices: 'Gewürzladen',
      sport_centre: 'Sportzentrum',
      sports: 'Sportgeschäft',
      sports_centre: 'Sportzentrum',
      stadium: 'Stadion',
      station: 'Bahnhof',
      stationery: 'Schreibwaren',
      subway_entrance: 'U-Bahn-Eingang',
      supermarket: 'Supermarkt',
      swimming: 'Schwimmen',
      swimming_area: 'Badebereich',
      swimming_pool: 'Swimming Pool',
      tailor: 'Schneider',
      tattoo: 'Tattoo-Studio',
      tea: 'Teegeschäft',
      theatre: 'Theater',
      theme_park: 'Freizeitpark',
      ticket: 'Ticketverkauf',
      tobacco: 'Tabakgeschäft',
      toys: 'Spielzeuggeschäft',
      trade: 'Fachhandel',
      train_station: 'Bahnhof',
      tram_stop: 'Tramhaltestelle',
      travel_agency: 'Reisebüro',
      trophy: 'Pokalgeschäft',
      tyres: 'Reifenhandel',
      university: 'Universität',
      vacant: 'Leerstand',
      vacuum_cleaner: 'Staubsaugergeschäft',
      variety_store: 'Gemischtwarenladen',
      video: 'Videothek',
      video_games: 'Videospiele',
      watches: 'Uhrengeschäft',
      water: 'Wassergeschäft',
      weapons: 'Waffengeschäft',
      wholesale: 'Grosshandel',
      wine: 'Weinhandlung',
      wood: 'Holzhandel',
      zoo: 'Zoo',
    },
    radius: 'Radius',
    sources: {
      googlePlaces: 'Google Places',
      label: 'Quellen:',
      openStreetMap: 'OpenStreetMap',
      swissFederalStatisticalOffice: 'Bundesamt für Statistik',
    },
    subcategories: {
      'Art & Culture': 'Kunst und Kultur',
      'Art, music, hobbies': 'Kunst, Musik, Hobbys',
      Bar: 'Bar',
      'Bus & Subway': 'Bus und U-Bahn',
      Cafe: 'Café',
      'Clothing, shoes, accessories': 'Kleidung, Schuhe, Accessoires',
      Convenience: 'Nahversorger',
      Dentist: 'Zahnarzt',
      Doctor: 'Arzt',
      Electronics: 'Elektronik',
      Financial: 'Finanzdienstleistungen',
      'Fuel Station': 'Tankstelle',
      'Furniture and interior': 'Möbel und Einrichtung',
      'Health and beauty': 'Gesundheit und Schönheit',
      'Hospital & Clinic': 'Krankenhaus und Klinik',
      Kindergarten: 'Kindergarten',
      'Leisure & Tourism': 'Freizeit und Tourismus',
      Mall: 'Einkaufszentrum',
      'Other Sport': 'Andere Sportarten',
      Others: 'Sonstige',
      'Outdoor activity': 'Outdoor-Aktivitäten',
      'Outdoors and sport, vehicles': 'Outdoor, Sport und Fahrzeuge',
      'Park and Forest': 'Park und Wald',
      Pharmacy: 'Apotheke',
      Pitch: 'Sportplatz',
      'Plant and flower': 'Pflanzen und Blumen',
      Playground: 'Spielplatz',
      'Public Utility': 'Öffentliche Einrichtungen',
      'Railway Station': 'Bahnhof',
      Restaurant: 'Restaurant',
      School: 'Schule',
      'Specialty food store': 'Feinkostladen',
      'Sport Centre': 'Sportzentrum',
      'Stationery, gifts, books, newspapers': 'Schreibwaren, Geschenke, Bücher, Zeitungen',
      Supermarket: 'Supermarkt',
      Swimming: 'Schwimmen',
      University: 'Universität',
    },
    subtitle: 'Analyse lokaler Annehmlichkeiten und Sehenswürdigkeiten',
    title: 'Einrichtungen',
    transitModes: {
      BOAT: 'Schiff',
      BUS: 'Bus',
      CABLE_CAR: 'Luftseilbahn',
      CABLE_RAILWAY: 'Standseilbahn',
      CHAIRLIFT: 'Sessellift',
      METRO: 'U-Bahn',
      RACK_RAILWAY: 'Zahnradbahn',
      TRAIN: 'Zug',
      TRAM: 'Tram',
    },
    walkTime: 'Gehzeit',
  },
  buildingAnalysis: {
    amenities: {
      loading: 'Ausstattung wird geladen...',
      other_category: 'Sonstiges',
      unknown_amenity: 'Unbekannt',
    },
    building_title: 'Gebäude {{egid}}',
    built_year: 'Gebaut {{year}}',
    enums: {
      buildingCategory: {
        "Bâtiment d'habitation avec usage annexe": 'Wohngebäude mit Nebennutzung',
        "Bâtiment exclusivement à usage d'habitation": 'Gebäude mit ausschliesslicher Wohnnutzung',
        "Bâtiment partiellement à usage d'habitation": 'Gebäude mit teilweiser Wohnnutzung',
        "Bâtiment sans usage d'habitation": 'Gebäude ohne Wohnnutzung',
        'Construction particulière': 'Sonderbau',
        'Habitation provisoire': 'Provisorische Unterkunft',
      },
      buildingClass: {
        'Autre bâtiment non classé ailleurs': 'Sonstige Hochbauten, anderweitig nicht genannt',
        "Autres bâtiments d'exploitation agricole": 'Andere landwirtschaftliche Gebäude',
        "Autres bâtiments d'hébergement de tourisme": 'Andere Gebäude für kurzfristige Beherbergungen',
        "Autres bâtiments pour l'hébergement collectif": 'Andere Gebäude für die kollektive Unterkunft',
        "Bâtiment d'exploitation agricole": 'Landwirtschaftliche Betriebsgebäude',
        'Bâtiment industriel': 'Industriegebäude',
        'Bâtiments commerciaux': 'Gross- und Einzelhandelsgebäude',
        "Bâtiments pour la garde d'animaux": 'Gebäude für die Tierhaltung',
        'Bâtiments pour les cultures végétales': 'Gebäude für den Pflanzenbau',
        Garage: 'Garagengebäude',
        'Gares, aérogares, centraux téléphoniques': 'Bahnhöfe, Abfertigungsgebäude, Fernsprechvermittlungszentralen',
        'Habitat communautaire': 'Wohngebäude für Gemeinschaften',
        'Hôpital et établissement de santé': 'Krankenhäuser und Facheinrichtungen des Gesundheitswesens',
        'Immeuble à trois logements et plus': 'Gebäude mit drei oder mehr Wohnungen',
        'Maison à deux logements': 'Gebäude mit zwei Wohnungen',
        'Maison individuelle': 'Einfamilienhaus',
        'Monument historique ou classé': 'Denkmäler oder unter Denkmalschutz stehende Bauwerke',
        'Réservoir, silo et entrepôt': 'Behälter, Silos und Lagergebäude',
        'Salle de sport': 'Sporthallen',
        'Salles de tir': 'Schiessanlagen',
      },
      buildingStatus: {
        autorisé: 'Bewilligt',
        démoli: 'Abgebrochen',
        'en construction': 'Im Bau',
        existant: 'Bestehend',
        inutilisable: 'Nicht nutzbar',
        'non réalisé': 'Nicht realisiert',
        projeté: 'Projektiert',
      },
    },
    environment: {
      loading: 'Umweltdaten werden geladen...',
      noise_levels: {
        moderate: 'Mässig',
        noisy: 'Laut',
        quiet: 'Ruhig',
        very_noisy: 'Sehr laut',
        very_quiet: 'Sehr ruhig',
      },
      sunlight_ratings: {
        excellent: 'Ausgezeichnet',
        fair: 'Ausreichend',
        good: 'Gut',
        poor: 'Schlecht',
      },
    },
    error_loading_data: 'Fehler beim Laden der Daten',
    feasibility: {
      considerations: {
        excellent_transport: 'Ausgezeichnete öffentliche Verkehrsanbindung ({{quality}}) steigert den Immobilienwert',
        high_energy: 'Hoher Energieverbrauch kann umweltbewusste Käufer abschrecken',
        minergie: 'Minergie-Zertifizierung deutet auf niedrigere Betriebskosten hin',
        moderate_age: 'Mässiges Gebäudealter ({{age}} Jahre) erfordert möglicherweise schrittweise Verbesserungen',
        multiple_owners: 'Mehrere Eigentümer ({{count}}) können die Entscheidungsfindung erschweren',
        old_building: 'Das Gebäudealter ({{age}} Jahre) erfordert möglicherweise erhebliche Renovierungsinvestitionen',
        protected_status: 'Schutzstatus kann Renovierungsoptionen einschränken, aber den Wert erhalten',
        recent_activity: 'Aktuelle Transaktionsaktivität deutet auf gesunde Marktnachfrage hin',
        solar_potential: 'Erhebliches Solarpotenzial ({{area}}m²) kann Energiekosten ausgleichen',
        title: 'Wichtige Überlegungen',
      },
      financial: {
        appreciation: {
          description: 'Langfristiges Wertsteigerungspotenzial basierend auf Standort- und Marktfaktoren',
          label: 'Wertsteigerungspotenzial',
        },
        capital: {
          description: 'Erwartete Renovierungs- und Modernisierungskosten basierend auf dem Gebäudezustand',
          label: 'Kapitalbedarf',
        },
        complexity: {
          description: 'Transaktions- und Entscheidungskomplexität basierend auf der Eigentumsstruktur',
          label: 'Investitionskomplexität',
        },
        operating: {
          description: 'Laufende Energie- und Wartungskosten basierend auf Effizienzstandards',
          label: 'Betriebskosten',
        },
        title: 'Finanzielle Machbarkeitsindikatoren',
      },
      metrics: {
        building_age: {
          built_in: 'Erbaut im Jahr {{year}}',
          title: 'Gebäudealter',
          tooltip: {
            calculation: 'Aktuelles Jahr minus Baujahr',
            description: 'Alter des Gebäudes seit der ursprünglichen Errichtung',
            importance: 'Beeinflusst Renovierungsbedarf, strukturelle Bedenken und Investitionszeitraum',
            limitations: 'Spiegelt keine grösseren Umbauten oder Modernisierungen wider',
            source: 'Eidgenössisches Gebäuderegister (GWR)',
            title: 'Bewertung des Gebäudealters',
          },
          value: '{{years}} Jahre',
        },
        market_activity: {
          last_transaction: 'Letzte Transaktion: {{year}}',
          title: 'Marktaktivität',
          tooltip: {
            calculation: 'Anzahl aktueller Transaktionen und aktiver Angebote',
            description: 'Aktuelle Transaktionen und Angebotsaktivitäten',
            importance: 'Zeigt Marktliquidität und Investitionsinteresse an',
            limitations: 'Historische Daten, keine Vorhersage zukünftiger Aktivitäten',
            source: 'Transaktions- und Angebotsdatenbanken',
            title: 'Aktuelle Marktaktivität',
          },
          value: '{{count}} Angebote',
        },
        ownership: {
          breakdown: '{{private}} privat, {{public}} öffentlich',
          title: 'Eigentumsstruktur',
          tooltip: {
            calculation: 'Anzahl der registrierten Grundeigentümer',
            description: 'Anzahl und Art der Eigentümer',
            importance: 'Beeinflusst die Entscheidungskomplexität und Transaktionsprozesse',
            limitations: 'Basierend auf dem Grundbuch, spiegelt möglicherweise nicht alle Beteiligten wider',
            source: 'Schweizer Grundbuch',
            title: 'Eigentumskomplexität',
          },
          value: '{{count}} Eigentümer',
          value_plural: '{{count}} Eigentümer',
        },
        renovation: {
          no_renovation: 'Keine Renovierung',
          renovated_in: 'Renoviert im Jahr {{year}}',
          title: 'Renovierungsstatus',
          tooltip: {
            calculation: 'Jahre seit der letzten dokumentierten Renovierung',
            description: 'Zeit seit der letzten grösseren Renovierung',
            importance: 'Zeigt Wartungsbedarf und potenzielle Investitionsanforderungen an',
            limitations: 'Basierend auf offiziellen Aufzeichnungen, kleinere Verbesserungen möglicherweise nicht enthalten',
            source: 'Eidgenössisches Gebäuderegister (GWR)',
            title: 'Renovierungszeitplan',
          },
          value: 'Vor {{years}} Jahren',
        },
      },
      no_data: 'Für dieses Gebäude sind keine Machbarkeitsstudiendaten verfügbar.',
      risk_assessment: {
        energy: {
          description: 'Risiko der Nichteinhaltung von Energiestandards. Möglicherweise sind Upgrades erforderlich, um aktuelle Vorschriften zu erfüllen.',
          title: 'Energiekonformitätsrisiko',
        },
        market: {
          description: 'Marktliquiditäts- und Nachfrageindikatoren. Geringeres Risiko deutet auf bessere Ausstiegsmöglichkeiten hin.',
          title: 'Marktrisiko',
        },
        renovation: {
          description: 'Bewertung des Renovierungsbedarfs basierend auf Alter und Wartungshistorie. Höheres Risiko deutet auf grösseren Kapitalbedarf hin.',
          title: 'Renovierungsrisiko',
        },
        structural: {
          description: 'Basierend auf Gebäudealter und strukturellen Indikatoren. Ältere Gebäude erfordern möglicherweise umfangreichere strukturelle Bewertungen.',
          title: 'Strukturelles Risiko',
        },
        title: 'Risikobewertung',
      },
      risk_levels: {
        high: 'Hohes Risiko',
        low: 'Niedriges Risiko',
        medium: 'Mittleres Risiko',
      },
      subtitle: 'Investitionseignung und Risikobewertung',
      title: 'Machbarkeitsstudie',
      values: {
        high: 'Hoch',
        low: 'Niedrig',
        moderate: 'Mässig',
        variable: 'Variabel',
      },
    },
    history: {
      empty_state: {
        no_data: {
          description: 'Keine historischen Ereignisse oder Zeitleistendaten für dieses Gebäude verfügbar. Dies kann auf begrenzte Aufzeichnungen oder einen kürzlichen Bau zurückzuführen sein.',
          title: 'Keine historischen Daten verfügbar',
        },
        no_matches: {
          description: 'Versuchen Sie, Ihre Filter anzupassen, um mehr historische Ereignisse zu sehen.',
          title: 'Keine Ereignisse entsprechen Ihren Filtern',
        },
      },
      events: {
        building_permit: 'Baubewilligung',
        for_rent: '{{propertyType}} zu vermieten',
        for_sale: '{{propertyType}} zu verkaufen',
        property_transaction: 'Immobilientransaktion',
        rental_listing: 'Mietanzeige',
        sale_listing: 'Verkaufsanzeige',
      },
      filters: {
        building_permits: 'Baubewilligungen',
        rentals: 'Vermietungen',
        sales: 'Verkäufe',
        transactions: 'Transaktionen',
      },
      labels: {
        online_days: '{{count}} Tage online',
        owner: 'Eigentümer: {{name}}',
        participants: '{{count}} Teilnehmer',
        permit_number: 'Bewilligung Nr. {{number}}',
        properties_one: '{{count}} Immobilie',
        properties_other: '{{count}} Immobilien',
        status_active: 'Aktiv',
        status_inactive: 'Inaktiv',
      },
    },
    listings: {
      filters: {
        any: 'Beliebig',
      },
      loading: 'Angebote werden geladen...',
    },
    loading: 'Gebäudeanalyse wird geladen...',
    loading_failed: 'Fehler beim Laden der Gebäudeanalysedaten',
    market: {
      available: 'Verfügbar',
      loading: 'Marktdaten werden geladen...',
      no_listings: 'Keine Angebote',
      properties: 'Immobilien',
      purchase: 'Kauf',
      rental: 'Miete',
      rentals: 'Mietobjekte',
    },
    overview: {
      building_overview: 'Gebäudeübersicht',
      elevator: 'Aufzug',
      property_features: 'Objektmerkmale',
    },
    section_not_shared: {
      description: 'Der Abschnitt {{sectionName}} wurde in dieser geteilten Analyse nicht einbezogen.',
      title: 'Abschnitt nicht geteilt',
    },
    sidebar: {
      items: {
        amenities: 'Einrichtungen',
        buildingCharacteristics: 'Gebäudemerkmale',
        buildingPermits: 'Baugenehmigungen',
        demographics: 'Demografie',
        electricity: 'Elektrizität',
        employment: 'Beschäftigung',
        energy: 'Energie',
        history: 'Geschichte',
        noiseAnalysis: 'Lärmanalyse',
        purchaseListings: 'Kaufinserate',
        purchaseMarket: 'Kaufmarkt',
        rentalListings: 'Mietinserate',
        rentalMarket: 'Mietmarkt',
        summary: 'Zusammenfassung',
        sunlightStudy: 'Sonneneinstrahlung',
        taxes: 'Steuern',
        transactions: 'Transaktionen',
        transportAccess: 'Verkehr & Erreichbarkeit',
        unitDetails: 'Einheitendetails',
      },
      sections: {
        development: 'Entwicklung',
        environment: 'Umgebung',
        market: 'Markt',
        overview: 'Übersicht',
        socialEconomic: 'Soziales & Wirtschaft',
      },
    },
    summaryTab: {
      activity: {
        buildingPermits: 'Baugenehmigungen',
        listingDetail_one: '{{count}} Angebot, zuletzt im {{year}}',
        listingDetail_other: '{{count}} Angebote, zuletzt im {{year}}',
        noData: 'Keine Daten verfugbar',
        permitDetail_one: '{{count}} Genehmigung, zuletzt im {{year}}',
        permitDetail_other: '{{count}} Genehmigungen, zuletzt im {{year}}',
        recentTransactions: 'Aktuelle Transaktionen',
        rentalListings: 'Mietangebote',
        saleListings: 'Verkaufsangebote',
        transactionDetail_one: '{{count}} Transaktion, zuletzt im {{year}}',
        transactionDetail_other: '{{count}} Transaktionen, zuletzt im {{year}}',
      },
      error: 'Fehler beim Laden der Zusammenfassung:',
      labels: {
        address: 'Adresse',
        buildingCategory: 'Gebaudekategorie',
        buildingType: 'Gebaudetyp',
        district: 'Bezirk',
        egid: 'Gebaude-ID (EGID)',
        institutionalOwners: 'Institutionelle Eigentumer',
        municipality: 'Gemeinde',
        numberOfOwners: 'Anzahl Eigentumer',
        privateOwners: 'Privateigentumer',
        publicOwners: 'Offentliche Eigentumer',
        status: 'Status',
        unknown: 'Unbekannt',
      },
      loading: 'Gebaudezusammenfassung wird geladen...',
      metrics: {
        buildingVolume: {
          subtext: 'm3',
          title: 'Gebaudevolumen',
          tooltip: {
            calculation: 'Berechnet aus Gebaudegrundriss und Hohenmessungen',
            importance: 'Verwendet fur Versicherungsberechnungen und Bauvorschriften',
            shortDescription: 'Gesamtes Kubikvolumen der Gebaudestruktur',
            source: 'Eidgenossisches Gebauderegister (GWR)',
            title: 'Gebaudevolumen',
          },
        },
        dwellingArea: {
          subtext: 'Mediane Einheit: {{value}}m2',
          title: 'Wohnflache',
          tooltip: {
            calculation: 'Summe der Wohnflachen aller registrierten Einheiten',
            importance: 'Wichtiger Indikator fur Mietwert und Wohnkapazitat',
            shortDescription: 'Summe aller Wohnflachen im Gebaude',
            source: 'Eidgenossisches Gebauderegister (GWR)',
            title: 'Gesamte Wohnflache',
          },
        },
        floors: {
          subtext: 'Hohe: {{value}}m',
          title: 'Stockwerke',
          tooltip: {
            calculation: 'Beinhaltet Erdgeschoss und alle oberen Etagen',
            importance: 'Wichtig fur Aufzugsanforderungen und Zuganglichkeitsvorschriften',
            shortDescription: 'Gesamtzahl der oberirdischen Stockwerke',
            source: 'Eidgenossisches Gebauderegister (GWR)',
            title: 'Anzahl Stockwerke',
          },
        },
        totalArea: {
          subtext: 'Mediane Einheit: {{value}}m2',
          title: 'Gesamtflache',
          tooltip: {
            calculation: 'Summe aller Grundflachen aus dem Eidgenossischen Gebauderegister (GWR)',
            importance: 'Wichtige Kennzahl zum Verstandnis der Gebaudekapazitat und des potenziellen Miet-/Verkaufswerts',
            limitations: 'Beinhaltet keine Gemeinschaftsflachen, Parkplatze oder Lagerraume',
            shortDescription: 'Die kombinierte Grundflache aller Einheiten im Gebaude',
            source: 'Eidgenossisches Gebauderegister (GWR)',
            title: 'Gesamte Gebaudeflache',
          },
        },
        units: {
          subtext: 'Median: {{value}} Zimmer',
          title: 'Einheiten',
          tooltip: {
            calculation: 'Anzahl der registrierten Wohneinheiten aus dem Bundesregister',
            importance: 'Wesentlich fur das Verstandnis der Gebaudedichte und des Investitionspotenzials',
            shortDescription: 'Gesamtzahl der Wohneinheiten im Gebaude',
            source: 'Eidgenossisches Gebauderegister (GWR)',
            title: 'Anzahl Einheiten',
          },
        },
        yearBuilt: {
          subtext: 'Renoviert: {{value}}',
          title: 'Baujahr',
          tooltip: {
            importance: 'Beeinflusst Bauvorschriften, Renovierungsbedarf und Immobilienwert',
            shortDescription: 'Das Jahr, in dem das Gebaude ursprunglich errichtet wurde',
            source: 'Eidgenossisches Gebauderegister (GWR)',
            title: 'Baujahr',
          },
        },
      },
      noData: 'Keine Gebaudedaten verfugbar',
      sections: {
        buildingInfo: 'Gebaudeinformationen',
        ownership: 'Eigentum',
        recentActivity: 'Aktuelle Aktivitat',
      },
      subtitle: 'Ubersicht von {{address}}, {{municipality}}',
      title: 'Gebaudezusammenfassung',
    },
    tabs: {
      amenities: 'Ausstattung',
      history: 'Historie',
      noise: 'Lärm',
      overview: 'Übersicht',
      purchase_market: 'Kaufmarkt',
      rental_market: 'Mietmarkt',
      sunlight: 'Sonnenlicht',
      transactions: 'Transaktionen',
      units: 'Einheiten',
    },
    title: 'Gebäudeanalyse',
    transactions: {
      loading: 'Transaktionsdaten werden geladen...',
      types: {
        all_types: 'Alle Typen',
        auction: 'Auktion',
        rental: 'Miete',
        sale: 'Verkauf',
      },
    },
    units: {
      balcony: 'Balkon',
      floor: 'Etage',
      unknown_floor: 'Unbekannte Etage',
    },
  },
  buildings: {
    characteristics: {
      common: {
        na: 'K.A.',
        no: 'Nein',
        source: 'Daten aus dem Eidgenössischen Gebäude- und Wohnungsregister (GWR)',
        sourceCalculated: 'Berechnet aus verfügbaren Gebäudedaten',
        years: 'Jahre',
        yes: 'Ja',
      },
      header: {
        subtitle: 'Umfassende physische, historische und vergleichende Analyse des Gebäudes',
        title: 'Gebäudemerkmale',
      },
      neighborhood: {
        ageRanges: {
          '1919_1945': '1919-45',
          '1946_1960': '1946-60',
          '1961_1970': '1961-70',
          '1971_1980': '1971-80',
          '1981_1990': '1981-90',
          '1991_2000': '1991-00',
          '2001_2010': '2001-10',
          '2011_2020': '2011-20',
          post2020: 'Nach 2020',
          pre1919: 'Vor 1919',
        },
        badges: {
          buildingOutlier: '⚠️ Gebäude-Ausreisser',
        },
        cards: {
          ageDistribution: {
            title: 'Gebäudealtersverteilung',
          },
          areaComparison: {
            title: 'Grundflächenvergleich',
            tooltip: {
              calculation: 'Vergleicht die Erdgeschossfläche dieses Gebäudes mit den durchschnittlichen und maximalen Flächen der Nachbargebäude',
              description: 'Wie sich die Grundfläche dieses Gebäudes mit den umliegenden Gebäuden vergleicht',
              importance: 'Die Gebäudegrundfläche im Vergleich zu Nachbarn zeigt die Landnutzungsintensität, Entwicklungsdichte und ob das Gebäude typisch für das Gebiet ist.',
              limitations: 'Die Grundfläche allein spiegelt nicht die Gesamtgrösse des Gebäudes wider. Prüfen Sie die Geschosszahl und Bruttogeschossfläche für eine vollständige Grössenbewertung.',
              title: 'Flächenvergleich mit Nachbarn',
            },
          },
          cohesionBreakdown: {
            title: 'Kohäsionsaufschlüsselung',
          },
          comparativeAnalysis: {
            title: 'Vergleichsanalyse',
          },
          conformityBreakdown: {
            title: 'Gebäudekonformitäts-Aufschlüsselung',
            tooltip: {
              calculation: 'Vergleicht die Eigenschaften dieses Gebäudes mit dem typischen Quartierprofil',
              description: 'Zeigt, wie gut dieses spezifische Gebäude zum Quartiermuster passt',
              importance: 'Niedrige Konformität in einem kohärenten Quartier weist auf ein Ausreissergebäude hin, was Bewertung, Entwicklungsbeschränkungen oder architektonische Harmonie beeinflussen kann.',
              title: 'Gebäudekonformitäts-Aufschlüsselung',
            },
          },
          heightComparison: {
            title: 'Höhenvergleich',
            tooltip: {
              calculation: 'Vergleicht die Gesamthöhe dieses Gebäudes mit den durchschnittlichen und maximalen Höhen der Nachbargebäude innerhalb eines definierten Radius (typischerweise 100-200m)',
              description: 'Wie sich die Höhe dieses Gebäudes mit den umliegenden Gebäuden vergleicht',
              importance: 'Die Gebäudehöhe im Vergleich zu Nachbarn beeinflusst Aussicht, Sonneneinstrahlung, Privatsphäre, architektonische Harmonie und Einhaltung lokaler Zonenvorschriften.',
              limitations: 'Vergleich basierend auf Gebäuden innerhalb des Suchradius. Lokale Topographie und Geländehöhenunterschiede werden in dieser Metrik nicht berücksichtigt.',
              title: 'Höhenvergleich mit Nachbarn',
            },
          },
          neighborhoodAnalysis: {
            title: 'Nachbarschafts- und Gebäudeanalyse',
            tooltip: {
              calculation: 'Nachbarschaftskohäsion misst, wie ähnlich die umliegenden Gebäude sind. Gebäudekonformität misst, wie gut DIESES Gebäude zum Nachbarschaftsmuster passt.',
              description: 'Analysiert sowohl die Nachbarschaftskohäsion als auch wie gut dieses Gebäude in das erkannte Quartier passt',
              importance: 'Hohe Kohäsion mit niedriger Konformität weist auf ein Ausreissergebäude in einer kohärenten Nachbarschaft hin, was Bewertung und Entwicklungspotenzial beeinflussen kann.',
              title: 'Nachbarschafts- und Gebäudeanalyse',
            },
          },
          quartierProfile: {
            title: 'Quartierprofil',
          },
          volumeComparison: {
            title: 'Volumenvergleich',
            tooltip: {
              calculation: 'Vergleicht das geschlossene Gesamtvolumen dieses Gebäudes mit den durchschnittlichen und maximalen Volumen der Nachbargebäude',
              description: 'Wie sich das Gesamtvolumen dieses Gebäudes mit den umliegenden Gebäuden vergleicht',
              importance: 'Das Gebäudevolumen ist ein wichtiger Indikator für die Gesamtmasse und Entwicklungsintensität. Wird für Energiemodellierung und HLK-Kapazitätsplanung verwendet.',
              limitations: 'Volumenberechnungen können vereinfachte geometrische Annahmen verwenden. Das tatsächliche Innenvolumen kann aufgrund der Dachgeometrie und Innenaufteilung variieren.',
              title: 'Volumenvergleich mit Nachbarn',
            },
          },
        },
        chart: {
          areaAxis: 'Fläche (m²)',
          buildingsAxis: 'Gebäude',
          heightAxis: 'Höhe (m)',
          neighborhoodAvg: 'Nachbarschafts-Durchschnitt',
          neighborhoodMax: 'Nachbarschafts-Maximum',
          thisBuilding: 'Dieses Gebäude',
          volumeAxis: 'Volumen (m³)',
        },
        cohesion: {
          density: {
            label: 'Dichte-Kohäsion (10%)',
            tooltip: {
              calculation: 'Basierend auf der Anzahl der Gebäude pro Quadratkilometer. Höhere Dichte deutet auf städtisches Quartier hin.',
              description: 'Misst die Entwicklungsdichte',
              title: 'Dichte-Kohäsion',
            },
          },
          physical: {
            label: 'Physische Kohäsion (30%)',
            tooltip: {
              calculation: 'Basierend auf der Ähnlichkeit von Höhe, Fläche und Geschosszahl. Höhere Werte zeigen einheitliche Gebäudeeigenschaften an.',
              description: 'Misst die architektonische Ähnlichkeit',
              title: 'Physische Kohäsion',
            },
          },
          temporal: {
            label: 'Zeitliche Kohäsion (40%)',
            tooltip: {
              calculation: 'Basierend auf der Ähnlichkeit der Baujahre. Höhere Werte zeigen Gebäude aus derselben Epoche an.',
              description: 'Misst, ob Gebäude in derselben Periode gebaut wurden',
              title: 'Zeitliche Kohäsion',
            },
          },
          typological: {
            label: 'Typologische Kohäsion (20%)',
            tooltip: {
              calculation: 'Basierend auf der Häufigkeit ähnlicher Gebäudekategorien (z.B. Einfamilienhaus, Mehrfamilienhaus, etc.)',
              description: 'Misst die Ähnlichkeit der Gebäudetypen',
              title: 'Typologische Kohäsion',
            },
          },
        },
        comparison: {
          aboveAverage: '{{percent}}% über Durchschnitt',
          belowAverage: '{{percent}}% unter Durchschnitt',
          similar: 'Ähnlich wie Durchschnitt',
        },
        conformity: {
          fitsWell: 'Passt gut',
          outlier: 'Ausreisser',
          partialFit: 'Teilweise passend',
          physicalMatch: {
            label: 'Physische Übereinstimmung (40%)',
            tooltip: {
              calculation: 'Durchschnitt der Ähnlichkeit von Höhe, Fläche und Geschosszahl. ±20-30% = hohe Übereinstimmung',
              description: 'Wie gut Grösse und Höhe dieses Gebäudes zum typischen Quartier passen',
              title: 'Physische Übereinstimmung',
            },
          },
          temporalMatch: {
            label: 'Zeitliche Übereinstimmung (40%)',
            tooltip: {
              calculation: 'Vergleicht Baujahr mit typischem Jahr. ±5 Jahre = 100%, ±10 Jahre = 75%, ±20 Jahre = 50%',
              description: 'Wie gut das Baujahr dieses Gebäudes zur typischen Quartierperiode passt',
              title: 'Zeitliche Übereinstimmung',
            },
          },
          typologicalMatch: {
            label: 'Typologische Übereinstimmung (20%)',
            tooltip: {
              calculation: '100 wenn gleiche Kategorie wie typisch, 0 wenn unterschiedlich',
              description: 'Ob der Typ dieses Gebäudes zur dominanten Quartierkategorie passt',
              title: 'Typologische Übereinstimmung',
            },
          },
        },
        errors: {
          loadFailed: 'Fehler beim Laden der Nachbarschaftsanalyse',
        },
        loading: 'Nachbarschaftsanalyse wird geladen...',
        metrics: {
          areaVsAverage: {
            label: 'Fläche vs Durchschnitt',
            tooltip: {
              calculation: 'Prozentuale Abweichung von der durchschnittlichen Fläche der Gebäude im Suchradius',
              description: 'Wie sich die Grundfläche dieses Gebäudes mit den nahegelegenen Gebäuden vergleicht',
              importance: 'Zeigt an, ob das Gebäude typisch oder ungewöhnlich gross/klein für das Gebiet ist. Beeinflusst GFZ und Entwicklungspotenzial.',
              title: 'Fläche vs Nachbarschaftsdurchschnitt',
            },
          },
          avgNeighborAge: {
            label: 'Durchschnittliches Nachbaralter',
            tooltip: {
              calculation: 'Durchschnitt der Alter aller Gebäude im Suchradius',
              description: 'Durchschnittsalter der umliegenden Gebäude',
              importance: 'Zeigt an, ob die Nachbarschaft vorwiegend alt (>50 Jahre), etabliert (20-50 Jahre) oder neu (<20 Jahre) ist.',
              title: 'Durchschnittliches Nachbaralter',
            },
            value: '{{years}} Jahre',
          },
          buildingConformity: 'Gebäudekonformität',
          buildingDensity: {
            label: 'Gebäudedichte',
            tooltip: {
              calculation: 'Anzahl der Gebäude innerhalb eines definierten Radius geteilt durch die Fläche dieses Radius',
              description: 'Anzahl der Gebäude pro Flächeneinheit in der Umgebung',
              importance: 'Zeigt an, ob das Gebiet urban, suburban oder ländlich ist. Hohe Dichte deutet auf städtische Umgebung mit näheren Gebäuden hin.',
              title: 'Gebäudedichte',
            },
            value: '{{density}} Gebäude/km²',
          },
          buildingsAnalyzed: 'Analysierte Gebäude',
          confidence: 'Konfidenz',
          heightVsAverage: {
            label: 'Höhe vs Durchschnitt',
            tooltip: {
              calculation: 'Prozentuale Abweichung von der durchschnittlichen Höhe der Gebäude im Suchradius',
              description: 'Wie sich die Höhe dieses Gebäudes mit den nahegelegenen Gebäuden vergleicht',
              importance: 'Gebäude, die deutlich höher oder niedriger als Nachbarn sind, können Zonenbeschränkungen unterliegen oder visuell auffallen.',
              title: 'Höhe vs Nachbarschaftsdurchschnitt',
            },
          },
          neighborhoodCohesion: 'Nachbarschaftskohäsion',
          neighboringBuildings: {
            label: 'Nachbargebäude',
            tooltip: {
              calculation: 'Anzahl der Gebäude, die innerhalb des ausgewählten Suchradius gefunden wurden',
              description: 'Anzahl der Gebäude innerhalb des Analyseradius',
              importance: 'Mehr Nachbarn ermöglichen einen besseren statistischen Vergleich. Weniger als 10 Nachbarn können auf ein ländliches Gebiet oder begrenzte Datenzuverlässigkeit hinweisen.',
              title: 'Nachbargebäude',
            },
          },
          volumeVsAverage: {
            label: 'Volumen vs Durchschnitt',
            tooltip: {
              calculation: 'Prozentuale Abweichung vom durchschnittlichen Volumen der Gebäude im Suchradius',
              description: 'Wie sich das Volumen dieses Gebäudes mit den nahegelegenen Gebäuden vergleicht',
              importance: 'Grössere Volumen weisen auf substanziellere Strukturen hin. Beeinflusst Heizkosten und Entwicklungsdichte.',
              title: 'Volumen vs Nachbarschaftsdurchschnitt',
            },
          },
        },
        neighboringBuildings: '{{count}} Nachbargebäude',
        noData: 'Keine Nachbarschaftsvergleichsdaten für dieses Gebäude verfügbar',
        notes: {
          differsByPattern: 'Dieses Gebäude unterscheidet sich erheblich vom Nachbarschaftsmuster.',
          physicalMismatch: 'Grösse/Höhe weicht erheblich ab.',
          temporalMismatch: 'Abweichung der Bauzeit.',
          title: 'Hinweis:',
          typologicalMismatch: 'Gebäudetyp weicht von der dominanten Kategorie ab.',
        },
        profile: {
          description: {
            label: 'Beschreibung',
            tooltip: {
              calculation: 'Generiert aus typischem Baujahr und dominanter Kategorie',
              description: 'Zusammenfassende Charakterisierung der Nachbarschaft',
              importance: "Bietet schnellen Überblick über den Nachbarschaftscharakter (z.B. 'Wohngebiet der 1960er' oder 'gemischt genutzt der 1980er').",
              title: 'Quartierbeschreibung',
            },
          },
          developmentPattern: {
            categories: {
              mixed: {
                description: 'Moderate Kohäsion, verschiedene Entwicklung (Score 55-74)',
                label: 'Gemischt',
              },
              organic: {
                description: 'Niedrige Kohäsion, vielfältige Entwicklung (Score <55)',
                label: 'Organisch',
              },
              planned: {
                description: 'Hohe Kohäsion, einheitliche Entwicklung (Score ≥75)',
                label: 'Geplant',
              },
            },
            label: 'Entwicklungsmuster',
            tooltip: {
              description: 'Klassifizierung des Nachbarschaftsentwicklungsstils',
              importance: 'Geplante Gebiete haben strengere Zonierung. Organische Gebiete bieten mehr Renovierungsflexibilität.',
              title: 'Entwicklungsmuster',
            },
          },
          typicalArea: {
            label: 'Typische Fläche',
            tooltip: {
              calculation: 'Durchschnittliche Grundfläche der Gebäude in der Nachbarschaft',
              description: 'Repräsentative Gebäudegrundfläche für das Quartier',
              importance: 'Zeigt typische Grundstücksauslastung und Gebäudemassstab im Gebiet.',
              title: 'Typische Fläche',
            },
          },
          typicalCategory: {
            label: 'Typische Kategorie',
            tooltip: {
              calculation: 'Häufigste Gebäudekategorie unter den Nachbarschaftsgebäuden',
              description: 'Dominierender Gebäudetyp im Quartier',
              importance: 'Definiert Nachbarschaftscharakter: Wohn-, Gewerbe-, Industrie- oder Mischnutzung.',
              title: 'Typische Kategorie',
            },
          },
          typicalHeight: {
            label: 'Typische Höhe',
            tooltip: {
              calculation: 'Durchschnittliche Höhe der Gebäude in der Nachbarschaft',
              description: 'Repräsentative Gebäudehöhe für das Quartier',
              importance: 'Zeigt an, ob das Gebiet vorwiegend niedrige (<10m), mittlere (10-25m) oder hohe (>25m) Bebauung hat.',
              title: 'Typische Höhe',
            },
          },
          typicalYear: {
            label: 'Typisches Baujahr',
            tooltip: {
              calculation: 'Durchschnittliches Baujahr der Gebäude in der Nachbarschaft',
              description: 'Repräsentativstes Baujahr für das Quartier',
              importance: 'Definiert die architektonische Epoche und wahrscheinliche Baustandards für das Gebiet.',
              title: 'Typisches Baujahr',
            },
          },
        },
        radius: {
          label: 'Radius',
          value: '{{radius}}m Radius',
        },
        statistics: {
          area: {
            mean: {
              tooltip: {
                calculation: 'Arithmetisches Mittel aller Gebäudeflächen',
                description: 'Durchschnittliche Gebäudegrundfläche in der Nachbarschaft',
                importance: 'Zeigt typische Grundstücksgrösse. Beeinflusst durch Ausreisser.',
                title: 'Durchschnittliche Fläche',
              },
            },
            median: {
              tooltip: {
                calculation: '50. Perzentil der Gebäudeflächen',
                description: 'Mittelwert der Nachbarschafts-Gebäudeflächen',
                importance: 'Repräsentativer als Mittelwert bei Ausreissern.',
                title: 'Medianfläche',
              },
            },
            range: {
              tooltip: {
                calculation: 'Kleinste und grösste Gebäudegrundflächen in der Nachbarschaft',
                description: 'Minimale und maximale Gebäudeflächen',
                importance: 'Zeigt Grössendiversität. Grosse Spanne zeigt gemischte Gebäudemassstäbe.',
                title: 'Flächenbereich',
              },
            },
            title: 'Flächenstatistiken',
          },
          floor: {
            floorsRange: '{{min}} - {{max}} Stockwerke',
            floorsValue: '{{floors}} Stockwerke',
            mean: {
              tooltip: {
                calculation: 'Arithmetisches Mittel aller Gebäudegeschosszahlen',
                description: 'Durchschnittliche Anzahl von Geschossen in der Nachbarschaft',
                importance: 'Zeigt typischen Gebäudemassstab. Beeinflusst durch Ausreisser.',
                title: 'Durchschnittliche Geschosszahl',
              },
            },
            median: {
              tooltip: {
                calculation: '50. Perzentil der Geschosszahlen',
                description: 'Mittelwert der Nachbarschafts-Geschosszahlen',
                importance: 'Repräsentativer als Mittelwert bei Ausreissern.',
                title: 'Median-Geschosszahl',
              },
            },
            range: {
              tooltip: {
                calculation: 'Niedrigste und höchste Geschosszahlen in der Nachbarschaft',
                description: 'Minimale und maximale Geschosszahlen',
                importance: 'Zeigt vertikale Diversität. Grosse Spanne zeigt gemischte Höhenniveaus.',
                title: 'Geschosszahlbereich',
              },
            },
            title: 'Geschossstatistiken',
          },
          height: {
            mean: {
              tooltip: {
                calculation: 'Arithmetisches Mittel aller Gebäudehöhen',
                description: 'Durchschnittliche Gebäudehöhe in der Nachbarschaft',
                importance: 'Zeigt typischen Gebäudemassstab. Beeinflusst durch Ausreisser.',
                title: 'Durchschnittliche Höhe',
              },
            },
            median: {
              tooltip: {
                calculation: '50. Perzentil der Gebäudehöhen',
                description: 'Mittelwert der Nachbarschafts-Gebäudehöhen',
                importance: 'Repräsentativer als Mittelwert bei Ausreissern.',
                title: 'Medianhöhe',
              },
            },
            range: {
              tooltip: {
                calculation: 'Niedrigste und höchste Gebäudehöhen in der Nachbarschaft',
                description: 'Minimale und maximale Gebäudehöhen',
                importance: 'Zeigt Höhendiversität. Grosse Spanne zeigt gemischte Entwicklung.',
                title: 'Höhenbereich',
              },
            },
            title: 'Höhenstatistiken',
          },
          mean: 'Mittelwert',
          median: 'Median',
          range: 'Bereich',
        },
        title: 'Nachbarschaftskontext',
        tooltips: {
          source: 'Eidgenössisches Gebäude- und Wohnungsregister (GWR)',
          sourceCalculated: 'Berechnet aus Gebäuderegisterdaten',
        },
        warnings: {
          outlierDescription: 'Dieses Gebäude passt nicht zum kohärenten Nachbarschaftsmuster. Es kann in Bezug auf Alter, Grösse oder Typ ein Ausreisser im Vergleich zu umliegenden Gebäuden sein.',
          outlierTitle: '⚠️ Warnung:',
        },
      },
      overview: {
        ageCategories: {
          contemporary: {
            description: 'Mit relativ modernen Bauverfahren und Materialien errichtet',
            label: 'Zeitgenössisch',
            range: '10-30 Jahre',
          },
          historic: {
            description: 'Historisches Gebäude mit potenziellem Denkmalwert und Charaktereigenschaften',
            label: 'Historisch',
            range: '>50 Jahre',
          },
          mature: {
            description: 'Etabliertes Gebäude, das von Renovierung oder Modernisierung profitieren könnte',
            label: 'Reif',
            range: '30-50 Jahre',
          },
          new: {
            description: 'Kürzlich mit modernen Baustandards und Energieeffizienz errichtet',
            label: 'Neu',
            range: '<10 Jahre',
          },
        },
        cards: {
          dimensions: {
            buildingVolume: 'Gebäudevolumen',
            footprintArea: 'Grundfläche',
            grossFloorArea: 'Bruttogeschossfläche',
            groundElevation: 'Bodenhöhe',
            title: 'Physische Masse',
            tooltips: {
              elevation: {
                calculation: 'Gemessen aus digitalen Geländemodellen unter Verwendung der durchschnittlichen Höhe an der Gebäudegrundfläche',
                description: 'Höhe des Bodenniveaus am Gebäudestandort über dem Meeresspiegel',
                importance: 'Wichtig für Hochwasserrisikobewertung, Entwässerungsplanung und Verständnis der lokalen Topographie',
                title: 'Bodenhöhe',
              },
              footprintImportance: 'Bestimmt die Bodenbedeckung und ist entscheidend für die Berechnung des Entwicklungspotenzials und der Einhaltung von Zonenvorschriften',
              grossFloorArea: {
                calculation: 'Summe aller Geschossflächen einschliesslich Wände, Treppen und Gemeinschaftsflächen. Berechnet aus dem Gebäuderegister oder Grundfläche × Geschosszahl',
                description: 'Gesamtgeschossfläche aller Stockwerke, gemessen bis zur Aussenseite der Aussenwände',
                importance: 'Schlüsselkennzahl für Immobilienbewertung, Mietberechnungen und Gebäudegrössenvergleich',
                limitations: 'Kann nicht bewohnbare Bereiche wie Flure und Technikräume einschliessen. Die Nettonutzfläche ist typischerweise 10-25% kleiner',
                title: 'Bruttogeschossfläche',
              },
              heightCalculation: 'Höhe gemessen vom Bodenniveau bis zum Dachfirst mittels LiDAR-Daten und offiziellen Gebäudevermessungen',
              heightImportance: 'Entscheidend für Zonenkonformität, Nachbarschaftsbeziehungen und Gebäudeklassifizierung',
              volume: {
                calculation: 'Typischerweise berechnet als Grundfläche × durchschnittliche Höhe, oder aus detaillierten 3D-Gebäudemodellen',
                description: 'Gesamtes umschlossenes Volumen des Gebäudes von den Fundamenten bis zum Dach',
                importance: 'Verwendet für Energiemodellierung, HLK-Dimensionierung und Entwicklungsdichteberechnungen',
                title: 'Gebäudevolumen',
              },
            },
          },
          occupancy: {
            avgFloorArea: 'Durchschnittliche Geschossfläche',
            avgFloorHeight: 'Durchschnittliche Geschosshöhe',
            buildingCategory: 'Gebäudekategorie',
            numberOfDwellings: 'Anzahl Wohnungen',
            primaryUse: 'Hauptnutzung',
            title: 'Nutzung & Typ',
            tooltips: {
              avgFloorArea: {
                calculation: 'Berechnet durch Division der Bruttogeschossfläche durch die Anzahl der Stockwerke',
                description: 'Die durchschnittliche Fläche jedes Stockwerks im Gebäude',
                importance: 'Nützlich zum Verständnis der Geschossplatteneffizienz und zum Vergleich ähnlicher Gebäude',
                title: 'Durchschnittliche Geschossfläche',
              },
              avgFloorHeight: {
                calculation: 'Berechnet durch Division der Gesamtgebäudehöhe durch die Anzahl der Stockwerke',
                description: 'Die durchschnittliche vertikale Distanz zwischen den Stockwerken im Gebäude',
                importance: 'Zeigt Gebäudequalität und Epoche an. Höhere Decken deuten oft auf ältere oder hochwertige Bauweise hin',
                title: 'Durchschnittliche Geschosshöhe',
              },
              category: {
                calculation: 'Von kantonalen Behörden basierend auf Gebäudenutzung, Struktur und Zweck zugewiesen',
                description: 'Offizielle Klassifizierung des Gebäudes nach Schweizer Bundesgebäudekategorien',
                importance: 'Bestimmt anwendbare Bauvorschriften, Steuerbewertungen und zulässige Nutzungen',
                title: 'Gebäudekategorie',
              },
              dwellings: {
                calculation: 'Gezählt aus offiziellen Gebäuderegistern, einschliesslich Wohnungen, Studios und Häuser',
                description: 'Gesamtzahl der einzelnen Wohneinheiten im Gebäude',
                importance: 'Schlüsselfaktor für Gebäudeverwaltung, Infrastrukturplanung und Dichtebeurteilung',
                title: 'Anzahl Wohnungen',
              },
              primaryUse: {
                calculation: 'Aus dem Gebäuderegister basierend auf der dominanten Nutzung der Gebäudefläche ermittelt',
                description: 'Der hauptsächliche funktionale Zweck, für den das Gebäude genutzt wird',
                importance: 'Beeinflusst Zonenkonformität, Versicherungsanforderungen und potenzielle Entwicklungsoptionen',
                title: 'Hauptnutzung',
              },
            },
          },
          occupancyType: {
            title: 'Nutzung & Typ',
          },
          physicalDimensions: {
            title: 'Physische Masse',
          },
          status: {
            constructionYear: 'Baujahr',
            currentStatus: 'Aktueller Status',
            lastRenovation: 'Letzte Renovation',
            minergieCertified: 'Minergie-zertifiziert',
            protectedStatus: 'Schutzstatus',
            title: 'Status & Zustand',
            tooltips: {
              constructionYear: {
                calculation: 'Im offiziellen Gebäuderegister bei Fertigstellung der Baugenehmigung erfasst',
                description: 'Das Jahr, in dem das Gebäude ursprünglich fertiggestellt wurde',
                importance: 'Wesentlich für Altersberechnungen, historischen Kontext und Verständnis der verwendeten Baustandards',
                limitations: 'Bei älteren Gebäuden kann aus dem Bauperiodebereich geschätzt werden. Grössere Umbauten aktualisieren dieses Datum möglicherweise nicht',
                title: 'Baujahr',
              },
              minergie: {
                calculation: 'Von der Minergie-Vereinigung basierend auf der Erfüllung strenger Energieeffizienzstandards verliehen',
                description: 'Schweizer Energieeffizienz-Zertifizierung für Gebäude',
                importance: 'Zeigt überlegene Energieeffizienz, höheren Komfort und typischerweise niedrigere Betriebskosten an',
                source: 'Zertifizierungsdatenbank der Minergie-Vereinigung',
                title: 'Minergie-Zertifizierung',
              },
              protected: {
                calculation: 'Von kantonalen Denkmalschutzbehörden basierend auf historischer, architektonischer oder kultureller Bedeutung bewertet',
                description: 'Von kantonalen Behörden zugewiesener Denkmalschutzstufe',
                importance: 'Beeinflusst Renovierungsmöglichkeiten, Entwicklungspotenzial und kann Steuervorteile bieten',
                source: 'Kantonales Denkmalschutzamt und Gebäuderegister',
                title: 'Schutzstatus',
              },
              renovation: {
                calculation: 'Aus Baugenehmigungsunterlagen für grössere Renovierungs- oder Umbauprojekte erfasst',
                description: 'Das jüngste Jahr, in dem bedeutende Renovierungsarbeiten abgeschlossen wurden',
                importance: 'Zeigt jüngere Verbesserungen an und wahrscheinlich besseren Zustand als das Baujahr allein vermuten liesse',
                limitations: 'Kleinere Renovierungen werden möglicherweise nicht erfasst. Innenrenovierungen ohne Genehmigung werden nicht erfasst',
                title: 'Letzte Renovation',
              },
              status: {
                calculation: 'Im Gebäuderegister erfasst und basierend auf Bau- oder Abrissgenehmigungen aktualisiert',
                description: 'Der aktuelle Betriebsstatus des Gebäudes',
                importance: 'Bestätigt, ob das Gebäude existiert, im Bau ist oder abgerissen wurde',
                title: 'Aktueller Gebäudestatus',
              },
            },
          },
          statusCondition: {
            title: 'Status & Zustand',
          },
        },
        heightTypes: {
          highRise: 'Hochhaus',
          lowRise: 'Niedriges Gebäude',
          midRise: 'Mittelgrosses Gebäude',
        },
        labels: {
          asl: 'ü.M.',
          estimated: 'geschätzt',
          period: 'Zeitraum',
        },
        metrics: {
          buildingAge: {
            label: 'Gebäudealter',
            tooltip: {
              calculation: 'Berechnet als aktuelles Jahr minus Baujahr aus dem offiziellen Gebäuderegister',
              calculationEstimated: 'Geschätzt basierend auf der Bauperiode {{period}}. Der Mittelpunkt des Periodenbereichs wird für die Berechnung verwendet',
              description: 'Die Anzahl der Jahre seit der ursprünglichen Errichtung des Gebäudes',
              importance: 'Schlüsselfaktor für die Bewertung von Wartungsbedarf, Renovierungspotenzial, Energieeffizienz und Immobilienbewertung',
              limitations: 'Berücksichtigt keine grösseren Renovierungen oder Umbauten, die das Gebäude möglicherweise erheblich modernisiert haben',
              limitationsEstimated: 'Das Alter ist aus der Bauperiode geschätzt und möglicherweise nicht exakt. Das tatsächliche Baujahr kann innerhalb des Periodenbereichs variieren',
              title: 'Gebäudealter',
            },
          },
          buildingArea: {
            label: 'Gebäudefläche',
            tooltip: {
              calculation: 'Gemessen aus offiziellen Katasterdaten oder dem Gebäuderegister als horizontale Projektion der Gebäudehülle',
              description: 'Die vom Gebäude auf Bodenniveau bedeckte Fläche',
              importance: 'Wesentlich für das Verständnis der Landnutzungseffizienz, Berechnung von Geschossflächenzahlen und Bewertung des Entwicklungspotenzials',
              limitations: 'Beinhaltet keine externen Strukturen wie Terrassen, Balkone oder Untergeschosse. Kann von der Gesamtgeschossfläche abweichen',
              title: 'Gebäudegrundfläche',
            },
          },
          buildingHeight: {
            label: 'Gebäudehöhe',
            tooltip: {
              calculation: 'Gemessen aus LiDAR-Daten oder offiziellen Gebäudevermessungen, vom Bodenniveau bis zum Dachfirst oder höchsten Strukturelement',
              description: 'Die vertikale Messung vom Bodenniveau bis zum höchsten Punkt des Gebäudes',
              importance: 'Kritisch für Zonenkonformität, Schattenanalyse, Sichtbewertungen und Bestimmung der Gebäudeklassifizierung',
              limitations: 'Kann je nach Messmethode variieren. Antennen, Schornsteine und temporäre Strukturen können eingeschlossen sein oder nicht',
              title: 'Gesamte Gebäudehöhe',
            },
          },
          floorCount: {
            label: 'Anzahl Stockwerke',
            tooltip: {
              calculation: 'Gezählt aus offiziellen Gebäuderegisterdaten, einschliesslich Erdgeschoss und aller Obergeschosse',
              description: 'Die Gesamtzahl der oberirdischen Stockwerke im Gebäude',
              importance: 'Wichtiger Indikator für Gebäudeklassifizierung, Zonenkonformität und Schätzung der Bruttogeschossfläche',
              limitations: 'Kann Kellergeschosse, Zwischengeschosse oder Technikgeschosse nicht einschliessen. Untergeschosse werden separat gezählt',
              title: 'Gesamte Stockwerkzahl',
            },
          },
          numberOfFloors: {
            label: 'Anzahl Stockwerke',
          },
        },
        sizeIndicators: {
          compact: 'Kompakt',
          large: 'Gross',
          medium: 'Mittel',
        },
        values: {
          asl: 'ü.M.',
          estimated: '(gesch.)',
          estimatedFrom: 'geschätzt aus {{period}}',
          na: 'K.A.',
          no: 'Nein',
          period: '(Zeitraum)',
          years: 'Jahre',
          yearsAgo: 'Jahre her',
          yearsCount: '{{count}} Jahre',
          yes: 'Ja',
        },
      },
      states: {
        error: 'Fehler beim Laden der Gebäudemerkmale',
        loading: 'Gebäudemerkmale werden geladen...',
        noData: 'Keine Gebäudedaten verfügbar',
      },
      tabs: {
        neighborhood: 'Nachbarschaftskontext',
        overview: 'Übersicht',
        timeline: 'Bau-Zeitachse',
      },
      timeline: {
        ageComparison: {
          newerThanAverage: 'Neuer als Durchschnitt',
          significantlyOlder: 'Deutlich älter',
          similarAge: 'Ähnliches Alter',
          yearsOld: 'Jahre alt',
        },
        badges: {
          estimatedData: 'Geschätzte Daten',
          historicalData: 'Historische Daten',
        },
        cards: {
          ageAnalysis: {
            title: 'Altersanalyse',
          },
          ageComparison: {
            title: 'Altersvergleich mit der Nachbarschaft',
          },
          constructionPhases: {
            title: 'Bauphasen',
          },
          constructionTimeline: {
            title: 'Bau-Zeitachse',
          },
          renovationHistory: {
            title: 'Renovierungsgeschichte',
          },
          timeline: {
            title: 'Bau-Zeitachse',
            tooltip: {
              calculation: 'Basierend auf offiziellen Baudaten, Renovierungsaufzeichnungen und Gebäuderegisterdaten',
              description: 'Visuelle Darstellung der Baugeschichte und wichtiger Ereignisse des Gebäudes',
              importance: 'Hilft, die Entwicklung des Gebäudes im Laufe der Zeit zu verstehen und zukünftige Wartung zu planen',
              limitations: 'Einige Daten können aus Bauperioden geschätzt werden, wenn genaue Jahre nicht verfügbar sind',
              title: 'Bau-Zeitachse',
            },
          },
        },
        events: {
          constructionPhase: 'Bauphase',
          dwellingAdded: 'Wohnung hinzugefügt',
          majorRenovation: 'Grössere Renovation',
          originalConstruction: 'Ursprüngliche Konstruktion',
          originalConstructionEst: 'Ursprüngliche Konstruktion (gesch.)',
          present: 'Gegenwart',
        },
        labels: {
          ageCategory: 'Alterskategorie',
          buildingAge: 'Gebäudealter',
          buildingPeriod: 'Bauperiode',
          comparison: 'Vergleich',
          constructionDates: 'Baudaten',
          constructionYear: 'Baujahr',
          lastRenovation: 'Letzte Renovation',
          neighborhoodAverage: 'Nachbarschaftsdurchschnitt',
          noRecord: 'Keine Aufzeichnung',
          numberOfPhases: 'Anzahl Phasen',
          phases: 'Phasen',
          renovationPeriod: 'Renovierungsperiode',
          renovationStatus: 'Renovierungsstatus',
          singlePhaseConstruction: 'Einphasige Konstruktion',
          thisBuilding: 'Dieses Gebäude',
          yearsSinceRenovation: 'Jahre seit Renovation',
        },
        noDataMessage: 'Keine Bau-Zeitachsen-Daten verfügbar',
        phaseLabels: {
          noRecord: 'Keine Aufzeichnung',
          singlePhase: 'Einphasige Konstruktion',
        },
        renovationStatuses: {
          considerUpdates: 'Aktualisierungen empfohlen',
          goodCondition: 'Guter Zustand',
          noRenovation: 'Keine Renovation',
          recentlyRenovated: 'Kürzlich renoviert',
          renovationNeeded: 'Renovation erforderlich',
        },
      },
    },
    filters: {
      buildingDetails: {
        buildingVolume: 'Gebäudevolumen oberirdisch (m³)',
        grossFloorArea: 'Bruttogeschossfläche (m²)',
        groundingArea: 'Grundfläche (m²)',
        height: 'Höhe',
        numberOfFloors: 'Anzahl Stockwerke',
        numberOfUnits: 'Anzahl Einheiten',
        title: 'Gebäudedetails',
      },
      buildingHistory: {
        buildingPeriod: 'Bauperiode',
        renovationPeriod: 'Renovierungsperiode',
        title: 'Gebäudegeschichte',
        yearOfConstruction: 'Baujahr',
        yearOfRenovation: 'Renovierungsjahr',
      },
      buildingType: {
        buildingCategory: 'Gebäudekategorie (GWR)',
        buildingClass: 'Gebäudeklasse (GWR)',
        classifications: {
          garage: 'Garage',
          industrial: 'Industriell',
          mixed1: 'Gemischt 1',
          mixed2: 'Gemischt 2',
          notClassified: 'Nicht klassifiziert',
          offices: 'Büros',
          other: 'Andere',
          public: 'Öffentlich',
          residential: 'Wohngebäude',
          retail: 'Einzelhandel',
        },
        constructionType: 'Bautyp',
        constructionTypes: {
          normal: 'Normal',
          projected: 'Geplant',
          underground: 'Unterirdisch',
        },
        hasCivilProtectionShelter: 'Hat Zivilschutzunterstand',
        popetyClassification: 'Popety.io Klassifizierung',
        protectedRank: 'Schutzrang',
        title: 'Gebäudetyp',
      },
      energy: {
        idc: 'IDC - MJ/m²/Jahr',
        mainHeaterGenerator: 'Hauptwärmeerzeuger',
        mainHeatingEnergySource: 'Hauptenergiequelle Heizung',
        mainHotWaterEnergySource: 'Hauptenergiequelle Warmwasser',
        mainHotWaterGenerator: 'Hauptwarmwassererzeuger',
        minergieLabel: 'Minergie-Label',
        title: 'Energie, Heizung & Warmwasser',
      },
      environmental: {
        distanceToPowerlines: 'Abstand zu Hochspannungsleitungen',
        lakeView: 'Seesicht',
        lakeViewArea: {
          large: 'Über 100 ha',
          none: '0 ha',
          small: '0 bis 100 ha',
        },
        mountainView: 'Bergsicht',
        mountainViewQuality: {
          few: '0 bis 4 Gipfel',
          many: 'Über 13 Gipfel',
          some: '5 bis 13 Gipfel',
        },
        noiseExposure: 'Lärmbelastung',
        noiseExposureLevels: {
          high: 'Über 52 dB',
          low: 'Bis 45 dB',
          medium: '45 bis 52 dB',
        },
        powerlineDistance: {
          close: '0 bis 100m',
          far: 'Über 100m',
        },
        publicTransportQuality: 'ÖV-Qualität',
        slope: 'Neigung',
        slopeLevels: {
          flat: '0 bis 4 Grad',
          moderate: '4 bis 9 Grad',
          steep: 'Über 9 Grad',
        },
        taxBurden: 'Steuerlast',
        taxBurdenLevels: {
          high: 'Hoch (über 7,1%)',
          medium: 'Mittel (5,1% bis 7,1%)',
          small: 'Klein (0 bis 5,1%)',
        },
        title: 'Umweltmerkmale',
        transportQuality: {
          badly: 'Schlecht erschlossen',
          medium: 'Mittelmässig erschlossen',
          veryBadly: 'Sehr schlecht erschlossen',
          veryWell: 'Sehr gut erschlossen',
          well: 'Gut erschlossen',
        },
        travelTime: {
          long: 'Lang',
          medium: 'Mittel',
          short: 'Kurz',
        },
        travelTimeToCenters: 'Reisezeit zu Zentren',
      },
      history: {
        buildingPermitNumber: 'Anzahl Baubewilligungen',
        buildingPermitsClassification: 'Klassifizierung Baubewilligungen',
        buildingPermitsDate: 'Datum Baubewilligungen',
        listingRentNumber: 'Anzahl Mietinserate',
        listingSaleNumber: 'Anzahl Verkaufsinserate',
        listingsListingDate: 'Inseratsdatum',
        listingsPrice: 'Inseratspreis',
        listingsPricePerSquareMeter: 'Inseratspreis pro Quadratmeter',
        listingsRentDate: 'Mietinserate Datum',
        listingsRentDateTooltip: 'Zeitraum, in dem Immobilien zur Miete angeboten wurden. Finden Sie kürzlich inserierte Mietobjekte.',
        listingsSaleDate: 'Verkaufsinserate Datum',
        listingsSaleDateTooltip: 'Zeitraum, in dem Immobilien zum Verkauf angeboten wurden. Finden Sie kürzlich inserierte Verkaufsobjekte.',
        permitClassifications: {
          development: 'Entwicklung',
          other: 'Andere',
        },
        title: 'Verlauf',
        transactionsDate: 'Transaktionsdatum',
        transactionsNumber: 'Anzahl Transaktionen',
        transactionsPrice: 'Transaktionspreis',
      },
      solar: {
        averageSolarRadiation: 'Durchschnittliche Solarstrahlung (kWh/m²/Jahr)',
        electricPotential: 'Elektrisches Potenzial (kWh/Jahr)',
        heatPotential: 'Wärmepotenzial (kWh/Jahr)',
        installationDate: 'Installationsdatum',
        installedPower: 'Installierte Leistung (kW)',
        roofArea: 'Dachfläche (m²)',
        roofPitch: 'Dachneigung (°)',
        title: 'Solarenergie',
        totalSolarRadiation: 'Gesamtsolarstrahlung (kWh/Jahr)',
      },
      user: {
        loadingTags: 'Tags werden geladen...',
        myTags: 'Meine Tags',
        noTagsAvailable: 'Keine Tags verfügbar. Erstellen Sie Tags im Gebäudedetail-Panel.',
        title: 'Benutzerfilter',
      },
    },
    sidebar: {
      items: {
        amenities: 'Einrichtungen',
        buildingPermits: 'Baugenehmigungen',
        characteristics: 'Gebäudemerkmale',
        demographics: 'Demografie',
        employment: 'Beschäftigung',
        energy: 'Energie',
        feasibilityStudy: 'Machbarkeitsstudie',
        history: 'Geschichte',
        land: 'Grundstück',
        noiseAnalysis: 'Lärmanalyse',
        potential: 'Aufstockungspotenzial',
        purchaseListings: 'Kaufinserate',
        purchaseMarket: 'Kaufmarkt',
        rentalListings: 'Mietinserate',
        rentalMarket: 'Mietmarkt',
        summary: 'Zusammenfassung',
        sunlightStudy: 'Sonnenlichtanalyse',
        transactions: 'Transaktionen',
        transportAccess: 'Verkehr & Erreichbarkeit',
        units: 'Einheitendetails',
      },
      sections: {
        elevation: 'Aufstockung',
        environment: 'Umgebung',
        market: 'Markt',
        overview: 'Übersicht',
        socialEconomic: 'Soziales & Wirtschaft',
      },
    },
    transactionsTab: {
      filters: {
        additionalFilters: 'Zusätzliche Filter',
        advancedFilters: 'Erweiterte Filter',
        allLocations: 'Alle Standorte',
        clearAll: 'Alle löschen',
        hideFilters: 'Filter ausblenden',
        landArea: 'Grundstücksfläche (m²)',
        legalTypeBF: 'B-F',
        legalTypeCOP: 'COP',
        legalTypeDDP: 'DDP',
        legalTypeDP: 'DP',
        legalTypeOther: 'Andere',
        legalTypePPE: 'PPE',
        numberOfBuyers: 'Anzahl der Käufer',
        numberOfSellers: 'Anzahl der Verkäufer',
        others: 'Andere',
        participantAssociation: 'Verein',
        participantCompany: 'Unternehmen',
        participantCooperative: 'Genossenschaft',
        participantFoundation: 'Stiftung',
        participantIndividual: 'Privatperson',
        participantOther: 'Andere',
        participantPublicEntity: 'Öffentliche Einrichtung',
        participants: 'Teilnehmer',
        participantType: 'Teilnehmertyp',
        propertyLegalType: 'Rechtlicher Eigentumstyp',
        radius: 'Radius',
        showFilters: 'Filter anzeigen',
        stepTransactionPrice: 'Schrittweiser Transaktionspreis (CHF)',
        transactionDate: 'Transaktionsdatum',
        transactionType: 'Transaktionstyp',
        typeAreaPrice: 'Typ, Fläche & Preis',
        unitApartment: 'Wohnung',
        unitCommercial: 'Gewerblich',
        unitHouse: 'Haus',
        unitLand: 'Grundstück',
        unitOther: 'Andere',
        unitParking: 'Parkplatz',
        unitType: 'Einheitstyp',
      },
      subtitle: 'Erkunden Sie die Transaktionshistorie rund um das Gebäude und speichern Sie die für diese Analyse interessanten.',
      tabs: {
        aroundBuilding: 'Transaktionen rund um das Gebäude',
        saved: 'Gespeicherte Transaktionen',
      },
      title: 'Transaktionen',
    },
    unitDetails: {
      actions: {
        addFirstUnit: 'Erste Einheit hinzufügen',
        addUnit: 'Einheit hinzufügen',
        cancel: 'Abbrechen',
        edit: 'Bearbeiten',
        save: 'Speichern',
        saving: 'Speichern...',
      },
      common: {
        chf: 'CHF',
        minMax: 'min-max',
        na: 'K.A.',
        squareMeters: 'm²',
      },
      entrance: {
        egid: 'EGID:',
        floorsCount: '{{count}} Stockwerke',
        floorsCountOne: '{{count}} Stockwerk',
        mainEntrance: 'Haupteingang',
        unitsCount: '{{count}} Einheiten',
        unitsCountOne: '{{count}} Einheit',
      },
      floor: {
        basement: 'Untergeschoss {{level}}',
        floorNumber: '{{number}}. Stock',
        groundFloor: 'Erdgeschoss',
      },
      metrics: {
        dwellingArea: 'Wohnfläche',
        floors: 'Stockwerke',
        footprint: 'Grundfläche',
        units: 'Einheiten',
      },
      multipleFloor: {
        no: 'Nein',
        yes: 'Ja',
      },
      states: {
        error: 'Fehler beim Laden der Einheitendetails:',
        loading: 'Einheitendetails werden geladen...',
        loadingConfigurations: 'Wohnungskonfigurationen werden geladen...',
        noBuilding: 'Keine Gebäudedaten verfügbar',
        noUnits: 'Keine Einheitendetails für dieses Gebäude verfügbar',
        noUnitsOnFloor: 'Keine Einheiten auf diesem Stockwerk',
      },
      subtitle: 'Umfassende Aufschlüsselung aller Einheiten nach Eingang und Stockwerk',
      table: {
        headers: {
          adminNo: 'ADMIN NR.',
          area: 'FLÄCHE',
          bathrooms: 'BÄDER',
          cYear: 'BAUJAHR',
          edid: 'EDID',
          fid: 'F.ID',
          multiFloor: 'MEHR. ST.',
          rentalValue: 'MONATLICHER MIETWERT',
          rooms: 'ZIMMER',
          type: 'TYP',
        },
      },
      title: 'Einheitendetails',
      unitTypes: {
        residential: 'Wohnung',
        roomCount: '{{count}} Zimmer',
        roomPlural: 'Zimmer',
        roomsCount: '{{count}} Zimmer',
        roomSingular: 'Zimmer',
      },
      validation: {
        areaPositive: 'Die Fläche muss positiv sein',
        bathroomsPositive: 'Die Anzahl der Badezimmer muss positiv sein',
        constructionDateFuture: 'Das Baudatum kann nicht in der Zukunft liegen',
        roomNumberRange: 'Die Zimmerzahl muss zwischen 1 und 10 liegen',
      },
    },
  },
  charts: {
    actions: {
      saveAsImage: 'Als Bild speichern',
    },
    categories: {
      apartment: 'Wohnung',
      apartmentTrend: 'Wohnungstrend',
      house: 'Haus',
      houseTrend: 'Haustrend',
    },
    common: {
      averageValue: 'Durchschnittswert',
      avgPrice: 'Durchschnittspreis',
      concentrated: 'konzentriert',
      consistency: 'Konsistenz',
      decrease: 'Rückgang',
      decreased: 'gesunken',
      decreases: 'sinkt',
      discount: 'einen Abschlag von',
      distributed: 'verteilt',
      downward: 'abwärts',
      exponential: 'exponentiell',
      gradual: 'allmähliche',
      high: 'hohe',
      higher: 'höher',
      increase: 'Anstieg',
      increased: 'gestiegen',
      increases: 'steigt',
      lessExpensive: 'günstiger',
      limited: 'begrenzt',
      linear: 'linear',
      low: 'geringe',
      lower: 'niedriger',
      moderate: 'moderate',
      mom: 'MüM',
      moreExpensive: 'teurer',
      noData: 'Keine Daten verfügbar',
      otherRegions: 'andere Regionen',
      smallestPremium: 'den kleinsten Aufschlag bei',
      stable: 'stabil',
      steep: 'steile',
      strong: 'stark',
      strongUpward: 'stark aufwärts',
      totalTransactions: 'Transaktionen insgesamt',
      totalValue: 'Gesamtwert',
      totalVolume: 'Gesamtvolumen',
      transactionCount: 'Anzahl Transaktionen',
      transactions: 'Transaktionen',
      variation: 'Variation',
      weak: 'schwach',
      yoy: 'JüJ',
    },
    empty: {
      newVsResale: 'Keine Neubau vs. Bestand Daten für die ausgewählten Filter verfügbar.',
      priceEvolution: 'Für die ausgewählten Filter sind keine Preisentwicklungsdaten verfügbar. Bitte passen Sie Ihre Suchkriterien an.',
      pricePerRoom: 'Für die ausgewählten Filter sind keine Preis-pro-Zimmer-Daten verfügbar. Bitte passen Sie Ihre Suchkriterien an.',
      pricePerSqmPerRoom: 'Für die ausgewählten Filter sind keine Preis/m²-pro-Zimmer-Daten verfügbar. Bitte passen Sie Ihre Suchkriterien an.',
      rentEvolution: 'Für die ausgewählten Filter sind keine Mietentwicklungsdaten verfügbar. Bitte passen Sie Ihre Suchkriterien an.',
      rentPerRoom: 'Für die ausgewählten Filter sind keine Miete-pro-Zimmer-Daten verfügbar. Bitte passen Sie Ihre Suchkriterien an.',
      rentPerSqmPerRoom: 'Für die ausgewählten Filter sind keine Miete/m²-pro-Zimmer-Daten verfügbar. Bitte passen Sie Ihre Suchkriterien an.',
      title: 'Keine Daten verfügbar',
    },
    geographicDistribution: {
      activeCantons: 'Aktive Kantone',
      avg: 'Durch',
      avgTransactionPrice: 'Durchschn. Transaktionspreis',
      topCitiesByVolume: 'Top-Städte nach Transaktionsvolumen',
      totalMarketVolume: 'Gesamtmarktvolumen',
      transactionsByCanton: 'Transaktionen nach Kanton',
    },
    inheritanceFlow: {
      donation: 'Schenkung',
      flowAnalysis: 'Erbschaftsflussanalyse',
      flowAnalysisSubtext: 'Vermögensübertragung von Verkäufern zu Käufern nach Immobilientyp',
      heritage: 'Erbschaft',
      inheritanceOverTime: 'Erbschaftstransaktionen im Zeitverlauf',
      inheritanceOverTimeSubtext: 'Quartalstrends nach Transaktionstyp',
      noData: 'Keine Erbschaftsdaten verfügbar',
      partage: 'Teilung',
      shareDistribution: 'Anteilsverteilungsanalyse',
      shareDistributionSubtext: 'Eigentumsanteilsmuster bei Übertragungen',
    },
    insights: {
      agency: {
        marketConcentration: 'Marktkonzentration',
        performanceDistribution: 'Leistungsverteilung',
        valueDistribution: 'Wertverteilung',
      },
      bestPerformer: 'Beste Leistung',
      bestValue: 'Beste Preis-Leistung',
      city: {
        cityPriceRange: 'Preisspanne nach Stadt',
        marketActivity: 'Marktaktivität',
        marketDistribution: 'Marktverteilung',
        premiumSegment: 'Premium-Segment',
        priceConsistency: 'Preiskonsistenz',
      },
      descriptions: {
        agency: {
          marketConcentration: 'Die Top 5 Agenturen kontrollieren {{percentage}}% des Marktes mit insgesamt {{count}} Angeboten.',
          performanceDistribution: 'Mit durchschnittlich {{avgListings}} Angeboten pro Agentur zeigt der Markt eine {{distribution}} Verteilung über {{count}} Agenturen.',
          valueDistribution: 'Die Top 10 Agenturen nach Portfoliowert verwalten {{percentage}}% des Gesamtmarktwerts von {{value}}.',
        },
        city: {
          cityPriceRange: 'Der Preis pro m² variiert um {{variation}}% zwischen {{cityHigh}} ({{priceHigh}}) und {{cityLow}} ({{priceLow}}).',
          marketActivity: 'Die Top 5 Städte nach Volumen repräsentieren {{percentage}}% aller Angebote, mit {{topCity}} an der Spitze mit {{topCount}} Immobilien.',
          marketDistribution: '{{count}} Städte haben Preise über dem Durchschnitt von {{average}}, was {{percentage}}% der analysierten Standorte ausmacht.',
          premiumSegment: '{{city}} hat den stärksten Premium-Markt mit {{percentage}}% der Angebote über {{threshold}}.',
          priceConsistency: '{{city}} zeigt die konstantesten Preise mit {{stdDev}} Standardabweichung im Preis/m².',
        },
        geography: {
          marketConcentration: 'Die Top-3-Märkte machen {{percentage}}% aller Angebote aus, was auf eine {{concentration}} Marktkonzentration hinweist.',
          nationalBenchmark: '{{count}} von {{total}} Standorten haben Preise über dem nationalen Durchschnitt von {{average}}.',
          priceM2Consistency: 'Der Preis pro m² zeigt {{consistency}} über die Regionen mit einem Variationskoeffizienten von {{variation}}%.',
          regionalPriceDisparity: '{{location1}} ist {{priceDiff}}% teurer als {{location2}}, was erhebliche regionale Preisunterschiede zeigt.',
          valueDensityLeader: '{{location}} hat den höchsten Preis pro m² bei {{priceM2}} und führt den Markt in der Wertdichte.',
        },
        newVsResale: {
          constructionPremiumNegative: 'Neubauten werden mit einem Abschlag von {{discount}}% verkauft mit einem {{priceType}} Preis/m² von {{newPrice}} im Vergleich zu {{existingPrice}} für Bestandsimmobilien.',
          constructionPremiumPositive: 'Neubauten erzielen einen Aufschlag von {{premium}}% mit einem {{priceType}} Preis/m² von {{newPrice}} im Vergleich zu {{existingPrice}} für Bestandsimmobilien.',
          marketComposition: 'Neubauten machen {{newPercentage}}% des Marktes mit {{totalNew}} Angeboten aus, während Bestandsimmobilien mit {{existingPercentage}}% und {{totalExisting}} Angeboten dominieren.',
          marketTrendChanged: 'Der Marktanteil von Neubauten ist von {{startPeriod}} bis {{endPeriod}} um {{change}} Prozentpunkte {{direction}}.',
          marketTrendStable: 'Der Marktanteil von Neubauten ist von {{startPeriod}} bis {{endPeriod}} stabil geblieben.',
          premiumVariations: '{{highCategory}}-Immobilien zeigen den höchsten Neubauaufschlag mit {{highPremium}}%, während {{lowCategory}}-Immobilien {{lowPremiumText}} haben.',
          regionalActivity: '{{topRegion}} führt die Neubauaktivität mit {{topPercentage}}% der Angebote als Neubauten an, gefolgt von {{secondRegion}}. Der Durchschnitt aller Regionen beträgt {{avgPercentage}}%.',
        },
        portal: {
          geographicReach: 'Portale sind in durchschnittlich {{avgRegions}} Regionen aktiv, wobei {{topPortal}} mit {{topRegions}} Regionen die grösste Reichweite hat.',
          marketEfficiency: 'Die Top 10 Portale bearbeiten {{percentage}}% aller Angebote, was eine {{efficiency}} Markteffizienz zeigt.',
          portalEcosystem: 'Der Markt besteht aus {{large}} grossen Portalen (>{{threshold}} Angebote), {{medium}} mittleren und {{small}} kleinen Portalen.',
          portalMarketConcentration: 'Die Top 5 Portale kontrollieren {{percentage}}% des Marktes mit insgesamt {{count}} Angeboten.',
          pricePositioning: 'Der Durchschnittspreis über alle Portale beträgt {{avgPrice}}, wobei {{highPortal}} am höchsten bei {{highPrice}} positioniert ist.',
        },
        priceEvolution: {
          bestPerformer: '{{category}}-Immobilien zeigen das stärkste Wachstum mit {{growth}}% und übertreffen andere Marktkategorien.',
          marketStability: '{{category}} zeigt die stabilsten Preise mit nur {{volatility}}% Variation, was auf konstante Marktbedingungen hinweist.',
          marketTrend: 'Der Gesamtmarkt ist im analysierten Zeitraum um {{change}}% {{direction}}, mit {{priceType}} Preisen von {{startPrice}} auf {{endPrice}}.',
          recentMomentum: 'Das letzte Jahr zeigt {{momentum}} Dynamik mit Preisen, die um {{change}}% {{direction}} sind im Vergleich zur Vorperiode.',
        },
        priceM2PerRoom: {
          bestValue: '{{rooms}}-Zimmer-{{category}} bieten das beste Preis/m²-Verhältnis bei {{priceM2}} und repräsentieren die optimale Wertdichte am Markt.',
          marketSweetSpot: '{{rooms}}-Zimmer-{{category}} dominieren den Markt mit {{count}} Angeboten bei einem Durchschnitt von {{priceM2}}/m².',
          priceM2Trend: 'Der Preis/m² {{direction}} um etwa {{change}} pro zusätzlichem Zimmer bei {{category}}.',
          propertyTypePremium: 'Häuser haben im Durchschnitt {{premium}}% {{comparison}} Preis/m² als Wohnungen.',
        },
        pricePerRoom: {
          bestValue: '{{rooms}}-Zimmer-{{category}} bieten den besten Wert bei {{price}} pro Immobilie und repräsentieren das optimale Preis-Raum-Verhältnis am Markt.',
          marketSweetSpot: '{{rooms}}-Zimmer-{{category}} sind die häufigste Konfiguration mit {{count}} Angeboten und repräsentieren {{percentage}}% des Marktes.',
          priceProgression: 'Jedes zusätzliche Zimmer bei {{category}} erhöht den Preis um etwa {{increment}}, was eine {{pattern}} Preissteigerung zeigt.',
          propertyTypePremium: 'Häuser sind im Durchschnitt {{premium}}% {{comparison}} als Wohnungen über alle Zimmerkonfigurationen hinweg.',
        },
      },
      geography: {
        marketConcentration: 'Marktkonzentration',
        nationalBenchmark: 'Nationaler Vergleichswert',
        priceM2Consistency: 'Preis/m² Konsistenz',
        regionalPriceDisparity: 'Regionale Preisunterschiede',
        valueDensityLeader: 'Führend bei Wertdichte',
      },
      keyInsights: 'Wichtige Erkenntnisse',
      marketStability: 'Marktstabilität',
      marketSweetSpot: 'Markt-Optimum',
      marketTrend: 'Markttrend',
      newVsResale: {
        constructionPremium: 'Neubauprämie',
        marketComposition: 'Marktzusammensetzung',
        premiumVariations: 'Prämienvariationen',
        regionalActivity: 'Regionale Aktivität',
      },
      portal: {
        geographicReach: 'Geografische Reichweite',
        marketEfficiency: 'Markteffizienz',
        portalEcosystem: 'Portal-Ökosystem',
        portalMarketConcentration: 'Marktkonzentration der Portale',
        pricePositioning: 'Preispositionierung',
      },
      priceM2Trend: '{{category}} Preis/m² Trend',
      priceProgression: '{{category}} Preisentwicklung',
      propertyTypePremium: 'Immobilientyp-Aufschlag',
      recentMomentum: 'Jüngste Dynamik',
    },
    kpis: {
      averagePrice: 'Durchschnittspreis',
      averagePricePerSqm: 'Durchschnittspreis/m²',
      averagePricePerSqmPerRoom: 'Durchschn. Preis/m² pro Zimmer',
      averageRent: 'Durchschnittsmiete',
      averageRentPerSqm: 'Durchschnittsmiete/m²',
      averageRentPerSqmPerRoom: 'Durchschn. Miete/m² pro Zimmer',
      averageRooms: 'Durchschnittliche Zimmer',
      avgPricePerRoom: 'Durchschn. Preis pro Zimmer',
      avgRentPerRoom: 'Durchschn. Miete pro Zimmer',
      marketVolume: 'Marktvolumen',
      medianPrice: 'Medianpreis',
      medianPricePerRoom: 'Medianpreis pro Zimmer',
      medianPricePerSqm: 'Medianpreis/m²',
      medianPricePerSqmPerRoom: 'Medianpreis/m² pro Zimmer',
      medianRent: 'Medianmiete',
      medianRentPerRoom: 'Medianmiete pro Zimmer',
      medianRentPerSqm: 'Medianmiete/m²',
      medianRentPerSqmPerRoom: 'Medianmiete/m² pro Zimmer',
      mostExpensive: 'Teuerste Kategorie',
      priceAllTypes: '{{priceType}} Preis (Alle Typen)',
      rentAllTypes: '{{priceType}} Miete (Alle Typen)',
      totalListings: 'Gesamtangebote',
      yearGrowth: 'Wachstum 1 Jahr',
    },
    labels: {
      allRooms: 'Alle Zimmer',
      allTypes: 'Alle Typen',
      count: 'Anzahl',
      listings: 'Angebote',
      notAvailable: 'k.A.',
      numberOfListings: 'Anzahl Angebote',
      numberOfRooms: 'Anzahl Zimmer',
      percentage: 'Prozent (%)',
      percentile10: '10. Perzentil',
      percentile10Short: '10. %',
      percentile30: '30. Perzentil',
      percentile30Short: '30. %',
      percentile50Median: '50. Perzentil (Median)',
      percentile50Short: '50. % (Median)',
      percentile70: '70. Perzentil',
      percentile70Short: '70. %',
      percentile90: '90. Perzentil',
      percentile90Short: '90. %',
      price: 'Preis',
      priceChf: 'Preis (CHF)',
      pricePerM2Chf: 'Preis pro m² (CHF)',
      propertyType: 'Immobilientyp',
      range: 'Bereich',
      rent: 'Miete',
      rentChf: 'Miete (CHF)',
      rentPerM2Chf: 'Miete pro m² (CHF)',
      rooms: 'Zimmer',
      stdDev: 'Std. Abw.',
    },
    marketTiming: {
      activityCalendar: 'Marktaktivitätskalender',
      activityCalendarSubtext: 'Transaktionsvolumen nach Tag',
      avgLagDays: 'Durchschnittliche Verzögerung (Tage)',
      monthlyActivity: 'Monatliche Transaktionsaktivität',
      monthlyActivitySubtext: 'Transaktionsvolumen im Zeitverlauf',
      noActivity: 'Keine Aktivität',
      noData: 'Keine Markttimingdaten verfügbar',
      numberOfTransactions: 'Anzahl Transaktionen',
      publicationLag: 'Veröffentlichungsverzögerungsanalyse',
      publicationLagSubtext: 'Durchschnittliche Tage zwischen Transaktion und Veröffentlichung',
    },
    newVsResale: {
      kpis: {
        newShare: 'Neubauanteil',
        premium: 'Neubauprämie',
        priceExisting: '{{priceType}} {{priceUnit}} - Bestand',
        priceNew: '{{priceType}} {{priceUnit}} - Neu',
      },
      legends: {
        existingProperties: 'Bestandsimmobilien',
        newConstruction: 'Neubau',
      },
      titles: {
        activity: 'Neubauaktivität in {{location}}',
        composition: 'Marktzusammensetzung: Neubau vs Bestand im Zeitverlauf',
        premium: '{{priceType}}-Prämie für Neubau nach Immobilienkategorie',
      },
      tooltips: {
        existing: 'Bestand',
        new: 'Neubau',
        premiumLabel: 'Prämie',
        total: 'Gesamt',
      },
    },
    participantDemographics: {
      buyersByGender: 'Käufer nach Geschlecht',
      companies: 'Unternehmen',
      companyParticipants: 'Unternehmen',
      female: 'Weiblich',
      genderDistributionOverTime: 'Geschlechterverteilung der Käufer im Zeitverlauf',
      genderParity: '50% Geschlechterparität',
      individualParticipants: 'Einzelpersonen',
      individuals: 'Privatpersonen',
      male: 'Männlich',
      participantTypesByLegalForm: 'Teilnehmertypen nach Rechtsform',
      personVsCompany: 'Privatpersonen vs Unternehmen',
      sellersByGender: 'Verkäufer nach Geschlecht',
      totalBuyers: 'Käufer insgesamt',
      totalSellers: 'Verkäufer insgesamt',
    },
    priceDynamics: {
      avgTransactionPrice: 'Durchschn. Transaktionspreis',
      priceByPropertyType: 'Preis nach Immobilientyp',
      priceDistribution: 'Preisverteilung',
      priceVelocityIndex: 'Preisgeschwindigkeitsindex',
      totalMarketVolume: 'Gesamtmarktvolumen',
      yearlyMarketVolume: 'Jährliches Marktvolumen',
    },
    priceM2PerRoom: {
      titles: {
        distribution: '{{priceType}} Verteilung nach Zimmern',
        roomCountVsPrice: 'Zimmeranzahl vs {{priceType}} Preis/m²',
        roomCountVsRent: 'Zimmeranzahl vs {{priceType}} Miete/m²',
      },
      tooltips: {
        listings: 'Angebote',
        price: '{{priceType}} Preis/m²',
        range: 'Spanne',
        rent: '{{priceType}} Miete/m²',
        rooms: 'Zimmer',
        stdDev: 'Std. Abw.',
      },
    },
    priceTypes: {
      average: 'Durchschnitt',
      median: 'Median',
    },
    propertyCharacteristics: {
      avgSurfaceArea: 'Durchschnittliche Fläche (m²)',
      complexityIndex: 'Gebäudekomplexitätsindex',
      complexityIndexSubtext: 'Preis und Fläche nach Stockwerksanzahl',
      noData: 'Keine Immobilienmerkmaldaten verfügbar',
      numberOfFloors: 'Anzahl Stockwerke',
      performanceMatrix: 'Leistungsmatrix nach Immobilientyp',
      performanceMatrixSubtext: 'Durchschnittliche Fläche vs Durchschnittspreis',
    },
    seasonalPatterns: {
      averageTransactionCount: 'Durchschnittliche Transaktionsanzahl',
      month: 'Monat',
      monthlyActivity: 'Monatliche Transaktionsaktivität',
      monthlyActivitySubtext: 'Volumen- und Werttrends nach Monat',
      noData: 'Keine saisonalen Musterdaten verfügbar',
      quarterlyComparison: 'Quartalsvergleich',
      quarterlyComparisonSubtext: 'Transaktionsvolumen nach Quartal',
      seasonalPatterns: 'Saisonale Muster',
      seasonalPatternsSubtext: 'Durchschnittliche Aktivität nach Monat über alle Jahre',
    },
    states: {
      loading: 'Daten werden geladen...',
      loadingNewVsResale: 'Lade Neubau vs. Bestand Daten...',
      loadingPriceM2PerRoom: 'Lade Preis/m² pro Zimmer Daten...',
      loadingPricePerRoom: 'Lade Preis pro Zimmer Daten...',
    },
    titles: {
      priceByRooms: 'Preisverteilung nach Zimmern',
      priceDistribution: 'Preisverteilung nach Quantilen',
      priceDistributionByQuantiles: 'Preisverteilung nach Quantilen',
      priceEvolution: 'Preisentwicklung nach Immobilientyp',
      priceEvolutionByType: 'Preisentwicklung nach Immobilientyp',
      priceM2Distribution: 'Preis/m² Verteilung nach Quantilen',
      rentByRooms: 'Mietverteilung nach Zimmern',
      rentDistribution: 'Mietverteilung nach Quantilen',
      rentDistributionByQuantiles: 'Mietverteilung nach Quantilen',
      rentEvolution: 'Mietentwicklung nach Immobilientyp',
      rentEvolutionByType: 'Mietentwicklung nach Immobilientyp',
      rentM2Distribution: 'Miete/m² Verteilung nach Quantilen',
      roomCountVsPrice: 'Zimmeranzahl vs {{priceType}} Preis',
      roomCountVsRent: 'Zimmeranzahl vs {{priceType}} Miete',
    },
    titlesM2: {
      priceDistributionByRooms: 'Preis/m² Verteilung nach Zimmern',
      rentDistributionByRooms: 'Miete/m² Verteilung nach Zimmern',
      roomCountVsPrice: 'Zimmeranzahl vs {{priceType}} Preis/m²',
    },
    transactionType: {
      distributionTitle: 'Verteilung nach Transaktionstyp',
      dominantType: 'Dominanter Typ',
      trendsTitle: 'Zeitliche Entwicklung',
    },
    unitComposition: {
      averageArea: 'Durchschnittliche Fläche',
      noData: 'Keine Einheitenzusammensetzungsdaten verfügbar',
      numberOfRooms: 'Anzahl Zimmer',
      numberOfUnits: 'Anzahl Einheiten',
      room: 'Zimmer',
      roomDistribution: 'Zimmerverteilung',
      roomDistributionSubtext: 'Anzahl Einheiten nach Zimmerzahl',
      rooms: 'Zimmer',
      units: 'Einheiten',
      unitTypeComposition: 'Einheitentypenzusammensetzung',
      unitTypeCompositionSubtext: 'Grösse entspricht Einheitenanzahl, Farbe entspricht durchschnittlicher Fläche',
    },
    views: {
      absolute: 'Absolute Preise',
      growth: 'Jahreswachstum %',
      index: 'Preisindex (Basis 100)',
      quantile: 'Quantilverteilung',
    },
    viewTypes: {
      percentage: 'Prozentansicht',
      sideBySide: 'Nebeneinander',
      stacked: 'Gestapelte Ansicht',
    },
  },
  common: {
    about: 'Über',
    app_description: 'Öffentliche Immobilienanalyse',
    app_name: 'Popety.io',
    attachments: {
      clearSearch: 'Suche löschen',
      filesEmptyDescription: 'Zu dieser Analyse wurde keine Datei hinzugefügt.',
      filesEmptyTitle: 'Keine Dateien',
      noResultsDescription: 'Versuchen Sie eine andere Suche.',
      noResultsTitle: 'Keine Ergebnisse',
      notesEmptyDescription: 'Zu dieser Analyse wurde keine Notiz hinzugefügt.',
      notesEmptyTitle: 'Keine Notizen',
      searchNotes: 'Notizen suchen...',
    },
    back: 'Zurück',
    buildingPermits: {
      saved: {
        approved: 'Genehmigt',
        buildingPermits: 'Baugenehmigungen',
        emptyDescription: 'Speichern Sie Baugenehmigungen aus dem Tab "Baugenehmigungen" zum späteren Vergleich',
        emptyTitle: 'Noch keine gespeicherten Baugenehmigungen',
        loading: 'Gespeicherte Baugenehmigungen werden geladen...',
        mostCommonCategory: 'Häufigste Kategorie',
        permits: 'Genehmigungen',
        totalSaved: 'Gesamt gespeichert',
      },
    },
    cancel: 'Abbrechen',
    close: 'Schliessen',
    contact: 'Kontakt',
    download: 'Herunterladen',
    error: 'Fehler',
    error_loading_data: 'Fehler beim Laden der Daten',
    export: 'Exportieren',
    fields: {
      access_quality: 'Zugangsqualität',
      buildable_area: 'Bebaubare Fläche',
      building_type: 'Gebäudetyp',
      canton: 'Kanton:',
      condition: 'Zustand',
      construction_year: 'Baujahr',
      coordinates: 'Koordinaten',
      description: 'Beschreibung',
      development_potential: 'Entwicklungspotential',
      elevation: 'Höhe:',
      elevator: 'Aufzug',
      energy_efficiency: 'Energieeffizienz',
      energy_rating: 'Energieklasse',
      filters: {
        location: 'Standort',
        price_range: 'Preisspanne',
        property_type: 'Immobilientyp',
      },
      heating_system: 'Heizsystem',
      land_area: 'Grundstücksfläche',
      last_renovation: 'Letzte Renovation',
      latitude: 'Breitengrad:',
      location: 'Standort',
      longitude: 'Längengrad:',
      max_floors: 'Max. Stockwerke',
      municipality: 'Gemeinde',
      parking_spaces: 'Parkplätze',
      postal_code: 'Postleitzahl:',
      propertyType: {
        Commercial: 'Gewerbe',
        Houseappartment: 'Haus/Wohnung',
      },
      slope: 'Neigung:',
      street: 'Strasse:',
      terrain_type: 'Geländetyp',
      total_area: 'Gesamtfläche',
      total_floors: 'Gesamte Stockwerke',
      total_units: 'Gesamte Einheiten',
      utilities: 'Versorgung',
      zone_type: 'Zonentyp',
    },
    filter: 'Filtern',
    help: 'Hilfe',
    languages: {
      english: 'Englisch',
      french: 'Französisch',
      german: 'Deutsch',
      italian: 'Italienisch',
      select_language: 'Sprache auswählen',
    },
    loading: 'Wird geladen...',
    next: 'Weiter',
    no_data_available: 'Keine Daten verfügbar',
    on: 'am',
    overview: {
      address_details: 'Adressdetails',
      building_overview: 'Gebäudeübersicht',
      geographic_information: 'Geografische Informationen',
      key_features: 'Hauptmerkmale',
      land_overview: 'Landübersicht',
      location_information: 'Standortinformationen',
    },
    powered_by: 'Powered by Popety.io',
    privacy: 'Datenschutz',
    refresh: 'Aktualisieren',
    save: 'Speichern',
    scoreModal: {
      methodology: {
        dataAge: 'Einige zugrunde liegende Daten können bis zu 6 Monate alt sein',
        dataSources: 'Datenquellen umfassen Katastereinträge, Zonenvorschriften, geografische Daten und Marktanalysen',
        generalPotential: 'Scores spiegeln allgemeines Potenzial wider, keine garantierten Entwicklungsergebnisse',
        howCalculated: 'Wie die Scores berechnet werden',
        limitations: 'Einschränkungen',
        localRegulations: 'Lokale Vorschriften können zusätzliche Einschränkungen auferlegen, die nicht in den Scores berücksichtigt sind',
        marketConditions: 'Marktbedingungen können sich unabhängig von diesen Kennzahlen ändern',
        range: 'Scores reichen von 0 bis 100, wobei 100 optimal für die Entwicklung ist',
        title: 'Methodik und Einschränkungen',
        weightedCombination: 'Der Entwicklungsscore ist eine gewichtete Kombination der vier einzelnen Kennzahlen',
      },
      overallScore: 'Gesamtscore',
      overallScoreDescription: 'Dieser Score repräsentiert das gesamte Entwicklungspotenzial des Grundstücks, berechnet als gewichtete Kombination der vier einzelnen Kennzahlen im Radardiagramm.',
      scoreBreakdown: 'Score-Aufschlüsselung',
      scores: {
        geometry: {
          description: 'Basierend auf Parzellenform, Fläche, Hangneigung und geografischen Merkmalen, die die Bebaubarkeit und Marktattraktivität beeinflussen.',
          displayLabel: 'Geoform',
          radarLabel: 'Geometrie',
        },
        legacy: {
          description: 'Bewertet die Qualität und den Zustand bestehender Gebäude auf dem Grundstück. Ein höherer Score weist auf weniger Einschränkungen durch bestehende Gebäude hin.',
          displayLabel: 'Bestehend',
          radarLabel: 'Bestand',
        },
        livability: {
          description: 'Misst Lebensqualitätsfaktoren wie Nähe zu Einrichtungen, Zugang zu öffentlichen Verkehrsmitteln und Umweltqualität.',
          displayLabel: 'Umgebung',
          radarLabel: 'Lebensqualität',
        },
        potential: {
          description: 'Zeigt an, wie viel des zulässigen Baupotenzials derzeit ungenutzt ist. Ein höherer Score bedeutet mehr verbleibende Entwicklungsmöglichkeiten.',
          displayLabel: 'Unterausgelastet',
          radarLabel: 'Potenzial',
        },
      },
      scoresUpdated: 'Die Scores werden regelmässig auf Basis der neuesten verfügbaren Daten aktualisiert.',
      title: 'Details zum Entwicklungsscore',
    },
    search: 'Suchen',
    settings: 'Einstellungen',
    shared_by: 'von {{name}}',
    shared_on: 'Geteilt am {{date}}',
    sidebar: {
      items: {
        amenities: 'Einrichtungen',
        buildingCharacteristics: 'Gebäudemerkmale',
        buildingDetails: 'Gebäudedetails',
        buildingPermits: 'Baugenehmigungen',
        demographics: 'Demografie',
        electricity: 'Elektrizität',
        employment: 'Beschäftigung',
        energy: 'Energie',
        feasibilityStudy: 'Machbarkeitsstudie',
        files: 'Dateien',
        geoAnalysis: 'Geo-Analyse',
        history: 'Geschichte',
        noiseAnalysis: 'Lärmanalyse',
        notes: 'Notizen',
        purchaseListings: 'Kaufinserate',
        purchaseMarket: 'Kaufmarkt',
        rentalListings: 'Mietinserate',
        rentalMarket: 'Mietmarkt',
        restrictions: 'Einschränkungen',
        summary: 'Zusammenfassung',
        sunlightStudy: 'Sonnenlichtanalyse',
        taxes: 'Steuern',
        transactions: 'Transaktionen',
        transportAccess: 'Verkehr & Erreichbarkeit',
        unitDetails: 'Einheitendetails',
        zoningRules: 'Zonenvorschriften',
      },
      sections: {
        development: 'Entwicklung',
        environment: 'Umgebung',
        market: 'Markt',
        overview: 'Übersicht',
        socialEconomic: 'Soziales & Wirtschaft',
      },
    },
    sort: 'Sortieren',
    status: {
      address_not_available: 'Adresse nicht verfügbar',
      available: 'Verfügbar',
      not_available: 'Nicht verfügbar',
      unknown: 'Unbekannt',
      unknown_location: 'Unbekannter Ort',
    },
    terms: 'Bedingungen',
    try_again: 'Erneut versuchen',
    units: {
      buildingUnits: '{{count}} Einheiten',
      currency: 'CHF',
      floors: '{{count}} Stockwerke',
      na: 'N/V',
      rooms: 'Zimmer',
      spaces: 'Plätze',
      square_meters: 'm²',
    },
    validation: {
      failed_to_validate: 'Zugangsvalidierung fehlgeschlagen',
      invalid_link: 'Ungültiger Link',
      link_expired: 'Dieser Link ist ungültig oder abgelaufen.',
      validating_access: 'Zugang wird validiert...',
    },
    view: 'Ansehen',
    yes_no: {
      no: 'Nein',
      yes: 'Ja',
    },
  },
  comparables: {
    no_location_data: {
      listings: 'Standortdaten für Vergleichsanalyse nicht verfügbar',
      transactions: 'Standortdaten für Transaktionsanalyse nicht verfügbar',
    },
  },
  demographics: {
    charts: {
      annualizedGrowthRate: {
        subtitle: 'Durchschnittliche jährliche Wachstumsrate über verschiedené Zeitraeume für genauen Vergleich',
        title: 'Vergleich der annualisierten Wachstumsrate',
      },
      axis: {
        annualGrowthRate: 'Jährliche Wachstumsrate (%)',
        households: 'Haushalte',
        population: 'Bevölkerung',
      },
      communityStability: {
        descriptions: {
          established: 'Établiert (6-10 Jahre)',
          longTerm: 'Langzeit (10+ Jahre)',
          natives: 'Einheimische (seit Geburt)',
          newcomers: 'Neuankömmlinge (0-1 Jahr)',
          settling: 'Sich einlebend (1-5 Jahre)',
        },
        implications: {
          established: 'Stabile Mieter, potenzielle Erstkaeufer',
          longTerm: 'Eigentumsorientiert, in die Gemeinschaft investiert',
          mixed: 'Vielfaeltige Wohnbeduerfnisse in der Gemeinschaft',
          natives: 'Tiefe Gemeinschaftsbindungen, oft geerbte Immobilien',
          newcomers: 'Hohe Mietnachfrage, moeblierte Einheiten, flexible Bedingungen',
          settling: 'Übergang zu laengeren Mietvertraegen, Qualitaetsverbesserungen',
        },
        legend: {
          '0to1Year': '0-1 Jahr',
          '10plusYears': '10+ Jahre',
          '1to5Years': '1-5 Jahre',
          '6to10Years': '6-10 Jahre',
          sinceBirth: 'Seit Geburt',
        },
        levels: {
          high: 'Hoch',
          low: 'Niedrig',
          moderate: 'Maessig',
          veryHigh: 'Sehr hoch',
        },
        markets: {
          balanced: 'Ausgeglichener Miet-/Eigentumsmarkt',
          mixed: 'Gemischter Markt mit vielfaeltigen Beduerfnissen',
          ownershipFocused: 'Eigentumsorientierter Markt',
          rentalFocused: 'Mietorientierter Markt',
        },
        subtitle: 'Wohndauermuster zeigen Gemeinschaftscharakter und Marktdynamik',
        summary: {
          establishedRésidents: 'Établierte Einwohner',
          marketDynamics: 'Beeinflusst Immobiliennachfragemuster',
          newcomers: 'Neuankömmlinge',
          ownershipPotential: 'Eigentumsmarktpotenzial',
          rentalOpportunities: 'Mietmarktchancen',
          stability: 'Stabilität',
          title: 'Gemeinschaftsstabilitätsanalyse',
          turnoverHigh: 'Hoch (aktiver Mietmarkt)',
          turnoverLow: 'Niedrig (stabile Gemeinschaft)',
          turnoverModerate: 'Maessig (ausgewogené Dynamik)',
          turnoverRate: 'Fluktuationsrate',
        },
        title: 'Gemeinschaftsstabilität',
        tooltips: {
          count: 'Anzahl',
          marketImpact: 'Auswirkungen auf den Markt',
          percentage: 'Prozentsatz',
          résidents: 'Einwohner',
        },
      },
      growthComparison: {
        axis: {
          annualGrowthRate: 'Jährliche Wachstumsrate (%)',
        },
        descriptions: {
          exceptional: 'Aussergewoehnliches Wachstum - Boomender Markt',
          good: 'Gutes Wachstum - Gesunder Markt',
          moderateDecline: 'Maessiger Rueckgang - Herausfordernde Bedingungen',
          modest: 'Bescheidenés Wachstum - Stabiles Gebiet',
          significantDecline: 'Erheblicher Rueckgang - Markt unter Druck',
          slightDecline: 'Leichter Rueckgang - Markt sorgfaeltig beobachten',
          strong: 'Starkes Wachstum - Gebiet mit hoher Nachfrage',
        },
        implications: {
          careful: 'Sorgfaeltige Analyse vor Investitionsentscheidungen erforderlich',
          cautious: 'Vorsichtiger Ansatz empfohlen, Markttrends beobachten',
          excellent: 'Ausgezeichnetes Investitionsklima mit starkem Wertsteigerungspotenzial',
          favorable: 'Guenstige Bedingungen für Immobilieninvestitionen und -entwicklung',
          stable: 'Stabiler Markt geeignet für langfristige Investitionen',
        },
        summary: {
          acrossAllPeriods: 'über alle Zeitraeume',
          averageGrowth: 'Durchschnittliches Wachstum',
          challengingPeriod: 'Herausfordernde Période',
          growthPattern: 'Wachstumsmuster',
          peakGrowth: 'Spitzenwachstum',
          positiveTrend: 'Positiver Trend',
          ppRange: 'PP-Bereich',
          strongPerformance: 'Starke Leistung',
          title: 'Wachstumsmusteranalyse',
          volatility: 'Volatilitaet',
          volatilityHigh: 'Hoch',
          volatilityLow: 'Niedrig',
          volatilityModerate: 'Maessig',
          weakestPeriod: 'Schwaechste Période',
        },
        tooltips: {
          annualized: 'Annualisiertes Wachstum',
          marketImpact: 'Auswirkungen auf den Markt',
          perYear: 'pro Jahr',
        },
        trends: {
          accelerating: 'Beschleunigend',
          consistent: 'Konsistent',
          decelerating: 'Verlangsamend',
        },
      },
      growthPeriods: {
        fiveYears: '5 Jahre',
        oneYear: '1 Jahr',
        tenYears: '10 Jahre',
        twoYears: '2 Jahre',
      },
      householdComposition: {
        legend: {
          '1person': '1 Person',
          '2people': '2 Personen',
          '3people': '3 Personen',
          '4people': '4 Personen',
          '5people': '5 Personen',
          '6plusPeople': '6+ Personen',
        },
        markets: {
          diverse: 'Vielfaeltiger Haushaltsmix erfordert verschiedené Immobilientypen',
          family: 'Von Familien dominiertes Gebiet mit Nachfrâge nach grösseren Immobilien und Haeusern',
          modern: 'Auf Paare ausgerichteter Markt mit Nachfrâge nach modernen 2-3-Zimmer-Immobilien',
          rental: 'Hoher Anteil an Einpersonenhaushalten deutet auf starken Mietmarkt für Studios und kleiné Wohnungen hin',
        },
        recommendations: {
          couple: '2-3-Zimmer-Wohnungen mit modernen Annehmlichkeiten bevorzugt',
          extendedFamily: 'Mehrgenerationenwohnen mit separaten Wohnbereichen',
          family: '4-5-Zimmer-Wohnungen und Haeuser mit Aussenbereich',
          largeFamily: 'Grosse 5+-Zimmer-Immobilien und Haeuser gefragt',
          mixed: 'Vielfaeltige Immobilientypen für unterschiedliche Haushaltsbeduerfnisse',
          smallFamily: '3-4-Zimmer familienfreundliche Wohnungen benoetigt',
          studio: 'Studios und 1-2-Zimmer-Wohnungen sind sehr gefragt',
        },
        subtitle: 'Verteilung der Haushaltsgrössen zeigt Nachfragemuster nach Immobilientyp',
        summary: {
          couples: 'Paare',
          couplesUnits: 'Moderné 2-3-Zimmer-Wohnungen',
          families: 'Familien (3+ Personen)',
          familiesUnits: '3+-Zimmer-Wohnungen und Haeuser',
          singlePerson: 'Einpersonenhaushalte',
          singlePersonUnits: 'Studios und 1-2-Zimmer-Einheiten',
          title: 'Immobiliennachfrageanalyse',
        },
        title: 'Haushaltszusammensetzung',
        tooltips: {
          count: 'Anzahl',
          households: 'Haushalte',
          percentage: 'Prozentsatz',
          propertyDemand: 'Immobiliennachfrage',
        },
      },
      householdSizes: {
        fivePeople: '5 Personen',
        fourPeople: '4 Personen',
        onePerson: '1 Person',
        sixPlusPeople: '6+ Personen',
        threePeople: '3 Personen',
        twoPeople: '2 Personen',
      },
      legend: {
        cantonal: 'Kantonal',
        female: 'Weiblich',
        foreign: 'Ausländer',
        foreignPopulation: 'Ausländische Bevölkerung',
        households: 'Haushalte',
        interCantonal: 'Interkantonal',
        international: 'International',
        local: 'Lokal',
        male: 'Männlich',
        newBorn: 'Neugeborene',
        swiss: 'Schweizer',
        swissPopulation: 'Schweizer Bevölkerung',
        totalPopulation: 'Gesamtbevölkerung',
      },
      migrationChart: {
        descriptions: {
          cantonal: 'Aus demselben Kanton',
          interCantonal: 'Aus anderen Kantonen',
          international: 'Aus dem Ausland',
          local: 'In derselben Stadt geblieben',
          newBorn: 'Im letzten Jahr geboren',
        },
        legend: {
          cantonal: 'Kantonal',
          interCantonal: 'Interkantonal',
          international: 'International',
          local: 'Lokal',
          newBorn: 'Neugeborene',
        },
        profiles: {
          balanced: {
            characteristics: 'Mischung aus lokaler Bindung und Neuankömmlingen, gesunde Fluktuation',
            title: 'Ausgewogené Migration',
          },
          highInternational: {
            characteristics: 'Starke Anziehungskraft für internationale Einwohner, vielfaeltige kulturelle Beduerfnisse',
            title: 'Hohe internationale Anziehungskraft',
          },
          régionalHub: {
            characteristics: 'Zieht Einwohner aus der ganzen Schweiz an, wachsende Region',
            title: 'Régionales Zentrum',
          },
          stableLocal: {
            characteristics: 'Hohe Verbleibsquote, établierte Einwohner, Gemeinschaftsstabilität',
            title: 'Stabile lokale Gemeinschaft',
          },
        },
        sources: {
          cantonal: 'Innerhalb des Kantons',
          international: 'International',
          local: 'Lokale Bindung',
          otherCantons: 'Andere Kantone',
        },
        summary: {
          dominantSource: 'Hauptquelle',
          externalNatural: 'Extern und natuerlich',
          growingInternational: 'Wachsende internationale Gemeinschaft mit vielfaeltigen Wohnbeduerfnissen',
          healthyMix: 'Gesunde Mischung aus Stabilität und Wachstum',
          highLocalRétention: 'Zeigt starke Gemeinschaftsbindung und geringe Fluktuation',
          internalMovement: 'Interné Bewegung',
          populationDynamics: 'Bevölkerungsdynamik',
        },
        tooltips: {
          origin: 'Herkunft',
        },
      },
      migrationOrigins: {
        subtitle: 'Quellen und Muster der Bevölkerungsbewegung in der Region',
        title: 'Migrationsherkunft',
      },
      nationalityChart: {
        legend: {
          foreign: 'Ausländer',
          swiss: 'Schweizer',
        },
        profiles: {
          balanced: {
            characteristics: 'Mischung aus Schweizer und internationalen Einwohnern, vielfaeltige Praeferenzen',
            title: 'Ausgewogené Gemeinschaft',
          },
          cosmopolitan: {
            characteristics: 'Staedtische Vielfalt, gemischte kulturelle Einfluesse, vielfaeltige Wohnbeduerfnisse',
            title: 'Kosmopolitische Gemeinschaft',
          },
          internationalHub: {
            characteristics: 'Global vernetzt, vielfaeltig, moderné Lebensstilpraeferenzen',
            title: 'Internationales Zentrum',
          },
          traditional: {
            characteristics: 'Überwiegend Schweizer, lokale Braeuche, Eigentumskultur',
            title: 'Traditionelle Schweizer Gemeinschaft',
          },
        },
        summary: {
          balanced: 'Ausgeglichener Markt bedient sowohl Miet- als auch Eigentumsbeduerfnisse mit vielfaeltigen Praeferenzen',
          composition: 'Nationalitätszusammensetzung',
          highForeign: 'Starkes Mietmarktpotenzial, moderné Annehmlichkeiten geschaetzt, flexible Mietbedingungen bevorzugt',
          lowForeign: 'Eigentumskultur dominiert, traditionelle Wohnpräferenzen, langfristige Stabilität',
          marketImplications: 'Auswirkungen auf den Markt',
        },
        tooltips: {
          foreignImplication: 'Mietmarktpotenzial, moderné Annehmlichkeiten geschaetzt, internationale Standards',
          housingImpact: 'Auswirkungen auf den Wohnungsmarkt',
          population: 'Bevölkerung',
          swissImplication: 'Traditionelle Eigentumspraeferenzen, stabile Langzeitbewohner',
        },
      },
      nationalityComposition: {
        subtitle: 'Verteilung von Schweizer und ausländischen Einwohnern in der lokalen Region',
        title: 'Nationalitätszusammensetzung',
      },
      populationDistribution: {
        subtitle: 'Alters- und Geschlechteraufschluesslung zeigt Zieldemografien für Immobilienentwicklung',
        title: 'Bevölkerungsverteilung',
      },
      populationEvolution: {
        subtitle: 'Historische Bevölkerungstrends zeigen Wachstumsmuster und Marktentwicklung',
        title: 'Zeitleiste der Bevölkerungsentwicklung',
      },
      populationPyramid: {
        annotations: {
          accessibility: 'Barrierefreiheit wichtig',
          familyHousing: 'Nachfrâge nach Familienwohnungen',
          strongRental: 'Starkes Mietmarktpotenzial',
        },
        legend: {
          female: 'Weiblich',
          male: 'Männlich',
        },
        summary: {
          accessibilityNeeds: 'Barrierefreiheit und Verkleinerungsbeduerfnisse',
          families: 'Familien (30-54)',
          purchasingDemand: 'Hauptzielgruppe für Immobilienkauf',
          rentalDemand: 'Wichtige Mietmarkt-Zielgruppe',
          seniors: 'Senioren (65+)',
          title: 'Einblicke in die Bevölkerungsstruktur',
          totalPopulation: 'Gesamtbevölkerung',
          youngAdults: 'Junge Erwachsené (20-39)',
        },
        tooltips: {
          ageGroup: 'Altersgruppe',
          population: 'Bevölkerung',
          ratio: 'Männlich/Weiblich-Verhältnis',
        },
      },
      populationTrend: {
        axis: {
          households: 'Haushalte',
          population: 'Bevölkerung',
        },
        legend: {
          foreignPopulation: 'Ausländische Bevölkerung',
          households: 'Haushalte',
          swissPopulation: 'Schweizer Bevölkerung',
          totalPopulation: 'Gesamtbevölkerung',
        },
        summary: {
          currentComposition: 'Aktuelle Zusammensetzung',
          decreasing: 'Abnehmend',
          foreignPopulation: 'Ausländische Bevölkerung',
          householdTrend: 'Haushaltstrend',
          increasing: 'Zunehmend',
          periodAnalysis: 'Périodenanalyse',
          stable: 'Stabil',
          title: 'Trendzusammenfassung',
          totalGrowth: 'Gesamtwachstum',
          years: 'Jahre',
        },
        tooltips: {
          change: 'Veränderung',
          décline: 'Rueckgang',
          foreign: 'Ausländer',
          growth: 'Wachstum',
          households: 'Haushalte',
          swiss: 'Schweizer',
          total: 'Gesamt',
          yearOverYear: 'Jahr für Jahr',
        },
      },
      résidentialTenure: {
        oneToFiveYears: '1-5 Jahre',
        sinceBirth: 'Seit Geburt',
        sixToTenYears: '6-10 Jahre',
        tenPlusYears: '10+ Jahre',
        zeroToOneYear: '0-1 Jahr',
      },
      series: {
        growthRate: 'Wachstumsrate',
        householdComposition: 'Haushaltszusammensetzung',
        migrationOrigin: 'Migrationsherkunft',
        nationality: 'Nationalität',
        residents: 'Einwohner',
        zeroGrowth: 'Nullwachstum',
      },
    },
    filters: {
      byBicycle: 'Mit dem Fahrrad',
      byCar: 'Mit dem Auto',
      byWalk: 'Zu Fuss',
      city: 'Stadt',
      district: 'Bezirk',
      location: 'Standort:',
      minBike: '{{time}}min Fahrrad',
      minDrive: '{{time}}min Fahrt',
      minWalk: '{{time}}min zu Fuss',
      options: {
        radius: {
          '1km': '1km',
          '2km': '2km',
          '500m': '500m',
          '5km': '5km',
        },
        time: {
          '10min': '10 Min',
          '15min': '15 Min',
          '20min': '20 Min',
          '30min': '30 Min',
          '5min': '5 Min',
        },
      },
      selectLocation: 'Standort auswählen',
    },
    insights: {
      currentComposition: 'Aktuelle Zusammensetzung',
      decreasing: 'Abnehmend',
      foreignPopulationGrowth: 'Ausländische Bevölkerung',
      growth: 'Wachstum',
      growthDescriptions: {
        exceptionalGrowth: 'Aussergewoehnliches Wachstum',
        goodGrowth: 'Gutes Wachstum',
        moderateDecline: 'Maessiger Rueckgang',
        modestGrowth: 'Bescheidenés Wachstum',
        significantDecline: 'Erheblicher Rueckgang',
        slightDecline: 'Leichter Rueckgang',
        strongGrowth: 'Starkes Wachstum',
      },
      growthPatternAnalysis: {
        acrossAllPeriods: 'über alle Zeitraeume',
        averageGrowth: 'Durchschnittliches Wachstum',
        growthPattern: 'Wachstumsmuster',
        patterns: {
          accelerating: 'Beschleunigend',
          consistent: 'Konsistent',
          decelerating: 'Verlangsamend',
        },
        peakGrowth: 'Spitzenwachstum',
        performanceDescriptions: {
          challengingPeriod: '(Herausfordernde Période)',
          positiveTrend: '(Positiver Trend)',
          strongPerformance: '(Starke Leistung)',
        },
        ppRange: '{{range}}PP-Bereich',
        title: 'Wachstumsmusteranalyse',
        volatility: 'Volatilitaet',
        volatilityLevels: {
          high: 'Hoch',
          low: 'Niedrig',
          moderate: 'Maessig',
        },
        weakestPeriod: 'Schwaechste Période',
      },
      householdMarkets: {
        couplesToModernProperties: 'Paare: {{percentage}}% - Moderné 2-3-Zimmer-Wohnungen',
        diverseHousingNeeds: 'Vielfaeltige Wohnbeduerfnisse',
        familiesToLargerProperties: 'Familien: {{percentage}}% - 3+-Zimmer-Wohnungen und Haeuser',
        highRentalMarketPotential: 'Hohes Mietmarktpotenzial',
        modernApartmentDemand: 'Nachfrâge nach modernen Wohnungen',
        singlePersonToStudios: 'Einzelpersonen: {{percentage}}% - Studios und 1-2-Zimmer-Wohnungen',
        strongFamilyHousingDemand: 'Starke Familienwohnungsnachfrage',
        title: 'Marktauswirkungen',
      },
      householdTrend: 'Haushaltstrend',
      housingMarketImplications: {
        balancedMarket: 'Ausgeglichener Markt bedient sowohl Miet- als auch Eigentumsbeduerfnisse mit vielfaeltigen Praeferenzen',
        modernAmenities: 'Moderné Annehmlichkeiten geschaetzt, Mietmarktpotenzial',
        ownershipCulture: 'Eigentumskultur dominiert, traditionelle Wohnpräferenzen, langfristige Stabilität',
        strongRentalMarket: 'Starkes Mietmarktpotenzial, moderné Annehmlichkeiten geschaetzt, flexible Mietbedingungen bevorzugt',
        title: 'Auswirkungen auf den Wohnungsmarkt:',
        traditionalPreferences: 'Traditionelle Wohnpräferenzen, Eigentumskultur',
      },
      increasing: 'Zunehmend',
      marketImpact: {
        carefulMarketAnalysisRequired: 'Sorgfaeltige Marktanalyse erforderlich',
        cautiousOptimismWarranted: 'Vorsichtiger Optimismus gerechtfertigt',
        excellentInvestmentClimate: 'Ausgezeichnetes Investitionsklima',
        favorableMarketConditions: 'Guenstige Marktbedingungen',
        stableMarketPotential: 'Stabiles Marktpotenzial',
      },
      marketImplications: {
        generationalOwnershipLowMobility: 'Generationsübergreifendes Eigentum, geringe Mobilitàet',
        highRentalDemand: 'Hohe Mietnachfrage, flexible Mietvertraege',
        mixedMarketCharacteristics: 'Gemischte Marktcharakteristiken',
        ownershipPreferenceFamilyProperties: 'Eigentumspraeferenz, Familienimmobilien',
        rentalToOwnershipTransition: 'Übergangsmarkt von Miete zu Eigentum',
        stableOwnershipMarketLowTurnover: 'Stabiler Eigentumsmarkt, geringe Fluktuation',
        title: 'Marktauswirkungen',
      },
      migrationCategories: {
        externalAndNatural: 'Extern und natuerlich:',
        internalMovement: 'Interné Bewegung:',
      },
      migrationDescriptions: {
        bornInPastYear: 'Im letzten Jahr geboren',
        fromAbroad: 'Aus dem Ausland',
        fromOtherCantons: 'Aus anderen Kantonen',
        fromWithinCanton: 'Aus demselben Kanton',
        stayedInSameCity: 'In derselben Stadt geblieben',
      },
      migrationProfiles: {
        balancedMigration: {
          characteristics: 'Mischung aus lokaler Bindung und Neuankömmlingen, gesunde Fluktuation',
          profile: 'Ausgewogené Migration',
        },
        highInternationalAttraction: {
          characteristics: 'Starke Anziehungskraft für internationale Einwohner, vielfaeltige kulturelle Beduerfnisse',
          profile: 'Hohe internationale Anziehungskraft',
        },
        régionalHub: {
          characteristics: 'Zieht Einwohner aus der ganzen Schweiz an, wachsende Region',
          profile: 'Régionales Zentrum',
        },
        stableLocalCommunity: {
          characteristics: 'Hohe Verbleibsquote, établierte Einwohner, Gemeinschaftsstabilität',
          profile: 'Stabile lokale Gemeinschaft',
        },
      },
      nationalityComposition: 'Nationalitätszusammensetzung:',
      nationalityProfiles: {
        balancedCommunity: {
          characteristics: 'Mischung aus Schweizer und internationalen Einwohnern, vielfaeltige Praeferenzen',
          profile: 'Ausgewogené Gemeinschaft',
        },
        cosmopolitanCommunity: {
          characteristics: 'Staedtische Vielfalt, gemischte kulturelle Einfluesse, vielfaeltige Wohnbeduerfnisse',
          profile: 'Kosmopolitische Gemeinschaft',
        },
        internationalHub: {
          characteristics: 'Global vernetzt, vielfaeltig, moderné Lebensstilpraeferenzen',
          profile: 'Internationales Zentrum',
        },
        traditionalSwissCommunity: {
          characteristics: 'Überwiegend Schweizer, lokale Braeuche, Eigentumskultur',
          profile: 'Traditionelle Schweizer Gemeinschaft',
        },
      },
      populationDynamics: {
        dominantSource: 'Hauptquelle: {{source}} ({{percentage}}%)',
        dominantSources: {
          international: 'International',
          localRétention: 'Lokale Bindung',
          otherCantons: 'Andere Kantone',
          withinCanton: 'Innerhalb des Kantons',
        },
        growingInternationalCommunity: ' - Wachsende internationale Gemeinschaft mit vielfaeltigen Wohnbeduerfnissen',
        healthyMixOfStabilityAndGrowth: ' - Gesunde Mischung aus Stabilität und Wachstum',
        strongCommunityAttachment: ' - Zeigt starke Gemeinschaftsbindung und geringe Fluktuation',
        title: 'Bevölkerungsdynamik:',
      },
      propertyRecommendations: {
        couple: '2-3 Zimmer, moderné Annehmlichkeiten',
        extendedFamily: 'Grosse Haeuser, Mehrgenerationen',
        family: '4-5 Zimmer, Aussenbereich',
        largeFamily: '5+ Zimmer, Haeuser',
        mixed: 'Gemischte Immobilientypen',
        smallFamily: '3-4 Zimmer, familienfreundlich',
        studio: 'Studios, 1-2 Zimmer',
      },
      pyramidAnnotations: {
        accessibilityImportant: 'Barrierefreiheit\\nwichtig',
        familyHousingDemand: 'Familienwohnungs\\nnachfrage',
        strongRentalMarket: 'Starkes Mietmarkt\\npotenzial',
      },
      pyramidInsights: {
        seniors: 'Senioren (65+):',
        totalPopulation: 'Gesamtbevölkerung:',
        youngAdults: 'Junge Erwachsené (20-39):',
      },
      stabilityAnalysis: {
        establishedRésidents: 'Établierte Einwohner',
        marketDynamics: 'Marktdynamik',
        marketTypes: {
          balancedMarket: 'Ausgeglichener Markt',
          mixedRentalOwnership: 'Gemischte Miete/Eigentum',
          ownershipFocused: 'Eigentumsorientiert',
          rentalFocused: 'Mietorientiert',
        },
        newcomers: 'Neuankömmlinge',
        ownershipPotential: 'Eigentumspotenzial',
        rentalMarketOpportunities: 'Mietmarktmoeglichkeiten',
        stability: 'Stabilität',
        stabilityLevels: {
          high: 'Hoch',
          low: 'Niedrig',
          moderate: 'Maessig',
          veryHigh: 'Sehr hoch',
        },
        title: 'Gemeinschaftsstabilitätsanalyse',
        turnoverLevels: {
          high: 'Hoch',
          low: 'Niedrig',
          moderate: 'Maessig',
        },
        turnoverRate: 'Fluktuationsrate',
      },
      stabilityImplications: {
        established: 'Établierte Einwohner, Eigentumspraeferenz',
        longTerm: 'Langzeitbewohner, stabile Gemeinschaft',
        natives: 'Lokale Einheimische, tiefe Gemeinschaftsbindungen',
        newcomers: 'Jüngste Ankömmlinge, hohe Mietnachfrage',
        settling: 'Sich niederlassen, Übergang von Miete zu Eigentum',
      },
      totalGrowth: 'Gesamtwachstum',
      trendSummary: '{{years}}-Jahres-Trend-Zusammenfassung ({{startYear}}-{{endYear}})',
    },
    metrics: {
      annualGrowthRate: {
        subtitle: '10-Jahres-Zinseszinsrate',
        title: 'Jährliche Wachstumsrate (CAGR)',
      },
      averageHouseholdSize: {
        people: '{{count}} Personen',
        subtitle: '{{count}} Haushalte insgesamt',
        title: 'Durchschnittliche Haushaltsgrösse',
      },
      communityStability: {
        subtitle: '{{count}} langfristige Einwohner',
        title: 'Gemeinschaftsstabilität',
      },
      currentPopulation: {
        subtitle: 'Im Jahr {{year}}',
        title: 'Aktuelle Bevölkerung',
      },
      familyHouseholds: {
        subtitle: '{{count}} Haushalte',
        title: 'Familienhaushalte',
      },
      foreignResidents: {
        subtitle: '{{count}} Einwohner',
        title: 'Ausländische Einwohner',
      },
      growth10Year: {
        subtitle: 'Langfristiger Trend',
        title: '10-Jahres-Wachstum',
      },
      growth1Year: {
        subtitle: 'Jüngste Bevölkerungsveränderung',
        title: '1-Jahres-Wachstum',
      },
      growth2Year: {
        subtitle: 'Kurzfristiger Trend',
        title: '2-Jahres-Wachstum',
      },
      growth5Year: {
        subtitle: 'Mittelfristiger Trend',
        title: '5-Jahres-Wachstum',
      },
      householdSize: {
        subtitle: '{{count}} Haushalte',
        title: 'Haushaltsgrösse',
      },
      medianAge: {
        subtitle: 'Altersprofil der Gemeinschaft',
        title: 'Medianalter',
        years: '{{age}} Jahre',
      },
      newResidents: {
        subtitle: '{{count}} kürzliche Ankömmlinge',
        title: 'Neue Einwohner',
      },
      populationGrowth: {
        subtitle: '10-Jahres-Entwicklung',
        title: 'Bevölkerungswachstum',
      },
      singlePersonHouseholds: {
        subtitle: '{{count}} Haushalte',
        title: 'Einpersonenhaushalte',
      },
      totalPopulation: {
        subtitle: 'Anwohner der lokalen Region',
        title: 'Gesamtbevölkerung',
      },
      twoPersonHouseholds: {
        subtitle: '{{count}} Haushalte',
        title: 'Zweipersonenhaushalte',
      },
    },
    states: {
      error: 'Fehler beim Laden der demografischen Daten: {{error}}',
      fetchError: 'Fehler beim Abrufen der demografischen Daten',
      loading: 'Demografische Daten werden geladen...',
      noBuildingData: 'Keine Gebäudedaten für die demografische Analyse verfügbar',
      noData: 'Für diesen Standort sind keine demografischen Daten verfügbar.',
      noTrendData: 'Keiné Trenddaten verfügbar',
    },
    subtitle: 'Bevölkerungsmerkmale und Markteinblicke für die lokale Region',
    tabs: {
      growth: 'Wachstumsanalyse',
      market: 'Marktzusammensetzung',
      overview: 'Übersicht',
    },
    title: 'Demografie',
    tooltips: {
      averageHouseholdSize: {
        calculation: 'Gesamtbevölkerung / Gesamtzahl der Haushalte',
        importance: 'Bestimmt optimale Wohnungsgrössen und Immobilienentwicklungsmix',
        limitations: 'Der Durchschnitt spiegelt möglicherweise nicht das gesamte Spektrum der Haushaltszusammensetzungen wider',
        shortDescription: 'Durchschnittliche Anzahl von Personen pro Haushalt',
        source: 'Haushaltszaehlungsdaten des Schweizerischen Bundesamts für Statistik',
        title: 'Durchschnittliche Haushaltsgrösse',
      },
      communityStability: {
        calculation: '(10+ Jahre Einwohner + Seit Geburt Einwohner) / Gesamtbevölkerung x 100',
        importance: 'Hohe Stabilität zeigt reife Gemeinschaften mit starkem Eigentumspotenzial',
        limitations: 'Basiert auf der Zeit in der aktuellen Gemeinde, nicht im spezifischen Viertel',
        shortDescription: 'Prozentsatz der Einwohner, die seit 10+ Jahren oder seit Geburt in der Gegend leben',
        source: 'Wohndauerdaten des Schweizerischen Bundesamts für Statistik',
        title: 'Gemeinschaftsstabilität',
      },
      compoundAnnualGrowthRate: {
        calculation: '((Aktuelle Bev. / Bev. vor 10 Jahren)^(1/10) - 1) x 100',
        importance: 'Glättet jährliche Schwankungen, um den zugrunde liegenden Wachstumstrend zu zeigen',
        limitations: 'Nimmt stetiges Wachstum an, tatsächliches Wachstum kann unregelmässig sein',
        shortDescription: 'Durchschnittliche jährliche Wachstumsrate über 10 Jahre unter Berücksichtigung des Zinseszinseffekts',
        source: 'Berechnet aus Daten des Schweizerischen Bundesamts für Statistik',
        title: 'Zusammengesetzte jährliche Wachstumsrate',
      },
      currentPopulation: {
        calculation: 'Summe aller Einwohner im 500m-Radius um die Immobilie',
        importance: 'Basis für die Berechnung von Wachstumsraten und Marktgrösse',
        limitations: 'Basiert auf Verwaltungsgrenzen und Volkszählungsmethodik',
        shortDescription: 'Gesamtbevölkerung der lokalen Region für das jüngste Jahr',
        source: 'Bevölkerungsdaten des aktuellen Jahres des Schweizerischen Bundesamts für Statistik',
        title: 'Aktuelle Bevölkerung',
      },
      familyHouseholds: {
        calculation: '(3+ Personen-Haushalte) / Gesamtanzahl Haushalte x 100',
        importance: 'Zeigt Nachfrâge nach grösseren Immobilien mit familienorientierten Merkmalen',
        limitations: 'Umfasst verschiedené Haushaltstypen, nicht nur Familien mit Kindern',
        shortDescription: 'Prozentsatz der Haushalte mit drei oder mehr Einwohnern',
        source: 'Haushaltgrössendaten des Schweizerischen Bundesamts für Statistik',
        title: 'Familienhaushalte (3+ Personen)',
      },
      foreignResidents: {
        calculation: 'Ausländische Bevölkerung / Gesamtbevölkerung x 100',
        importance: 'Zeigt internationalen Charakter und potenziellen Mietmarkt an',
        limitations: 'Staatsangehoerigkeit zum Zeitpunkt der Volkszaehlung, spiegelt möglicherweise nicht die kulturelle Vielfalt wider',
        shortDescription: 'Prozentsatz der Einwohner mit ausländischer Staatsangehoerigkeit',
        source: 'Staatsangehoerigkeitsdaten des Schweizerischen Bundesamts für Statistik',
        title: 'Ausländische Einwohner',
      },
      growth10Year: {
        calculation: '(Aktuelle Bevölkerung - Vor 10 Jahren) / Vor 10 Jahren x 100',
        importance: 'Zeigt langfristige demografische Trends und strukturelle Veränderungen',
        limitations: 'Historische Leistung sagt möglicherweise keiné zukünftigen Trends voraus',
        shortDescription: 'Bevölkerungsveränderung im letzten Jahrzehnt',
        source: 'Dekaden-Demografievergleich des Schweizerischen Bundesamts für Statistik',
        title: '10-Jahres-Bevölkerungswachstum',
      },
      growth1Year: {
        calculation: '(Aktuelle Bevölkerung - Vorjahr) / Vorjahr x 100',
        importance: 'Zeigt unmittelbare Markttrends und kurzfristige Nachfrageänderungen',
        limitations: 'Kann temporäre Faktoren oder saisonale Schwankungen widerspiegeln',
        shortDescription: 'Bevölkerungsveränderung im letzten Jahr',
        source: 'Jährliche Bevölkerungsdaten des Schweizerischen Bundesamts für Statistik',
        title: '1-Jahres-Bevölkerungswachstum',
      },
      growth2Year: {
        calculation: '(Aktuelle Bevölkerung - Vor 2 Jahren) / Vor 2 Jahren x 100',
        importance: 'Zeigt kurzfristige Trends jenseits jährlicher Schwankungen',
        limitations: 'Noch von zyklischen Schwankungen und temporären Faktoren beeinflusst',
        shortDescription: 'Bevölkerungsveränderung in den letzten zwei Jahren',
        source: 'Demografische Verfolgung des Schweizerischen Bundesamts für Statistik',
        title: '2-Jahres-Bevölkerungswachstum',
      },
      growth5Year: {
        calculation: '(Aktuelle Bevölkerung - Vor 5 Jahren) / Vor 5 Jahren x 100',
        importance: 'Zeigt mittelfristige demografische Trends und Wirtschaftszyklen',
        limitations: 'Kann Auswirkungen von Wirtschaftszyklen oder Politikänderungen enthalten',
        shortDescription: 'Bevölkerungsveränderung in den letzten fünf Jahren',
        source: 'Fünfjahres-Demografieanalyse des Schweizerischen Bundesamts für Statistik',
        title: '5-Jahres-Bevölkerungswachstum',
      },
      medianAge: {
        calculation: 'Geschätzt aus Altersgruppenverteilungen mittels linearer Interpolation',
        importance: 'Zeigt den Zielmarkt für verschiedene Immobilientypen und Annehmlichkeiten an',
        limitations: 'Approximation basierend auf Altersgruppen, nicht auf individuellen Altern',
        shortDescription: 'Mittlerer Alterswert wenn alle Einwohner nach Alter sortiert sind',
        source: 'Altersgruppendaten des Schweizerischen Bundesamts für Statistik',
        title: 'Medianalter',
      },
      newResidents: {
        calculation: '0-1 Jahr Einwohner / Gesamtbevölkerung x 100',
        importance: 'Hohe Prozentsätze zeigen dynamische Gebiete mit Mietmöglichkeiten',
        limitations: 'Umfasst alle Arten von Umzügen, von lokalen Umzügen bis zur internationalen Migration',
        shortDescription: 'Prozentsatz der Einwohner, die im letzten Jahr in die Gegend gezogen sind',
        source: 'Migrationsdaten des Schweizerischen Bundesamts für Statistik',
        title: 'Neue Einwohner (0-1 Jahr)',
      },
      populationGrowth: {
        calculation: '(Aktuelle Bevölkerung - Bevölkerung vor 10 Jahren) / Bevölkerung vor 10 Jahren',
        importance: 'Wachstum zeigt steigende Immobiliennachfrâge und Investitionspotenzial an',
        limitations: 'Historische Trends sagen möglicherweise keiné zukünftige Leistung voraus',
        shortDescription: 'Bevölkerungsveränderung in den letzten 10 Jahren',
        source: 'Jährliche Bevölkerungsdaten des Schweizerischen Bundesamts für Statistik',
        title: 'Bevölkerungswachstum',
      },
      singlePersonHouseholds: {
        calculation: 'Einpersonenhaushalte / Gesamtanzahl Haushalte x 100',
        importance: 'Hohe Prozentsätze weisen auf starke Mietmarktnachfrâge nach kleineren Einheiten hin',
        limitations: 'Umfasst alle Altersgruppen, von jungen Berufstätigen bis zu älteren Bewohnern',
        shortDescription: 'Prozentsatz der Haushalte mit nur einem Einwohner',
        source: 'Haushaltszusammensetzungsdaten des Schweizerischen Bundesamts für Statistik',
        title: 'Einpersonenhaushalte',
      },
      totalPopulation: {
        calculation: 'Summe aller Einwohner im définierten geografischen Gebiet',
        importance: 'Zeigt Marktgrösse und -dichte für die Immobiliennachfrâge an',
        limitations: 'Basiert auf offiziellen Statistiken, spiegelt möglicherweise saisonale Schwankungen nicht wider',
        shortDescription: 'Gesamtzahl der Einwohner im 500m-Radius um die Immobilie',
        source: 'Demografische Daten des Schweizerischen Bundesamts für Statistik',
        title: 'Gesamtbevölkerung',
      },
      twoPersonHouseholds: {
        calculation: 'Zweipersonenhaushalte / Gesamtanzahl Haushalte x 100',
        importance: 'Zeigt Nachfrâge nach 2-3-Zimmer-Wohnungen, typisch für Paare und kleiné Familien',
        limitations: 'Umfasst verschiedené Haushaltstypen: Paare, Mitbewohner, Elternteil mit Kind, etc.',
        shortDescription: 'Prozentsatz der Haushalte mit zwei Einwohnern',
        source: 'Haushaltszusammensetzungsdaten des Schweizerischen Bundesamts für Statistik',
        title: 'Zweipersonenhaushalte',
      },
    },
  },
  electricity: {
    categories: {
      C1: 'Sehr kleines Unternehmen, max 8 kW',
      C2: 'Kleines Unternehmen, max 15 kW',
      C3: 'Mittleres Unternehmen, max 50 kW',
      C4: 'Grosses Unternehmen, 150 kW, Niederspannung',
      C5: 'Grosses Unternehmen, 150 kW, Mittelspannung',
      C6: 'Grosses Unternehmen, 400 kW, Mittelspannung',
      C7: "Grosses Unternehmen, 1'630 kW, Mittelspannung",
      H1: 'Whg. 2 Zi., Elektroherd',
      H2: 'Whg. 4 Zi., Elektroherd',
      H3: 'Whg. 4 Zi. + Herd + Boiler',
      H4: 'Whg. 5 Zi. + Herd + Tumbler',
      H5: 'Haus 5 Zi., vollelektrisch',
      H6: 'Haus 5 Zi. + Widerstandsheizung',
      H7: 'Haus 5 Zi. + Wärmepumpe 5 kW',
      H8: 'Grosse Whg. Stockwerkeigentum, hoch elektrifiziert',
    },
    categoryDescriptions: {
      C1: "Sehr kleines Unternehmen, Leistung max 8 kW, 8'000 kWh/Jahr",
      C2: "Kleines Unternehmen, Leistung max 15 kW, 30'000 kWh/Jahr",
      C3: "Mittleres Unternehmen, Leistung max 50 kW, 150'000 kWh/Jahr",
      C4: "Grosses Unternehmen, Leistung 150 kW, Niederspannung, 500'000 kWh/Jahr",
      C5: "Grosses Unternehmen, Leistung 150 kW, Mittelspannung, eigene Transformatorenstation, 500'000 kWh/Jahr",
      C6: "Grosses Unternehmen, Leistung 400 kW, Mittelspannung, eigene Transformatorenstation, 1'500'000 kWh/Jahr",
      C7: "Grosses Unternehmen, Leistung 1'630 kW, Mittelspannung, eigene Transformatorenstation, 7'500'000 kWh/Jahr",
      H1: "2-Zimmerwohnung mit Elektroherd, 1'600 kWh/Jahr",
      H2: "4-Zimmerwohnung mit Elektroherd, 2'500 kWh/Jahr",
      H3: "4-Zimmerwohnung mit Elektroherd, Elektroboiler (ohne Tumbler), 4'500 kWh/Jahr",
      H4: "5-Zimmerwohnung mit Elektroherd, Elektroboiler und Tumbler, 4'500 kWh/Jahr",
      H5: "Einfamilienhaus, 5 Zimmer, Elektroherd, Elektroboiler, Tumbler, 7'500 kWh/Jahr",
      H6: "Einfamilienhaus, 5 Zimmer, Elektroherd, Elektroboiler, Tumbler, elektrische Widerstandsheizung, 25'000 kWh/Jahr",
      H7: "Einfamilienhaus, 5 Zimmer, Elektroherd, Elektroboiler, Tumbler, Wärmepumpe 5 kW, 13'000 kWh/Jahr",
      H8: "Grosse Wohnung im Stockwerkeigentum, hoch elektrifiziert (Herd, Boiler, Tumbler, Geschirrspüler), 7'500 kWh/Jahr",
    },
    categoryGroups: {
      commercial: 'Unternehmen (C1-C7)',
      commercialSubtitle: 'Gewerblicher / industrieller Verbrauch',
      residential: 'Haushalte (H1-H8)',
      residentialSubtitle: 'Wohnverbrauch',
    },
    charts: {
      noData: 'Keine Diagrammdaten verfügbar',
      priceEvolution: {
        axis: {
          price: 'Preis (Rp./kWh)',
        },
        subtitle: 'Historische Tariftrends (Rp./kWh)',
        summary: {
          avgChange: 'Durchschn. Änderung',
          decreasing: 'Sinkend',
          increasing: 'Steigend',
          stable: 'Stabil',
          title: 'Preistrends {{startYear}}–{{endYear}}',
          trend: 'Trend',
        },
        title: 'Preisentwicklung nach Netzbetreiber',
      },
    },
    comparison: {
      aboveCantonMedian: 'über dem kantonalen Median',
      aboveNationalMedian: 'über dem nationalen Median',
      belowCantonMedian: 'unter dem kantonalen Median',
      belowNationalMedian: 'unter dem nationalen Median',
      canton: 'Kanton Median',
      switzerland: 'Schweiz Median',
      thisLocation: 'Dieser Standort',
      title: 'Geografischer Preisvergleich',
    },
    efficiency: {
      high: 'Niedrige Kosten',
      low: 'Hohe Kosten',
      medium: 'Durchschnittliche Kosten',
    },
    evolution: {
      '10year': '10 Jahre',
      '1year': '1 Jahr',
      '2year': '2 Jahre',
      '5year': '5 Jahre',
      na: 'N/V',
      title: 'Zusammenfassung der Preisentwicklung',
    },
    filters: {
      category: 'Kategorie',
      categoryTrigger: 'Kategorie:',
      location: 'Standort',
    },
    gridOperators: {
      cheapest: 'Günstigster',
      distribution: 'Netznutzung',
      energy: 'Energie',
      name: 'Netzbetreiber',
      supplement: 'Zuschlag',
      taxes: 'Steuern',
      title: 'Netzbetreibervergleich',
      total: 'Gesamt',
      unit: 'Rp./kWh',
    },
    insights: {
      highEfficiency: 'Die Strompreise in dieser Gemeinde liegen unter dem kantonalen und nationalen Median. Dies ist günstig für Nebenkosten und Wärmepumpen.',
      lowEfficiency: 'Die Strompreise in dieser Gemeinde liegen über dem kantonalen und nationalen Median. Dies erhöht die Nebenkosten erheblich, besonders bei Elektroheizung oder Wärmepumpen.',
      mediumEfficiency: 'Die Strompreise in dieser Gemeinde liegen nahe am regionalen und nationalen Median. Nebenkosten sind im typischen Bereich für die Schweiz.',
      title: 'Stromkostenbewertung',
    },
    metrics: {
      annualCost: {
        subtitle: 'Geschätzte Jahresrechnung (günstigster)',
        title: 'Jahreskosten',
      },
      cheapestPrice: {
        subtitle: 'Bester verfügbarer Tarif (Rp./kWh)',
        title: 'Günstigster Preis',
      },
      priceRange: {
        subtitle: 'Min – Max aller Netzbetreiber',
        title: 'Preisspanne',
      },
    },
    states: {
      categoryNotAvailable: 'Keine Daten für diese Kategorie verfügbar. Nur die Kategorie H4 (Mittleres Haus) ist derzeit verfügbar.',
      error: 'Fehler: {{error}}',
      fetchError: 'Fehler beim Laden der Stromdaten',
      loading: 'Strompreisdaten werden geladen...',
      noData: 'Keine Strompreisdaten für diesen Standort verfügbar.',
      noHistoricalData: 'Keine historischen Preisdaten verfügbar.',
    },
    subtitle: 'Tarifdaten der Netzbetreiber (ElCom)',
    tabs: {
      overview: 'Übersicht',
      trends: 'Trends',
    },
    title: 'Strompreise',
    tooltips: {
      annualCost: {
        calculation: 'Günstigster Tarif (Rp./kWh) × Jahresverbrauch (kWh) der gewählten Kategorie.',
        importance: 'Wichtiger Bestandteil der Nebenkosten für Gesamtkostenberechnungen.',
        limitations: 'Der tatsächliche Verbrauch kann abweichen. Basierend auf ElCom-Standardverbrauchsprofilen.',
        shortDescription: 'Geschätzte jährliche Stromrechnung basierend auf dem günstigsten Netzbetreiber und Standardverbrauch.',
        source: 'ElCom (Eidgenössische Elektrizitätskommission)',
        title: 'Geschätzte Jahreskosten',
      },
      cheapestPrice: {
        calculation: 'Beinhaltet Netznutzung, Energie, Steuern und Bundesabgabe (KEV).',
        importance: 'Direkter Einfluss auf die Nebenkosten für Eigentümer und Mieter.',
        limitations: 'Preise können jährlich ändern. Basierend auf ElCom-Standardprofilen.',
        shortDescription: 'Der günstigste verfügbare Gesamtstromtarif aller Netzbetreiber in dieser Gemeinde.',
        source: 'ElCom (Eidgenössische Elektrizitätskommission)',
        title: 'Günstigster Strompreis',
      },
      priceRange: {
        calculation: 'Minimaler und maximaler Gesamtpreis aller Netzbetreiber für die gewählte Kategorie.',
        importance: 'Eine größere Spanne bedeutet Einsparpotenzial durch die richtige Netzbetreiberwahl.',
        limitations: 'Nicht alle Netzbetreiber versorgen möglicherweise alle Adressen innerhalb einer Gemeinde.',
        shortDescription: 'Die Spanne zwischen günstigstem und teuerstem Netzbetreiber in dieser Gemeinde.',
        source: 'ElCom (Eidgenössische Elektrizitätskommission)',
        title: 'Preisspanne',
      },
    },
  },
  elevation: {
    constraints: {
      amongTallest: {
        description: 'Dieses Gebäude gehört bereits zu den oberen {{percentile}}% der Höhen in der Nachbarschaft. Zusätzliche Höhe kann genauer geprüft werden.',
        title: 'Unter den höchsten der Nachbarschaft:',
      },
      architecturalCohesion: {
        description: 'Nachbargebäude stammen aus einer ähnlichen Bauzeit. Die Aufstockung sollte die architektonische Harmonie wahren.',
        title: 'Architektonische Kohärenz:',
      },
      heritageProtected: {
        description: 'Dieses Gebäude hat Denkmalschutzstatus ({{rank}}). Jegliche Änderungen erfordern eine Sondergenehmigung und können eingeschränkt sein.',
        title: 'Denkmalgeschützt:',
      },
      maxHeightReached: {
        description: 'Das Gebäude hat die maximale legale Höhe für diese Zone bereits erreicht oder überschritten. Keine weiteren Stockwerke können hinzugefügt werden.',
        title: 'Maximale Höhe erreicht:',
      },
      protectedNearby: {
        description: 'Es gibt denkmalgeschützte Gebäude in unmittelbarer Nähe. Aufstockungsprojekte können eine Denkmalverträglichkeitsprüfung erfordern.',
        title: 'Geschützte Gebäude in der Nähe:',
      },
      structuralAssessment: {
        description: 'Das Gebäude ist {{age}} Jahre alt. Eine umfassende statische Begutachtung wird vor jedem Aufstockungsprojekt empfohlen.',
        title: 'Statische Begutachtung erforderlich:',
      },
    },
    elevationCharts: {
      far: {
        available: 'Verfügbar',
        current: 'Aktuell',
        maximum: 'Maximum',
        subtitle: 'Aktuelle Bebauungsdichte vs. maximal zulässig',
        title: 'Auslastung der Geschossflächenzahl ({{indiceType}})',
        used: 'AZ genutzt',
      },
      height: {
        available: 'Verfügbar',
        availableMeters: '+{{meters}}m verfügbar',
        currentBuilding: 'Aktuelles\nGebäude',
        height: 'Höhe',
        legalMaximum: 'Legales\nMaximum',
        legend: {
          availableSpace: 'Verfügbarer Raum (+{{height}}m)',
          currentBuilding: 'Aktuelles Gebäude ({{height}}m)',
          legalMaximum: 'Legales Maximum ({{height}}m)',
          neighborsAverage: 'Nachbarn Durchschn. ({{height}}m)',
          neighborsMaximum: 'Nachbarn Max ({{height}}m)',
        },
        maxAllowedByZoning: 'Maximum gemäss Zonenvorschriften',
        neighborsAverage: 'Nachbarn\nDurchschnitt',
        neighborsMaximum: 'Nachbarn\nMaximum',
        subtitle: 'Gebäudehöhe vs. legales Maximum und Nachbarschaftskontext',
        title: 'Höhenvergleich',
        utilization: 'Auslastung',
      },
    },
    header: {
      subtitle: 'Analyse der vertikalen Erweiterungsmöglichkeiten',
      subtitleFull: 'Umfassende Analyse des Aufstockungspotenzials basierend auf Zonenvorschriften, Tragfähigkeit und Nachbarschaftskontext',
      title: 'Aufstockungspotenzial',
    },
    overview: {
      availableFloors: {
        label: 'Verfügbare Stockwerke',
        tooltip: {
          calculation: 'Max. legale Stockwerke - Aktuelle Stockwerke = Verfügbare Stockwerke',
          importance: 'Schlüsselmetrik zur Bewertung des vertikalen Erweiterungspotenzials',
          limitations: 'Vorbehaltlich struktureller Machbarkeit und Baugenehmigungen',
          shortDescription: 'Anzahl zusätzlicher Stockwerke, die gemäss Zonenvorschriften potenziell hinzugefügt werden können',
          source: 'Kantonale Zonenvorschriften',
          title: 'Verfügbare Stockwerke für Aufstockung',
        },
      },
      availableHeight: {
        label: 'Verfügbare Höhe',
        limited: 'Begrenzter Raum',
        none: 'Kein Raum',
        oneFloor: '1 Stockwerk möglich',
        tooltip: {
          calculation: 'Max. legale Höhe - Aktuelle Höhe = Verfügbare Höhe',
          importance: 'Bestimmt den verfügbaren physischen Raum für neue Stockwerke',
          limitations: 'Berücksichtigt keine Dachstrukturanforderungen',
          shortDescription: 'Zusätzliche Höhe in Metern, die dem Gebäude hinzugefügt werden kann',
          source: 'Gebäudehöhendaten und Zonengrenzen',
          title: 'Verfügbare Höhe für Aufstockung',
        },
        twoFloors: '2+ Stockwerke möglich',
      },
      elevationScore: {
        label: 'Aufstockungswert',
        tooltip: {
          calculation: 'Gewichtete Kombination aus verfügbaren Stockwerken, regulatorischer Konformität und strukturellen Faktoren',
          categories: {
            excellent: 'Ausgezeichnetes Potenzial',
            limited: 'Begrenztes Potenzial',
            moderate: 'Mässiges Potenzial',
            veryLow: 'Sehr geringes Potenzial',
          },
          importance: 'Schnelle Bewertung der Aufstockbarkeit für Investitionsentscheidungen',
          limitations: 'Ersetzt keine professionelle strukturelle und rechtliche Bewertung',
          shortDescription: 'Zusammengesetzter Wert zur Bewertung des Gesamtpotenzials für Gebäudeaufstockung',
          source: 'Popety.io proprietärer Algorithmus',
          title: 'Gesamtwert der Aufstockbarkeit',
        },
      },
      feasibility: {
        buildingAge: {
          historic: 'Historisch',
          label: 'Gebäudealter',
          mature: 'Reif',
          modern: 'Modern',
          old: 'Alt',
          tooltip: {
            calculation: 'Aktuelles Jahr - Baujahr',
            categories: {
              historic: 'Historisch (100+ Jahre): Umfassende Bewertung unerlässlich',
              mature: 'Reif (30-60 Jahre): Bewertung empfohlen',
              modern: 'Modern (0-30 Jahre): Standard-Tragfähigkeit',
              old: 'Alt (60-100 Jahre): Detaillierte Bewertung erforderlich',
            },
            importance: 'Ältere Gebäude können strukturelle Verstärkung erfordern',
            shortDescription: 'Wie das Alter des Gebäudes die Aufstockbarkeit und erforderliche Bewertungen beeinflusst',
            source: 'Eidgenössisches Gebäude- und Wohnungsregister (GWR)',
            title: 'Auswirkung des Gebäudealters auf die Aufstockung',
          },
          years: '{{years}} Jahre',
        },
        heritageProtection: {
          label: 'Denkmalschutz',
          tooltip: {
            importance: 'Geschützte Gebäude unterliegen erheblichen Einschränkungen bei Änderungen',
            shortDescription: 'Die Denkmalschutzklassifizierung des Gebäudes, falls vorhanden',
            source: 'Kantonale Denkmalregister',
            title: 'Denkmalschutzstatus',
          },
        },
        overallRating: {
          excellent: 'Ausgezeichnet',
          good: 'Gut',
          label: 'Gesamtbewertung',
          limited: 'Begrenzt',
          poor: 'Schlecht',
          tooltip: {
            calculation: 'Gewichtete Kombination aus regulatorischen, strukturellen und Nachbarschaftsfaktoren',
            categories: {
              excellent: {
                description: 'Sehr günstige Bedingungen für Aufstockung',
                label: 'Ausgezeichnet (70-100)',
              },
              good: {
                description: 'Günstig mit einigen Überlegungen',
                label: 'Gut (40-69)',
              },
              limited: {
                description: 'Erhebliche Einschränkungen zu überwinden',
                label: 'Begrenzt (20-39)',
              },
              poor: {
                description: 'Grosse Hindernisse; Aufstockung wahrscheinlich nicht machbar',
                label: 'Schlecht (0-19)',
              },
            },
            importance: 'Schnelle Referenz für Investitionsentscheidungen',
            limitations: 'Professionelle Bewertung für endgültige Entscheidungen empfohlen',
            shortDescription: 'Umfassende Bewertung, die alle Machbarkeitsfaktoren kombiniert',
            title: 'Gesamtbewertung der Machbarkeit',
          },
        },
        quartierBuildings: {
          label: 'Quartiersgebäude',
          tooltip: {
            importance: 'Grössere Stichprobe bietet zuverlässigeren Nachbarschaftskontext',
            shortDescription: 'Anzahl der Gebäude im analysierten Nachbarschaftsbereich',
            source: 'Eidgenössisches Gebäude- und Wohnungsregister (GWR)',
            title: 'Gesamtgebäude in der Nachbarschaft',
          },
        },
        similarPeriod: {
          label: 'Gebäude ähnlicher Periode',
          noFlexible: 'Nein - Flexibler',
          tooltip: {
            importance: 'Kann Designanforderungen für Aufstockungsprojekte beeinflussen',
            shortDescription: 'Ob Nachbargebäude in einer ähnlichen Zeit gebaut wurden, was architektonische Kohärenz erfordert',
            source: 'Analyse der Bautermine in der Nachbarschaft',
            title: 'Nachbargebäude aus ähnlicher Bauzeit',
          },
          yesRequired: 'Ja - Kohärenz erforderlich',
        },
        title: 'Machbarkeitsbewertung',
      },
      legalFramework: {
        availableFarSpace: {
          label: 'Verfügbarer AZ-Raum',
          tooltip: {
            calculation: '(Max. AZ - Aktuelle AZ) × Grundstücksfläche',
            importance: 'Schlüsselmetrik zur Bestimmung der zusätzlichen bebaubaren Fläche',
            shortDescription: 'Zusätzliche Geschossfläche in m², die gemäss AZ-Vorschriften gebaut werden kann',
            source: 'Berechnet aus Grundbuch- und Zonendaten',
            title: 'Verfügbarer Geschossflächenraum',
          },
        },
        currentFloors: {
          label: 'Aktuelle Stockwerke',
          tooltip: {
            calculation: 'Anzahl der Stockwerke über dem Bodenniveau, ohne Keller',
            importance: 'Basis für die Berechnung des zusätzlichen Stockwerkpotenzials',
            shortDescription: 'Die aktuelle Anzahl der oberirdischen Stockwerke im Gebäude',
            source: 'Eidgenössisches Gebäude- und Wohnungsregister (GWR)',
            title: 'Aktuelle Anzahl Stockwerke',
          },
        },
        currentHeight: {
          label: 'Aktuelle Höhe',
          tooltip: {
            calculation: 'Gemessen vom natürlichen Bodenniveau bis zum Dachfirst',
            importance: 'Referenzpunkt zur Berechnung des verfügbaren Aufstockungsraums',
            shortDescription: 'Die gemessene Höhe des Gebäudes vom Bodenniveau bis zum höchsten Punkt',
            source: 'Eidgenössisches Gebäude- und Wohnungsregister (GWR)',
            title: 'Aktuelle Gebäudehöhe',
          },
        },
        farIndex: {
          label: 'Verwendeter AZ-Index',
          tooltip: {
            calculation: 'Bestimmt durch kantonale Vorschriften basierend auf dem Zonentyp',
            categories: {
              sp: {
                description: 'Geschossflächenindex - Kanton Waadt',
                label: 'Geschossfläche (GF)',
              },
              spd: {
                description: 'Anrechenbare Geschossfläche - Kanton Genf',
                label: 'Anrechenbare Geschossfläche (aGF)',
              },
              std: {
                description: 'Anrechenbare Grundstücksfläche',
                label: 'Anrechenbare Grundstücksfläche (aGSF)',
              },
            },
            importance: 'Bestimmt die Berechnungsmethode für die bebaubare Fläche',
            shortDescription: 'Die Art des Geschossflächenindex, der für diese Immobilie gilt',
            source: 'Kantonale Bauvorschriften',
            title: 'Geschossflächenindex',
          },
        },
        maxLegalFloors: {
          label: 'Max. legale Stockwerke',
          tooltip: {
            calculation: 'Abgeleitet aus der maximalen Höhe geteilt durch die Standard-Stockwerkshöhe (3m)',
            importance: 'Bestimmt die Obergrenze für die vertikale Erweiterung',
            limitations: 'Kann je nach Gebäudetyp und spezifischen Zonenregeln variieren',
            shortDescription: 'Die maximale Anzahl von Stockwerken, die für Gebäude in dieser Zone erlaubt sind',
            source: 'Kantonale Zonenvorschriften',
            title: 'Maximale legale Anzahl Stockwerke',
          },
        },
        maxLegalHeight: {
          label: 'Max. legale Höhe',
          tooltip: {
            calculation: 'Definiert durch kantonale und kommunale Zonenpläne',
            importance: 'Harte Grenze, die ohne Sondergenehmigung nicht überschritten werden kann',
            limitations: 'Kann zusätzlichen Einschränkungen wie Abstandsregeln unterliegen',
            shortDescription: 'Die maximal zulässige Höhe für Gebäude in dieser Zone gemäss den Zonenvorschriften',
            source: 'Kommunale Zonenvorschriften',
            title: 'Maximale legale Gebäudehöhe',
          },
        },
        title: 'Rechtsrahmen',
      },
      legalStatus: {
        floorsPossible: '{{count}} Stockwerk(e) möglich',
        label: 'Rechtsstatus',
        noExpansion: 'Keine Erweiterung möglich',
        tooltip: {
          categories: {
            allowed: {
              description: 'Gebäude kann innerhalb der Zonengrenzen aufgestockt werden',
              label: 'Aufstockung erlaubt',
            },
            assessment: {
              description: 'Detaillierte Bewertung erforderlich zur Bestimmung der Machbarkeit',
              label: 'Bewertung erforderlich',
            },
            maximum: {
              description: 'Gebäude hat die maximal zulässige Höhe erreicht',
              label: 'Maximum erreicht',
            },
            protected: {
              description: 'Denkmalschutz beschränkt Änderungen',
              label: 'Geschütztes Gebäude',
            },
          },
          importance: 'Bestimmt, ob Aufstockung rechtlich möglich ist',
          limitations: 'Basiert auf aktuellen Vorschriften; kann sich ändern',
          shortDescription: 'Aktueller regulatorischer Status bezüglich Aufstockungsmöglichkeiten',
          source: 'Kantonale Bauvorschriften und Denkmalregister',
          title: 'Rechtsstatus für Aufstockung',
        },
      },
      neighborhoodFit: {
        avgHeight: {
          label: 'Durchschn. Höhe Nachbarn',
          tooltip: {
            calculation: 'Mittlere Höhe aller Gebäude im Nachbarschaftsradius',
            importance: 'Referenz für kontextuelle Gebäudehöhenbewertung',
            shortDescription: 'Die durchschnittliche Höhe der Gebäude in der unmittelbaren Nachbarschaft',
            source: 'Eidgenössisches Gebäude- und Wohnungsregister (GWR)',
            title: 'Durchschnittliche Höhe der Nachbargebäude',
          },
        },
        buildingDensity: {
          label: 'Gebäudedichte',
          tooltip: {
            calculation: 'Gebäudegrundfläche / Grundstücksfläche, verglichen mit Nachbarschaft',
            importance: 'Hohe Dichte kann Erweiterungsoptionen einschränken',
            shortDescription: 'Wie dicht die Gebäudeabdeckung im Vergleich zum Nachbarschaftsdurchschnitt ist',
            source: 'Grundbuch und Gebäudegrundflächen-Daten',
            title: 'Gebäudedichte-Perzentil',
          },
        },
        contiguityRatio: {
          label: 'Angrenzungsrate',
          tooltip: {
            calculation: 'Länge der gemeinsamen Wände / Gesamtumfang × 100',
            importance: 'Hohe Angrenzung beeinflusst die Baukomplexität und Nachbarkoordination',
            shortDescription: 'Prozentsatz des Gebäudeumfangs, der mit angrenzenden Gebäuden geteilt wird',
            source: 'Analyse der Gebäudegrundfläche',
            title: 'Gebäude-Angrenzungsrate',
          },
        },
        heightPercentile: {
          label: 'Höhenperzentil',
          tooltip: {
            calculation: 'Prozentsatz der Nachbarschaftsgebäude, die niedriger sind',
            categories: {
              belowAvg: 'Unter dem Durchschnitt',
              lowerMid: 'Untere Mitte',
              tallest: 'Unter den höchsten',
              upperMid: 'Obere Mitte',
            },
            importance: 'Zeigt an, wie die Aufstockung die Skyline der Nachbarschaft beeinflussen könnte',
            shortDescription: 'Wie sich die Höhe dieses Gebäudes mit anderen in der unmittelbaren Nachbarschaft vergleicht',
            source: 'Analyse der Nachbargebäude im Umkreis von 100m',
            title: 'Gebäudehöhen-Perzentil in der Nachbarschaft',
          },
        },
        protectedNearby: {
          label: 'Geschützt in der Nähe',
          tooltip: {
            importance: 'Kann eine Denkmalverträglichkeitsprüfung für Aufstockungsprojekte erfordern',
            shortDescription: 'Zeigt an, ob es denkmalgeschützte Gebäude in unmittelbarer Nähe gibt',
            source: 'Kantonale Denkmalregister',
            title: 'Geschützte Gebäude in der Nähe',
          },
        },
        tallestNeighbor: {
          label: 'Höchster Nachbar',
          tooltip: {
            calculation: 'Maximale Höhe unter allen Nachbarschaftsgebäuden',
            importance: 'Zeigt bestehende Höhenpräzedenz in der Gegend',
            shortDescription: 'Die Höhe des höchsten Gebäudes in der unmittelbaren Nachbarschaft',
            source: 'Eidgenössisches Gebäude- und Wohnungsregister (GWR)',
            title: 'Höchstes Gebäude in der Nachbarschaft',
          },
        },
        title: 'Quartierspassung',
      },
    },
    regulatory: {
      approvals: {
        architecturalPlans: 'Architekturpläne',
        buildingPermit: 'Baugenehmigung',
        elevator: 'Aufzugsinstallation',
        fireSafety: 'Brandschutzgenehmigung',
        heritageConsultation: 'Denkmalberatung',
        heritageImpact: 'Denkmalverträglichkeitsprüfung',
        recommended: 'Empfohlen',
        required: 'Erforderlich',
        structuralReview: 'Statische Prüfung',
        title: 'Erforderliche Genehmigungen',
      },
      farCompliance: {
        availableSpace: {
          label: 'Verfügbarer AZ-Raum',
          tooltip: {
            importance: 'Schlüsselmetrik zur Bestimmung des zusätzlichen Baupotenzials',
            shortDescription: 'Zusätzliche bebaubare Fläche in m² basierend auf AZ-Grenzen',
            source: 'Berechnet aus Grundbuch- und Zonendaten',
            title: 'Verfügbarer Geschossflächenraum',
          },
        },
        indiceType: {
          label: 'Verwendeter Indextyp',
          tooltip: {
            shortDescription: 'Die spezifische AZ-Berechnungsmethode, die in diesem Kanton verwendet wird',
            source: 'Kantonale Bauvorschriften',
            title: 'Geschossflächenindex-Typ',
          },
        },
        sp: 'Geschossfläche (GF)',
        spd: 'Anrechenbare Geschossfläche (aGF)',
        std: 'Anrechenbare Grundstücksfläche (aGSF)',
        title: 'AZ-Konformität',
      },
      heightFloor: {
        availableFloors: 'Verfügbare Stockwerke',
        availableHeight: 'Verfügbare Höhe',
        currentFloors: 'Aktuelle Stockwerke',
        currentHeight: {
          label: 'Aktuelle Höhe',
          tooltip: {
            shortDescription: 'Gemessene Höhe vom Bodenniveau bis zum Dachfirst',
            source: 'Eidgenössisches Gebäude- und Wohnungsregister (GWR)',
            title: 'Aktuelle Gebäudehöhe',
          },
        },
        maxLegalFloors: 'Max. legale Stockwerke',
        maxLegalHeight: {
          label: 'Max. legale Höhe',
          tooltip: {
            importance: 'Gesetzliche Grenze, die ohne Sondergenehmigung nicht überschritten werden darf',
            shortDescription: 'Maximale Gebäudehöhe gemäss Zonenvorschriften',
            source: 'Kommunale Zonenvorschriften',
            title: 'Maximale legale Höhe',
          },
        },
        title: 'Höhen- und Stockwerksvorschriften',
      },
      timeline: {
        construction: 'Bauphase',
        constructionDuration: '{{min}}-{{max}} Monate',
        heritageReview: 'Denkmalprüfung',
        heritageReviewDuration: '+3-6 Monate',
        permitApplication: 'Genehmigungsantrag',
        permitApplicationDuration: '3-6 Monate',
        preliminaryStudies: 'Vorstudien',
        preliminaryStudiesDuration: '2-4 Monate',
        title: 'Geschätzter Zeitplan',
        totalDuration: 'Gesamtdauer',
        totalProtected: '18-24 Monate',
        totalStandard: '12-18 Monate',
      },
    },
    score: {
      label: 'Aufstockungswert',
      tooltip: 'Gesamtbewertung der Aufstockbarkeit unter Berücksichtigung regulatorischer, struktureller und nachbarschaftlicher Faktoren',
    },
    shared: {
      estimated: 'geschätzt',
      month: 'Monat',
      na: 'K.A.',
      no: 'Nein',
      none: 'Keine',
      units: 'Einheiten',
      year: 'Jahr',
      yes: 'Ja',
    },
    states: {
      error: 'Fehler beim Laden: {{error}}',
      loading: 'Aufstockungsdaten werden geladen...',
      noBuilding: 'Kein Gebäude ausgewählt',
      noData: {
        description: 'Die Aufstockungsanalyse ist für dieses Gebäude nicht verfügbar. Dies kann an fehlenden Zonendaten liegen oder daran, dass sich das Gebäude in einer Zone befindet, in der die Aufstockungsanalyse nicht anwendbar ist.',
        title: 'Aufstockungsdaten nicht verfügbar',
      },
    },
    status: {
      elevationAllowed: 'Aufstockung erlaubt',
      maximumReached: 'Maximum erreicht',
      protectedBuilding: 'Geschütztes Gebäude',
      requiresAssessment: 'Bewertung erforderlich',
    },
    structural: {
      condition: {
        assessmentNeeded: 'Bewertung erforderlich',
        buildingAge: 'Gebäudealter',
        foundationReinforcement: 'Fundamentverstärkung',
        inDepthRequired: 'Tiefgehend erforderlich',
        likelyNotRequired: 'Wahrscheinlich nicht erforderlich',
        likelyRequired: 'Wahrscheinlich erforderlich',
        loadBearingWalls: 'Tragende Wände',
        mature: 'Reif',
        modern: 'Modern',
        old: 'Alt',
        professionalReview: 'Professionelle Prüfung erforderlich',
        standardReview: 'Standardprüfung',
        structuralCapacity: {
          label: 'Tragfähigkeit',
          tooltip: {
            importance: 'Kritischer Faktor für die Bestimmung der Aufstockbarkeit',
            shortDescription: 'Bewertung der Fähigkeit des Gebäudes, zusätzliche Stockwerke zu tragen',
            source: 'Basierend auf Gebäudealter und Baustandards',
            title: 'Strukturelle Tragfähigkeit',
          },
        },
        title: 'Gebäudezustandsbewertung',
        years: '{{years}} Jahre',
      },
      method: {
        craneAccess: 'Kranzugang',
        critical: 'Kritisch',
        highCarefulPlanning: 'Hoch - sorgfältige Planung',
        lightSteelClt: 'Leichtstahlrahmen/CLT',
        neighborImpact: 'Auswirkung auf Nachbarn',
        recommended: 'Empfohlen',
        recommendedMethod: 'Empfohlene Methode',
        siteSurveyRequired: 'Standortuntersuchung erforderlich',
        standardMeasures: 'Standardmassnahmen',
        steelFrameConcrete: 'Stahlrahmen + Beton',
        title: 'Bauweise',
        traditionalMasonry: 'Traditionelles Mauerwerk',
        weightOptimization: 'Gewichtsoptimierung',
      },
      reinforcement: {
        assessmentRequired: 'Bewertung erforderlich',
        basicAssessment: 'Grundbewertung',
        estimatedWeight: 'Geschätztes Zusatzgewicht',
        foundationAssessment: 'Fundamentbewertung',
        inDepthGeotechnical: 'Tiefgehende geotechnische Studie',
        reinforcementNeeded: 'Verstärkung erforderlich',
        seismic: 'Erdbebensicherheit',
        siaStandards: 'SIA-Normen gelten',
        standardSoilTest: 'Standard-Bodentest',
        structuralFrame: 'Tragwerksrahmen',
        title: 'Strukturelle Verstärkungsbedürfnisse',
        typicallyAdequate: 'Normalerweise ausreichend',
        weightRange: '{{min}}-{{max}} kg/m²',
      },
      requirements: {
        accessDuringConstruction: 'Zugang während der Bauphase',
        elevator: 'Aufzugsanforderung',
        elevatorRequired: 'Aufzug erforderlich (4+ Stockwerke)',
        enhancedRequirements: 'Erhöhte Anforderungen',
        fireSafety: 'Brandschutz',
        notRequired: 'Nicht erforderlich',
        planningRequired: 'Planung erforderlich',
        standard: 'Standard',
        temporaryRoof: 'Temporäres Dach erforderlich',
        title: 'Bauanforderungen',
        weatherProtection: 'Wetterschutz',
      },
    },
    tabs: {
      overview: 'Übersicht',
      regulatory: 'Regulierung',
      structural: 'Struktur',
    },
  },
  employment: {
    charts: {
      employmentTrend: {
        axis: {
          employment: 'Beschäftigung',
        },
        legend: {
          fullTimeEmployment: 'Vollzeitbeschäftigung',
          totalEmployment: 'Gesamtbeschäftigung',
        },
        noData: 'Keine Beschäftigungstrenddaten verfügbar',
        subtitle: 'Historische Beschäftigungsentwicklung mit Arbeitsmarktentwicklung (2011-2022)',
        summary: {
          annualCompoundGrowth: 'jährliches zusammengesetztes Wachstum',
          cagr: 'CAGR',
          currentFTRatio: 'Aktuelles Vollzeitverhältnis',
          declining: 'Rückläufig',
          fullTimeGrowth: 'Vollzeitwachstum',
          growing: 'Wachsend',
          jobMarketStatus: 'Arbeitsmarktstatus',
          ofJobsAreFullTime: 'der Arbeitsplätze sind Vollzeit',
          rapidGrowth: 'Schnelles Wachstum',
          stableGrowth: 'Stabiles Wachstum',
          title: '{{years}}-Jahres-Beschäftigungstrend ({{startYear}}-{{endYear}})',
          totalJobGrowth: 'Gesamtwachstum der Arbeitsplätze',
        },
        title: 'Beschäftigungstrend',
        tooltips: {
          fullTime: 'Vollzeit',
          totalJobs: 'Gesamte Arbeitsplätze',
          year: 'Jahr',
        },
      },
      fullTimeVsTotal: {
        subtitle: 'Vergleich der Vollzeit- und Gesamtbeschäftigungstrends zur Darstellung der Arbeitsqualitätsentwicklung',
        title: 'Vollzeit- vs. Gesamtbeschäftigung',
      },
      jobsPerEstablishment: {
        average: 'Durchschn.',
        axis: {
          ratio: 'Arbeitsplätze pro Betrieb',
        },
        noData: 'Keine Daten zu Arbeitsplätzen pro Betrieb verfügbar',
        subtitle: 'Wirtschaftlicher Effizienzindikator zeigt durchschnittliche Unternehmensgrösse über die Zeit',
        summary: {
          balancedMix: 'Ausgewogene Mischung der Unternehmensgrössen',
          consolidating: 'Konsolidierung - Grössere Unternehmen entstehen, weniger kleine Firmen',
          currentRatio: 'Aktuelles Verhältnis',
          fragmenting: 'Fragmentierung - Mehr kleine Unternehmen, unternehmerisches Wachstum',
          historicalChange: 'Historische Veränderung',
          interpretation: 'Interpretation',
          jobsPerEstablishment: 'Arbeitsplätze pro Betrieb',
          largeEmployerDominated: 'Von Grossunternehmen dominiert - Unternehmenswirtschaft',
          periodAverage: 'Durchschnitt des Zeitraums',
          smallBusinessEconomy: 'Kleinunternehmenswirtschaft - Unternehmerisches Umfeld',
          title: 'Trend der wirtschaftlichen Effizienz ({{startYear}}-{{endYear}})',
        },
        title: 'Arbeitsplätze pro Betrieb Verhältnis',
        tooltips: {
          employment: 'Beschäftigung',
          establishments: 'Betriebe',
          jobsPerEstablishment: 'Arbeitsplätze/Betrieb',
          ratio: 'Verhältnis',
          year: 'Jahr',
        },
      },
      publicPrivate: {
        axis: {
          employment: 'Beschäftigung',
          establishments: 'Betriebe',
        },
        legend: {
          privateSector: 'Privater Sektor',
          publicSector: 'Öffentlicher Sektor',
        },
        noData: 'Keine öffentlich/privat Verteilungsdaten verfügbar',
        subtitle: 'Historische Aufteilung zwischen öffentlichen und privaten Betrieben',
        summary: {
          balancedMix: 'Ausgewogene öffentlich-private Mischung',
          governmentDominated: 'Staatlich dominierte Wirtschaft - Stabil, aber langsameres Wachstum',
          investmentImplications: 'Investitionsimplikationen',
          marketCharacter: 'Marktcharakter',
          marketDrivenDemand: 'Marktgetriebene Nachfrage, höheres Wachstumspotenzial, vielfältige Mieterzusammensetzung',
          privateDriven: 'Privatwirtschaftlich geprägte Wirtschaft - Dynamisch und unternehmerisch',
          privateSector: 'Privater Sektor',
          publicSector: 'Öffentlicher Sektor',
          stableTenantBase: 'Stabile Mieterbasis, geringeres Leerstandsrisiko, auf Regierung ausgerichtete Immobilien',
          title: 'Öffentlicher vs. privater Sektor ({{year}})',
        },
        title: 'Öffentlich vs. privat Verteilung',
        tooltips: {
          private: 'Privat',
          public: 'Öffentlich',
          total: 'Gesamt',
          year: 'Jahr',
        },
      },
      sectorComposition: {
        noData: 'Keine Sektordaten verfügbar',
        subtitle: 'Wirtschaftsstruktur nach Sektoren mit Beschäftigungsverteilung',
        summary: {
          balancedDiversified: 'Ausgewogene diversifizierte Wirtschaft',
          dominantSector: 'Dominanter Sektor',
          economicCharacter: 'Wirtschaftscharakter',
          highlyServiceOriented: 'Stark dienstleistungsorientierte Wirtschaft',
          jobs: 'Arbeitsplätze',
          primarySectorEconomy: 'Primärsektorwirtschaft',
          strongIndustrialBase: 'Starke industrielle Basis',
          title: 'Wirtschaftsstruktur',
        },
        title: 'Sektorzusammensetzung',
        tooltips: {
          jobs: 'Arbeitsplätze',
          share: 'Anteil',
        },
      },
      sectorEvolution: {
        axis: {
          employment: 'Beschäftigung',
        },
        legend: {
          primarySector: 'Primärsektor',
          secondarySector: 'Sekundärsektor',
          tertiarySector: 'Tertiärsektor',
        },
        noData: 'Keine Sektorentwicklungsdaten verfügbar',
        subtitle: 'Historische Sektorzusammensetzung mit wirtschaftlichen Übergängen (2011-2022)',
        summary: {
          economicTransformation: 'Wirtschaftliche Transformation',
          gradualTransition: 'Schrittweiser wirtschaftlicher Übergang',
          serviceSectorTrend: 'Trend im Dienstleistungssektor',
          significantStructuralChange: 'Signifikanter Strukturwandel',
          stableSectorComposition: 'Stabile Sektorzusammensetzung',
          title: 'Sektorentwicklung ({{startYear}}-{{endYear}})',
          totalEmploymentChange: 'Gesamtbeschäftigungsänderung',
        },
        title: 'Sektorentwicklung über die Zeit',
        tooltips: {
          total: 'Gesamt',
          year: 'Jahr',
        },
      },
      totalEmploymentTrend: {
        subtitle: 'Historische Beschäftigung mit Wachstumsphasen und Wendepunkten (2011-2022)',
        title: 'Gesamtbeschäftigungstrend',
      },
    },
    common: {
      establishments: 'Betriebe',
      jobs: 'Arbeitsplätze',
    },
    filters: {
      byBicycle: 'Mit dem Fahrrad',
      byCar: 'Mit dem Auto',
      byWalk: 'Zu Fuss',
      city: 'Stadt',
      district: 'Bezirk',
      location: 'Standort:',
      minBike: '{{minutes}}min mit dem Fahrrad',
      minDrive: '{{minutes}}min mit dem Auto',
      minWalk: '{{minutes}}min zu Fuss',
      selectLocation: 'Standort auswählen',
    },
    loading: {
      employment: 'Beschäftigungsdaten werden geladen...',
      error: 'Fehler beim Laden der Beschäftigungsdaten:',
      fetchFailed: 'Laden der Beschäftigungsdaten fehlgeschlagen',
      noData: 'Für diesen Standort sind keine Beschäftigungsdaten verfügbar.',
    },
    metrics: {
      cagr: {
        subtitle: '10-Jahres-Zinseszins',
        title: 'Jährliche Wachstumsrate (CAGR)',
      },
      dominantSector: {
        subtitle: '{{percentage}}% der Gesamtbeschäftigung',
        title: 'Dominanter Sektor',
      },
      employmentGrowth: {
        subtitle: '10-Jahres-Entwicklung',
        title: 'Beschäftigungswachstum',
      },
      establishmentGrowth: {
        subtitle: '10-Jahres-Entwicklung',
        title: 'Wachstum der Betriebe',
      },
      fiveYearGrowth: {
        subtitle: 'Mittelfristige Entwicklung',
        title: '5-Jahres-Wachstum',
      },
      fullTimeRatio: {
        subtitle: 'Stabilitätsindikator',
        title: 'Vollzeitbeschäftigungsquote',
      },
      jobsPerEstablishment: {
        subtitle: 'Wirtschaftliche Effizienz',
        title: 'Arbeitsplätze pro Betrieb',
      },
      oneYearGrowth: {
        subtitle: 'Neuester Trend',
        title: '1-Jahres-Wachstum',
      },
      privateSectorShare: {
        subtitle: '{{count}} Betriebe',
        title: 'Anteil privater Sektor',
      },
      publicSectorShare: {
        subtitle: '{{count}} Betriebe',
        title: 'Anteil öffentlicher Sektor',
      },
      tenYearGrowth: {
        subtitle: 'Langfristiger Strukturwandel',
        title: '10-Jahres-Wachstum',
      },
      totalEmployment: {
        subtitle: 'Arbeitsplätze in der Region',
        title: 'Gesamtbeschäftigung',
      },
      totalEstablishments: {
        subtitle: 'Anzahl Unternehmen',
        title: 'Anzahl Unternehmen',
      },
      twoYearGrowth: {
        subtitle: 'Bestätigung des aktuellen Trends',
        title: '2-Jahres-Wachstum',
      },
    },
    section: {
      subtitle: 'Arbeitsmarkttrends und Einblicke in die Geschäftstätigkeit der Region',
      title: 'Beschäftigung',
    },
    sectors: {
      agriculture: 'Landwirtschaft',
      industry: 'Industrie',
      primary: {
        description: 'Landwirtschaft, Bergbau',
        name: 'Primärsektor (Landwirtschaft, Bergbau)',
        short: 'Primär',
      },
      privateSector: 'Privater Sektor',
      publicSector: 'Öffentlicher Sektor',
      secondary: {
        description: 'Industrie, Bau',
        name: 'Sekundärsektor (Industrie, Bau)',
        short: 'Sekundär',
      },
      services: 'Dienstleistungen',
      tertiary: {
        description: 'Dienstleistungen',
        name: 'Tertiärsektor (Dienstleistungen)',
        short: 'Tertiär',
      },
    },
    tabs: {
      business: 'Geschäftstätigkeit',
      growth: 'Beschäftigungswachstum',
      overview: 'Übersicht',
      sectors: 'Wirtschaftssektoren',
    },
    tooltips: {
      cagr: {
        calculation: '((Aktuelle Beschäftigung / Beschäftigung vor 10 Jahren)^(1/10) - 1) × 100',
        importance: 'Glättet jährliche Schwankungen, um den zugrunde liegenden Beschäftigungswachstumstrend zu zeigen. Genauer als der einfache Durchschnitt.',
        limitations: 'Geht von stetigem Wachstum aus, tatsächliches Wachstum kann mit Boom/Bust-Zyklen unregelmässig sein',
        shortDescription: 'Durchschnittliche jährliche Beschäftigungswachstumsrate über 10 Jahre, unter Berücksichtigung des Zinseszinseffekts',
        source: 'Berechnet aus Daten des Bundesamts für Statistik',
        title: 'Jährliche Wachstumsrate (zusammengesetzt)',
      },
      dominantSector: {
        calculation: 'Sektor mit max(Sektor 1 %, Sektor 2 %, Sektor 3 %)',
        importance: 'Zeigt den wirtschaftlichen Charakter der Region. Dienstleistungsdominante Gebiete haben Angestellte, die höhere Immobilienwerte unterstützen. Industriedominante Gebiete brauchen Arbeiterwohnungen. Landwirtschaft zeigt ländlichen Charakter an.',
        limitations: 'Sektor 3 (Dienstleistungen) ist sehr breit gefasst und umfasst alles vom Einzelhandel bis zum Finanzwesen.',
        shortDescription: 'Wirtschaftssektor mit dem höchsten Beschäftigungsanteil',
        source: 'Bundesamt für Statistik - Sektorbeschäftigungsdaten',
        title: 'Dominanter Sektor',
      },
      employmentGrowth: {
        calculation: '(Aktuelle Beschäftigung - Beschäftigung vor 10 Jahren) / Beschäftigung vor 10 Jahren',
        importance: 'Beschäftigungswachstum ist DER wichtigste Treiber für die Immobiliennachfrage. Positives Wachstum zeigt Wertsteigerungspotenzial und steigende Immobiliennachfrage an.',
        limitations: 'Historische Trends können die zukünftige Performance nicht vorhersagen. Externe Schocks können den Verlauf ändern.',
        shortDescription: 'Beschäftigungsveränderung in den letzten 10 Jahren',
        source: 'Bundesamt für Statistik - Historische Beschäftigungsdaten',
        title: 'Beschäftigungswachstum',
      },
      establishmentGrowth: {
        calculation: '(Aktuelle Betriebe - Betriebe vor 10 Jahren) / Betriebe vor 10 Jahren',
        importance: 'Frühindikator für Beschäftigungswachstum. Neue Unternehmen stellen oft vor dem Umsatz ein. Positives Wachstum deutet auf ein unternehmerisches Ökosystem und zukünftige Arbeitsplatzschaffung hin.',
        limitations: 'Unternehmensgründungen können dem Scheitern vorausgehen. Die Nettanzahl zeigt nicht die Flukturationsdynamik.',
        shortDescription: 'Veränderung der Anzahl der Unternehmen über 10 Jahre',
        source: 'Bundesamt für Statistik - Historische Betriebsdaten',
        title: 'Wachstum der Betriebe',
      },
      fiveYearGrowth: {
        calculation: '(Beschäftigung aktuelles Jahr - Beschäftigung vor 5 Jahren) / Beschäftigung vor 5 Jahren',
        importance: 'Mittelfristiger Trendindikator. Zuverlässiger als kurzfristig, aber immer noch reaktiv auf strukturelle Veränderungen.',
        limitations: 'Umfasst die COVID-19-Pandemiezeit, die Trends verzerren kann.',
        shortDescription: 'Beschäftigungsveränderung in den letzten 5 Jahren',
        source: 'Bundesamt für Statistik - Jährliche Beschäftigungsdaten',
        title: '5-Jahres-Beschäftigungswachstum',
      },
      fullTimeRatio: {
        calculation: '(Vollzeitbeschäftigung / Gesamtbeschäftigung) × 100',
        importance: 'Höhere Quoten zeigen stabilere Beschäftigung und Einkommen an. Mehr Vollzeitbeschäftigte bedeuten zuverlässigere Nachfrage nach Wohn- und Gewerberaum.',
        limitations: 'Teilzeit kann freiwillig oder unfreiwillig sein. Spiegelt nicht Einkommensniveaus oder Arbeitsplatzsicherheit wider.',
        shortDescription: 'Prozentsatz der Gesamtbeschäftigung, der Vollzeit ist',
        source: 'Bundesamt für Statistik - Statistiken zu Beschäftigungsarten',
        title: 'Vollzeitbeschäftigungsquote',
      },
      jobsPerEstablishment: {
        calculation: 'Gesamtbeschäftigung / Gesamtzahl der Betriebe',
        importance: 'Zeigt die durchschnittliche Unternehmensgrösse und Wirtschaftsstruktur an. Höhere Verhältnisse deuten auf grössere Arbeitgeber hin, niedrigere Verhältnisse auf eine Kleinunternehmenswirtschaft.',
        limitations: 'Unterscheidet nicht zwischen Sektoren. Grosse Arbeitgeber können den Durchschnitt verzerren.',
        shortDescription: 'Durchschnittliche Anzahl der Mitarbeiter pro Unternehmen',
        source: 'Berechnet aus Betriebs- und Beschäftigungszensus-Daten',
        title: 'Arbeitsplätze pro Betrieb',
      },
      oneYearGrowth: {
        calculation: '(Beschäftigung aktuelles Jahr - Beschäftigung Vorjahr) / Beschäftigung Vorjahr',
        importance: 'Zeigt die neueste Dynamik. Schnelles aktuelles Wachstum kann auf entstehende Möglichkeiten hindeuten, Rückgang kann ein Frühwarnsignal sein.',
        limitations: 'Kann aufgrund des kurzen Zeitraums volatil sein. Daten eines einzelnen Jahres spiegeln möglicherweise nicht den Trend wider.',
        shortDescription: 'Beschäftigungsveränderung im letzten Jahr',
        source: 'Bundesamt für Statistik - Jährliche Beschäftigungsdaten',
        title: '1-Jahres-Beschäftigungswachstum',
      },
      primarySector: {
        calculation: 'Summe aller Beschäftigten in NOGA-Sektor-1-Aktivitäten',
        importance: 'Die Dominanz des Primärsektors zeigt einen ländlichen Charakter mit spezialisierten Immobilienmöglichkeiten. Typischerweise niedrigere Immobilienwerte, aber stabile langfristige Nachfrage.',
        limitations: 'Unterliegt saisonalen Schwankungen. Kann Teilzeit-Landarbeiter einschliessen.',
        shortDescription: 'Arbeitsplätze in Landwirtschaft, Forstwirtschaft, Fischerei und Bergbau',
        source: 'Bundesamt für Statistik - Sektorklassifizierung nach NOGA-Codes',
        title: 'Beschäftigung im Primärsektor',
      },
      privateSectorEstablishments: {
        calculation: '(Private Betriebe / Gesamtzahl der Betriebe) × 100',
        importance: 'Hoher privater Sektor zeigt eine unternehmerische, marktorientierte Wirtschaft an. Dynamischer, aber potenziell volatiler. Vielfältige Nachfrage nach Gewerbeimmobilien.',
        limitations: 'Unterscheidet nicht zwischen kleinen Unternehmen und grossen Konzernen.',
        shortDescription: 'Prozentsatz der Betriebe, die private Unternehmen sind',
        source: 'Bundesamt für Statistik - Sektorklassifizierung',
        title: 'Private Betriebe',
      },
      publicSectorEstablishments: {
        calculation: '(Öffentliche Betriebe / Gesamtzahl der Betriebe) × 100',
        importance: 'Hohe öffentliche Präsenz zeigt eine von der Regierung abhängige Wirtschaft an. Stabiler, aber langsameres Wachstum. Anderes Mieterprofil für Gewerbeimmobilien.',
        limitations: 'Spiegelt nicht die Beschäftigungsgrösse wider. Eine grosse Regierungseinheit zählt wie ein kleines Büro.',
        shortDescription: 'Prozentsatz der Betriebe, die Regierungseinheiten sind',
        source: 'Bundesamt für Statistik - Sektorklassifizierung',
        title: 'Öffentliche Betriebe',
      },
      secondarySector: {
        calculation: 'Summe aller Beschäftigten in NOGA-Sektor-2-Aktivitäten',
        importance: 'Die industrielle Basis schafft Nachfrage nach Arbeiterwohnungen, Logistikeinrichtungen und Gewerbeimmobilien. Arbeiter benötigen typischerweise erschwingliche Wohnmöglichkeiten.',
        limitations: 'Kann mit den wirtschaftlichen Bedingungen zyklisch sein. Automatisierung kann die Beschäftigung im Laufe der Zeit reduzieren.',
        shortDescription: 'Arbeitsplätze in Fertigung, Bau und industrieller Produktion',
        source: 'Bundesamt für Statistik - Sektorklassifizierung nach NOGA-Codes',
        title: 'Beschäftigung im Sekundärsektor',
      },
      tenYearGrowth: {
        calculation: '(Beschäftigung aktuelles Jahr - Beschäftigung vor 10 Jahren) / Beschäftigung vor 10 Jahren',
        importance: 'Langfristiger struktureller Trend. Bester Indikator für grundlegende wirtschaftliche Transformation und Immobiliennachfrage-Entwicklung.',
        limitations: 'Langer Zeitraum kann aktuelle Veränderungen verschleiern. Umfasst mehrere Wirtschaftszyklen.',
        shortDescription: 'Beschäftigungsveränderung in den letzten 10 Jahren',
        source: 'Bundesamt für Statistik - Jährliche Beschäftigungsdaten',
        title: '10-Jahres-Beschäftigungswachstum',
      },
      tertiarySector: {
        calculation: 'Summe aller Beschäftigten in NOGA-Sektor-3-Aktivitäten',
        importance: 'Die Dominanz des Dienstleistungssektors zeigt einen urbanen Charakter mit starker Nachfrage nach Wohn- und Einzelhandelsimmobilien. Angestellte unterstützen höhere Immobilienwerte.',
        limitations: 'Breite Kategorie, die sehr unterschiedliche Berufsarten und Einkommensniveaus umfasst.',
        shortDescription: 'Arbeitsplätze in Dienstleistungen, Einzelhandel, Finanzen, Bildung, Gesundheitswesen und Gastgewerbe',
        source: 'Bundesamt für Statistik - Sektorklassifizierung nach NOGA-Codes',
        title: 'Beschäftigung im Tertiärsektor',
      },
      totalEmployment: {
        calculation: 'Summe aller Beschäftigten (Vollzeit und Teilzeit) über alle Sektoren',
        importance: 'Zeigt das Niveau der wirtschaftlichen Aktivität und die Grösse des Arbeitsmarktes an. Höhere Beschäftigung deutet auf stärkere Immobiliennachfrage hin.',
        limitations: 'Basiert auf offiziellen Statistiken, umfasst möglicherweise nicht die informelle Wirtschaft oder Selbstständige',
        shortDescription: 'Gesamtzahl der Arbeitsplätze im definierten geografischen Gebiet',
        source: 'Bundesamt für Statistik - Betriebszählung',
        title: 'Gesamtbeschäftigung',
      },
      totalEstablishments: {
        calculation: 'Anzahl aller registrierten Geschäftsstandorte (öffentlicher + privater Sektor)',
        importance: 'Zeigt die Grösse des Geschäftsökosystems und die wirtschaftliche Vielfalt an. Mehr Betriebe deuten auf ein lebhaftes Geschäftsumfeld hin, das Immobilienwerte unterstützt.',
        limitations: 'Spiegelt nicht die Unternehmensgrösse oder den Umsatz wider. Umfasst sehr kleine Unternehmen.',
        shortDescription: 'Gesamtzahl der Geschäftsbetriebe in der Region',
        source: 'Bundesamt für Statistik - Betriebszählung',
        title: 'Gesamtzahl der Betriebe',
      },
      twoYearGrowth: {
        calculation: '(Beschäftigung aktuelles Jahr - Beschäftigung vor 2 Jahren) / Beschäftigung vor 2 Jahren',
        importance: 'Bestätigt, ob der 1-Jahres-Trend anhält. Hilft, einmalige Ereignisse auszufiltern.',
        limitations: 'Immer noch relativ kurzfristig. Kann Pandemie-Effekte enthalten.',
        shortDescription: 'Beschäftigungsveränderung in den letzten 2 Jahren',
        source: 'Bundesamt für Statistik - Jährliche Beschäftigungsdaten',
        title: '2-Jahres-Beschäftigungswachstum',
      },
    },
  },
  energy: {
    dataSource: {
      egid: 'Gebäude-ID (EGID)',
      regbl: 'Eidgenössisches Gebäude- und Wohnungsregister (GWR)',
      title: 'Datenquelle',
      viewInRegBL: 'Im GWR anzeigen',
    },
    dataSourceBanner: {
      description: 'Diese Daten werden von Bundes- und Kantonsbehörden erhoben und gepflegt. Die Aktualisierungsdaten variieren je nach Feld und werden neben jedem Datenpunkt angezeigt.',
      title: 'Datenquelle: Eidgenössisches Gebäude- und Wohnungsregister (GWR)',
      viewCompleteRecord: 'Vollständigen Gebäudeeintrag im GWR anzeigen',
    },
    freshness: {
      daysAgo: 'Vor {{count}} Tagen',
      fresh: 'Kürzlich aktualisiert',
      levels: {
        aging: 'Älter werdend',
        outdated: 'Veraltet',
        recent: 'Aktuell',
      },
      monthsAgo: 'Vor {{count}} Monaten',
      oneYearAgo: 'vor 1 Jahr',
      stale: 'Daten können veraltet sein',
      thisYear: 'dieses Jahr',
      today: 'Heute',
      yearsAgo: 'Vor {{count}} Jahren',
      yesterday: 'Gestern',
    },
    header: {
      subtitle: 'Gebäude-Energiedaten aus dem Eidgenössischen Gebäude- und Wohnungsregister (GWR)',
      title: 'Energieanalyse',
    },
    heating: {
      card: {
        egidNotAvailable: 'EGID nicht verfügbar',
        entryOf: 'Eintrag {{number}} von {{total}}',
        mostRecent: 'Neueste',
        title: 'Heizsysteme',
      },
      checkRegBL: 'GWR prüfen',
      metrics: {
        distributionSystem: 'Verteilsystem',
        generatorType: 'Generatortyp',
        lastUpdated: 'Zuletzt aktualisiert',
        noDataAvailable: 'Keine Daten verfügbar',
        notDeclared: 'Nicht angegeben',
        powerSource: 'Energiequelle',
        status: 'Status',
      },
      multipleEntries: {
        description: 'Dieses Gebäude hat {{count}} separate Einträge im GWR, möglicherweise von verschiedenen Registrierungsdaten oder Aktualisierungen. Alle Einträge werden unten angezeigt, sortiert nach dem neuesten zuerst.',
        title: 'Mehrere Registereinträge gefunden',
      },
      noData: 'Keine Heizungsdaten im GWR für dieses Gebäude verfügbar.',
      sections: {
        additionalHeating: 'Zusätzliche Heizung',
        additionalWaterHeating: 'Zusätzliche Warmwasserbereitung',
        primaryHeating: 'Primäre Heizung',
        waterHeating: 'Warmwasserbereitung',
      },
    },
    idc: {
      actionPlan: {
        heating: 'Heizsystem modernisieren',
        insulation: 'Gebäudedämmung verbessern',
        solar: 'Solaranlagen installieren',
        title: 'Empfohlene Massnahmen',
        windows: 'Fenster durch energieeffiziente Modelle ersetzen',
      },
      comparison: {
        buildingAge: 'Ähnliches Gebäudealter',
        canton: 'Kantonsdurchschnitt',
        district: 'Bezirksdurchschnitt',
        title: 'IDC-Vergleich',
      },
      costEstimator: {
        annual: 'Jährliche Kosten',
        perM2: 'Kosten pro m²',
        title: 'Geschätzte Energiekosten',
      },
      gauge: {
        current: 'Aktueller IDC',
        legalLimit: 'Gesetzliche Grenze',
        target: 'Ziel',
      },
      ratings: {
        average: 'Durchschnittlich',
        critical: 'Kritisch',
        excellent: 'Ausgezeichnet',
        good: 'Gut',
        poor: 'Schlecht',
      },
      regulatory: {
        compliant: 'Konform',
        deadline: 'Konformitätsfrist',
        nonCompliant: 'Nicht konform',
        title: 'Regulatorische Konformität',
      },
      subtitle: 'Energieleistungsindikator für Genfer Gebäude',
      title: 'IDC - Wärmeverbrauchsindex',
    },
    idcComparisonCard: {
      noData: 'Keine Vergleichsdaten für dieses Gebäude verfügbar.',
      noDataForZone: 'Keine Daten für diese Zone verfügbar.',
      performanceText: 'Ihr IDC von {{idc}} MJ/m² liegt im {{percentile}}. Perzentil unter {{count}} Gebäuden in {{scope}}.',
      scopeLabels: {
        municipality: 'Gemeinde',
        npa: 'Postleitzahl',
        radius_500m: 'Radius 500m',
        region: 'Kanton',
      },
      stats: {
        average: 'Durchschnitt',
        maximum: 'Maximum',
        median: 'Median',
        minimum: 'Minimum',
        percentile25: '25. Perzentil',
        percentile75: '75. Perzentil',
      },
      title: 'IDC-Vergleiche',
      tooltipDescription: 'Vergleichen Sie den IDC dieses Gebäudes mit Statistiken anderer Gebäude in Genf. Ein niedrigerer Perzentilwert deutet auf eine bessere Energieeffizienz hin.',
      tooltipDescriptionLoading: 'Vergleichen Sie den IDC dieses Gebäudes mit Statistiken anderer Gebäude in Genf in verschiedenen geografischen Zonen.',
    },
    idcDistributionChart: {
      title: 'IDC-Verteilung - {{scope}}',
      tooltipBuildings: 'Anzahl Gebäude: <strong>{{count}}</strong>',
      xAxisName: 'IDC (MJ/m²·Jahr)',
      yAxisName: 'Anzahl Gebäude',
      yourBuilding: 'Ihr Gebäude',
    },
    idcGaugeChart: {
      legend: {
        compliant: 'Konform (0-{{threshold}})',
        critical: 'Kritisch (>{{threshold}})',
        optimizationRequired: 'Optimierung erforderlich ({{min}}-{{max}})',
        warning: 'Warnung ({{min}}-{{max}})',
      },
      title: 'IDC-Position',
      unit: 'MJ/m²·Jahr',
    },
    idcRegulatoryBanner: {
      actionTypes: {
        audit: 'Energieaudit empfohlen',
        mandatoryRenovation: 'Obligatorische Sanierung erforderlich',
        noObligation: 'Keine regulatorische Verpflichtung',
        optimization: 'Energieoptimierung erforderlich',
      },
      deadline: 'Frist: {{year}}',
      yearsRemaining: {
        one: '({{count}} Jahr verbleibend)',
        other: '({{count}} Jahre verbleibend)',
      },
    },
    idcTab: {
      dataSourceNote: {
        description: 'Kantonales Energieamt (OCEN) - Kanton Genf. Der IDC wird auf Basis der tatsächlich deklarierten und geprüften Verbräuche berechnet. Weitere Informationen:',
        linkText: 'ge.ch/energie',
        title: 'Datenquelle:',
      },
      infoBanner: 'Wärmeverbrauchsindex (IDC) - Obligatorischer Indikator für beheizte Gebäude im Kanton Genf. Der IDC misst den jährlichen Energieverbrauch für Heizung und Warmwasser bezogen auf die Energiebezugsfläche (EBF).',
      metrics: {
        regulatoryThreshold: {
          title: 'Gesetzlicher Grenzwert',
          tooltip: {
            calculation: 'Auf {{threshold}} MJ/m²/Jahr ({{kWh}} kWh/m²/Jahr) seit September 2022 festgelegt',
            description: 'Vom Kanton Genf festgelegter Schwellenwert, oberhalb dessen Optimierungsmassnahmen erforderlich sind',
            importance: 'Bei Überschreitung dieses Schwellenwerts besteht die Pflicht zur Umsetzung von Energieoptimierungsmassnahmen',
            source: 'Energiegesetz (EnG) - Kanton Genf',
          },
        },
        significantExceedanceThreshold: {
          exceeded: 'Überschritten - Obligatorische Sanierung',
          notExceeded: 'Nicht überschritten',
          periods: {
            from2031: 'ab 2031',
            until2026: 'bis 2026',
            until2030: 'bis 2030',
          },
          title: 'Schwellenwert für signifikante Überschreitung',
          tooltip: {
            calculation: 'Derzeit {{threshold}} MJ/m² ({{period}}). Der Schwellenwert wird schrittweise gesenkt: 800 MJ/m² (2022-2026) → 650 MJ/m² (2027-2030) → 550 MJ/m² (2031+)',
            description: 'Über diesem Schwellenwert ist eine obligatorische energetische Sanierung erforderlich',
            importance: 'Bei Überschreitung dieses Schwellenwerts besteht die gesetzliche Pflicht, innerhalb von 3 Jahren nach dem Verwaltungsbescheid eine energetische Sanierung durchzuführen',
            limitations: 'Der Schwellenwert variiert je nach Jahr und wird schrittweise gesenkt, um die kontinuierliche Verbesserung des Gebäudebestands zu fördern',
            source: 'Energieverordnung (EnV) - Kanton Genf',
          },
        },
        yourPosition: {
          title: 'Ihre Position',
          tooltip: {
            calculation: '(Gebäude-IDC - Gesetzlicher Grenzwert) / Gesetzlicher Grenzwert × 100',
            description: 'Abweichung vom gesetzlichen Grenzwert von {{threshold}} MJ/m²',
            importance: 'Zeigt an, ob Ihr Gebäude den regulatorischen Anforderungen entspricht oder Optimierungsmassnahmen benötigt',
            source: 'Berechnet aus OCEN-Daten',
          },
        },
      },
    },
    regblLink: {
      viewBuildingTitle: 'Gebäude {{egid}} im Eidgenössischen Gebäude- und Wohnungsregister anzeigen',
      viewInRegBL: 'Im GWR anzeigen',
    },
    solar: {
      comparison: {
        actual: 'Aktuelle Installation',
        optimal: 'Optimales Potenzial',
        title: 'Solarpotenzialvergleich',
        utilizationRate: 'Nutzungsrate',
      },
      history: {
        title: 'Installationsverlauf',
      },
      installation: {
        estimatedProduction: 'Geschätzte Jahresproduktion',
        installedPower: 'Installierte Leistung',
        moduleArea: 'Modulfläche',
        title: 'Solaranlage',
        yearInstalled: 'Installationsjahr',
      },
      potential: {
        electricalEfficiency: 'Elektrische Effizienz',
        roofArea: 'Geeignete Dachfläche',
        thermalEfficiency: 'Thermische Effizienz',
        title: 'Solarpotenzial',
      },
    },
    solarComparison: {
      actualConditions: 'Tatsächliche Bedingungen',
      annualProductionPotential: 'Jährliches Produktionspotenzial',
      bestAnnualProduction: 'Beste Jahresproduktion',
      bestCase: 'Bestfall',
      bestSolarIrradiance: 'Beste Sonneneinstrahlung',
      bestSuitableArea: 'Beste geeignete Fläche',
      estimatedCapacity: 'Geschätzte Kapazität',
      noData: 'Keine Solarpotenzialdaten für dieses Gebäude verfügbar.',
      noteDescription: 'Tatsächliche Bedingungen umfassen alle geeigneten Dachflächen unabhängig von der Ausrichtung. Optimale Bedingungen nutzen nur die am besten ausgerichteten Flächen (typischerweise nach Süden, ~30° Neigung). Verwenden Sie "Tatsächlich" für eine realistische Planung.',
      noteTitle: 'Was ist der Unterschied?',
      optimalConditions: 'Optimale Bedingungen',
      realistic: 'Realistisch',
      solarIrradiance: 'Sonneneinstrahlung',
      suitableRoofArea: 'Geeignete Dachfläche',
      title: 'Solarpotenzialvergleich',
      titleActualVsOptimal: 'Solarpotenzial: Tatsächlich vs Optimal',
      tooltips: {
        annualProduction: {
          calculation: 'Dachfläche × Einstrahlung × Panel-Effizienz (~17-20%) × Systemverluste (~15%)',
          description: 'Geschätzte Stromproduktion, wenn die geeignete Dachfläche vollständig mit Solarmodulen ausgestattet ist',
          importance: 'Dies ist die Schlüsselmetrik zur Schätzung potenzieller Energieeinsparungen und der Kapitalrendite',
          limitations: 'Geht von vollständiger Dachbedeckung mit Standardmodulen aus. Die tatsächliche Produktion hängt vom Modultyp, der Installationsqualität und der Wartung ab.',
          source: 'BFE Solarkataster (Bundesamt für Energie)',
          title: 'Jährliches Produktionspotenzial',
        },
        bestAnnualProduction: {
          calculation: 'Beste geeignete Fläche × Beste Einstrahlung × Panel-Effizienz × Systemverluste',
          description: 'Maximale Stromproduktion unter Nutzung nur optimal ausgerichteter Dachflächen',
          importance: 'Zeigt die theoretische Maximaleffizienz. Kann weniger Gesamtenergie produzieren als die Nutzung aller geeigneten Flächen, wenn die optimale Fläche klein ist.',
          limitations: 'Nützlich für Vergleiche, stellt aber möglicherweise nicht die beste wirtschaftliche Wahl dar, wenn die optimale Fläche begrenzt ist.',
          source: 'BFE Solarkataster (Bundesamt für Energie)',
          title: 'Beste Jahresproduktion',
        },
        bestSolarIrradiance: {
          calculation: 'Durchschnittliche Einstrahlung auf nach Süden ausgerichteten Flächen mit optimaler Neigung (~30° in der Schweiz)',
          description: 'Maximale Sonnenstrahlung auf den am besten ausgerichteten Dachabschnitten',
          importance: 'Stellt das Spitzeneffizienzpotenzial dar. Vergleichen Sie mit der tatsächlichen Einstrahlung, um zu sehen, wie sehr die Ausrichtung die Produktion beeinflusst.',
          limitations: 'Nur auf ideal ausgerichteten Dachabschnitten erreichbar. Die meisten Gebäude haben eine begrenzte optimal ausgerichtete Fläche.',
          source: 'BFE Solarkataster (Bundesamt für Energie)',
          title: 'Beste Sonneneinstrahlung',
        },
        bestSuitableArea: {
          calculation: 'Gefilterte Teilmenge der gesamten geeigneten Fläche: nur nach Süden ausgerichtete Flächen mit ~30° Neigung erhalten maximale jährliche Einstrahlung',
          description: 'Dachfläche mit optimaler Ausrichtung für Solarmodule (nur am besten ausgerichtete Abschnitte)',
          importance: 'Stellt die effizientesten Platzierungszonen dar. Die Installation hier maximiert die Energieproduktion pro Modul.',
          limitations: 'Kann deutlich kleiner sein als die gesamte geeignete Fläche. Die Fokussierung nur auf optimale Bereiche kann den verfügbaren Dachraum unternutzen.',
          source: 'BFE Solarkataster (Bundesamt für Energie)',
          title: 'Beste geeignete Fläche',
        },
        estimatedCapacity: {
          calculation: 'Geeignete Dachfläche ÷ 6,5 m²/kWp (Branchenstandard: ~6,5 m² pro 1 kWp installierter Leistung)',
          description: 'Theoretische maximale Solarinstallationskapazität in Kilowatt-Peak (kWp)',
          importance: 'Hilft bei der Schätzung der Installationsgrösse, der Kosten und beim Vergleich mit bestehenden Installationen. Ein typischer Haushalt benötigt 3-5 kWp.',
          limitations: 'Dies ist eine grobe Schätzung. Die tatsächliche Kapazität hängt von der Panel-Effizienz, den Installationsbeschränkungen und Dachhindernissen ab.',
          source: 'Berechnete Schätzung basierend auf Industriestandards',
          title: 'Geschätzte Kapazität',
        },
        estimatedCapacityOptimal: {
          calculation: 'Beste geeignete Fläche ÷ 6,5 m²/kWp (Branchenstandard)',
          description: 'Maximale Installationskapazität unter Nutzung nur der am besten ausgerichteten Dachabschnitte',
          importance: 'Vergleichen Sie mit der tatsächlichen Kapazitätsschätzung, um zu sehen, wie sehr die Dachausrichtung die potenzielle Installationsgrösse beeinflusst.',
          limitations: 'Oft kleiner als die tatsächliche Kapazitätsschätzung. Überlegen Sie, ob die Maximierung der Effizienz oder der Gesamtproduktion wichtiger ist.',
          source: 'Berechnete Schätzung basierend auf Industriestandards',
          title: 'Geschätzte Kapazität (Optimal)',
        },
        solarIrradiance: {
          calculation: 'Modelliert aus meteorologischen Daten, Topografie, Dachausrichtung und lokaler Beschattung durch Gebäude und Vegetation',
          description: 'Durchschnittliche jährlich pro Quadratmeter Dachfläche empfangene Solarstrahlungsenergie',
          importance: 'Höhere Einstrahlungswerte weisen auf ein besseres Solarenergiepotenzial hin. Werte über 1000 kWh/m²/Jahr gelten für die Schweiz als gut.',
          limitations: 'Basiert auf Modellierung, nicht auf tatsächlichen Messungen. Wettervariationen zwischen den Jahren können die realen Werte um ±10-15% beeinflussen.',
          source: 'BFE Solarkataster (Bundesamt für Energie)',
          title: 'Sonneneinstrahlung',
        },
        suitableRoofArea: {
          calculation: '3D-Analyse der Dachflächen, gefiltert nach Neigung (>10°), Ausrichtung und Mindestgrössenanforderungen',
          description: 'Gesamte Dachfläche, die für die Installation von Solarmodulen geeignet ist',
          importance: 'Bestimmt die maximale Anzahl installierbarer Solarmodule und beeinflusst direkt die potenzielle Energieproduktion',
          limitations: 'Berücksichtigt keine Hindernisse wie Schornsteine, Oberlichter, HLK-Anlagen oder strukturelle Einschränkungen. Professionelle Bewertung empfohlen.',
          source: 'BFE Solarkataster (Bundesamt für Energie)',
          title: 'Geeignete Dachfläche',
        },
      },
    },
    solarInstallation: {
      added: 'hinzugefügt',
      firstInstallation: 'Erste Installation',
      installationCount: '{{count}} Installation',
      installationEvents: 'Installationsereignisse',
      installationHistory: 'Installationsverlauf',
      installationsCount: '{{count}} Installationen',
      installationYear: 'Installationsjahr',
      installed: 'installiert',
      noData: 'Keine Solaranlage für dieses Gebäude erfasst.',
      title: 'Solaranlage',
      totalInstalledCapacity: 'Installierte Gesamtkapazität',
    },
    states: {
      error: 'Fehler beim Laden der Energieanalyse: {{error}}',
      loading: 'Energieanalyse wird geladen...',
      noData: 'Keine Gebäudedaten verfügbar',
    },
    tabs: {
      heating: 'Heizung',
      idc: 'IDC Genf',
      solar: 'Solarenergie',
    },
  },
  environment: {
    air_quality: {
      aqi: 'Luftqualitätsindex',
      category: 'Kategorie',
      title: 'Luftqualität',
    },
    failed_to_fetch: 'Fehler beim Abrufen der Umweltdaten',
    loading: 'Umweltdaten werden geladen...',
    no_data: 'Keine Umweltdaten verfügbar',
    no_data_description: 'Umweltdaten sind für diesen Standort nicht verfügbar. Dies könnte auf eine begrenzte Überwachungsabdeckung in diesem Bereich zurückzuführen sein.',
    noise: {
      aircraft: 'Fluglärm',
      description: 'Lärmpegel und Schallverschmutzungsanalyse für diesen Standort',
      guidelines: 'Lärmpegelrichtlinien',
      levels: {
        moderate: 'Mässig',
        noisy: 'Laut',
        quiet: 'Ruhig',
        very_noisy: 'Sehr laut',
        very_quiet: 'Sehr ruhig',
      },
      railway_day: 'Bahnlärm (Tag)',
      road_day: 'Strassenlärm (Tag)',
      road_night: 'Strassenlärm (Nacht)',
      title: 'Lärmpegel',
    },
    noise_analysis: 'Lärmanalyse',
    sunlight: {
      afternoon_sun: 'Nachmittagssonne',
      daily_hours: 'Tägliches Sonnenlicht',
      description: 'Sonnenexposition und Sonnenlicht-Verfügbarkeit den ganzen Tag über',
      levels: {
        excellent: 'Ausgezeichnet',
        good: 'Gut',
        low: 'Niedrig',
        moderate: 'Mässig',
        very_low: 'Sehr niedrig',
      },
      morning_sun: 'Morgensonne',
      seasonal_variation: 'Saisonale Schwankung',
      title: 'Sonnenexposition',
    },
    sunlight_study: 'Sonnenlicht-Studie',
    title: 'Umweltanalyse',
  },
  estimate: {
    autoValuations: {
      back: 'Zurück zu den Bewertungen',
      details: 'Details',
      empty: {
        text: 'Automatische Bewertungen von AVM-Anbietern sind für diese Immobilie nicht verfügbar.',
        title: 'Keine automatischen Bewertungen',
      },
      meta: {
        confidenceScore: 'Konfidenzwert',
        dataRange: 'Datenbereich',
        dealType: 'Transaktionsart',
        landArea: 'Grundstücksfläche',
        listingsCount: 'Anzahl Angebote',
        method: 'Methode',
        modelVersion: 'Modellversion',
        pricePerM2: 'Preis pro m²',
        provider: 'Anbieter',
        unknown: 'Unbekannt',
        valuePerM2LandConservative: 'Wert pro m² Grundstück (konservativ)',
        valuePerM2LandOptimistic: 'Wert pro m² Grundstück (optimistisch)',
        values: {
          purchase: 'Kauf',
          rent: 'Miete',
          sale: 'Verkauf',
        },
      },
      methodDescriptions: {
        popety_io: 'Automatisierte Bewertung basierend auf dem proprietären Algorithmus von Popety.io, der Immobilienmerkmale, aktuelle Markttransaktionen und standortspezifische Faktoren analysiert.',
        pricehubble: 'Bewertung durch die Machine-Learning-Modelle von PriceHubble unter Verwendung umfassender Marktdaten und Immobilienattribute.',
        wuest_partner: 'Professionelle Bewertung von Wüest Partner basierend auf ihrer umfangreichen Expertise im Schweizer Immobilienmarkt und Daten.',
      },
      methodology: 'Methodik',
      subtitle: 'Professionelle Immobilienbewertungen von führenden AVM-Anbietern',
      title: 'Automatische Bewertungen',
    },
    comparables: {
      active_listings: 'Aktive Angebote',
      allSaved: 'Alle gespeichert',
      averagePrice: 'Durchschnittspreis',
      avgLivingArea: 'Durchschn. Wohnfläche',
      avgPricePerSqm: 'Durchschn. Preis/m²',
      listing_price: 'Angebotspreis',
      listings: 'Angebote',
      listingsStats: '{{count}} gespeicherte Angebote - Durchschn. {{average}}',
      listingsTitle: 'Vergleichsangebote',
      livingArea: 'Wohnfläche',
      noListingsDescription: 'Für diese Schätzung wurden keine Angebote gespeichert. Angebote können in der Hauptanwendung gespeichert werden.',
      noListingsSaved: 'Keine Angebote gespeichert',
      noTransactionsDescription: 'Für diese Schätzung wurden keine Transaktionen gespeichert. Transaktionen können in der Hauptanwendung gespeichert werden.',
      noTransactionsSaved: 'Keine Transaktionen gespeichert',
      perListing: 'Pro Angebot',
      priceRange: 'Preisbereich',
      recent_sales: 'Aktuelle Verkäufe',
      similar_properties: 'Ähnliche Immobilien',
      sold_price: 'Verkaufspreis',
      sqm: 'm²',
      title: 'Vergleichsobjekte',
      to: 'bis',
      totalSaved: 'Gesamt gespeichert',
      totalValue: 'Gesamtwert',
      transactionsStats: '{{count}} gespeicherte Transaktionen - Durchschn. {{average}}',
      transactionsTitle: 'Vergleichstransaktionen',
    },
    confirmDelete: {
      cancel: 'Abbrechen',
      confirm: 'Löschen',
      defaultItem: 'dieses Element',
      deleting: 'Wird gelöscht...',
      message: 'Möchten Sie "{{name}}" wirklich löschen?',
      title: 'Bewertung löschen',
      warning: 'Diese Aktion kann nicht rückgängig gemacht werden.',
    },
    error_loading_data: 'Fehler beim Laden der Daten',
    failed_to_load: 'Fehler beim Laden der Immobilienschätzungsdaten',
    land: {
      area: 'Fläche',
      buildableArea: 'Bebaubare Fläche',
      canton: 'Kanton',
      coordinates: 'Geografische Koordinaten',
      generalInfo: 'Allgemeine Informationen',
      latitude: 'Breitengrad',
      longitude: 'Längengrad',
      maxFloors: 'Max. Stockwerke',
      multiplePlots: '{{count}} Grundstücke',
      municipality: 'Gemeinde',
      noLandData: 'Keine Grundstücksdaten verfügbar',
      plot: 'Grundstück',
      plotNumber: 'Grundstücksnummer',
      singlePlot: '1 Grundstück',
      title: 'Grundstücksinformationen',
      zoneName: 'Zonenname',
      zoneType: 'Zonentyp',
      zoningInfo: 'Zonierungs-Informationen',
    },
    manualValuations: {
      confidence: {
        high: 'Hoch',
        low: 'Niedrig',
        medium: 'Mittel',
      },
      emptyText: 'Für diese Schätzung wurden keine manuellen Bewertungen hinzugefügt.',
      emptyTitle: 'Keine manuellen Bewertungen',
      methods: {
        avm: 'Automatische Bewertung',
        comparable: 'Vergleichswerte',
        custom: 'Benutzerdefinierte Bewertung',
        dcf: 'DCF Methode',
        developer: 'Entwicklermethode',
        intrinsic: 'Intrinsischer Wert Methode',
        staticYield: 'Statische Ertragswert Methode',
      },
      subtitle: 'Professionelle Bewertungsmethoden für eine genaue Immobilienbewertung',
      title: 'Manuelle Bewertungen',
      ui: {
        chartColor: 'Diagrammfarbe: {{color}}',
      },
    },
    market: {
      activity: 'Marktaktivität',
      average_price: 'Durchschnittspreis',
      time_on_market: 'Marktzeit',
      trends: 'Markttrends',
    },
    navigation: {
      amenities: 'Ausstattung',
      demographics: 'Demografie',
      history: 'Historie',
      listings_comparables: 'Vergleichsangebote',
      noise_analysis: 'Lärmanalyse',
      property_details: 'Objektdetails',
      purchase_market: 'Kaufmarkt',
      rental_market: 'Mietmarkt',
      sunlight_study: 'Sonnenlicht-Studie',
      transactions_comparables: 'Vergleichstransaktionen',
      valuations: 'Bewertungen',
    },
    pricePerSqm: {
      basisLabel: 'Berechnungsgrundlage',
      basisLiving: 'Wohnfläche',
      basisUsable: 'Nutzfläche',
      basisWeighted: 'Gewichtete Fläche',
      fallbackHint: 'Verwendet {{effective}} — {{requested}} nicht verfügbar',
      gearButton: 'Einstellungen Preis pro m²',
      showToggle: 'Preis pro m² anzeigen',
      unavailable: 'Nicht verfügbar',
    },
    property: {
      address: 'Adresse',
      area: 'Fläche',
      bathrooms: 'Badezimmer',
      bedrooms: 'Schlafzimmer',
      condition: 'Zustand',
      rooms: 'Zimmer',
      type: 'Immobilientyp',
      year_built: 'Baujahr',
    },
    propertyDetails: {
      attributes: 'Objekteigenschaften',
      description: 'Beschreibung',
      noDataAvailable: 'Keine Objektdetails verfügbar',
      photos: 'Fotos',
      situationLocation: 'Lage und Standort',
      subtitle: 'Übersicht der Objekteigenschaften',
      title: 'Objektdetails',
    },
    sections: {
      environment: 'Umgebung',
      estimate: 'Schätzung',
      market: 'Markt',
      property: 'Immobilie',
      social_economic: 'Sozial & Wirtschaftlich',
    },
    share: {
      section_not_available: 'Abschnitt nicht verfügbar',
      section_not_shared: 'Dieser Abschnitt wurde nicht in den Freigabelink aufgenommen.',
    },
    sidebar: {
      autoValuations: 'Automatische Bewertungen',
      building: 'Gebäude',
      buildingPermits: 'Baugenehmigungen',
      employment: 'Beschäftigung',
      energy: 'Energie',
      land: 'Grundstück',
      manualValuations: 'Manuelle Bewertungen',
      overview: 'Übersicht',
      summary: 'Zusammenfassung',
      transportAccess: 'Verkehrsanbindung',
    },
    summary: {
      checklist: {
        avmRetrieved: 'AVM-Bewertungen abgerufen',
        finalSelected: 'Endpreis ausgewählt',
        listingsSelected: 'Vergleichsangebote ausgewählt',
        manualAdded: 'Manuelle Bewertung hinzugefügt',
        propertyDetails: 'Immobiliendetails hinzugefügt',
        title: 'Bewertungs-Checkliste',
        transactionsSelected: 'Vergleichstransaktionen ausgewählt',
      },
      finalValuation: 'Endgültige Bewertung',
      finalValue: 'Endwert',
      listingsComparables: 'Vergleichsangebote',
      noFinalValuation: 'Für diese Schätzung wurde keine endgültige Bewertung festgelegt.',
      range: 'Bereich: {{min}} - {{max}}',
      transactionsComparables: 'Vergleichstransaktionen',
      valuationComparison: 'Bewertungsvergleich',
    },
    title: 'Immobilienanalyse',
    valuation: {
      confidence: 'Vertrauensniveau',
      estimated_value: 'Geschätzter Wert',
      price_per_sqm: 'Preis pro m²',
      range: 'Wertbereich',
      title: 'Immobilienbewertung',
    },
    valuations: {
      confidence: {
        high: 'Hoch',
        low: 'Niedrig',
        medium: 'Mittel',
      },
      detail: {
        confidence: 'Vertrauen',
        daysAgo: 'Vor {{days}} Tagen',
        estimatedValue: 'Geschätzter Wert',
        today: 'Heute',
        valueRange: 'Wertebereich',
        weeksAgo: 'Vor {{weeks}} Wochen',
        yesterday: 'Gestern',
      },
    },
  },
  explore: {
    aiFilter: {
      building: {
        description: 'Beschreiben Sie das Gebäude, das Sie suchen, und ich helfe Ihnen dabei, es zu finden.',
        placeholder: "z.B. 'Moderne Bürogebäude in der Zürcher Innenstadt'",
        prompts: {
          '0': 'Neue Wohngebäude (nach 2010) mit mehr als 5 Stockwerken',
          '1': 'Gebäude mit Gas- oder Ölheizung aber gutem Solarpotential auf dem Dach',
          '2': 'Gebäude mit einer Mietanzeige in den letzten 6 Monaten',
          '3': 'Wohngebäude mit mindestens 20 Einheiten und kurzer Reisezeit zu Zentren',
        },
        title: 'Gebäude-Filter-Assistent',
      },
      clearAllResponses: 'Alle Antworten löschen ({{count}})',
      description: 'Beschreiben Sie, wonach Sie suchen, in natürlicher Sprache, und ich werde die entsprechenden Filter anwenden.',
      deviceSelector: {
        iphoneNotRecommended: ' (iPhone - Nicht empfohlen)',
        microphoneDefault: 'Mikrofon {{id}}',
        recommended: ' (Empfohlen)',
        selectMicrophone: '🎤 Mikrofon auswählen:',
      },
      errors: {
        general: 'Fehler',
        processingFailed: 'Fehler beim Verarbeiten Ihrer Anfrage. Bitte versuchen Sie es erneut.',
        voiceProcessingFailed: 'Fehler beim Verarbeiten Ihrer Sprachanfrage. Bitte versuchen Sie es erneut.',
        voiceRecording: 'Sprachaufzeichnungsfehler',
      },
      examplePrompts: {
        '0': 'Zeigen Sie mir freie Grundstücke über 500m² in Zone 3',
        '1': 'Private Immobilien gebaut nach 2010',
        '2': 'Finden Sie Grundstücke in Seenähe mit Baugenehmigung',
      },
      land: {
        description: 'Beschreiben Sie das Grundstück, das Sie suchen, und ich helfe Ihnen dabei, es zu finden.',
        placeholder: "z.B. 'Entwicklungsland in Zürich mit guten Bewertungen'",
        prompts: {
          '0': 'Grundstücke über 1000m² mit Entwicklungswert über 70% und keine geschützten Gebäude',
          '1': 'Bare Grundstücke in Bauzonen im Kanton Zürich',
          '2': 'Grundstücke mit alten Gebäuden (<1950) aber nicht geschützt',
          '3': 'Grundstücke mit Baugenehmigung für Entwicklungsprojekte, veröffentlicht in den letzten 2 Jahren',
        },
        title: 'Grundstück-Filter-Assistent',
      },
      response: {
        filtersApplied: 'Filter angewendet',
      },
      textInput: {
        apply: 'Anwenden',
        placeholder: 'Geben Sie Ihre Filteranfrage ein oder sprechen Sie sie...',
      },
      thinkingAnimation: {
        analyzing: 'Analysiere Ihre Anfrage...',
      },
      title: 'KI-Filter-Assistent',
      voiceInput: {
        notSupported: 'Sprachaufzeichnung nicht unterstützt',
        recording: 'Aufnahme... {{duration}}s - Klicken zum Stoppen und Senden',
        startRecording: 'Klicken Sie, um die Sprachaufzeichnung zu starten',
      },
    },
    buildingCategories: {
      characteristics: 'Eigenschaften',
      classification: 'Klassifikation',
      energy: 'Energie',
      environmental: 'Umwelt',
      history: 'Geschichte',
      myMaps: 'Meine Karten',
    },
    buildingClassification: {
      garage: 'Garage',
      industrial: 'Industriell',
      mixedLow: 'Wohnanteil Minderheit',
      mixHigh: 'Wohnanteil Mehrheitlich',
      notClassified: 'Nicht klassifiziert',
      office: 'Büros',
      other: 'Andere',
      public: 'Öffentlich',
      residential: 'Wohnen',
      retail: 'Handel',
    },
    buildingClassifications: {
      Garage: 'Garage',
      Industrial: 'Industrie',
      Mixed_1: 'Mischnutzung',
      Mixed_2: 'Mischnutzung',
      Offices: 'Büros',
      Other: 'Andere',
      Public: 'Öffentlich',
      Residential: 'Wohngebäude',
      Retail: 'Einzelhandel',
    },
    buildingLayers: {
      buildingPeriod: 'Bauperiode',
      buildingPermits: 'Baugenehmigungen',
      buildingType: 'Gebäudetyp',
      constructionYear: 'Baujahr',
      favorites: 'Favoriten',
      heatingSystem: 'Heizsystem',
      lakeView: 'Seeblick',
      mountainView: 'Bergblick',
      myTags: 'Meine Tags',
      noiseExposure: 'Lärmbelastung',
      numberOfDwellings: 'Anzahl Wohnungen',
      numberOfFloors: 'Anzahl Stockwerke',
      numberOfUnits: 'Anzahl Wohneinheiten',
      officialCategory: 'Offizielle Kategorie',
      popetyClassification: 'Gebäudeklassifizierung',
      prospectiveBuildings: 'Potentielle Gebäude',
      protectionLevel: 'Denkmalschutz-Stufe',
      publicTransportQuality: 'Qualität öffentlicher Verkehr',
      renovationPeriod: 'Sanierungsjahr',
      rentListings: 'Mietanzeigen',
      saleListings: 'Verkaufsanzeigen',
      solarExposure: 'Sonneneinstrahlung',
      transactions: 'Transaktionen',
      travelTimeToCenters: 'Reisezeit zu Zentren',
      waterHeatingSystem: 'Warmwassersystem',
    },
    buildingPanel: {
      administrativeDetails: {
        addresses: 'Adressen',
        buildingName: 'Gebäudename',
        egids: 'Eidgenössische Gebäudeidentifikatoren (EGIDs)',
        officialNumber: 'Offizielle Nummer',
        renovationRange: 'Renovierungsjahr',
        title: 'Verwaltungsdetails',
        units: 'Einheiten',
        yearRange: 'Baujahr',
      },
      dwellings: {
        area: 'Fläche',
        dwellingNumber: 'Wohnung',
        features: 'Ausstattung',
        floor: 'Stock',
        hideIndividual: 'Einzelwohnungen ausblenden',
        kitchen: 'Küche',
        lastConstruction: 'Letzte Baumassnahme',
        medianArea: 'Median Fläche',
        medianRooms: 'Median Zimmer',
        monthlyRent: 'Monatsmiete',
        multiFloor: 'Mehrstöckig',
        noDwellings: 'Keine Wohnungsinformationen verfügbar',
        perMonth: '/ Monat',
        pricePredictions: 'Preisprognosen',
        purchasePrice: 'Kaufpreis',
        rooms: 'Zimmer',
        singleFloor: 'Einstöckig',
        sizeRange: 'Grössenbereich',
        status: 'Status',
        title: 'Wohnungsinformationen',
        totalArea: 'Gesamtfläche',
        totalDwellings: 'Gesamtzahl Wohnungen',
        viewIndividual: 'Einzelwohnungen anzeigen',
      },
      dwellingsLabel: 'Wohnungen',
      emptyStates: {
        noAdministrativeDetails: 'Keine Verwaltungsdetails verfügbar',
      },
      error: {
        buildingId: 'Gebäude-ID: {{propertyId}}',
        general: 'Fehler beim Laden der Gebäudedaten',
        notFound: 'Keine Gebäudedaten gefunden',
        retry: 'Erneut versuchen',
      },
      federalRegistry: {
        addressesLabel: 'Adressen',
        title: 'Eidgenössisches Gebäuderegister',
      },
      floorsLabel: 'Stockwerke',
      history: {
        empty: {
          description: 'Es sind keine aufgezeichneten Ereignisse für dieses Gebäude vorhanden',
          title: 'Keine Historie gefunden',
        },
        error: {
          description: 'Beim Laden der Gebäude-Historiendaten ist ein Fehler aufgetreten',
          title: 'Historie konnte nicht geladen werden',
        },
        filtered: {
          description: 'Versuchen Sie, Ihre Filterauswahl anzupassen, um mehr Ereignisse zu sehen',
          title: 'Keine Ereignisse entsprechen den Filtern',
        },
        filters: {
          permits: 'Genehmigungen',
          rentals: 'Vermietungen',
          sales: 'Verkäufe',
          transactions: 'Transaktionen',
        },
        loading: 'Gebäude-Historie wird geladen...',
      },
      information: {
        buildingYear: 'Baujahr',
        category: 'Kategorie',
        energyEfficiency: 'Energieeffizienz',
        heatingType: 'Heizungstyp',
        height: 'Höhe',
        notAvailable: 'N/V',
        title: 'Gebäudeinformationen',
        type: 'Typ',
        volume: 'Volumen',
      },
      links: {
        description: 'Links für Gebäude {{buildingId}}',
        title: 'Gebäude-Links',
      },
      loading: 'Gebäudedaten für ID: {{propertyId}} werden geladen...',
      market: {
        description: 'Marktdaten für Gebäude {{buildingId}}',
        title: 'Marktdaten',
      },
    },
    buildingStatus: {
      existing: 'Bestehend',
      planned: 'Geplant',
      under_construction: 'Im Bau',
    },
    buildingTooltip: {
      area: 'Fläche',
      buildingInfo: 'Gebäudeinformationen',
      dwellings: 'Wohnungen',
      energy: 'Energie',
      environment: 'Umgebung',
      floors: 'Stockwerke',
      heating: 'Heizung',
      height: 'Höhe',
      listings: 'Anzeigen',
      noAddress: 'Keine Adresse verfügbar',
      noiseLevel: 'Lärmpegel',
      permits: 'Genehmigungen',
      relatedData: 'Zugehörige Daten',
      transactions: 'Transaktionen',
      transport: 'Transport',
      units: 'Einheiten',
      viewQuality: 'Aussichtsqualität',
      year: 'Baujahr',
    },
    categories: {
      buildings: 'Gebäude',
      environmental: 'Umwelt',
      externalMaps: 'Externe Karten',
      myMaps: 'Meine Karten',
      noise: 'Lärm',
      satelliteTimeTravel: 'BA - Satelliten-Zeitreise',
      score: 'Score',
      urbanization: 'BA - Urbanisierung',
      zone: 'Zone',
    },
    createDeal: {
      addContact: 'Kontakt hinzufügen',
      addDescription: 'Beschreibung hinzufügen...',
      addNotes: 'Zusätzliche Notizen hinzufügen...',
      addParticipant: 'Teilnehmer hinzufügen',
      addParticipantTitle: 'Teilnehmer hinzufügen',
      addUser: 'Benutzer hinzufügen',
      buildingTitle: 'Neues Gebäude-Geschäft erstellen',
      cancel: 'Abbrechen',
      contact: 'Kontakt',
      contactRole: 'Kontaktrolle',
      created: 'Erstellt',
      createDeal: 'Geschäft erstellen',
      creating: 'Wird erstellt...',
      dealId: 'Geschäfts-ID',
      dealInformation: 'Geschäftsinformationen',
      dealName: 'Geschäftsname',
      dealType: 'Geschäftstyp',
      dealValue: 'Geschäftswert',
      description: 'Beschreibung',
      editBuildingTitle: 'Gebäude-Geschäft bearbeiten',
      editTitle: 'Geschäft bearbeiten',
      enterDealName: 'Geschäftsname eingeben',
      expectedCloseDate: 'Erwartetes Abschlussdatum',
      lastModified: 'Zuletzt geändert',
      loadingUsers: 'Benutzer laden...',
      metadata: 'Metadaten',
      noPipelines: 'Keine Pipelines verfügbar',
      notes: 'Notizen',
      noUsersFound: 'Keine Benutzer gefunden',
      optional: 'Optional',
      participantRole: 'Rolle',
      participants: 'Teilnehmer',
      pipeline: 'Pipeline',
      pipelineStage: 'Pipeline & Stufe',
      removeParticipant: 'Teilnehmer entfernen',
      roleContributor: 'Mitwirkender',
      roleOwner: 'Eigentümer',
      roleParticipant: 'Teilnehmer',
      roleViewer: 'Betrachter',
      searchingUsers: 'Benutzer suchen...',
      searchUsers: 'Benutzer nach Name oder E-Mail suchen...',
      selectPipelineFirst: 'Wählen Sie zuerst eine Pipeline',
      selectUser: 'Einen Benutzer zum Hinzufügen auswählen',
      stage: 'Stufe',
      summary: 'Zusammenfassung',
      title: 'Neues Geschäft erstellen',
      updateDeal: 'Geschäft aktualisieren',
    },
    dataSources: {
      faoData: 'Amtsblatt',
      faoDataHeritage: 'Denkmalpflege Kanton Genf',
      federalEnergyOffice: 'Bundesamt für Energie',
      federalEnvironmentOffice: 'Bundesamt für Umwelt',
      federalSpatialDevelopment: 'Eidg. Gebäude- und Wohnungsregister',
      federalStatisticalOffice: 'Bundesamt für Statistik',
      federalTransportOffice: 'Bundesamt für Verkehr',
      marketData: 'Schweizer Immobilienportale',
      personalCollection: 'Persönliche Sammlung',
      popetyioLabs: 'Popety.io Data Labs',
    },
    deals: {
      addDeal: 'Geschäft hinzufügen',
      archived: 'Archiviert',
      attachError: 'Fehler beim Anhängen der Geschäfte. Bitte versuchen Sie es erneut.',
      attachExisting: 'Bestehendes Geschäft anhängen',
      attaching: 'Wird angehängt...',
      attachSelected: 'Auswahl anhängen',
      availableDeals: 'Verfügbare Geschäfte',
      cancel: 'Abbrechen',
      confirmDelete: 'Sind Sie sicher, dass Sie dieses Geschäft von der Immobilie entfernen möchten?',
      contact: 'Kontakt',
      created: 'Erstellt',
      createdOn: 'Erstellt am',
      createFirstDeal: 'Erstes Geschäft erstellen',
      createNewDeal: 'Erstellen Sie ein neues Geschäft, um zu beginnen',
      dealName: 'Geschäftsname',
      dealsSelected: 'Geschäfte ausgewählt',
      dealType: 'Geschäftstyp',
      dealTypeDevelopment: 'Entwicklung',
      dealTypeJointVenture: 'Joint Venture',
      dealTypeLease: 'Miete',
      dealTypeSale: 'Verkauf',
      dealValue: 'Geschäftswert (CHF)',
      description: 'Beschreibung',
      edit: 'Bearbeiten',
      editDeal: 'Geschäft bearbeiten',
      emptyDescription: 'Beginnen Sie mit der Erstellung eines Geschäfts für diese Immobilie',
      emptyTitle: 'Noch keine Geschäfte',
      enterDealName: 'Geschäftsname eingeben',
      enterDescription: 'Beschreibung eingeben',
      enterNotes: 'Notizen eingeben',
      expectedClose: 'Erwarteter Abschluss',
      expectedCloseDate: 'Erwartetes Abschlussdatum',
      loading: 'Geschäfte werden geladen...',
      loadingAvailableDeals: 'Verfügbare Geschäfte werden geladen...',
      noAvailableDeals: 'Keine verfügbaren Geschäfte',
      noMatchingDeals: 'Keine passenden Geschäfte gefunden',
      noParticipants: 'Keine Teilnehmer',
      notApplicable: 'N/A',
      notes: 'Notizen',
      owner: 'Eigentümer',
      participants: 'Teilnehmer',
      pipeline: 'Pipeline',
      remove: 'Von Immobilie entfernen',
      removing: 'Wird entfernt...',
      retry: 'Wiederholen',
      searchForDeals: 'Nach Geschäften suchen',
      searchPlaceholder: 'Nach Name, Pipeline oder Typ suchen...',
      title: 'Immobiliengeschäfte',
      tryDifferentSearch: 'Versuchen Sie, Ihre Suchkriterien anzupassen',
      type: 'Typ',
      unassigned: 'Nicht zugewiesen',
      update: 'Geschäft aktualisieren',
      updating: 'Wird aktualisiert...',
      value: 'Geschäftswert',
      viewInPipeline: 'Im Pipeline anzeigen',
    },
    filterPanel: {
      area: {
        landArea: 'Grundstücksfläche',
        maxPlaceholder: 'Max. Fläche',
        minPlaceholder: 'Min. Fläche',
        title: 'Fläche',
      },
      buildingFilters: {
        common: {
          loadingTags: 'Tags werden geladen...',
          noTagsAvailable: 'Keine Tags verfügbar',
          noTagsHelpBuilding: 'Keine Tags verfügbar. Erstellen Sie Tags im Gebäudedetail-Panel.',
          noTagsHelpLand: 'Keine Tags verfügbar. Erstellen Sie Tags im Grundstücksdetail-Panel.',
          selectPermitTypes: 'Genehmigungstypen auswählen',
          selectTags: 'Tags auswählen',
        },
        environmental: {
          distanceToPowerlines: {
            '0to100m': '0 bis 100m',
            over100m: 'Über 100m',
            placeholder: 'Entfernung auswählen',
          },
          lakeView: {
            '0ha': '0 ha',
            '0to100ha': '0 bis 100 ha',
            over100ha: 'Über 100 ha',
            placeholder: 'Seeblick auswählen',
          },
          mountainView: {
            '0to4peaks': '0 bis 4 Gipfel',
            '5to13peaks': '5 bis 13 Gipfel',
            moreThan13peaks: 'Mehr als 13 Gipfel',
            placeholder: 'Bergblick auswählen',
          },
          noiseExposure: {
            '45to52db': '45 bis 52 dB',
            moreThan52db: 'Mehr als 52 dB',
            placeholder: 'Lärmpegel auswählen',
            upTo45db: 'Bis 45 dB',
          },
          publicTransport: {
            badlyServed: 'Schlecht erschlossen',
            mediumServed: 'Mittel erschlossen',
            placeholder: 'Verkehrsqualität auswählen',
            veryBadlyServed: 'Sehr schlecht erschlossen',
            veryWellServed: 'Sehr gut erschlossen',
            wellServed: 'Gut erschlossen',
          },
          slope: {
            '0to4degrees': '0 bis 4 Grad',
            '4to9degrees': '4 bis 9 Grad',
            moreThan9degrees: 'Mehr als 9 Grad',
            placeholder: 'Neigung auswählen',
          },
          taxBurden: {
            high: 'Hoch (über 7.1%)',
            medium: 'Mittel (5.1% bis 7.1%)',
            placeholder: 'Steuerbelastung auswählen',
            small: 'Gering (0 bis 5.1%)',
          },
          travelTime: {
            long: 'Lang',
            medium: 'Mittel',
            placeholder: 'Reisezeiten auswählen',
            short: 'Kurz',
          },
        },
        status: {
          accessible: 'Zugänglich',
          active: 'Aktiv',
          activeStatus: 'Aktiver Status',
          approximate: 'Ungefähr',
          exactLocation: 'Genauer Standort',
          furnished: 'Möbliert',
          furnishedStatus: 'Möblierungsstatus',
          inactive: 'Inaktiv',
          newConstruction: 'Neubau',
          no: 'Nein',
          noPets: 'Keine Haustiere',
          notAccessible: 'Nicht zugänglich',
          petsAllowed: 'Haustiere erlaubt',
          selectAccessibility: 'Barrierefreiheit auswählen...',
          selectActiveStatus: 'Aktiven Status auswählen...',
          selectConstructionStatus: 'Baustatus auswählen...',
          selectFurnishedStatus: 'Möblierungsstatus auswählen...',
          selectLocationPrecision: 'Standortgenauigkeit auswählen...',
          selectPetPolicy: 'Haustierrichtlinie auswählen...',
          title: 'Statusfilter',
          unfurnished: 'Unmöbliert',
          wheelchairAccessible: 'Rollstuhlgerecht',
          yes: 'Ja',
        },
      },
      buildingFiltersTitle: 'Gebäude-Filter',
      buildingMode: 'Gebäude',
      clearAll: 'Alle Filter löschen',
      close: 'Filter schliessen',
      landFilters: {
        building: {
          buildingHeight: 'Gebäudehöhe',
          buildingVolume: 'Gebäudevolumen oberirdisch (m3)',
          constructionYear: 'Baujahr',
          floorNumber: 'Anzahl Stockwerke',
          grossFloorArea: 'Bruttogeschossfläche (BGF)',
          groundingArea: 'Grundfläche (m2)',
          hideUnknownYear: 'Unbekanntes Jahr ausblenden',
          numberOfDwellings: 'Anzahl Wohnungen',
          title: 'Gebäude',
        },
        common: {
          display: 'Anzeigen',
          displayOnly: 'Nur anzeigen',
          from: 'Von',
          hide: 'Ausblenden',
          max: 'Max',
          min: 'Min',
          mixed: 'Gemischt',
          private: 'Privat',
          public: 'Öffentlich',
          selectOption: 'Option auswählen',
          to: 'Bis',
        },
        development: {
          availableBuildableCapacity: 'Verfügbare Baukapazität (verfügbare GF)',
          buildableCapacity: 'Baukapazität (Zonierung GF)',
          developmentScore: 'Entwicklungswert',
          title: 'Entwicklung',
          underExploitedScore: 'Unterauslastungswert',
        },
        history: {
          buildingPermit: 'Baugenehmigung',
          buildingPermitsClassification: 'Klassifizierung der Baubewilligungen',
          onlyDevelopment: 'Nur Entwicklung',
          permitClassifications: {
            development: 'Entwicklung',
            other: 'Andere',
          },
          purchaseDate: 'Kaufdatum',
          purchasePrice: 'Kaufpreis',
          rentDate: 'Mietdatum',
          rentPrice: 'Mietpreis',
          title: 'Historie',
          transactionDate: 'Transaktionsdatum',
          transactionPrice: 'Transaktionspreis',
        },
        land: {
          title: 'Parzelle',
        },
        landUsePlanAssignments: {
          label: 'Nutzungsplanzuweisung',
          noAssignments: 'Keine Nutzungsplanzuweisungen verfügbar',
          placeholder: 'Nutzungsplanzuweisung auswählen',
          selectLocationFirst: 'Bitte wählen Sie zuerst einen Standort aus',
        },
        locationZoning: {
          landUsePlan: 'Nutzungsplan',
          location: 'Standort',
          noBuildingZone: 'Nicht-Bauzone',
          noLandUsePlans: 'Keine Nutzungspläne verfügbar',
          plan: 'Plan',
          planPlaceholder: 'Plannummer',
          selectLandUsePlan: 'Nutzungsplan auswählen',
          selectLocationFirst: 'Bitte wählen Sie zuerst einen Standort aus',
          specialZone: 'Sonderzone',
          title: 'Standort und Zonierung',
        },
        ownership: {
          numberOfOwners: 'Anzahl Eigentümer',
          ownersType: 'Eigentümerart',
          title: 'Eigentum',
        },
        plot: {
          area: 'Fläche',
          bareLand: 'Bauland',
          title: 'Parzelle',
        },
        restrictions: {
          archaeologicalZone: 'Archäologische Zone',
          buildingRight: 'Baurecht',
          builtSitesProtectedZone: 'Schutzzone für bebaute Standorte',
          dangerZone: 'Gefahrenzone',
          forestLimitZone: 'Waldgrenzzone',
          forestZone: 'Waldzone',
          mandatoryPlanningZone: 'Planungspflichtige Zone',
          natureProtectionZone: 'Naturschutzzone',
          noMaxCosZone: 'Zone ohne max. Überbauungskoeffizient',
          notYetDefinedSpecialZone: 'Noch nicht definierte Sonderzone',
          otherZone: 'Andere Zone',
          pollutedZone: 'Verschmutzte Zone',
          protectedBuilding: 'Denkmalgeschütztes Gebäude',
          protectedObjects: 'Geschützte Objekte',
          reservedZone: 'Reservierte Zone',
          title: 'Beschränkungen',
          underwaterProtectedZone: 'Unterwasser-Schutzzone',
          watercourseLimitZone: 'Gewässergrenzzone',
        },
      },
      landFiltersTitle: 'Grundstücksfilter',
      loadFilters: 'Gespeicherte Filter laden',
      location: {
        municipality: 'Gemeinde',
        region: 'Region',
        searchPlaceholder: 'Regionen, Gemeinden, Städte suchen...',
        selectMunicipality: 'Bitte wählen Sie eine Gemeinde',
        selectPlan: 'Bitte wählen Sie einen Plan',
        selectRegion: 'Bitte wählen Sie eine Region',
        title: 'Standort',
      },
      municipalities: {
        carouge: 'Carouge',
        geneva: 'Genf',
        lancy: 'Lancy',
        meyrin: 'Meyrin',
        vernier: 'Vernier',
      },
      plotMode: 'Parzelle',
      propertyType: {
        placeholder: 'Immobilientyp auswählen',
      },
      quickFilters: {
        maxArea: 'Max {{area}}m²',
        minArea: 'Min {{area}}m²',
        privateOwnership: 'Privateigentum',
        privateProperty: 'Privates Eigentum',
        title: 'Schnellfilter',
        zone3: 'Zone 3',
      },
      regions: {
        basel: 'Basel-Region',
        central: 'Zentralschweiz',
        lakeGeneva: 'Genfersee-Region',
        ticino: 'Tessin',
        zurich: 'Zürich-Region',
      },
      savePreset: 'Filtervoreinstellung speichern',
      title: 'Filter',
    },
    financial: {
      'Nombre de logements': 'Anzahl Wohnungen',
    },
    heatingTypes: {
      district: 'Fernwärme',
      electric: 'Elektrisch',
      gas: 'Gas',
      heat_pump: 'Wärmepumpe',
      oil: 'Öl',
      solar: 'Solar',
      wood: 'Holz',
    },
    landPlotTooltip: {
      buildings: 'Gebäude',
      landArea: 'Grundstücksfläche',
      noAddress: 'Keine Adresse verfügbar',
      noZoning: 'Keine Zonierungsinformationen',
      units: 'Wohneinheiten',
      zoning: 'Zonierung',
    },
    layers: {
      availability: 'Verfügbarkeit',
      buildingArea: 'Gebäudefläche',
      constructionYear: 'Baujahr',
      daytimeRailwayNoise: 'Bahnlärm tagsüber',
      daytimeRoadTrafficNoise: 'Strassenlärm tagsüber',
      densifiableArea: 'Verdichtbare Fläche',
      developmentPotential: 'Entwicklungspotential',
      favorites: 'Favoriten',
      legacyRiskScore: 'Denkmalschutz-Risiko',
      livabilityScore: 'Lebensqualitäts-Score',
      myTags: 'Meine Tags',
      numberOfUnits: 'Anzahl Wohneinheiten',
      prospectiveProperties: 'Potentielle Immobilien',
      protectedBuildings: 'Geschützte Gebäude',
      restrictions: 'Beschränkungen',
      underExploitationIndex: 'Unternutzungsindex',
      zoneLayout: 'Zonengestaltung',
    },
    legends: {
      categoricalLabels: {
        availability: {
          available: 'Verfügbar',
          notAvailable: 'Nicht verfügbar',
        },
        buildingArea: {
          no: 'Nein',
          yes: 'Ja',
        },
        buildingClassification: {
          garage: 'Garage',
          industrial: 'Industriell',
          mixed1: 'Mischnutzung 1',
          mixed2: 'Mischnutzung 2',
          notClassified: 'Nicht klassifiziert',
          offices: 'Büros',
          other: 'Andere',
          public: 'Öffentlich',
          residential: 'Wohngebäude',
          retail: 'Einzelhandel',
        },
        buildingPeriod: {
          '1919to1945': '1919-1945',
          '1946to1960': '1946-1960',
          '1961to1970': '1961-1970',
          '1971to1980': '1971-1980',
          '1981to1985': '1981-1985',
          '1986to1990': '1986-1990',
          '1991to1995': '1991-1995',
          '1996to2000': '1996-2000',
          '2001to2005': '2001-2005',
          '2006to2010': '2006-2010',
          '2011to2015': '2011-2015',
          '2015onward': 'Ab 2015',
          before1919: 'Vor 1919',
        },
        buildingType: {
          exclusivelyResidential: 'Ausschliesslich Wohnnutzung',
          nonResidential: 'Keine Wohnnutzung',
          partiallyResidential: 'Teilweise Wohnnutzung',
          residentialWithAnnex: 'Wohngebäude mit Nebennutzung',
          special: 'Sonderbauwerk',
          temporary: 'Provisorische Unterkunft',
          unknown: 'Unbekannt',
        },
        customContent: {
          customTags: 'Benutzerdefinierte Tags',
          favoriteProperties: 'Lieblings-Immobilien',
          prospectiveProperties: 'Potentielle Immobilien',
        },
        lakeView: {
          large: 'Grosse Seesicht (> 100 ha)',
          none: 'Keine Seesicht',
          small: 'Kleine Seesicht (< 100 ha)',
        },
        monumentProtection: {
          no: 'Nicht geschützt',
          yes: 'Geschützt',
        },
        mountainView: {
          few: 'Wenige Gipfel (< 5)',
          many: 'Viele Gipfel (> 13)',
          medium: 'Mittlere Gipfel (5-13)',
        },
        noiseExposure: {
          high: 'Hoch (> 52 dB)',
          low: 'Niedrig (< 45 dB)',
          medium: 'Mittel (45-52 dB)',
        },
        officialCategory: {
          agricultural: 'Landwirtschaftsgebäude',
          apartment: 'Mehrfamilienhaus (3+ Einheiten)',
          collectiveHousing: 'Kollektivunterkunft',
          commercial: 'Gewerbegebäude',
          communityHousing: 'Gemeinschaftsunterkunft',
          crops: 'Gebäude für Pflanzenbau',
          cultural: 'Kultur / Freizeit',
          education: 'Bildung / Forschung',
          garage: 'Garage',
          health: 'Krankenhaus / Gesundheit',
          hotel: 'Hotel',
          industrial: 'Industriegebäude',
          livestock: 'Tierhaltungsgebäude',
          monument: 'Historisches Denkmal',
          museum: 'Museum / Bibliothek',
          office: 'Bürogebäude',
          otherAgricultural: 'Andere landwirtschaftliche',
          otherUnclassified: 'Andere nicht klassifiziert',
          religious: 'Religiöses Gebäude',
          restaurant: 'Restaurant / Bar',
          singleFamily: 'Einfamilienhaus',
          sports: 'Sportanlage',
          tourism: 'Tourismusunterkunft',
          transport: 'Verkehr / Kommunikation',
          twoFamily: 'Zweifamilienhaus',
          unknown: 'Unbekannt',
          warehouse: 'Lagerhaus / Silo / Speicher',
        },
        powerSource: {
          air: 'Luft',
          districtHeating: 'Fernwärme',
          electricity: 'Elektrizität',
          gas: 'Gas',
          geothermal: 'Geothermie',
          none: 'Keine',
          oil: 'Öl',
          solar: 'Solar (thermisch)',
          unknown: 'Unbekannt',
          wood: 'Holz',
        },
        protectionStatus: {
          level1: 'Stufe 1',
          level2: 'Stufe 2',
          level3: 'Stufe 3',
          level4: 'Stufe 4 (Höchste)',
          notProtected: 'Nicht geschützt',
        },
        renovationPeriod: {
          '1919to1945': '1919-1945',
          '1946to1960': '1946-1960',
          '1961to1970': '1961-1970',
          '1971to1980': '1971-1980',
          '1981to1985': '1981-1985',
          '1986to1990': '1986-1990',
          '1991to1995': '1991-1995',
          '1996to2000': '1996-2000',
          '2001to2005': '2001-2005',
          '2006to2010': '2006-2010',
          '2011to2015': '2011-2015',
          '2015onward': 'Ab 2015',
          before1919: 'Vor 1919',
        },
        transportQuality: {
          badly: 'Schlecht erschlossen',
          medium: 'Mittel erschlossen',
          veryBadly: 'Sehr schlecht erschlossen',
          veryWell: 'Sehr gut erschlossen',
          well: 'Gut erschlossen',
        },
        travelTime: {
          long: 'Lang',
          medium: 'Mittel',
          short: 'Kurz',
        },
        zoneTypes: {
          archaeological: 'Archäologisch',
          danger: 'Gefahr',
          forest: 'Wald',
          polluted: 'Verschmutzt',
          reserved: 'Reserviert',
          watercourse: 'Wasserlauf',
        },
      },
      gradientLabels: {
        before1950: '< 1950',
        db45: '45 dB',
        db55: '55 dB',
        db65: '65 dB',
        db75Plus: '75+ dB',
        high: 'Hoch',
        low: 'Niedrig',
        medium: 'Mittel',
        older: 'Älter',
        oneOrMore: '1+',
        recent: 'Kürzlich',
        twentyOrMore: '20+',
        year1960: '1960',
        year1970: '1970',
        year1990: '1990',
        year2010: '2010',
        year2024: '2024',
      },
      titles: {
        buildingYear: 'Baujahr',
        protectedBuildings: 'Geschützte Gebäude',
        availability: 'Zonenverfügbarkeit',
        averageBuildingYear: 'Baujahr',
        averageRenovationYear: 'Durchschnittliches Renovierungsjahr',
        buildingArea: 'Gebäudefläche',
        buildingClassification: 'Gebäudeklassifizierung',
        buildingPeriod: 'Bauperiode',
        buildingPermitLastYear: 'Baugenehmigungen',
        buildingProtectionStatus: 'Denkmalschutz-Stufe',
        buildingType: 'Gebäudetyp',
        daytimeRailwayNoise: 'Bahnlärm tagsüber',
        daytimeRoadTrafficNoise: 'Strassenlärm tagsüber',
        developmentPotentialScore: 'Entwicklungspotential',
        favorites: 'Favoriten',
        heatingEnergySource: 'Heizsystem',
        lakeView: 'Seeblick',
        legacyRiskScore: 'Denkmalschutz-Risiko',
        listingRentLastYear: 'Mietanzeigen',
        listingSaleLastYear: 'Verkaufsanzeigen',
        livabilityScore: 'Lebensqualitäts-Score',
        mountainView: 'Bergblick',
        myTags: 'Meine Tags',
        nighttimeRailwayNoise: 'Bahnlärm nachts',
        nighttimeRoadTrafficNoise: 'Strassenlärm nachts',
        noiseExposure: 'Lärmbelastung',
        numberOfDwellings: 'Anzahl Wohnungen',
        numberOfFloors: 'Anzahl Stockwerke',
        numberOfUnits: 'Anzahl Wohneinheiten',
        officialCategory: 'Offizielle Kategorie',
        prospects: 'Interessenten',
        publicTransportQuality: 'Qualität öffentlicher Verkehr',
        renovationPeriod: 'Sanierungsjahr',
        solarExposure: 'Sonneneinstrahlung',
        transactionLastYear: 'Transaktionen',
        travelTimeToCenters: 'Reisezeit zu Zentren',
        underExploitationScore: 'Unternutzungsindex',
        waterHeatingSource: 'Warmwassersystem',
        zoneRestrictions: 'Beschränkungen',
      },
      units: {
        decibels: 'Dezibel',
        dwellings: 'Wohnungen',
        floors: 'Stockwerke',
        kwhPerM2: 'kWh/m²',
        score: 'Score',
        units: 'Einheiten',
      },
    },
    listView: {
      actions: {
        addTag: 'Tag hinzufügen',
        addToDeal: 'Zum Deal hinzufügen',
        addToFavorites: 'Zu Favoriten hinzufügen',
        export: 'Exportieren',
      },
      columns: {
        activity: 'Aktivität',
        addLabel: '+ Label hinzufügen',
        address: 'Adresse',
        area: 'Fläche',
        building: 'Gebäude',
        buildings: 'Gebäude',
        floors: 'Stockwerke',
        history: 'Historie',
        labels: 'Tags',
        municipality: 'Gemeinde',
        notClassified: 'Nicht klassifiziert',
        otherAddresses: '+{{count}} Adressen',
        otherZones: '+{{count}} weitere Zonen',
        plotNumber: 'Parzellennummer',
        score: 'Score',
        surface: 'Fläche',
        type: 'Typ',
        units: 'Einheiten',
        volume: 'Volumen',
        year: 'Jahr',
        zone: 'Zone',
      },
      exportSelected: 'Auswahl exportieren',
      found: 'gefunden',
      of: 'von',
      results: 'Ergebnisse',
      rowsPerPage: 'Zeilen pro Seite',
      selectAll: 'Alle auswählen',
      sortBy: 'Sortieren nach',
      sortOptions: {
        address: 'Adresse',
        buildings: 'Gebäude',
        landType: 'Landtyp',
        municipality: 'Gemeinde',
        plotId: 'Grundstück-ID',
        recentActivity: 'Aktuelle Aktivität',
        surfaceArea: 'Fläche',
        units: 'Einheiten',
        utilizationRate: 'Nutzungsgrad',
      },
    },
    mapControls: {
      '2d': '2D',
      '3d': '3D',
      layers: 'Ebenen',
      legend: 'Legende',
      print: 'Drucken',
      satellite: 'Satellit',
      street: 'Strasse',
    },
    mapLayerPanel: {
      activeLayer: {
        label: 'Aktive Ebene',
        neutralView: 'Neutrale Ansicht',
        noLayer: 'Keine Ebene',
        noLayerSelected: 'Keine Ebene ausgewählt',
        turnOff: 'Ausschalten',
      },
      favorites: {
        add: 'Zu Favoriten hinzufügen',
        remove: 'Aus Favoriten entfernen',
        title: 'Lieblings-Ebenen',
      },
      search: {
        legend: {
          category: 'Kategorie',
        },
        placeholder: 'Ebenen suchen...',
      },
      title: 'Kartenebenen',
      wms: {
        error: 'Externe Ebenen konnten nicht geladen werden',
        externalSource: 'Externe Quelle',
        info: 'Ebeneninformationen',
        loading: 'Externe Ebenen werden geladen...',
      },
    },
    propertyPanel: {
      actionLabels: {
        activity: 'Aktivität',
        alert: 'Alarm',
        deal: 'Geschäft',
        exit: 'Beenden',
        favorite: 'Favorit',
        group: 'Gruppe',
      },
      activities: {
        empty: {
          description: 'Versuchen Sie, Ihre Filter oder Suchbegriffe anzupassen',
          title: 'Keine Aktivitäten gefunden',
        },
        filters: {
          all: 'Alle Aktivitäten',
          analysis: 'Analysen',
          favorites: 'Favoriten',
          files: 'Dateien',
          notes: 'Notizen',
          tags: 'Tags',
        },
        hoursAgo: 'Vor {{count}} Stunde',
        hoursAgo_plural: 'Vor {{count}} Stunden',
        minutesAgo: 'Vor {{count}} Minute',
        minutesAgo_plural: 'Vor {{count}} Minuten',
        searchPlaceholder: 'Aktivitäten suchen...',
        title: 'Aktivitäten',
        today: 'Heute',
        yesterday: 'Gestern',
      },
      addToDeal: 'Zu Geschäft hinzufügen',
      addToFavorites: 'Zu Favoriten hinzufügen',
      buildingsLabel: 'Gebäude',
      createAlert: 'Alarm erstellen',
      creatingEstimation: 'Schätzung wird erstellt...',
      deals: {
        addDeal: 'Geschäft hinzufügen',
        allPipelines: 'Alle Pipelines',
        allStatuses: 'Alle Status',
        attachExisting: 'Vorhandenes anhängen',
        attachExistingBuilding: 'Bestehendes Geschäft anhängen',
        attachSelected: 'Ausgewählte anhängen',
        buildingTitle: 'Gebäude-Geschäfte',
        cancel: 'Abbrechen',
        confirmDeleteText: 'Dieses Geschäft von der Immobilie entfernen?',
        created: 'Erstellt',
        createDeal: 'Geschäft erstellen',
        createFirst: 'Erstes Geschäft erstellen',
        daysAgo: 'Vor {{days}}T',
        edit: 'Bearbeiten',
        emptyBuildingDescription: 'Beginnen Sie damit, ein Geschäft für dieses Gebäude zu erstellen oder anzuhängen',
        emptyDescription: 'Beginnen Sie damit, ein Geschäft für diese Immobilie zu erstellen oder anzuhängen',
        emptyTitle: 'Noch keine Geschäfte',
        foundDeals_one: '{{count}} Geschäft gefunden',
        foundDeals_other: '{{count}} Geschäfte gefunden',
        hoursAgo: 'Vor {{hours}}h',
        justNow: 'Gerade eben',
        loadingPipelines: 'Pipelines werden geladen...',
        loadPipelinesError: 'Pipelines konnten nicht geladen werden',
        lost: 'Verloren',
        minsAgo: 'Vor {{mins}} Min.',
        noDealsAvailable: 'Keine Geschäfte verfügbar',
        noDealsFound: 'Keine Geschäfte gefunden',
        noPipeline: 'Keine Pipeline',
        noResults: 'Keine Geschäfte entsprechen Ihrer Suche',
        noStage: 'Keine Phase',
        open: 'Offen',
        participants: 'Teilnehmer',
        pipeline: 'Pipeline',
        remove: 'Entfernen',
        removeDeal: 'Geschäft entfernen',
        searchDealsError: 'Geschäftssuche fehlgeschlagen',
        searchPlaceholder: 'Geschäfte nach Name, Pipeline oder Phase suchen...',
        selectAll: 'Alle auswählen',
        selected: 'Ausgewählt',
        stage: 'Stufe',
        status: 'Status',
        summary: 'Zusammenfassung',
        title: 'Immobiliengeschäfte',
        untitledDeal: 'Unbenanntes Geschäft',
        viewInPipeline: 'In Pipeline anzeigen',
        won: 'Gewonnen',
      },
      errors: {
        noLandId: 'Keine Grundstücks-ID verfügbar',
      },
      estimateCreated: 'Schätzung erfolgreich erstellt',
      files: {
        confirmDelete: 'Sind Sie sicher, dass Sie {{name}} löschen möchten?',
        delete: 'Löschen',
        download: 'Herunterladen',
        empty: {
          description: 'Laden Sie Dateien hoch oder passen Sie Ihre Suche an',
          title: 'Keine Dateien gefunden',
        },
        filters: {
          all: 'Alle Dateien',
        },
        searchPlaceholder: 'Dateien suchen...',
        title: 'Dateien',
        uploadButton: 'Dateien durchsuchen',
        uploadText: 'Dateien hierher ziehen oder klicken zum Durchsuchen',
      },
      history: {
        adjustFilters: 'Versuchen Sie, Ihre Filter anzupassen, um mehr Ereignisse zu sehen',
        error: 'Fehler beim Laden der Historiedaten',
        loading: 'Historiedaten werden geladen...',
        loadingText: 'Bitte warten Sie, während wir detaillierte Informationen abrufen',
        noEvents: 'Keine Ereignisse gefunden',
        onlineDays: 'Online: {{days}} Tage',
        permitRequest: 'Genehmigungsantrag',
        permits: 'Genehmigungen',
        rentalListing: 'Mietanzeige',
        rentals: 'Vermietungen',
        rooms: 'Zimmer',
        saleListing: 'Verkaufsanzeige',
        sales: 'Verkäufe',
        transaction: 'Transaktion',
        transactions: 'Transaktionen',
      },
      information: {
        active: 'Aktiv',
        beneficiary: 'Begünstigter',
        buildingCount: 'Anzahl Gebäude',
        buildingPeriod: 'Bauperiode',
        buildings: 'Gebäude',
        built: 'Gebaut',
        company: 'Unternehmen',
        conditions: 'Bedingungen',
        constructible: 'Bebaubar',
        created: 'Erstellt',
        duration: 'Dauer',
        dwellings: 'Wohnungen',
        energyConsumption: 'Energieverbrauch',
        energySurface: 'Energiebezugsfläche',
        floors: 'Stockwerke',
        foundation: 'Stiftung',
        grossFloorArea: 'Bruttogeschossfläche',
        groundFloorArea: 'Erdgeschossfläche',
        heatingSource: 'Heizungsquelle',
        inactive: 'Inaktiv',
        individual: 'Privatperson',
        landArea: 'Grundstücksfläche',
        landInfo: 'Grundstücksinformationen',
        landType: 'Grundstückstyp',
        lastOwnerChange: 'Letzter Eigentümerwechsel',
        lastRenovation: 'Letzte Renovierung',
        maxHeight: 'Max. Höhe',
        no: 'Nein',
        noDataAvailable: 'Keine detaillierten Informationen für diese Immobilie verfügbar',
        owners: 'Eigentümer',
        plotNumber: 'Parzellennummer',
        protected: 'Geschützt',
        renovated: 'Renoviert',
        residentialArea: 'Wohnfläche',
        residentialFloors: 'Wohngeschosse',
        restrictions: 'Beschränkungen',
        searchGoogle: 'Auf Google suchen',
        searchLinkedIn: 'Auf LinkedIn suchen',
        searchLocalCh: 'Auf local.ch suchen',
        solarPotential: 'Solarpotential',
        totalResidentialArea: 'Gesamte Wohnfläche',
        type: 'Typ',
        unitCount: 'Anzahl Einheiten',
        validity: 'Gültigkeit',
        volume: 'Volumen',
        yes: 'Ja',
        zones: 'Zonen',
      },
      links: {
        accessOfficialData: 'Zugang zu offiziellen Daten und rechtlichen Dokumenten',
        buildingInformation: 'Gebäudeinformationen und Details',
        buildingPermitsHistory: 'Baugenehmigungen und Baugeschichte',
        buildingStatistics: 'Gebäudestatistik',
        cadastreRDPPF: 'Kataster ÖREB',
        cantonalGeoportal: 'Kantonales Geoportal',
        cantonalInteractiveMap: 'Kantonale interaktive Karte und Daten',
        constructionHistory: 'Baugeschichte',
        constructionPermits: 'Baugenehmigungen',
        demographics: 'Demografie',
        detailedBuildingData: 'Detaillierte Gebäudeeigenschaften und Daten',
        energyAndEnvironmentalData: 'Energieeffizienz und Umweltdaten',
        energyCertificate: 'Energieausweis',
        energyEnvironment: 'Energie und Umwelt',
        exploreWithMaps: 'Erkunden Sie das Grundstück mit verschiedenen Kartenwerkzeugen',
        federalBuildingRegistry: 'Eidg. Gebäude- und Wohnungsregister (GWR)',
        federalGeoportal: 'Bundesgeoportal',
        geoAdminFederalData: 'map.geo.admin.ch - Bundesdaten',
        googleEarth: 'Google Earth',
        googleMaps: 'Google Maps',
        landRegistry: 'Grundbuch',
        localBuildingRecords: 'Lokale Gebäudeakten und Bewilligungen',
        mapsNavigation: 'Karten und Navigation',
        municipalPortal: 'Gemeindeportal',
        neighborhood: 'Nachbarschaft',
        neighborhoodLocalMarket: 'Nachbarschaftsinformationen und lokaler Markt',
        neighborhoodStatistics: 'Demografie und Statistik des Quartiers',
        noBuildingData: 'Gebäudedaten sind erforderlich, um externe Links zu generieren',
        noiseExposure: 'Lärmbelastung',
        noLinksAvailable: 'Keine externen Links verfügbar',
        noPropertyData: 'Immobiliendaten sind erforderlich, um externe Links zu generieren',
        officialBuildingData: 'Offizielle Gebäudedaten und Klassifikationen',
        officialBuildingStats: 'Offizielle eidgenössische Gebäudestatistik',
        officialEnergyRating: 'Offizielle GEAK-Energieetikette',
        officialExtractServitudes: 'Offizieller Auszug und Dienstbarkeiten',
        officialRegistries: 'Offizielle Register',
        permitsHistory: 'Geschichte der erteilten Genehmigungen in der Umgebung',
        publicLawRestrictions: 'Öffentlich-rechtliche Eigentumsbeschränkungen',
        purchaseListings: 'Kaufanzeigen',
        recentSalesHistory: 'Verkaufshistorie in der Umgebung',
        rentalListings: 'Mietanzeigen',
        rooftopSolarAnalysis: 'Analyse des Solarpotenzials der Dächer',
        similarPurchasePropertiesMarket: 'Verkaufsanzeigen in derselben Gegend auf dem Markt',
        similarRentalPropertiesMarket: 'Mietanzeigen in derselben Gegend auf dem Markt',
        situationPlan: 'cadastre.ch - Situationsplan',
        situationPlanDescription: 'Amtliche Vermessung Schweiz',
        solarPotential: 'Solarpotenzial',
        streetViewRoutes: 'Street View und Routen',
        trafficNoiseData: 'Strassen- und Bahnlärmdaten',
        transactions: 'Transaktionen',
        view3dSatelliteHistory: '3D-Ansicht und Satellitenhistorie',
      },
      loading: 'Immobiliendaten werden geladen...',
      loadingForId: 'Immobiliendaten für ID: {{id}} werden geladen...',
      market: {
        all: 'Alle',
        allResidentialProperties: 'Alle Wohnimmobilien',
        apartment: 'Wohnung',
        avgPricePerSqm: 'Durchschnittspreis pro m²',
        avgRentPerSqm: 'Durchschnittsmiete pro m²',
        canton: 'Kanton',
        cantonLevel: 'Kantonsebene',
        cityGeneva: 'Stadt Genf',
        dataUnavailable: 'Marktdaten sind derzeit nicht verfügbar',
        district: 'Bezirk',
        districtGeneva: 'Bezirk Genf',
        districtLevel: 'Bezirksebene',
        faoData: 'Kanton Genf',
        house: 'Haus',
        locationRequired: 'Immobilienstandort ist erforderlich, um Marktinformationen anzuzeigen',
        marketComparison: 'Marktvergleich',
        marketOverview: 'Marktübersicht',
        medianPrice: 'Medianpreis',
        medianPricePerSqm: 'Medianpreis pro m²',
        medianRent: 'Medianmiete',
        medianRentPerSqm: 'Medianmiete pro m²',
        municipality: 'Gemeinde',
        municipalityLevel: 'Gemeindeebene',
        noMarketData: 'Keine Marktdaten verfügbar',
        noRecentListings: 'Keine aktuellen Anzeigen verfügbar',
        priceEvolution: 'Preisentwicklung',
        pricePerSqm: 'Preis pro m²',
        pricePerSqmEvolution: 'Entwicklung des Preises pro m²',
        recentListings: 'Aktuelle Anzeigen',
        rent: 'Vermietung',
        rentPerSqm: 'Miete pro m²',
        rooms: 'Zimmer',
        sale: 'Verkauf',
        thisYear: 'dieses Jahr',
        viewMoreAnalysis: 'Weitere Analysen anzeigen',
        viewMoreListings: 'Weitere Anzeigen anzeigen',
        yearOverYear: 'über 1 Jahr',
      },
      noAddress: 'Keine Adresse verfügbar',
      noPropertyData: 'Keine Immobiliendaten gefunden',
      notes: 'Notizen',
      notesPanel: {
        addNote: 'Notiz hinzufügen',
        aiAssistant: 'KI-Assistent',
        cancel: 'Abbrechen',
        clearSearch: 'Suche löschen',
        daysAgo: 'Vor {{count}} Tagen',
        deleteConfirm: 'Diese Notiz löschen?',
        deleteNote: 'Löschen',
        editNote: 'Bearbeiten',
        hoursAgo: 'Vor {{count}} Stunde',
        hoursAgo_plural: 'Vor {{count}} Stunden',
        justNow: 'Gerade eben',
        loading: 'Notizen werden geladen...',
        minutesAgo: 'Vor {{count}} Minute',
        minutesAgo_plural: 'Vor {{count}} Minuten',
        newNote: 'Neue Notiz',
        noNotes: 'Keine Notizen',
        noNotesText: 'Beginnen Sie mit dem Hinzufügen einer ersten Notiz zu dieser Immobilie',
        noResults: 'Keine Ergebnisse gefunden',
        noResultsText: 'Versuchen Sie es mit anderen Stichwörtern',
        noteHint: 'Fügen Sie Ihre Beobachtungen zu dieser Immobilie hinzu',
        resultsInfo: '{{visible}} Ergebnis',
        resultsInfo_plural: '{{visible}} Ergebnisse von {{total}} Notizen',
        saveNote: 'Speichern',
        searchPlaceholder: 'In Notizen suchen...',
        title: 'Notizen',
        weeksAgo: 'Vor {{count}} Woche',
        weeksAgo_plural: 'Vor {{count}} Wochen',
        yesterday: 'Gestern',
      },
      openAnalysis: 'Analyse öffnen',
      openEstimation: 'Schätzung öffnen',
      propertyIdLabel: 'Immobilien-ID: {{id}}',
      removeFromFavorites: 'Aus Favoriten entfernen',
      retry: 'Erneut versuchen',
      landAreaLabel: 'Grundstücksfläche',
      surfaceLabel: 'm² Fläche',
      tabs: {
        comingSoon: 'Bald verfügbar...',
        history: 'Geschichte',
        information: 'Überblick',
        links: 'Links',
        market: 'Markt',
      },
      unitsLabel: 'Wohneinheiten',
    },
    propertyTooltip: {
      buildingInformation: {
        title: 'Gebäudeinformationen',
      },
      buildings: {
        buildingLabel: 'Gebäude {{id}}',
        buildingYear: 'Baujahr',
        energyReferenceSurface: 'Energiebezugsfläche',
        floorNumber: 'Anzahl Stockwerke',
        grossUsefulFloorArea: 'Bruttogeschossfläche',
        groundFloorArea: 'Grundfläche',
        heatingEnergySource: 'Heizenergiequelle',
        idc: 'IDC',
        maxHeight: 'Maximale Höhe',
        numberOfDwellings: 'Anzahl Wohnungen',
        protected: 'Geschütztes Gebäude',
        renovationYear: 'Renovierungsjahr',
        residentialFloorNumber: 'Anzahl Wohngeschosse',
        solarPotential: 'Solarpotenzial',
        title: 'Gebäude',
        totalResidentialArea: 'Gesamtwohnfläche',
        units: 'Einheiten',
        volume: 'Volumen',
      },
      energy: {
        idc: 'IDC (Wärmebedarfsindex)',
        minergie: 'Minergie',
        title: 'Energie & Nachhaltigkeit',
      },
      landInformation: {
        area: 'Fläche',
        buildingArea: 'Bebaute Fläche',
        buildingPeriod: 'Bauperiode',
        buildingRights: 'Baurechte',
        district: 'Bezirk',
        egrid: 'EGRID',
        lastRenovation: 'Letzte Gebäuderenovierung',
        municipality: 'Gemeinde',
        notApplicable: 'Nicht zutreffend',
        numberOfBuildings: 'Anzahl Gebäude',
        numberOfDwellings: 'Anzahl Wohneinheiten',
        propertyNature: 'Grundstücksart',
        propertyNatureBF: 'Grundstück',
        propertyNatureDDP: 'Selbständiges und dauerndes Recht (SDR)',
        swimmingPool: 'Swimming Pool',
        title: 'Grundstück',
        totalResidentialArea: 'Gesamtwohnfläche',
        type: 'Typ',
        zone: 'Zone',
      },
      lands: {
        title: 'Zugehörige Grundstücke',
        unknownEgrid: 'Unbekannte EGRID',
        unknownType: 'Unbekannter Typ',
      },
      owners: {
        company: 'Unternehmen',
        lastChange: 'Letzte Änderung',
        localLabel: 'local',
        searchGoogle: 'Auf Google suchen',
        searchLinkedIn: 'Auf LinkedIn suchen',
        searchLocal: 'Auf local.ch suchen',
        searchZefix: 'Auf Zefix suchen (Handelsregister)',
        title: 'Eigentümer',
        unknown: 'Unbekannter Eigentümer',
      },
      restrictions: {
        active: 'Aktiv',
        coverage: '{{percent}}% Abdeckung',
        coverageArea: 'Abdeckungsfläche',
        description: 'Beschreibung',
        inactive: 'Inaktiv',
        newConstruction: 'Neubau erlaubt',
        status: 'Status',
        title: 'Einschränkungen',
        type: 'Typ',
      },
      transport: {
        title: 'Transport & Erreichbarkeit',
      },
      view: {
        title: 'Aussicht & Ausrichtung',
      },
      zones: {
        adoptedDate: 'angenommen am {{date}}',
        authorizedCOS: 'Zulässiger Überbauungskoeffizient',
        authorizedCUS: 'Zulässiger Ausnützungskoeffizient',
        authorizedIBUS: 'Zulässige Geschossflächenziffer (GFZ)',
        buildingArea: 'Baufläche',
        category: 'Kategorie',
        categoryCantonal: 'Kantonal',
        categoryGeneral: 'Kommunal',
        categoryLocal: 'Lokal',
        categoryPartial: 'Teilweise',
        name: 'Name',
        notApplicable: 'N/A',
        part: 'Anteil',
        planType: 'Plantyp',
        title: 'Zonen',
        zone: 'Zone',
      },
    },
    qualityLevels: {
      average: 'Durchschnittlich',
      excellent: 'Ausgezeichnet',
      good: 'Gut',
      high: 'Hoch',
      low: 'Niedrig',
      medium: 'Mittel',
      poor: 'Schlecht',
      very_poor: 'Sehr schlecht',
    },
    viewToggle: {
      list: 'Liste',
      map: 'Karte',
    },
    wmsLayers: {
      ' Cadastral Surveying (OpenData)': 'Amtliche Vermessung',
      airport_noise: 'Fluglärm',
      building_zones_switzerland_harmonized: 'Bauzonen Schweiz',
      daily_railway_noise: 'Eisenbahnlärm Tag',
      daily_traffic_noise: 'Strassenverkehrslärm Tag',
      nightly_railway_noise: 'Eisenbahnlärm Nacht',
      nightly_traffic_noise: 'Strassenverkehrslärm Nacht',
      swissimage_past_1960: '1960 Schweizer Luftbilder',
      swissimage_past_1970: '1970 Schweizer Luftbilder',
      swissimage_past_1980: '1980 Schweizer Luftbilder',
      swissimage_past_1990: '1990 Schweizer Luftbilder',
      swissimage_past_2000: '2000 Schweizer Luftbilder',
      swissimage_past_2010: '2010 Schweizer Luftbilder',
      swissimage_past_2015: '2015 Schweizer Luftbilder',
      swissimage_past_2020: '2020 Schweizer Luftbilder',
      unconsolidated_deposits_thickness_model: 'Mächtigkeit Lockergestein',
    },
  },
  feasibility: {
    assessment: {
      marginal: {
        description: 'Das Projekt liegt nahe an der {{target}}%-Rentabilitätsschwelle ({{marginal}}–{{target}}%). Erwägen Sie, Kosten oder Erlöse zu optimieren.',
        title: 'Marginale Realisierbarkeit',
      },
      not_viable: {
        description: 'Das Projekt liegt unter der {{marginal}}%-Schwelle der Entwicklermarge. Erhebliche Änderungen sind erforderlich.',
        title: 'Nicht realisierbar',
      },
      viable: {
        description: 'Das Projekt erfüllt das {{target}}%-Ziel der Entwicklermarge und zeigt eine starke finanzielle Tragfähigkeit.',
        title: 'Projekt realisierbar',
      },
    },
    empty: {
      description: 'Für diese geteilte Analyse sind keine Machbarkeitsstudiendaten verfügbar.',
      title: 'Keine Machbarkeitsstudie',
    },
    keyMetrics: {
      belowTarget: 'Unter Ziel',
      critical: 'Kritisch',
      developerMetrics: 'Entwicklerkennzahlen',
      internalRateOfReturn: 'Interner Zinssatz (annualisiert)',
      investmentOverview: 'Investitionsübersicht',
      netProfitEquity: 'Nettogewinn / Gesamtinvestiertes Eigenkapital',
      revenueInvestment: 'Erlöse / Gesamtinvestition',
      targetLabel: 'Ziel: ≥ {{target}}%',
      targetMet: 'Ziel erreicht',
      totalEquityInProject: 'Gesamtes im Projekt gebundenes Eigenkapital',
    },
    metrics: {
      developerMargin: 'Entwicklermarge',
      equityInvested: 'Investiertes Eigenkapital',
      irr: 'IRR',
      profitMultiple: 'Gewinnmultiplikator',
      roiOnEquity: 'ROI auf Eigenkapital',
    },
    quickFacts: {
      durationValue: '{{months}} Monate ({{years}} Jahre)',
      equityRequired: 'Erforderliches Eigenkapital',
      landFinancing: 'Grundstücksfinanzierung',
      notAvailable: 'N/V',
      pricePerM2: 'Durchschn. Preis/m²',
      projectDuration: 'Projektdauer',
      projectType: 'Projekttyp',
      saleableArea: 'Verkaufsfläche',
      timelineSplit: 'Zeitplanaufteilung',
      timelineValue: '{{planning}}M Planung + {{build}}M Bau',
      totalUnits: 'Gesamteinheiten',
    },
    residual: {
      interpretation: 'Bei diesem maximalen Kaufpreis wird der Zielgewinn von {{pct}} % des GDV erreicht, sofern die Annahmen eintreffen. Die Finanzierung entspricht dem aktuellen Modell und wird nicht mit dem Landpreis iteriert.',
      maxBid: 'Maximaler Kaufpreis',
      negativeNote: 'Der Residualwert ist negativ — Bau, Finanzierung und Zielgewinn übersteigen den Projektwert. Das Grundstück trägt dieses Programm bei der Zielmarge nicht.',
      noPlotArea: 'Grundstücksfläche nicht verfügbar — CHF/m² nicht angezeigt',
      perM2Value: '{{value}} / m² Grundstück',
      question: 'Was darf ich für dieses Grundstück bezahlen und trotzdem den Zielgewinn erreichen?',
      title: 'Residualwert des Grundstücks',
    },
    sections: {
      costBreakdown: 'Kostenaufschlüsselung',
      financialSummary: 'Finanzübersicht',
      keyPerformanceIndicators: 'Wichtige Leistungskennzahlen',
      projectQuickFacts: 'Projekteckdaten',
    },
    summaryCards: {
      costBreakdown: 'Grundstück: {{land}} | Bau: {{construction}}',
      financingCosts: 'Finanzierungskosten',
      fromSales: 'Aus Einheitenverkäufen und Zusatzerlösen',
      grossProfit: 'Brutto: {{gross}}',
      interestAndFees: 'Zinsen und Gebühren während des Projekts',
      netProfit: 'Netto-Entwicklergewinn',
      totalCosts: 'Gesamtkosten',
      totalRevenue: 'Gesamterlös',
    },
    waterfall: {
      construction: 'Bau',
      financing: 'Finanzierung',
      landCosts: 'Grundstückskosten',
      netProfit: 'Nettogewinn',
      revenue: 'Erlöse',
    },
  },
  geoAnalysis: {
    charts: {
      altitude: 'Höhe (Meter)',
      distance: 'Entfernung',
      flatArea: 'Flache Fläche',
      meters: 'm',
      plotBoundary: 'Grundstücksgrenze',
      position: 'Position',
      slopedArea: 'Geneigte Fläche',
      status: 'Status',
      xAxis: 'X (Meter)',
      yAxis: 'Y (Meter)',
    },
    directions: {
      east: 'Osten',
      eastWest: 'Ost-West',
      flat: 'Flach',
      north: 'Norden',
      northEast: 'Nordosten',
      northSouth: 'Nord-Süd',
      northWest: 'Nordwesten',
      south: 'Süden',
      southEast: 'Südosten',
      southWest: 'Südwesten',
      square: 'Quadratisch',
      west: 'Westen',
    },
    error: 'Geografische Daten konnten nicht geladen werden',
    header: {
      scoreLabel: 'Geo-Score',
      scoreTooltip: 'Gesamtbewertung der geografischen Eignung basierend auf Neigung, Ausrichtung und Form',
      subtitle: 'Umfassende topografische und geometrische Analyse für Grundstück {{egrid}}',
      title: 'Geografische Analyse',
    },
    loading: 'Laden der geografischen Daten...',
    metrics: {
      areaEfficiency: 'Flächeneffizienz',
      averageSlope: 'Durchschnittliche Neigung',
      buildable: 'Bebaubar',
      compactness: 'Kompaktheit',
      compactnessScore: 'Kompaktheitsbewertung',
      constructionSuitability: 'Baueignung',
      dataPoints: 'Datenpunkte',
      dimensions: 'Abmessungen (L x B)',
      dominantOrientation: 'Dominante Ausrichtung',
      elevationRange: 'Höhenbereich',
      faces: 'Ausrichtung',
      gridSize: 'Rastergrösse',
      lengthWidth: 'Länge x Breite',
      maxAltitude: 'Max. Höhe',
      maxFlatArea: 'Max. flache Fläche',
      maximum: 'Maximum',
      maximumFlatArea: 'Maximale flache Fläche',
      maximumSlope: 'Maximale Neigung',
      minAltitude: 'Min. Höhe',
      minimum: 'Minimum',
      percentOfTotal: '% der Gesamtfläche',
      perimeter: 'Umfang',
      regularity: 'Regelmässigkeit',
      shapeFactor: 'Formfaktor',
      shapeRegularity: 'Formregelmässigkeit',
      slopeThreshold: 'Neigungsschwelle',
      sunExposure: 'Sonneneinstrahlung',
      totalArea: 'Gesamtfläche',
    },
    noAltitudeData: 'Keine Höhendaten verfügbar',
    noData: 'Keine Daten verfügbar',
    noElevationData: 'Keine Höhendaten für diese Region verfügbar',
    noPolygonData: 'Keine Polygondaten verfügbar',
    noSlopeAnalysis: 'Keine Hanganalyse verfügbar',
    plotTooSmall: 'Grundstück zu klein für Hanganalyse',
    plotTooSmallDescription: 'Das Grundstück ist zu klein für eine detaillierte Hanganalyse. Mindestfläche erforderlich: 100m².',
    sections: {
      altitudeProfile: 'Höhenprofil',
      developmentAnalysis: 'Entwicklungsanalyse',
      flatAreaAnalysis: 'Analyse der flachen Flächen',
      geometryAnalysis: 'Geometrieanalyse',
      orientationAnalysis: 'Ausrichtungsanalyse (Sonneneinstrahlung)',
      plotBoundaryVisualization: 'Visualisierung der Grundstücksgrenzen',
      shapeMetrics: 'Formmetriken',
      slopeDistribution: 'Neigungsverteilung',
      slopeSunOrientation: 'Neigung & Sonneneinstrahlung',
      topographicVisualization: '3D-Topografische Visualisierung',
    },
    slopeRanges: {
      flat: 'Flach (0-5°)',
      gentle: 'Sanft (5-10°)',
      moderate: 'Mässig (10-15°)',
      range0_5: '0-5° (Flach)',
      range10_15: '10-15° (Mässig)',
      range15_25: '15-25° (Steil)',
      range5_10: '5-10° (Sanft)',
      rangeOver25: '>25° (Sehr steil)',
      steep: 'Steil (15-25°)',
      verysteep: 'Sehr steil (>25°)',
    },
    status: {
      challenging: 'Herausfordernd',
      excellent: 'Ausgezeichnet',
      good: 'Gut',
      irregular: 'Unregelmässig',
      loading: 'Wird geladen...',
      moderate: 'Mässig',
      na: 'N/A',
      neutral: 'Neutral',
      noData: 'Keine Daten',
      poor: 'Schlecht',
      realData: 'Echte Daten',
      regular: 'Regelmässig',
    },
    sunExposureNotes: {
      excellent: 'Potenzial für passive Sonnenwärme',
      moderate: 'Ausgewogenes Tageslicht',
      neutral: 'Keine dominante Neigung',
      poor: 'Wenig direkte Sonne',
    },
    tabs: {
      analysis: 'Neigung und Ausrichtung',
      overview: 'Übersicht',
      shape: 'Form und Geometrie',
      topography: '3D-Topographie',
    },
    tooltips: {
      areaEfficiency: {
        calculation: 'Flache Fläche / Gesamtfläche × 100%',
        importance: 'Höhere Effizienz bedeutet, dass mehr vom Grundstück sofort nutzbar ist.',
        shortDescription: 'Prozentsatz der flachen, bebaubaren Fläche im Vergleich zur Gesamtgrundstücksfläche.',
        source: 'Zusammengesetzte Analyse aus Höhen- und Katasterdaten',
        title: 'Flächeneffizienz',
      },
      averageSlope: {
        calculation: 'Gewichteter Durchschnitt der Neigungswerte von Höhenrasterpunkten.',
        categories: [
          {
            description: 'Ideal für den Bau, minimale Erdarbeiten erforderlich',
            label: 'Flach',
            range: '0-5°',
          },
          {
            description: 'Gut für den Bau mit geringen Anpassungen',
            label: 'Sanft',
            range: '5-10°',
          },
          {
            description: 'Erfordert erhebliche Erdarbeiten und Stützstrukturen',
            label: 'Mässig',
            range: '10-15°',
          },
          {
            description: 'Schwieriger Bau, spezialisierte Techniken erforderlich',
            label: 'Steil',
            range: '>15°',
          },
        ],
        importance: 'Kritisch für die Baumachbarkeit und Entwässerungsplanung.',
        limitations: 'Zeigt keine lokalen Neigungsvariationen innerhalb des Grundstücks.',
        shortDescription: 'Der mittlere Neigungswinkel über die gesamte Grundstücksfläche.',
        source: 'SwissTopo Höhendaten (swissALTI3D)',
        title: 'Durchschnittliche Neigung',
      },
      compactness: {
        calculation: '4π × Fläche / Umfang² (1.0 = perfekter Kreis)',
        importance: 'Kompaktere Formen haben niedrigere Grenzkosten pro Flächeneinheit.',
        shortDescription: 'Verhältnis von Grundstücksfläche zu Umfang, zeigt Formeffizienz an.',
        source: 'Berechnet aus Katasterpolygondaten',
        title: 'Kompaktheit',
      },
      compactnessScore: {
        calculation: 'Isoperimetrischer Quotient: 4π × Fläche / Umfang²',
        categories: [
          {
            description: 'Sehr kompakte Form, effiziente Raumnutzung',
            label: 'Hoch',
            range: '>0.7',
          },
          {
            description: 'Mässige Kompaktheit, typisch für die meisten Grundstücke',
            label: 'Mittel',
            range: '0.4-0.7',
          },
          {
            description: 'Längliche oder komplexe Form, weniger effizient',
            label: 'Niedrig',
            range: '<0.4',
          },
        ],
        importance: 'Höhere Kompaktheit bedeutet weniger Grenze relativ zur Fläche, was die Kosten senkt.',
        shortDescription: 'Misst, wie kompakt (kreisförmig) die Grundstücksform ist.',
        source: 'Berechnet aus Katasterpolygondaten',
        title: 'Kompaktheitsbewertung',
      },
      constructionSuitability: {
        calculation: 'Zusammengesetzter Score basierend auf Neigung, Form und Anteil der flachen Fläche.',
        categories: [
          {
            description: 'Ideale Bedingungen für den Bau',
            label: 'Ausgezeichnet',
            range: '>80%',
          },
          {
            description: 'Günstige Bedingungen mit geringen Herausforderungen',
            label: 'Gut',
            range: '60-80%',
          },
          {
            description: 'Erhebliche Erdarbeiten oder Anpassungen erforderlich',
            label: 'Mässig',
            range: '40-60%',
          },
          {
            description: 'Komplexe Bauanforderungen',
            label: 'Herausfordernd',
            range: '<40%',
          },
        ],
        importance: 'Schneller Indikator für Entwicklungspotenzial und Baukosten.',
        shortDescription: 'Gesamtbewertung, wie geeignet das Grundstück für den Bau ist.',
        source: 'Zusammengesetzte Analyse aus mehreren Datenquellen',
        title: 'Baueignung',
      },
      dimensions: {
        calculation: 'Berechnet aus dem minimalen umgebenden Rechteck.',
        importance: 'Hilft bei der Bestimmung der maximalen Gebäudeabmessungen, die auf das Grundstück passen.',
        shortDescription: 'Länge und Breite des umgebenden Rechtecks des Grundstücks.',
        source: 'Berechnet aus Katasterpolygondaten',
        title: 'Abmessungen',
      },
      dominantOrientation: {
        calculation: 'Bestimmt durch Analyse des Aspekts (Neigungsrichtung) des Geländes.',
        importance: 'Beeinflusst Solargewinn, natürliche Beleuchtung und Energieeffizienz von Gebäuden.',
        shortDescription: 'Die Haupthimmelsrichtung, in die das Grundstück zeigt, beeinflusst die Sonneneinstrahlung.',
        source: 'SwissTopo Höhendaten (swissALTI3D)',
        title: 'Dominante Ausrichtung',
      },
      flatAreaAnalysis: {
        calculation: 'Gitteranalyse zur Identifizierung zusammenhängender flacher Zonen.',
        importance: 'Flache Bereiche sind optimal für die Gebäudeplatzierung und erfordern weniger Erdarbeiten.',
        shortDescription: 'Identifiziert und misst Bereiche mit einer Neigung von weniger als 5°.',
        source: 'SwissTopo Höhendaten (swissALTI3D)',
        title: 'Analyse der flachen Flächen',
      },
      maxFlatArea: {
        calculation: 'Analyse der grössten verbundenen Komponente flacher Rasterzellen.',
        importance: 'Bestimmt den maximal möglichen Gebäudegrundriss ohne Aushub.',
        shortDescription: 'Die grösste zusammenhängende flache Fläche auf dem Grundstück.',
        source: 'SwissTopo Höhendaten (swissALTI3D)',
        title: 'Maximale flache Fläche',
      },
      maximumSlope: {
        calculation: 'Maximalwert aus der Neigungsgitteranalyse.',
        importance: 'Identifiziert potenzielle Problembereiche für den Bau.',
        shortDescription: 'Der steilste Neigungswinkel, der irgendwo auf dem Grundstück gefunden wurde.',
        source: 'SwissTopo Höhendaten (swissALTI3D)',
        title: 'Maximale Neigung',
      },
      perimeter: {
        calculation: 'Summe aller Kantenlängen des Grenzpolygons.',
        importance: 'Beeinflusst Zaunkosten und Grenzüberlegungen.',
        shortDescription: 'Die Gesamtlänge der Grundstücksgrenze.',
        source: 'Berechnet aus Katasterpolygondaten',
        title: 'Umfang',
      },
      regularity: {
        calculation: 'Grundstücksfläche / Fläche des umgebenden Rechtecks × 100%',
        importance: 'Höhere Regelmässigkeit bedeutet mehr nutzbaren Raum für den Bau.',
        shortDescription: 'Wie gut das Grundstück sein umgebendes Rechteck ausfüllt.',
        source: 'Berechnet aus Katasterpolygondaten',
        title: 'Regelmässigkeit',
      },
      shapeFactor: {
        calculation: 'Länge / Breite des minimalen umgebenden Rechtecks.',
        categories: [
          {
            description: 'Nahezu gleiche Länge und Breite',
            label: 'Quadratisch',
            range: '1.0-1.5',
          },
          {
            description: 'Mässiges Länge-zu-Breite-Verhältnis',
            label: 'Rechteckig',
            range: '1.5-3.0',
          },
          {
            description: 'Lange und schmale Form',
            label: 'Länglich',
            range: '>3.0',
          },
        ],
        importance: 'Zeigt an, ob das Grundstück quadratisch, rechteckig oder länglich ist.',
        shortDescription: 'Verhältnis von Länge zu Breite des umgebenden Rechtecks des Grundstücks.',
        source: 'Berechnet aus Katasterpolygondaten',
        title: 'Formfaktor',
      },
      shapeRegularity: {
        calculation: 'Verhältnis der Grundstücksfläche zur Fläche des minimalen umgebenden Rechtecks.',
        categories: [
          {
            description: 'Fast rechteckig, optimal für die Gebäudeplatzierung',
            label: 'Regelmässig',
            range: '>80%',
          },
          {
            description: 'Komplexe Form, kann Bauoptionen einschränken',
            label: 'Unregelmässig',
            range: '<80%',
          },
        ],
        importance: 'Regelmässige Formen sind einfacher und kostengünstiger zu bebauen.',
        shortDescription: 'Wie nahe die Grundstücksform einem regelmässigen Rechteck ist.',
        source: 'Berechnet aus Katasterpolygondaten',
        title: 'Formregelmässigkeit',
      },
      slopeDistribution: {
        calculation: 'Gitterbasierte Neigungsanalyse mit Kategorisierung.',
        importance: 'Zeigt die Vielfalt der Geländebedingungen über das Grundstück.',
        shortDescription: 'Aufschlüsselung des Grundstücks nach Neigungskategorien.',
        source: 'SwissTopo Höhendaten (swissALTI3D)',
        title: 'Neigungsverteilung',
      },
      totalArea: {
        calculation: 'Berechnet mit der Schuhbandformel auf den Polygonkoordinaten.',
        importance: 'Wesentlich für die Bestimmung des Baupotenzials und des Immobilienwerts.',
        limitations: 'Kann geringfügig von offiziellen Katastermessungen abweichen.',
        shortDescription: 'Die Gesamtfläche des Grundstücks, berechnet aus seinem Grenzpolygon.',
        source: 'Berechnet aus Katasterpolygondaten',
        title: 'Gesamtfläche',
      },
    },
  },
  history: {
    actions: {
      exportCSV: 'Als CSV exportieren',
      exportExcel: 'Als Excel exportieren',
      filterByType: 'Nach Typ filtern',
      sortByDate: 'Nach Datum sortieren',
      sortByPrice: 'Nach Preis sortieren',
      viewDetails: 'Details anzeigen',
    },
    adjustFilters: 'Versuchen Sie, Ihre Filter anzupassen',
    back: 'Zurück',
    buildingHistory: 'Gebäudehistorie',
    buildingHistorySubtitle: 'Alle von Popety.io gesammelten Ereignisse, die in den letzten Jahren am Gebäude {{egid}} stattgefunden haben.',
    detailView: {
      active: 'Aktiv',
      addressNotSpecified: 'Adresse nicht angegeben',
      available: 'Verfügbar',
      balcony: 'Balkon',
      bathrooms: 'Badezimmer',
      built: 'Baujahr',
      constructionYear: 'Baujahr',
      days: 'Tage',
      description: 'Beschreibung',
      elevator: 'Aufzug',
      energyLabel: 'Energielabel',
      featuresAndAmenities: 'Merkmale & Ausstattung',
      floor: 'Stockwerk',
      furnished: 'Möbliert',
      garage: 'Garage',
      garden: 'Garten',
      heatingType: 'Heizungsart',
      immediately: 'Sofort',
      inactive: 'Inaktiv',
      landArea: 'Grundstücksfläche',
      livingArea: 'Wohnfläche',
      onlineFor: 'Online seit',
      parking: 'Parkplatz',
      petsAllowed: 'Haustiere erlaubt',
      propertyAgents: 'Immobilienmakler',
      propertyCategory: 'Immobilienkategorie',
      propertyDetails: 'Immobiliendetails',
      propertyForRent: 'Immobilie zur Miete',
      propertyForSale: 'Immobilie zum Verkauf',
      propertyType: 'Immobilientyp',
      published: 'Veröffentlicht',
      renovationYear: 'Renovierungsjahr',
      rooms: 'Zimmer',
      statusLabel: 'Status',
      terrace: 'Terrasse',
    },
    error: 'Fehler',
    eventDetails: 'Ereignisdetails',
    fields: {
      address: 'Adresse',
      architect: 'Architekt',
      area: 'Fläche',
      availableDate: 'Verfügbar',
      balcony: 'Balkon',
      bathrooms: 'Badezimmer',
      broker: 'Makler',
      buildingClassification: 'Gebäudeklassifikation',
      buyers: 'Käufer',
      classification: 'Klasse',
      constructionYear: 'Baujahr',
      date: 'Datum',
      description: 'Beschreibung',
      elevator: 'Aufzug',
      energyLabel: 'Energie',
      floor: 'Stockwerk',
      furnished: 'Möbliert',
      garage: 'Garage',
      garden: 'Garten',
      heatingType: 'Heizung',
      inquiryEnd: 'Enddatum',
      inquiryStart: 'Startdatum',
      landArea: 'Grundstück',
      listingType: 'Inseratstyp',
      onlineDays: 'Online-Tage',
      owner: 'Eigentümer',
      ownersType: 'Eigentümerart',
      parking: 'Parkplatz',
      permitNumber: 'Bewilligung',
      permitType: 'Bewilligungstyp',
      petsAllowed: 'Haustiere erlaubt',
      previousTransaction: 'Vorherige Transaktion',
      price: 'Preis',
      pricePerSqm: 'Preis/m²',
      projectArea: 'Fläche',
      projectValue: 'Wert',
      propertyCategory: 'Kategorie',
      propertyType: 'Immobilientyp',
      reason: 'Grund',
      renovationYear: 'Renoviert',
      rooms: 'Zimmer',
      sellers: 'Verkäufer',
      status: 'Status',
      terrace: 'Terrasse',
      type: 'Typ',
      units: 'Einheiten',
      workDescription: 'Arbeitsbeschreibung',
      workType: 'Typ',
    },
    filters: {
      allTime: 'Alle Zeit',
      buildingPermits: 'Baubewilligungen',
      dateRange: 'Zeitraum',
      export: 'Exportieren',
      listings: 'Inserate',
      rentalListings: 'Mietinserate',
      saleListings: 'Verkaufsinserate',
      searchPlaceholder: 'Geschichte durchsuchen...',
      transactions: 'Transaktionen',
    },
    loading: 'Wird geladen...',
    noBuildingDataAvailable: 'Keine Gebäudedaten verfügbar',
    noDataAvailable: 'Keine Daten verfügbar',
    noEstimateDataAvailable: 'Keine Schätzungsdaten verfügbar',
    noEvents: 'Keine historischen Ereignisse gefunden',
    noLandDataAvailable: 'Keine Grundstücksdaten verfügbar',
    ownershipType: 'Eigentumsart',
    plotHistory: 'Grundstückshistorie',
    plotHistorySubtitle: 'Alle von Popety.io gesammelten Ereignisse, die in den letzten Jahren auf dem Grundstück {{egrid}} stattgefunden haben.',
    propertyHistory: 'Immobilienhistorie',
    propertyHistorySubtitle: 'Alle von Popety.io gesammelten Ereignisse, die in den letzten Jahren auf dieser Immobilie stattgefunden haben.',
    propertyTypes: {
      apartment: 'Wohnung',
      commercial: 'Gewerbe',
      house: 'Haus',
      land: 'Grundstück',
      office: 'Büro',
      other: 'Andere',
      parking: 'Parkplatz',
    },
    sections: {
      inquiryPeriod: 'Öffentliche Auflagefrist',
      parties: 'Beteiligte Parteien',
      permitDetails: 'Bewilligungsdetails',
      projectInfo: 'Projektinformationen',
      propertyInfo: 'Immobilieninformationen',
      transactionDetails: 'Transaktionsdetails',
      workDescription: 'Arbeitsbeschreibung',
    },
    status: {
      active: 'Aktiv',
      approved: 'Genehmigt',
      inactive: 'Inaktiv',
      pending: 'Ausstehend',
      rejected: 'Abgelehnt',
    },
    subtitle: 'Ereignisse für {{address}}',
    timeline: {
      active: 'Aktiv',
      buildingPermit: 'Baubewilligung',
      completed: 'Abgeschlossen',
      days: 'Tage',
      expired: 'Abgelaufen',
      noEvents: 'Keine historischen Ereignisse gefunden',
      online: 'Online',
      pending: 'Ausstehend',
      permitRequest: 'Bewilligungsantrag',
      rentalListing: 'Mietinserat',
      saleListing: 'Verkaufsinserat',
      transaction: 'Transaktion',
    },
    title: 'Geschichte',
    transactionDetail: {
      fields: {
        city: 'Stadt',
        legalType: 'Rechtsform',
        numberOfBuyers: 'Anzahl der Käufer',
        numberOfProperties: 'Anzahl der Immobilien',
        numberOfSellers: 'Anzahl der Verkäufer',
        officialId: 'Offizielle ID',
        participant: 'Teilnehmer',
        participantType: 'Typ',
        postalCode: 'Postleitzahl',
        property: 'Immobilie',
        propertyNumber: 'Grundstücksnummer',
        publicationDate: 'Veröffentlichungsdatum',
        role: 'Rolle',
        share: 'Anteil',
        totalPrice: 'Gesamtpreis',
        totalSurface: 'Gesamtfläche',
        transactionDate: 'Transaktionsdatum',
        transactionId: 'Transaktions-ID',
        transactionType: 'Transaktionstyp',
      },
      sections: {
        participants: 'Teilnehmer',
        properties: 'Immobilien',
        summary: 'Zusammenfassung',
        transactionInfo: 'Transaktionsinformationen',
      },
    },
  },
  landAnalysis: {
    buildingDetails: {
      actions: {
        analysis: 'Analyse',
        cancel: 'Abbrechen',
        edit: 'Bearbeiten',
        explore: 'Erkunden',
        noBuildingId: 'Gebäude-ID nicht verfügbar',
        noEgid: 'EGID für dieses Gebäude nicht verfügbar',
        regbl: 'GWR',
        save: 'Speichern',
      },
      card: {
        building: 'Gebäude {{number}}',
        egid: 'EGID {{egid}}',
        floor: 'Stockwerk',
        floors: 'Stockwerke',
      },
      header: {
        scoreLabel: 'Bestandswert',
        scoreTooltip: 'Bestandswert basierend auf Bau- und Renovierungsjahren',
        subtitle: 'Umfassende Informationen über alle Gebäude auf {{address}}',
        title: 'Gebäudedetails',
      },
      legend: {
        estimatedValues: 'Geschätzte Werte',
        fullCoverage: 'Vollständige Abdeckung',
        garage: 'Garage',
        industrial: 'Industrie',
        offices: 'Büros',
        other: 'Andere',
        partialCoverage: 'Teilweise Abdeckung',
        public: 'Öffentlich',
        residential: 'Wohnen',
        residentialMajority: 'Wohnen Mehrheit',
        residentialMinority: 'Wohnen Minderheit',
        retail: 'Einzelhandel',
      },
      sections: {
        dimensions: {
          estFloorArea: 'Gesch. Geschossfläche',
          grossFloorArea: 'Bruttogeschossfläche',
          groundArea: 'Grundfläche',
          height: 'Höhe',
          title: 'Abmessungen',
          volume: 'Volumen',
        },
        energy: {
          mainHeating: 'Hauptheizung',
          secondaryHeating: 'Nebenheizung',
          solarPotential: 'Solarpotenzial',
          title: 'Energie',
          waterHeating: 'Warmwasser',
        },
        propertyInfo: {
          classification: 'BFS-Klassifizierung',
          officialNumber: 'Amtliche Nummer',
          ofsCategory: 'BFS-Kategorie',
          title: 'Objektinformationen',
          units: 'Einheiten',
        },
        status: {
          compliance: 'Konformität',
          constructionStatus: 'Baustatus',
          lastRenovation: 'Letzte Renovierung',
          protectionStatus: 'Schutzstatus',
          title: 'Status',
        },
      },
      states: {
        loading: 'Gebäudedetails werden geladen...',
        noData: 'Keine Daten verfügbar',
        unknownLocation: 'Unbekannter Standort',
      },
      summary: {
        buildingsNumber: 'Anzahl Gebäude',
        protectedBuildings: 'Geschützte Gebäude',
        unitsNumber: 'Anzahl Einheiten',
      },
      summaryBar: {
        other: 'andere Bauten',
        plannedConstruction: 'geplant/Bau',
        protected: 'geschützt',
        registered: 'registriert',
        total: 'Gebäude insgesamt',
        underground: 'unterirdisch',
      },
      units: {
        cubicMeters: 'm³',
        meters: 'm',
        notAvailable: 'k.A.',
        squareMeters: 'm²',
      },
      values: {
        building: 'Gebäude {{index}}',
        compliant: 'Konform',
        good: 'Gut',
        heritageProtected: 'Denkmalgeschützt',
        na: 'N/A',
        notClassified: 'Nicht klassifiziert',
        notProtected: 'Nicht geschützt',
        notSpecified: 'Nicht angegeben',
        projected: 'Geplant',
        solarExcellent: 'Ausgezeichnet',
        solarGood: 'Gut',
        solarLow: 'Niedrig',
        solarMedium: 'Mittel',
      },
    },
    buildingsOverview: {
      aboveGroundVolume: 'Oberirdisches Volumen',
      buildingCoverage: 'Gebäudebedeckung (IDC)',
      constructionYear: 'Baujahr',
      dimensions: 'Abmessungen',
      general: 'Allgemein',
      maximumFloors: 'Maximale Stockwerke',
      maximumHeight: 'Maximale Höhe',
      notAvailable: 'N/V',
      numberOfBuildings: 'Anzahl Gebäude',
      title: 'Gebäudeübersicht',
      totalFloorArea: 'Gesamte Geschossfläche',
      totalGroundArea: 'Gesamte Grundfläche',
    },
    common: {
      no: 'Nein',
      notAvailable: 'k.A.',
      yes: 'Ja',
    },
    filesPanel: {
      title: 'Dateien',
    },
    header: {
      addTags: 'Tags hinzufügen',
      addToDeal: 'Zum Deal hinzufügen',
      buildingAnalysis: 'Gebäudeanalyse',
      built: 'Baujahr',
      createNewBuildingAnalysis: 'Neue Gebäudeanalyse erstellen',
      createNewLandAnalysis: 'Neue Grundstücksanalyse erstellen',
      favorite: 'Favorit',
      files: 'Dateien',
      floors: 'Stockwerke',
      groupLandAnalysis: 'Gruppierte Grundstücksanalyse',
      landAnalysis: 'Grundstücksanalyse',
      newBuildingAnalysis: 'Neue Gebäudeanalyse',
      newLandAnalysis: 'Neue Grundstücksanalyse',
      notes: 'Notizen',
      pdfReports: 'PDF-Berichte',
      share: 'Teilen',
      subtitle: 'Grundstücksinformationen',
      subtitleMultiplePlots: '{{count}} Grundstücke für {{address}}',
      subtitleSinglePlot: 'Grundstücksdetails für {{address}}',
      subtitleWithAddress: 'Grundstücksinformationen für {{address}}',
      tags: 'Tags',
      title: 'Grundstück',
      units: 'Einheiten',
    },
    info: {
      area: 'Fläche',
      buildable: 'Bebaubar',
      buildingAreaPresent: 'Bauzone vorhanden',
      egridNumber: 'EGRID-Nummer',
      officialArea: 'Amtliche Fläche',
      plotNumber: 'Parzellennummer',
      propertyNature: 'Art des Grundstücks',
      propertyNatureBF: 'BF – Grundstück',
      propertyNatureDDP: 'sdR – Selbständiges und dauerndes Recht',
      title: 'Grundstücksinformationen',
      type: 'Eigentumsart',
    },
    links: {
      openLandAnalysis: 'Grundstücksanalyse öffnen',
      title: 'Schnelllinks',
      viewInExplore: 'In Explore ansehen',
    },
    marketActivity: {
      activeListings: 'Aktive Inserate',
      buildingPermits: 'Baugenehmigungen',
      recentActivity: 'Aktuelle Aktivität',
      title: 'Marktaktivität',
      transactions: 'Transaktionen',
    },
    metrics: {
      buildings: {
        subtext: 'Auf diesem Grundstück',
        title: 'Gebäude',
      },
      landArea: {
        subtext: 'Gesamtfläche',
        title: 'Grundstücksfläche',
      },
      underExploitedScore: {
        subtext: 'Entwicklungspotenzial',
        title: 'Unternutzt',
        tooltip: {
          calculation: 'Basierend auf aktuellem vs. erlaubtem Geschossflächenverhältnis.',
          description: 'Misst, wie viel des bebaubaren Potenzials derzeit genutzt wird.',
          importance: 'Höhere Werte deuten auf mehr Entwicklungspotenzial hin.',
          source: 'Berechnet aus Zonenvorschriften und aktuellen Gebäuden.',
          title: 'Unternutzungswert',
        },
      },
      units: {
        subtext: 'Wohneinheiten',
        title: 'Einheiten',
      },
    },
    owners: {
      lastChange: 'Letzte Änderung',
      names: 'Eigentümernamen',
      number: 'Anzahl Eigentümer',
      ownershipType: 'Eigentumsart',
      title: 'Eigentümer',
    },
    ownership: {
      contact: 'Kontakt',
      lastChange: 'Letzte Änderung:',
      noOwnerInfo: 'Keine Eigentümerinformationen verfügbar',
      owners: 'Eigentümer:',
      title: 'Eigentum',
      unknown: 'Unbekannt',
      unknownOwner: 'Unbekannter Eigentümer',
      viewProfile: 'Profil anzeigen',
    },
    propertyInformation: {
      addresses: 'Adressen',
      area: 'Fläche',
      bareLand: 'Unbebautes Land',
      basicInformation: 'Grundinformationen',
      municipality: 'Gemeinde',
      no: 'Nein',
      notAvailable: 'N/V',
      plotNumber: 'Parzellennummer',
      privateLand: 'Privatgrundstück',
      propertyId: 'Liegenschafts-ID (EGRID)',
      publicLand: 'Öffentliches Grundstück',
      title: 'Immobilieninformationen',
      type: 'Typ',
      unknown: 'Unbekannt',
      viewAllAddresses: 'Alle {{count}} Adressen anzeigen',
      viewOnGeoPortal: 'Im Geoportal anzeigen',
      yes: 'Ja',
    },
    restrictions: {
      activeRestrictions: {
        one: '{{count}} aktive Einschränkung',
        other: '{{count}} aktive Einschränkungen',
      },
      affected: 'Betroffen',
      affectedTypes: 'Betroffene Typen',
      noActiveRestrictions: 'Keine aktiven Einschränkungen',
      notAffected: 'Nicht betroffen',
      notAvailable: 'Nicht verfügbar',
      title: 'Einschränkungen (ÖREB)',
      typesChecked: '{{total}} Typen geprüft, {{affected}} betroffen',
      viewDetailedRestrictions: 'Detaillierte Einschränkungen anzeigen',
    },
    scoreOverview: {
      developmentScore: 'Entwicklungswert',
      legacyScore: 'Bestandswert',
      livabilityScore: 'Wohnqualitätswert',
      underExploitedScore: 'Unternutzungswert',
    },
    sidebar: {
      items: {
        amenities: 'Einrichtungen',
        buildingDetails: 'Gebäudedetails',
        buildingPermits: 'Baugenehmigungen',
        demographics: 'Demografie',
        electricity: 'Elektrizität',
        employment: 'Beschäftigung',
        feasibilityStudy: 'Machbarkeitsstudie',
        geoAnalysis: 'Geo-Analyse',
        history: 'Geschichte',
        noiseAnalysis: 'Lärmanalyse',
        purchaseListings: 'Kaufinserate',
        purchaseMarket: 'Kaufmarkt',
        rentalListings: 'Mietinserate',
        rentalMarket: 'Mietmarkt',
        restrictions: 'Einschränkungen',
        summary: 'Zusammenfassung',
        sunlightStudy: 'Sonnenlichtanalyse',
        taxes: 'Steuern',
        transactions: 'Transaktionen',
        transportAccess: 'Verkehr & Erreichbarkeit',
        zoning: 'Zonierung',
        zoningRules: 'Zonenvorschriften',
      },
      sections: {
        development: 'Entwicklung',
        environment: 'Umgebung',
        market: 'Markt',
        overview: 'Übersicht',
        socialEconomic: 'Soziales & Wirtschaft',
      },
    },
    states: {
      empty: {
        description: 'Keine Grundstücksinformationen für diese Immobilie verfügbar.',
        title: 'Keine Grundstücksdaten',
      },
      error: {
        retry: 'Erneut versuchen',
        title: 'Fehler beim Laden',
      },
      errorLoadingData: 'Fehler beim Laden der Grundstücksdaten',
      loading: 'Grundstücksdaten werden geladen...',
      noDataAvailable: 'Keine Grundstücksdaten verfügbar',
      notAvailable: 'k.A.',
      retry: 'Erneut versuchen',
    },
    summaryTab: {
      loading: 'Daten werden geladen...',
      noData: 'Keine Daten verfügbar',
      subtitle: 'Übersicht und wichtige Informationen für {{address}}',
      title: 'Immobilienübersicht',
      unknownLocation: 'Unbekannter Standort',
    },
    tagsPanel: {
      add: 'Hinzufügen',
      adding: 'Wird hinzugefügt...',
      addNewTag: 'Neues Tag hinzufügen',
      buildingTags: 'Gebäude-Tags',
      closePanel: 'Panel schliessen',
      currentTags: 'Aktuelle Tags ({{count}})',
      emptyStateHint: 'Fügen Sie oben Tags hinzu, um diese Immobilie zu organisieren und zu kategorisieren',
      enterTagName: 'Tag-Name eingeben...',
      groupLandTags: 'Gruppengrundstücks-Tags',
      landTags: 'Grundstücks-Tags',
      loadingTags: 'Tags werden geladen...',
      manageTags: 'Tags verwalten',
      noTagsAssigned: 'Keine Tags zugewiesen',
      title: 'Tags',
    },
    transactionsTab: {
      filters: {
        additionalFilters: 'Zusätzliche Filter',
        advancedFilters: 'Erweiterte Filter',
        allLocations: 'Alle Standorte',
        clearAll: 'Alle löschen',
        hideFilters: 'Filter ausblenden',
        landArea: 'Grundstücksfläche (m²)',
        legalTypeBF: 'B-F',
        legalTypeCOP: 'COP',
        legalTypeDDP: 'DDP',
        legalTypeDP: 'DP',
        legalTypeOther: 'Andere',
        legalTypePPE: 'PPE',
        numberOfBuyers: 'Anzahl der Käufer',
        numberOfSellers: 'Anzahl der Verkäufer',
        others: 'Andere',
        participantAssociation: 'Verein',
        participantCompany: 'Unternehmen',
        participantCooperative: 'Genossenschaft',
        participantFoundation: 'Stiftung',
        participantIndividual: 'Privatperson',
        participantOther: 'Andere',
        participantPublicEntity: 'Öffentliche Einrichtung',
        participants: 'Teilnehmer',
        participantType: 'Teilnehmertyp',
        propertyLegalType: 'Rechtlicher Eigentumstyp',
        radius: 'Radius',
        showFilters: 'Filter anzeigen',
        stepTransactionPrice: 'Schrittweiser Transaktionspreis (CHF)',
        transactionDate: 'Transaktionsdatum',
        transactionType: 'Transaktionstyp',
        typeAreaPrice: 'Typ, Fläche & Preis',
        unitApartment: 'Wohnung',
        unitCommercial: 'Gewerblich',
        unitHouse: 'Haus',
        unitLand: 'Grundstück',
        unitOther: 'Andere',
        unitParking: 'Parkplatz',
        unitType: 'Einheitstyp',
      },
      subtitle: 'Erkunden Sie die Transaktionshistorie rund um das Grundstück und speichern Sie die für diese Analyse interessanten.',
      tabs: {
        aroundPlot: 'Transaktionen rund um das Grundstück',
        saved: 'Gespeicherte Transaktionen',
      },
      title: 'Transaktionen',
    },
    units: {
      percent: '%',
      score: '/100',
      squareMeters: 'm²',
    },
    zoneAssignment: {
      buildable: 'Bebaubar',
      nonBuildable: 'Nicht bebaubar',
      title: 'Zonenzuweisung',
      unknownZone: 'Unbekannte Zone',
    },
    zones: {
      adopted: 'Angenommen',
      buildingArea: 'Baufläche',
      cos: 'Überbauungskoeffizient',
      coverageArea: 'Abdeckung',
      cus: 'Ausnützungskoeffizient',
      defaultName: 'Zone {{number}}',
      ibus: 'GFZ',
      planTypeAdoption: 'Plantyp',
      title: 'Zonenplan',
      zoneName: 'Zonenname',
    },
  },
  listings: {
    aiFilter: {
      description: 'Beschreiben Sie die Immobilie, die Sie suchen, und ich helfe Ihnen dabei, sie zu finden.',
      errors: {
        processingFailed: 'Fehler beim Verarbeiten Ihrer Anfrage',
      },
      examplePrompts: {
        '0': 'Zeigen Sie mir Wohnungen zur Miete in Zürich unter 3000 CHF',
        '1': 'Finden Sie Häuser zum Verkauf in Genf mit 4+ Zimmern',
      },
      placeholder: "z.B. '2-Zimmer-Wohnung zur Miete in Lausanne unter 2500 CHF'",
      processing: 'Verarbeitung...',
      recentSearches: 'Letzte Suchen',
      search: 'Suchen',
      title: 'Inserat-Filter-Assistent',
    },
    common: {
      active: 'Aktiv',
      addressNotAvailable: 'Adresse nicht verfügbar',
      allLocations: 'Alle Standorte',
      built: 'gebaut',
      days: 'Tage',
      distance: 'Entfernung',
      expired: 'Abgelaufen',
      km: 'km',
      m: 'm',
      na: 'K.A.',
      perSqm: '/ m²',
      priceOnRequest: 'Preis auf Anfrage',
      propertyImage: 'Immobilienbild',
      propertyListing: 'Immobilieninserat',
      radius: 'Radius',
      rooms: 'Zimmer',
      sqm: 'm²',
      to: 'bis',
      unknown: 'Unbekannt',
    },
    dates: {
      daysAgo: 'Vor {{count}} Tagen',
      listed: 'Inseriert',
      monthsAgo: 'Vor {{count}} Monaten',
      today: 'Heute',
      weeksAgo: 'Vor {{count}} Wochen',
      yearsAgo: 'Vor {{count}} Jahren',
      yesterday: 'Gestern',
    },
    detail: {
      agents: {
        unknownAgent: 'Unbekannter Makler',
      },
      buttons: {
        addToFavorites: 'Zu Favoriten hinzufügen',
        estimate: 'Schätzen',
        findAddress: 'Adresse finden',
        findExactAddress: 'Genaue Adresse finden',
        goToAnalysis: 'Zur Analyse gehen',
        goToEstimate: 'Zur Schätzung gehen',
        goToExplore: 'Zu Erkunden gehen',
        viewInLandAnalysis: 'In Grundstücksanalyse anzeigen',
        viewOnExplore: 'Auf Erkunden anzeigen',
      },
      error: 'Fehler',
      fallbacks: {
        addressNotSpecified: 'Adresse nicht angegeben',
        day: 'Tag',
        days: 'Tage',
        house: 'Haus',
        immediately: 'Sofort',
        listedOnPlatform: 'Auf dieser Plattform gelistet',
        noAdditionalImages: 'Keine weiteren Bilder verfügbar',
        noDescriptionAvailable: 'Keine Beschreibung verfügbar',
        property: 'Immobilie',
        propertyId: 'Immobilien-ID',
        propertyImage: 'Immobilienbild',
      },
      labels: {
        agency: 'Agentur',
        available: 'Verfügbar',
        bathrooms: 'Badezimmer',
        buildingYear: 'Baujahr',
        category: 'Kategorie',
        constructionYear: 'Baujahr',
        floor: 'Stockwerk',
        id: 'ID',
        landSurface: 'Grundstücksfläche',
        listedOn: 'Gelistet auf',
        mandateType: 'Mandatstyp',
        newConstruction: 'Neubau',
        onlineFor: 'Online seit',
        published: 'Veröffentlicht',
        status: 'Status',
        type: 'Typ',
      },
      loading: 'Details werden geladen...',
      metrics: {
        bathrooms: 'Badezimmer',
        buildYear: 'Baujahr',
        landArea: 'Grundstücksfläche',
        livingArea: 'Wohnfläche',
        price: 'Preis',
        rooms: 'Zimmer',
      },
      sections: {
        description: 'Beschreibung',
        features: 'Merkmale & Ausstattung',
        listedOnPortals: 'Auf Portalen gelistet',
        listingInformation: 'Inserat-Informationen',
        propertyAgents: 'Immobilienmakler',
        propertyDetails: 'Immobiliendetails',
        propertyGallery: 'Immobiliengalerie',
      },
      status: {
        active: 'Aktiv',
        expired: 'Abgelaufen',
      },
      vendorTypes: {
        private: 'Privat',
        professional: 'Professionell',
        unknown: 'Unbekannt',
      },
    },
    detailPanel: {
      columns: {
        change: 'Änderung',
        date: 'Datum',
        price: 'Preis',
        pricePerSqm: 'Preis/m²',
      },
      empty: {
        noDescription: 'Keine Beschreibung verfügbar',
        noFeatures: 'Keine Ausstattung aufgeführt',
        noPriceHistory: 'Kein Preisverlauf verfügbar',
      },
      labels: {
        address: 'Adresse',
        availability: 'Verfügbarkeit',
        daysOnMarket: 'Tage auf dem Markt',
        description: 'Beschreibung',
        features: 'Ausstattung',
        floor: 'Stockwerk',
        listingDate: 'Inserierungsdatum',
        livingArea: 'Wohnfläche',
        price: 'Preis',
        pricePerSqm: 'Preis pro m²',
        propertyDetails: 'Immobiliendetails',
        propertyListing: 'Immobilieninserat',
        propertyType: 'Immobilientyp',
        rooms: 'Zimmer',
        status: 'Status',
        usableArea: 'Nutzfläche',
        viewOriginal: 'Originalinserat ansehen',
        yearBuilt: 'Baujahr',
      },
      tabs: {
        details: 'Details',
        location: 'Standort',
        overview: 'Übersicht',
        priceHistory: 'Preisverlauf',
      },
    },
    distanceOptions: {
      '1km': '1km',
      '2km': '2km',
      '500m': '500m',
      '5km': '5km',
    },
    filter: {
      activeFilter: 'aktiver Filter',
      activeFilters: 'aktive Filter',
      additionalFilters: 'Zusätzliche Filter',
      advancedFilters: 'Erweiterte Filter',
      allLocations: 'Alle Standorte',
      clearAll: 'Alle löschen',
      customPriceRange: 'Benutzerdefinierte Preisspanne (CHF)',
      floorLevel: 'Stockwerk',
      from: 'Von',
      hideFilters: 'Filter ausblenden',
      listingDate: 'Veröffentlichungsdatum',
      livingArea: 'Wohnfläche (m²)',
      max: 'Max',
      min: 'Min',
      priceSizeRooms: 'Preis, Grösse & Zimmer',
      propertyType: 'Immobilientyp',
      propertyTypes: {
        apartment: 'Wohnung',
        commercial: 'Gewerbe',
        garageParking: 'Garage/Parkplatz',
        house: 'Haus',
        other: 'Sonstiges',
        plot: 'Grundstück',
        residential: 'Wohnimmobilien',
      },
      radius: 'Radius',
      rooms: 'Zimmer',
      roomsLabel: 'Zimmer',
      showFilters: 'Filter anzeigen',
      to: 'Bis',
      yearBuilt: 'Baujahr',
    },
    filters: {
      actions: {
        activeFilters: 'Aktive Filter',
        apply: 'Anwenden',
        clearAll: 'Alle löschen',
        clearAllFilters: 'Alle Filter löschen',
        closeFilters: 'Filter schliessen',
        lessFilters: 'Weniger Filter',
        loadSavedFilters: 'Gespeicherte Filter laden',
        moreFilters: 'Mehr Filter',
        openFilters: 'Filter öffnen',
        saveCurrentFilters: 'Aktuelle Filter speichern',
      },
      ai: {
        textSearchError: 'Ihre Anfrage konnte nicht verarbeitet werden. Bitte versuchen Sie es erneut.',
        voiceSearchError: 'Ihre Sprachanfrage konnte nicht verarbeitet werden. Bitte versuchen Sie es erneut.',
      },
      fields: {
        area: 'Fläche',
        floor: 'Stockwerk',
        from: 'Von',
        listingDate: 'Anzeigendatum',
        listingDuration: 'Anzeigendauer',
        mandateType: 'Mandatstyp',
        max: 'Max',
        min: 'Min',
        price: 'Preis',
        pricePerSqm: 'Preis pro m²',
        status: 'Status',
        to: 'Bis',
        typeOfProperty: 'Objekttyp',
        vendorType: 'Verkäufertyp',
        yearOfConstruction: 'Baujahr',
      },
      loading: 'Filter werden geladen...',
      mandateTypes: {
        exclusive: 'Exklusiv',
        simple: 'Einfach',
        unknown: 'Unbekannt',
      },
      placeholders: {
        enterValue: 'Wert eingeben',
        from: 'Von',
        max: 'Max',
        min: 'Min',
        searchLocation: 'Standort suchen...',
        selectOption: 'Option auswählen',
        to: 'Bis',
      },
      propertyTypes: {
        apartment: 'Wohnung',
        commercial: 'Gewerbe',
        garageParking: 'Garage/Parkplatz',
        house: 'Haus',
        other: 'Sonstiges',
        plot: 'Grundstück',
      },
      quickFilters: {
        listed: 'Gelistet',
        propertyCategory: 'Immobilienkategorie',
      },
      saved: {
        appliedFilter: 'Filter angewendet: {{name}}',
        failedToSave: 'Filter konnte nicht gespeichert werden',
        savedFilter: 'Filter gespeichert: {{name}}',
        savedOn: 'Gespeichert am {{date}}',
      },
      sections: {
        brokerInfo: 'Makler-Info',
        buildingYear: 'Baujahr',
        dateRange: 'Zeitraum',
        floor: 'Stockwerk',
        landArea: 'Grundstücksfläche',
        livingArea: 'Wohnfläche',
        location: 'Standort',
        locationDate: 'Standort & Datum',
        mandateType: 'Mandatstyp',
        portals: 'Portale',
        price: 'Preis',
        priceRange: 'Preisbereich',
        propertyCharacteristics: 'Objekteigenschaften',
        propertyType: 'Immobilientyp',
        rooms: 'Zimmer',
        status: 'Status',
        vendorType: 'Verkäufertyp',
      },
      title: 'Inseratfilter',
      validation: {
        invalidRange: 'Ungültiger Bereich',
        requiredField: 'Pflichtfeld',
      },
      vendorTypes: {
        private: 'Privat',
        professional: 'Professionell',
        unknown: 'Unbekannt',
      },
    },
    list: {
      columns: {
        area: 'Fläche',
        date: 'Datum',
        duration: 'Dauer',
        image: 'Bild',
        location: 'Standort',
        mandateType: 'Mandatstyp',
        portals: 'Portale',
        price: 'Preis',
        property: 'Immobilie',
        rooms: 'Zimmer',
        status: 'Status',
        vendor: 'Verkäufer',
        year: 'Jahr',
      },
      duration: {
        day: 'Tag',
        days: 'Tage',
      },
      export: {
        filename: 'inserate_export',
        toExcel: 'Als Excel exportieren',
        toPdf: 'Als PDF exportieren',
      },
      fallbacks: {
        dash: '—',
        noData: 'Keine Daten',
        noImage: 'Kein Bild',
        unknown: 'Unbekannt',
      },
      mandate: {
        exclusive: 'Exklusiv',
        shared: 'Geteilt',
        unknown: 'Unbekannt',
      },
      status: {
        active: 'Aktiv',
        expired: 'Abgelaufen',
      },
      vendor: {
        individual: 'Privat',
        pro: 'Professionell',
        unknown: 'Unbekannt',
      },
    },
    map: {
      errorLoadingMapData: 'Fehler beim Laden der Kartendaten',
      loading: 'Wird geladen...',
      loadingMapData: 'Kartendaten werden geladen...',
      tooltip: {
        area: 'Fläche',
        forRent: 'Zu vermieten',
        forSale: 'Zu verkaufen',
        listingAlt: 'Inserat',
        location: 'Standort',
        noImageAvailable: 'Kein Bild verfügbar',
        priceOnRequest: 'Preis auf Anfrage',
        propertyId: 'Immobilien-ID',
        rooms: 'Zimmer',
      },
    },
    priceRanges: {
      '1MTo2M': '1M - 2M',
      '500kTo1M': '500k - 1M',
      over2M: '> 2M',
      under500k: '< 500k',
    },
    print: {
      about: {
        realTimeData: 'Dieser Bericht bietet Echtzeit-Marktanalysen basierend auf Inseraten, die von grossen Schweizer Immobilienportalen aggregiert werden.',
      },
      contact: {
        email: 'E-Mail',
        forQuestions: 'Bei Fragen zu diesem Bericht kontaktieren Sie bitte:',
        popetyContact: 'Popety.io | info@popety.io | www.popety.io',
        title: 'Kontaktinformationen',
        website: 'Webseite',
        yourContact: 'Ihr Kontakt',
      },
      cover: {
        aboutThisReport: 'Über diesen Bericht',
        analyticsFooter: 'Immobilienmarkt-Analyseplattform',
        appliedFilters: 'Angewendete Filter',
        createdOnPopety: 'Erstellt auf Popety.io - Immobilienmarkt-Analyseplattform',
        dealType: 'Transaktionstyp',
        generated: 'Erstellt',
        generatedOn: 'Erstellt am',
        listingDate: 'Inseratdatum',
        listingsList: 'Inserateliste',
        listingsSelectedOn: 'Inserate ausgewählt am',
        location: 'Standort',
        priceRange: 'Preisbereich',
        propertyType: 'Immobilientyp',
        realEstateMarketReport: 'Immobilienmarktbericht',
        rentalListingsReport: 'Statistischer Bericht über Mietinserate',
        rentals: 'Vermietungen',
        sales: 'Verkäufe',
        salesListingsReport: 'Statistischer Bericht über Verkaufsinserate',
        switzerland: 'Schweiz',
        timePeriod: 'Zeitraum',
      },
      dataSource: {
        collectionPeriod: 'Datenerfassungszeitraum: Kontinuierlich, mit regelmässigen Aktualisierungen',
        description: 'Dieser Bericht aggregiert Daten aus den folgenden Quellen:',
        includesOutlierFiltering: 'Datenquellen: Offizielle Immobilienanzeigen und Markttransaktionen. Die Analyse beinhaltet Ausreisserfilterung für Genauigkeit.',
        lastRefresh: 'Letzte Datenaktualisierung: Echtzeit zum Zeitpunkt der Berichterstellung',
        popetyAnalytics: 'Proprietäre Analyseplattform von Popety.io',
        publicListings: 'Öffentliche Immobilienanzeigen und Marktdaten',
        statisticalAnalysis: 'Statistische Analyse durch Popety.io-Algorithmen',
        swissPortals: 'Grosse Schweizer Immobilienportale einschliesslich Homegate, ImmoScout24 und andere',
        title: 'Datenquellen',
      },
      details: {
        built: 'Gebaut',
        listingOf: 'Inserat {{current}} von {{total}}',
        noImageAvailable: 'Kein Bild verfügbar',
        propertyListing: 'Immobilieninserat',
        unknownAddress: 'Unbekannte Adresse',
      },
      disclaimer: {
        accuracyOfInformation: {
          content: 'Die in diesem Bericht enthaltenen Informationen dienen nur allgemeinen Informationszwecken. Obwohl wir uns bemühen, die Informationen aktuell und korrekt zu halten, geben wir keine ausdrücklichen oder stillschweigenden Zusicherungen oder Gewährleistungen hinsichtlich der Vollständigkeit, Genauigkeit, Zuverlässigkeit, Eignung oder Verfügbarkeit des Berichts oder der darin enthaltenen Informationen, Produkte, Dienstleistungen oder zugehörigen Grafiken für irgendeinen Zweck.',
          title: 'Genauigkeit der Informationen',
        },
        copyrightNotice: {
          content: '© {{year}} Popety.io. Alle Rechte vorbehalten. Dieser Bericht und sein Inhalt sind urheberrechtlich und durch andere geistige Eigentumsrechte geschützt. Die unbefugte Vervielfältigung, Verbreitung oder Nutzung dieses Berichts ist strengstens untersagt.',
          title: 'Urheberrechtshinweis',
        },
        dataPrivacy: {
          content: 'Wir respektieren Ihre Privatsphäre und verpflichten uns zum Schutz Ihrer personenbezogenen Daten. Dieser Bericht kann aggregierte und anonymisierte Marktdaten enthalten, die aus öffentlich zugänglichen Quellen gesammelt wurden.',
          title: 'Datenschutz',
        },
        noInvestmentAdvice: {
          content: 'Dieser Bericht stellt keine Anlage-, Rechts-, Steuer- oder sonstige professionelle Beratung dar. Sie sollten sich nicht allein auf diesen Bericht als Grundlage für Anlageentscheidungen verlassen. Holen Sie immer den Rat qualifizierter Fachleute ein, bevor Sie Anlageentscheidungen treffen.',
          title: 'Keine Anlageberatung',
        },
        title: 'Haftungsausschluss und rechtliche Hinweise',
      },
      format: {
        details: 'Details',
        fullPage: 'Eine Seite pro Inserat',
        summary: 'Zusammenfassung',
        tableView: 'Tabellenansicht, mehrere pro Seite',
      },
      modal: {
        cancel: 'Abbrechen',
        close: 'Schliessen',
        downloadPdf: 'PDF herunterladen',
        exportListingsToPdf: 'Inserate als PDF exportieren',
        failedToGeneratePdf: 'PDF-Erstellung fehlgeschlagen. Bitte versuchen Sie es erneut.',
        fullMarketReport: 'Vollständiger Marktbericht',
        generatePdf: 'PDF erstellen',
        generatingPdf: 'PDF wird erstellt...',
        listing: 'Inserat',
        listings: 'Inserate',
        pageOf: 'Seite {{current}} von {{total}}',
        pagesTotal: 'Seiten insgesamt',
        preview: 'Vorschau',
        previewAndDownload: 'Vorschau und Download eines umfassenden Marktberichts mit allen Abschnitten',
        priceEvolution: 'Preisentwicklung',
        rentEvolution: 'Mietentwicklung',
        resetZoom: 'Zoom zurücksetzen',
        zoomIn: 'Vergrössern',
        zoomOut: 'Verkleinern',
      },
      progress: {
        addingContent: 'Inhalte werden hinzugefügt',
        addingPageNumbers: 'Seitenzahlen und letzte Details werden hinzugefügt',
        addingTitleAndBranding: 'Titel, Firmeninfos und Branding werden hinzugefügt',
        convertingCharts: 'Diagramme werden in hochwertige Bilder konvertiert',
        creatingCoverPage: 'Titelseite wird erstellt',
        exportingCharts: 'Diagramme werden exportiert',
        finalizingPdf: 'PDF wird fertiggestellt',
        generatingPdfReport: 'PDF-Bericht wird erstellt',
        generatingSections: 'Abschnitte, Erkenntnisse und Daten werden erstellt',
        initializingPdf: 'PDF wird initialisiert',
        pleaseWait: 'Bitte warten Sie, während wir Ihre umfassende Marktanalyse erstellen',
        settingUpDocument: 'Dokumentstruktur und -stile werden eingerichtet',
      },
      sections: {
        tableOfContents: 'Inhaltsverzeichnis',
      },
      summary: {
        area: '{{value}} m²',
        builtYear: 'Baujahr {{year}}',
        id: 'ID',
        pageOfListings: 'Seite {{page}} von {{total}} • Inserate {{start}}-{{end}}',
        rooms: '{{count}} Zimmer',
        type: 'Typ',
      },
    },
    propertyTypes: {
      apartment: 'Wohnung',
      commercial: 'Gewerbe',
      house: 'Haus',
      parking: 'Parkplatz',
      plot: 'Grundstück',
    },
    roomOptions: {
      '1room': '1 Zimmer',
      '2rooms': '2 Zimmer',
      '3rooms': '3 Zimmer',
      '4rooms': '4 Zimmer',
      '5plusRooms': '5+ Zimmer',
    },
    saved: {
      addressNotAvailable: 'Adresse nicht verfügbar',
      allSaved: 'Alle gespeichert',
      averagePrice: 'Durchschnittspreis',
      avgLivingArea: 'Durchschnittliche Wohnfläche',
      avgPricePerSqm: 'Durchschnittspreis/m²',
      avgRooms: 'Durchschn. Zimmer',
      empty: 'Noch keine gespeicherten Inserate',
      emptyDescription: 'Speichern Sie Inserate aus dem Tab "Inserate um das Grundstück", um sie später zu vergleichen',
      emptyTitle: 'Noch keine gespeicherten Inserate',
      listings: 'Inserate',
      livingArea: 'Wohnfläche',
      loading: 'Gespeicherte Inserate werden geladen...',
      perListing: 'Pro Inserat',
      perListing2: 'Pro Inserat',
      perSqm: '/m²',
      priceOnRequest: 'Preis auf Anfrage',
      priceRangeLabel: 'Preisspanne',
      propertyImage: 'Immobilienbild',
      propertyListing: 'Immobilieninserat',
      removeFromSaved: 'Aus Gespeicherten entfernen',
      saveListing: 'Inserat speichern',
      sqm: 'm²',
      to: 'bis',
      totalSaved: 'Gesamt gespeichert',
      totalValue: 'Gesamtwert',
    },
    sections: {
      purchaseSubtitleBuilding: 'Kaufinserate in der Nähe dieses Gebäudes anzeigen',
      purchaseSubtitleLand: 'Kaufinserate in der Nähe dieses Grundstücks anzeigen',
      purchaseTitle: 'Kaufinserate',
      rentSubtitleBuilding: 'Mietinserate in der Nähe dieses Gebäudes anzeigen',
      rentSubtitleLand: 'Mietinserate in der Nähe dieses Grundstücks anzeigen',
      rentTitle: 'Mietinserate',
    },
    stats: {
      actions: {
        showLess: 'Weniger anzeigen',
        showMore: 'Mehr anzeigen',
      },
      charts: {
        byPropertyType: 'nach Immobilientyp',
        distributionByQuantiles: 'Verteilung nach Quantilen',
        distributionByRooms: 'Verteilung nach Zimmern',
        geographicVolumeDistribution: 'Geografische Volumenverteilung',
        portalMarketShareEvolution: 'Entwicklung der Marktanteile nach Portal',
        pricePerSquareMeter: 'Preis pro Quadratmeter',
        rankingsByPrice: 'Rangliste nach Preis',
        rankingsByRent: 'Rangliste nach Miete',
        rentPerSquareMeter: 'Miete pro Quadratmeter',
      },
      dataSource: {
        description: 'Daten aggregiert von grossen Schweizer Immobilienportalen',
        disclaimer: 'Haftungsausschluss',
        title: 'Datenquellen',
      },
      defaults: {
        allProperties: 'Alle Immobilien',
        allSwitzerland: 'Gesamte Schweiz',
      },
      descriptions: {
        agencyAnalysis: 'Bewerten Sie die Leistung und den Marktanteil verschiedener Immobilienagenturen, um Marktführer zu identifizieren.',
        agencyAnalysisRental: 'Bewerten Sie die Leistung und den Marktanteil verschiedener Vermietungsagenturen.',
        cityAnalysis: 'Analyse von Preisdichtemustern in Grossstädten, um Marktvariationen zu verstehen und Chancen zu identifizieren.',
        cityAnalysisRental: 'Analyse von Mietdichtemustern in Grossstädten, um Mietmarktvariationen zu verstehen.',
        newVsResale: 'Vergleichen Sie Preistrends und Marktdynamik zwischen neu gebauten Immobilien und Wiederverkaufsimmobilien.',
        newVsResaleRental: 'Vergleichen Sie Mietpreise zwischen neu gebauten Immobilien und älteren Immobilien.',
        portalAnalysis: 'Bewerten Sie die Effektivität und Reichweite verschiedener Immobilienportale für die Immobilienvermarktung.',
        portalAnalysisRental: 'Bewerten Sie die Effektivität verschiedener Mietportale für die Immobilienvermarktung.',
        priceEvolution: 'Verfolgen Sie die Entwicklung der Immobilienpreise im Zeitverlauf, um Markttrends und Muster im Immobilienmarkt zu identifizieren.',
        priceGeography: 'Visualisieren Sie Immobilienpreise in verschiedenen geografischen Gebieten, um hochwertige und erschwingliche Regionen zu identifizieren.',
        priceM2Evolution: 'Analysieren Sie die Entwicklung der Immobilienpreise pro Quadratmeter, um Werttrends über verschiedene Immobiliengrössen zu verstehen.',
        priceM2PerRoom: 'Untersuchen Sie, wie der Preis pro Quadratmeter mit der Zimmerzahl variiert, um die effizientesten Immobilienkonfigurationen zu identifizieren.',
        pricePerRoom: 'Analysieren Sie, wie Immobilienpreise je nach Anzahl der Zimmer variieren, um Preismuster nach Immobiliengrösse zu verstehen.',
        rentEvolution: 'Beobachten Sie Mietpreistrends im Zeitverlauf, um die Dynamik des Mietmarkts zu verstehen.',
        rentGeography: 'Visualisieren Sie Mietpreise in verschiedenen Gebieten, um Premium- und erschwingliche Mietstandorte zu identifizieren.',
        rentM2Evolution: 'Verfolgen Sie Mietpreise pro Quadratmeter, um Werttrends im Mietmarkt zu analysieren.',
        rentM2PerRoom: 'Untersuchen Sie, wie die Miete pro Quadratmeter mit der Zimmerzahl variiert, um die effizientesten Mietkonfigurationen zu identifizieren.',
      },
      footer: {
        dataSources: 'Homegate, ImmoScout24, Newhome, Acheter-Louer',
        dataSourcesLabel: 'Datenquellen:',
        description: 'Dieser statistische Bericht wird auf Basis von Echtzeitdaten erstellt, die von Schweizer Immobilienportalen gesammelt werden. Die Daten werden kontinuierlich aktualisiert und analysiert, um genaue Markteinblicke zu liefern.',
        title: 'Über diesen Bericht',
      },
      interface: {
        chartPlaceholder: 'Platzhalter für Diagramm',
        downloadFullReport: 'Vollständigen Bericht herunterladen',
        hideSection: 'Abschnitt ausblenden',
        showSection: 'Abschnitt anzeigen',
        sources: 'Quellen:',
        sourcesList: 'Schweizer Immobilienportale • Popety.io',
      },
      kpi: {
        keyInsights: 'Wichtige Erkenntnisse',
        keyMetrics: 'Wichtige Kennzahlen',
        oneYearGrowth: '1-Jahres-Wachstum',
      },
      periods: {
        allAvailable: 'Alle verfügbaren Daten',
        fullHistory: 'Vollständiger Verlauf',
        last12Months: 'Letzte 12 Monate',
        since2022: 'Seit 2022',
        sinceJanuary2022: 'Seit Januar 2022',
      },
      sections: {
        agencyAnalysis: 'Agenturanalyse',
        cityAnalysis: 'Städteanalyse',
        marketShare: 'Marktanteil',
        newVsResale: 'Neubau vs Wiederverkauf',
        portalAnalysis: 'Portalanalyse',
        priceDistribution: 'Preisverteilung',
        priceEvolution: 'Preisentwicklung',
        priceGeography: 'Preisgeografie',
        priceM2Evolution: 'Preis/m² Entwicklung',
        priceM2PerRoom: 'Preis/m² pro Zimmer',
        pricePerRoom: 'Preis pro Zimmer',
        rentDistribution: 'Mietverteilung',
        rentEvolution: 'Mietentwicklung',
        rentGeography: 'Mietgeografie',
        rentM2Evolution: 'Miete/m² Entwicklung',
        rentM2PerRoom: 'Miete/m² pro Zimmer',
      },
      table: {
        city: 'Stadt',
        listings: 'Inserate',
        medianChfM2: 'Median CHF/m²',
        percentile25: '25. Perzentil',
        percentile75: '75. Perzentil',
        stdDeviation: 'Standardabweichung',
      },
    },
    statusOptions: {
      all: 'Alle',
    },
    tabs: {
      aroundPlot: 'Inserate um das Grundstück',
      saved: 'Gespeicherte Inserate',
    },
    views: {
      list: 'Liste',
      map: 'Karte',
      stats: 'Statistiken',
    },
  },
  market: {
    common: {
      currency: {
        chf: 'CHF',
        chfPerM2: 'CHF/m²',
      },
      errors: {
        loadingData: 'Fehler beim Laden der Daten. Bitte versuchen Sie es später erneut.',
      },
      filters: {
        advancedFilters: 'Erweiterte Filter',
        city: 'Gemeinde',
        district: 'Bezirk',
        hideFilters: 'Filter ausblenden',
        location: 'Standort',
        postalCode: 'Postleitzahl',
        propertyType: 'Immobilientyp',
      },
      month: 'Monat',
      na: 'k.A.',
      placeholder: {
        chartPlaceholder: 'Diagrammplatzhalter für {{section}}',
      },
      propertyTypes: {
        apartment: 'Wohnung',
        commercial: 'Gewerbe',
        house: 'Haus',
        houseApartment: 'Haus & Whg',
        plot: 'Grundstück',
      },
      year: 'Jahr',
    },
    distribution: {
      charts: {
        area: 'Flächenverteilung',
        constructionYear: 'Baujahr',
        price: 'Preisverteilung',
        priceM2: 'Preis/m² Verteilung',
        rent: 'Mietverteilung',
        rentM2: 'Miete/m² Verteilung',
        rooms: 'Zimmerverteilung',
        timeOnMarket: 'Vermarktungsdauer',
      },
      empty: {
        description: 'Für die aktuelle Auswahl sind keine Verteilungsdaten verfügbar.',
        title: 'Keine Daten verfügbar',
      },
      insights: {
        areaRange: 'Flächenübersicht',
        areaRangeDesc: 'Die Durchschnittsfläche beträgt {{avg}} m² mit einem Median von {{median}} m².',
        mostCommonRooms: 'Häufigste Konfiguration',
        mostCommonRoomsDesc: 'Immobilien mit {{rooms}} Zimmern machen {{percentage}}% der Inserate in dieser Gegend aus.',
        priceRange: 'Preisübersicht',
        priceRangeDesc: 'Der Durchschnittspreis beträgt {{avg}} CHF mit einem Median von {{median}} CHF.',
        rentRange: 'Mietübersicht',
      },
      kpis: {
        medianArea: 'Median Fläche',
        medianPrice: 'Median Preis',
        medianRent: 'Median Miete',
        medianRooms: 'Zimmer Median',
        totalListings: 'Inserate gesamt',
      },
      states: {
        loading: 'Verteilungsdaten werden geladen...',
      },
      stats: {
        avg: 'Durchschn',
        median: 'Median',
        total: 'Gesamt',
      },
      units: {
        days: 'Tage',
        rooms: 'Zimmer',
        year: 'Jahr',
      },
    },
    distributionView: {
      combined: 'Zusammen',
      listings: 'Inserate',
      perMonth: '/Monat',
      perYear: '/Jahr',
      separate: 'Nach Objekttyp',
    },
    purchase: {
      header: {
        subtitle: 'Analysieren Sie Markttrends und Muster für Immobilienkäufe im ausgewählten Gebiet',
        title: 'Kaufmarktanalyse',
      },
      sections: {
        distribution: {
          description: 'Erkunden Sie die Marktzusammensetzung nach Zimmern, Preisklassen, Flächen, Baujahren und Vermarktungsdauer, um die lokalen Marktmerkmale zu verstehen.',
          title: 'Marktverteilung',
        },
        newVsResale: {
          description: 'Vergleichen Sie Preistrends und Marktdynamik zwischen Neubauten und Wiederverkaufsimmobilien.',
          title: 'Neubau vs Wiederverkauf',
        },
        priceEvolution: {
          description: 'Verfolgen Sie die Entwicklung der Immobilienpreise im Laufe der Zeit, um Markttrends und Muster auf dem Immobilienmarkt zu identifizieren.',
          title: 'Preisentwicklung',
        },
        priceM2Evolution: {
          description: 'Analysieren Sie die Entwicklung der Immobilienpreise pro Quadratmeter, um Werttrends bei verschiedenen Immobiliengrössen zu verstehen.',
          title: 'Preis/m² Entwicklung',
        },
        priceM2PerRoom: {
          description: 'Untersuchen Sie, wie der Preis pro Quadratmeter mit der Zimmeranzahl variiert, um die effizientesten Immobilienkonfigurationen zu identifizieren.',
          title: 'Preis/m² pro Zimmer',
        },
        pricePerRoom: {
          description: 'Analysieren Sie, wie sich die Immobilienpreise je nach Anzahl der Zimmer unterscheiden, um Preismuster nach Immobiliengrösse zu verstehen.',
          title: 'Preis pro Zimmer',
        },
      },
    },
    readOnly: {
      purchaseDescription: 'Die Kaufmarktanalyse mit Preisentwicklung, Immobilienvergleichen und Markttrends ist in der vollständigen Anwendung verfügbar. Diese öffentliche Ansicht zeigt eine Zusammenfassung der Immobilienbewertung.',
      rentalDescription: 'Die Mietmarktanalyse mit Preisentwicklung, Immobilienvergleichen und Markttrends ist in der vollständigen Anwendung verfügbar. Diese öffentliche Ansicht zeigt eine Zusammenfassung der Immobilienbewertung.',
      title: 'Marktanalyse',
    },
    rental: {
      header: {
        subtitle: 'Analysieren Sie Mietmarkttrends und Muster für Immobilien im ausgewählten Gebiet',
        title: 'Mietmarktanalyse',
      },
      sections: {
        availability: {
          description: 'Überwachen Sie die Verfügbarkeit auf dem Mietmarkt, Leerstandsquoten und Fluktuationsmuster, um die Angebots- und Nachfragedynamik zu verstehen.',
          title: 'Mietverfügbarkeit & Fluktuation',
        },
        distribution: {
          description: 'Erkunden Sie die Mietmarktzusammensetzung nach Zimmern, Mietklassen, Flächen, Baujahren und Vermarktungsdauer, um die lokalen Marktmerkmale zu verstehen.',
          title: 'Marktverteilung',
        },
        priceEvolution: {
          description: 'Verfolgen Sie die Entwicklung der Mietpreise im Laufe der Zeit, um Markttrends und Muster auf dem Mietmarkt zu identifizieren.',
          title: 'Mietpreisentwicklung',
        },
        priceM2Evolution: {
          description: 'Analysieren Sie die Entwicklung der Mietpreise pro Quadratmeter, um Werttrends bei verschiedenen Immobiliengrössen zu verstehen.',
          title: 'Mietpreis/m² Entwicklung',
        },
        priceM2PerRoom: {
          description: 'Untersuchen Sie, wie der Mietpreis pro Quadratmeter mit der Zimmeranzahl variiert, um die effizientesten Mietkonfigurationen zu identifizieren.',
          title: 'Mietpreis/m² pro Zimmer',
        },
        pricePerRoom: {
          description: 'Analysieren Sie, wie sich die Mietpreise je nach Anzahl der Zimmer unterscheiden, um Preismuster nach Immobiliengrösse zu verstehen.',
          title: 'Mietpreis pro Zimmer',
        },
      },
      summary: {
        marketVolume: {
          subtitle: 'Aktive Inserate (12 Monate)',
          title: 'Marktvolumen',
        },
        medianRent: {
          subtitle: 'Pro {{period}}',
          title: 'Medianmiete',
        },
        medianRentM2: {
          subtitle: 'Pro {{period}}',
          title: 'Medianmiete/m²',
        },
      },
    },
    shared: {
      average: 'Durchschnitt',
      avgPrice: 'Durchschn. Preis',
      keyInsights: 'Wichtige Erkenntnisse',
      listings: 'Inserate',
      marketShare: 'Marktanteil',
      median: 'Median',
      noData: 'Keine Daten verfügbar',
      totalListings: 'Inserate gesamt',
    },
    summary: {
      marketVolume: {
        subtitle: 'Aktive Inserate (12 Monate)',
        title: 'Marktvolumen',
      },
      medianPrice: {
        subtitle: 'Alle Immobilientypen',
        title: 'Medianpreis',
      },
      medianPriceM2: {
        subtitle: 'Alle Immobilientypen',
        title: 'Medianpreis/m²',
      },
    },
  },
  noise: {
    dataSources: {
      federal: 'Bundesamt für Umwelt',
      geneva: 'Staat Genf - DALE',
      sitg: 'SITG',
    },
    descriptions: {
      day: 'Maximaler Lärmpegel während des Tages',
      night: 'Maximaler Lärmpegel in der Nacht',
    },
    periods: {
      day: 'TAG',
      night: 'NACHT',
    },
    scale: {
      examples: {
        breathing: 'Atmung, raschelnde Blätter',
        conversation: 'Normale Unterhaltung',
        lawnmower: 'Rasenmäher, Krankenwagen',
        sleepInterference: 'Schlafstörungen beginnen',
        traffic: 'Staubsauger, Stadtverkehr',
        whispering: 'Flüstern, Kühlschrank',
      },
      indicators: {
        day: 'Tag: {{value}} dB',
        night: 'Nacht: {{value}} dB',
      },
      levels: {
        harmful: 'Schädlich',
        loud: 'Laut',
        moderate: 'Mässig',
        quiet: 'Ruhig',
        silent: 'Still',
        veryLoud: 'Sehr laut',
      },
      ranges: {
        '0-20': '0-20 dB',
        '30-40': '30-40 dB',
        '40+': '40+ dB',
        '50-60': '50-60 dB',
        '70-80': '70-80 dB',
        '90-100': '90-100 dB',
      },
      title: 'Dezibel-Skala Referenz',
    },
    sources: {
      railway: 'Eisenbahn',
      roadTraffic: 'Strassenverkehr',
    },
    states: {
      error: 'Fehler beim Laden der Lärmdaten',
      errorDescription: 'Lärmanalysedaten konnten nicht geladen werden. Bitte versuchen Sie es später erneut.',
      loading: 'Lärmdaten werden geladen...',
      noData: 'Keine Lärmdaten verfügbar',
      noDataDescription: 'Lärmanalysedaten sind für diesen Standort nicht verfügbar.',
    },
    subtitle: 'Geschätzte Lärm- und Belästigungswerte an dieser Adresse',
    title: 'Lärmanalyse',
    unit: 'dB',
  },
  property: {
    analysis_types: {
      building_analysis: {
        description: 'Umfassende Gebäudeanalyse einschliesslich Einheiten, Marktdaten, Ausstattung und Umweltfaktoren.',
        title: 'Gebäudeanalyse',
      },
      land_analysis: {
        description: 'Detaillierte Landanalyse mit Bebauungsregeln, Entwicklungspotential und Markteinblicken.',
        title: 'Landanalyse',
      },
      property_estimate: {
        description: 'Immobilienbewertung und Marktschätzung mit Vergleichsanalyse.',
        title: 'Immobilienschätzung',
      },
    },
    available_analysis: 'Verfügbare Analyse',
    available_sections: 'Verfügbare Abschnitte:',
    loading: 'Immobiliendaten werden geladen...',
    loading_failed: 'Fehler beim Laden der Immobiliendaten',
    title: 'Immobilienübersicht',
    view_analysis: 'Analyse ansehen',
  },
  restrictions: {
    affected: 'Betroffen',
    affectedTypes: 'Betroffene Typen',
    categories: {
      affecting: 'Einschränkungen, die das Grundstück betreffen',
      notAffecting: 'Einschränkungen ohne Auswirkung auf das Grundstück',
    },
    error: 'Fehler beim Laden der regionalen Einschränkungen',
    heritage: {
      buildingUnderProtection: 'Gebäude unter Denkmalschutz',
      heritageProtection: 'Denkmalschutz',
      protectedBuilding: 'Geschütztes Gebäude',
      protectedObjects: 'Geschützte Objekte',
    },
    instances: {
      instanceNumber: 'Instanz {{number}}',
      multiple: '{{count}} Instanzen',
      single: '1 Instanz',
    },
    labels: {
      additionalInformation: 'Zusätzliche Informationen',
      additionalText: 'Zusätzlicher Text',
      affectedArea: 'Betroffene Fläche',
      area: 'Fläche',
      class: 'Klasse',
      classification: 'Klassifizierung',
      content: 'Inhalt',
      heritageDatabase: 'Denkmal-Datenbank',
      integrationDate: 'Integrationsdatum',
      registryNumber: 'Registernummer',
      servitudeClass: 'Dienstbarkeitstyp',
      servitudeRegistryNumber: 'Dienstbarkeits-Registernr.',
      status: 'Status',
      type: 'Typ',
      validity: 'Gültigkeit',
      viewDocumentation: 'Dokumentation ansehen',
      viewInSipatrimoine: 'In SIPATRIMOINE ansehen',
    },
    legalNotice: {
      disclaimer: 'Die obigen Informationen sind nicht vollständig. Bitte konsultieren Sie das RDPPF und wenden Sie sich an die Planungsabteilung der betreffenden Gemeinde für weitere Informationen.',
      rdppfOfficialReport: 'Offizieller RDPPF-Bericht',
      sources: 'Quellen:',
      sourcesList: 'SITG • RDPPF • SIPATRIMOINE • État de Genève - DALE',
    },
    loading: 'Einschränkungsdaten werden geladen...',
    messages: {
      coverage: 'Abdeckung: {{percent}}%',
      notApplicable: 'Diese Einschränkung gilt nicht für das aktuelle Grundstück.',
    },
    metrics: {
      affectingPlot: 'Betrifft Grundstück',
      notAffecting: 'Ohne Auswirkung',
      typesAnalyzed: 'Analysierte Typen',
    },
    noData: 'Keine Daten verfügbar',
    notAffected: 'Nicht betroffen',
    notAvailable: 'Nicht verfügbar',
    restrictionTypes: {
      archaeologicalZone: 'Archäologische Schutzzone',
      buildingRight: 'Selbständiges und dauerndes Recht (sdR)',
      builtSitesProtectedZone: 'Ortsbildschutzzone',
      dangerZone: 'Gefahrenzone',
      forestLimitZone: 'Waldgrenze',
      forestZone: 'Waldzone',
      heritageInventory: 'Denkmalinventar',
      mandatoryPlanningZone: 'Planungspflichtige Zone (ZPP)',
      natureProtectionZone: 'Naturschutzzone',
      noiseSensibilityLevel: 'Lärmempfindlichkeitsstufe',
      noiseSensitivityLevel: 'Lärmempfindlichkeitsstufe',
      noMaxCosZone: 'Zone ohne maximalen Überbauungskoeffizienten',
      notYetDefinedSpecialZone: 'Noch nicht definierte Sonderzone',
      otherZone: 'Andere Zone',
      pollutedZone: 'Verschmutzte Zone',
      protectedBuilding: 'Geschütztes Gebäude',
      protectedObjects: 'Geschützte Objekte',
      protectionZone: 'Schutzzone',
      reservedZone: 'Reservierte Zone',
      servitude: 'Dienstbarkeit',
      underwaterProtectedZone: 'Gewässerschutzzone',
      watercourseLimitZone: 'Gewässergrenze',
    },
    status: {
      active: 'Aktiv',
      clear: 'Frei',
      inactive: 'Inaktiv',
      protected: 'Geschützt',
      valid: 'Gültig',
    },
    subtitle: 'Analyse der rechtlichen und baulichen Einschränkungen für {{address}}',
    title: 'Einschränkungen (ÖREB)',
  },
  sunlight: {
    common: {
      blueHour: 'Blaue Stunde',
      daylight: 'Tageslicht',
      goldenHour: 'Goldene Stunde',
      hours: 'Stunden',
      location: 'Standort',
      ofDaylight: 'Tageslicht',
      solarNoon: 'Sonnenhöchststand',
    },
    dataSources: {
      label: 'Quellen:',
      list: 'MétéoSuisse • Bundesamt für Meteorologie • Solar-Berechnungsalgorithmen',
    },
    header: {
      subtitle: 'Umfassende Sonnenexpositionsdaten für {{latitude}}°, {{longitude}}°',
      title: 'Sonnenlichtanalyse',
    },
    legalNotice: {
      text: 'Dies sind theoretische Sonnenstunden basierend auf astronomischen Berechnungen. Die tatsächliche Sonnenexposition kann aufgrund lokaler Topographie, umliegender Gebäude, Bäume und anderer Hindernisse erheblich variieren. Wir empfehlen, die interaktive Karte für detaillierte Schattenanalysen und reale Sonnenlichtbedingungen während des Tages und Jahres zu überprüfen.',
    },
    overview: {
      annualAverage: {
        longestDay: 'Längster Tag',
        shortestDay: 'Kürzester Tag',
        subtitle: 'durchschnittliches Tageslicht pro Tag',
        title: 'Jahresdurchschnitt',
        totalAnnual: 'Gesamtjahr',
      },
      lightQuality: {
        evening: {
          title: 'Abendlichtqualität',
        },
        morning: {
          title: 'Morgenlichtqualität',
        },
      },
      solarEnergy: {
        efficiencyPotential: 'Effizienzpotenzial',
        optimalAngle: 'Optimaler Winkel',
        peakHoursDay: 'Spitzenzeiten/Tag',
        title: 'Solarenergie',
        yearlyAverage: 'Jahresdurchschnitt',
      },
      todaySunlight: {
        title: 'Heutiges Sonnenlicht',
      },
    },
    seasonal: {
      average: {
        title: 'Jahresdurchschnitt',
      },
      duration: 'Dauer',
      summer: {
        title: 'Sommersonnenwende',
      },
      sunrise: 'Aufgang',
      sunset: 'Untergang',
      title: 'Saisonaler Tageslicht-Vergleich',
      winter: {
        title: 'Wintersonnenwende',
      },
    },
    seasons: {
      analysis: {
        daylightDuration: 'Tageslichtdauer',
        energyEfficiency: 'Energieeffizienz',
        high: 'Hoch',
        limited: 'Begrenzt',
        low: 'Niedrig',
        medium: 'Mittel',
        moderate: 'Moderat',
        optimal: 'Optimal',
        propertyImpact: 'Immobilienauswirkung',
        sunriseTime: 'Sonnenaufgangszeit',
        sunsetTime: 'Sonnenuntergangszeit',
        title: '{{season}}-Analyse',
        vsAnnualAverage: 'vs Jahresdurchschnitt',
      },
      autumn: {
        equinox: 'Herbst-Tagundnachtgleiche',
        name: 'Herbst',
      },
      spring: {
        equinox: 'Frühlings-Tagundnachtgleiche',
        name: 'Frühling',
      },
      summer: {
        name: 'Sommer',
        solstice: 'Sommersonnenwende',
      },
      winter: {
        name: 'Winter',
        solstice: 'Wintersonnenwende',
      },
    },
    section: {
      subtitle: 'Geschätzte Sonnenstunden und Tageslichtanalyse für diesen Standort',
      title: 'Sonnenlicht-Studie',
    },
    solar: {
      energySavings: {
        annualProduction: {
          label: 'Jährliche Produktion',
          tooltip: {
            calculation: 'Spitzen-Sonnenstunden × 5 kWp × 20 % Paneleffizienz',
            importance: 'Kritisch für die Berechnung der Kapitalrendite und die Bestimmung der optimalen Systemgrösse für Ihren Energiebedarf',
            limitations: 'Nur theoretische Berechnung. Berücksichtigt keine tatsächliche Dachflächenverfügbarkeit, Panelausrichtung, Beschattung durch nahegelegene Strukturen, Schneebedeckung, Paneldegradation im Laufe der Zeit oder Wechselrichter-/Batteriesystemverluste.',
            shortDescription: 'Geschätzte jährliche Energieproduktion pro kWp installierter Solarkapazität',
            source: 'Berechnungen der Sonneneinstrahlung basierend auf astronomischen Daten',
            title: 'Jährliche Produktion',
          },
        },
        co2Reduction: {
          label: 'CO2-Reduktion',
          tooltip: {
            calculation: 'Jährliche Produktion × 0,4 kg CO2/kWh ÷ 1000 (basierend auf durchschnittlichen Schweizer Netz-Emissionsfaktoren)',
            importance: 'Quantifiziert den Umweltnutzen der Solarinstallation für Ziele zur Reduzierung des CO2-Fussabdrucks',
            limitations: 'Basierend auf durchschnittlichen Schweizer Netzemissionen. Die tatsächlichen CO2-Einsparungen hängen von Ihrer aktuellen Energiequelle, zeitbasierten Verbrauchsmustern und Änderungen der Netzzusammensetzung im Laufe der Zeit ab.',
            shortDescription: 'Geschätzte jährliche Reduzierung der Kohlendioxidemissionen durch Solarenergie',
            source: 'Schweizer Netz-Emissionsfaktoren - Bundesamt für Umwelt BAFU',
            title: 'CO2-Reduktion',
          },
          unit: 'Tonnen/Jahr',
        },
        estimated: 'Geschätzt',
        propertyValue: {
          label: 'Immobilienwertwirkung',
          tooltip: {
            calculation: 'Basierend auf Schweizer Immobilienmarktstudien, die eine typische Wertsteigerung von 3-5% zeigen',
            categories: {
              buyerPreferences: {
                description: 'Umweltbewusstsein und Energieeffizienz-Prioritäten',
                label: 'Käuferpräferenzen',
              },
              locationFactors: {
                description: 'Regionale Marktpräferenzen und Energiekosten',
                label: 'Standortfaktoren',
              },
              marketTrends: {
                description: 'Aktuelle Immobilien- und Energiemarktbedingungen',
                label: 'Markttrends',
              },
              systemCondition: {
                description: 'Alter, Leistung und Wartungsstatus',
                label: 'Systemzustand',
              },
            },
            importance: 'Potenzieller zusätzlicher finanzieller Vorteil über Energieeinsparungen hinaus',
            limitations: 'Nur Marktstudien-Durchschnitte. Die tatsächliche Immobilienwertwirkung variiert erheblich und ist nicht garantiert. Professionelle Immobilienbewertung für genaue Einschätzung empfohlen.',
            shortDescription: 'Geschätzte Wertsteigerung der Immobilie durch Solarinstallation',
            source: 'Schweizer Immobilienmarktstudien',
            title: 'Immobilienwertwirkung',
          },
          value: '+3-5%',
        },
        roiPeriod: {
          label: 'ROI-Zeitraum',
          tooltip: {
            calculation: 'Basierend auf Schweizer Marktdurchschnitten für Wohnanlagen von CHF 15.000-25.000',
            categories: {
              electricityPrices: {
                description: 'Aktuelle und prognostizierte Energietarife',
                label: 'Strompreise',
              },
              feedInTariffs: {
                description: 'Vergütung für ins Netz eingespeiste Überschussenergie',
                label: 'Einspeisevergütungen',
              },
              installationCosts: {
                description: 'Systempreis, Genehmigungen und Einrichtung',
                label: 'Installationskosten',
              },
              maintenanceCosts: {
                description: 'Reinigung, Reparaturen und Komponentenaustausch',
                label: 'Wartungskosten',
              },
              subsidies: {
                description: 'Staatliche und lokale Anreize',
                label: 'Subventionen',
              },
            },
            importance: 'Kritische Finanzkennzahl für Investitionsentscheidungen',
            limitations: 'Generische Marktschätzung. Die tatsächliche Kapitalrendite erfordert eine professionelle Finanzbewertung unter Berücksichtigung der spezifischen Systemkonfiguration, lokaler Anreize und individueller Energieverbrauchsmuster.',
            shortDescription: 'Geschätzte Zeit zur Amortisation der Erstinvestition in das Solarsystem',
            source: 'Finanzstudien des Schweizer Solarmarktes',
            title: 'ROI-Zeitraum',
          },
          value: '7-10 Jahre',
        },
        selfSufficiency: {
          label: 'Eigenversorgung',
          tooltip: {
            calculation: 'Generische Wohngebäudeschätzung basierend auf typischen Installationsmustern',
            categories: {
              batteryCapacity: {
                description: 'Energiespeicherung für Nacht und bewölkte Tage',
                label: 'Batteriekapazität',
              },
              consumptionPatterns: {
                description: 'Tägliche und saisonale Energieverbrauchsgewohnheiten',
                label: 'Verbrauchsmuster',
              },
              electricVehicle: {
                description: 'Zusätzlicher Energiebedarf',
                label: 'Laden von Elektrofahrzeugen',
              },
              heatPumpUsage: {
                description: 'Hoher Strombedarf im Winter',
                label: 'Wärmepumpennutzung',
              },
              seasonalVariations: {
                description: 'Sommerüberschuss vs. Winterdefizit',
                label: 'Saisonale Schwankungen',
              },
            },
            importance: 'Schlüsselmetrik für Energieunabhängigkeit und Reduzierung der Netzabhängigkeit',
            limitations: 'Nur generische Schätzung. Die tatsächliche Eigenversorgung variiert erheblich je nach individuellen Umständen und erfordert eine detaillierte Verbrauchsanalyse.',
            shortDescription: 'Geschätzter Prozentsatz des Energiebedarfs, der durch Solarproduktion gedeckt wird',
            source: 'Statistische Durchschnitte der Schweizer Solarindustrie',
            title: 'Eigenversorgung',
          },
          value: '60-80%',
        },
        title: 'Energieeinsparpotenzial',
      },
      monthlyGeneration: {
        perDay: 'h/Tag',
        quarterAverage: '{{quarter}} Durchschnitt',
        title: 'Monatliches Solarstromerzeugungspotenzial',
      },
      panelInstallation: {
        efficiencyRating: {
          label: 'Effizienzbewertung',
          tooltip: {
            calculation: '(Durchschnittliche Spitzenzeiten ÷ 6,5h) × 100 - wobei 6,5h optimale äquatoriale Bedingungen darstellt',
            importance: 'Zeigt an, wie geeignet Ihr Standort für Solarenergie im Vergleich zu idealen Bedingungen ist',
            limitations: 'Basiert rein auf Breitengradberechnungen. Berücksichtigt keine reale Bewölkung, Wettermuster, Luftqualität oder lokale Klimabedingungen, die die tatsächliche Effizienz erheblich beeinflussen.',
            shortDescription: 'Solareffizienz-Bewertung basierend auf geografischer Lage (100 % = äquatoriales Optimum)',
            source: 'Berechnungen der Sonneneinstrahlung basierend auf astronomischen Daten',
            title: 'Effizienzbewertung',
          },
        },
        highPotential: 'Hohes Potenzial',
        monthlyAverage: {
          label: 'Monatsdurchschnitt',
          tooltip: {
            calculation: 'Basierend auf astronomischen Berechnungen mit Sonnenpositionsdaten das ganze Jahr über',
            importance: 'Bietet Einblick in saisonale Variationen der Solarenergieproduktion für Planungszwecke',
            limitations: 'Nur theoretische Berechnung. Berücksichtigt keine lokalen Klimamuster, tatsächlichen Wetterbedingungen oder standortspezifische Beschattung durch Gebäude, Bäume oder Gelände.',
            shortDescription: 'Durchschnittliche tägliche Spitzen-Sonnenstunden berechnet über einen typischen Monat',
            source: 'Berechnungen der Sonneneinstrahlung basierend auf astronomischen Daten',
            title: 'Monatsdurchschnitt',
          },
        },
        optimalPanelAngle: {
          label: 'Optimaler Panelwinkel',
          tooltip: {
            calculation: 'Formel: Breitengrad ({{latitude}}°) × 0,9 + 29° für ganzjährige Leistung',
            importance: 'Der richtige Panelwinkel maximiert die Energieproduktion durch optimale Sonnenexposition das ganze Jahr über',
            limitations: 'Berücksichtigt nicht die lokale Topographie, die tatsächliche Dachausrichtung, strukturelle Einschränkungen oder saisonale Anpassungsoptionen. Professionelle Standortbewertung für optimale Ergebnisse empfohlen.',
            shortDescription: 'Der theoretisch ideale Neigungswinkel für Solarmodule basierend auf Ihrem Standort',
            source: 'Astronomische Berechnungen basierend auf geografischen Koordinaten',
            title: 'Optimaler Panelwinkel',
          },
        },
        peakSunHours: {
          label: 'Spitzenzeiten/Tag',
          tooltip: {
            calculation: 'Theoretische Spitzen-Sonnenstunden bei klarem Himmel mit 1000 W/m² Intensität, berechnet aus Breitengrad und saisonalen Sonnenwinkeln',
            importance: 'Spitzen-Sonnenstunden korrelieren direkt mit dem Potenzial der Solarenergieproduktion und helfen bei der Schätzung der Systemleistung',
            limitations: 'Basiert nur auf theoretischen Klarwetterbedingungen. Berücksichtigt keine Bewölkung, Nebel, Luftverschmutzung, Schatten von Gebäuden oder Bäumen oder tatsächliche lokale Wettermuster.',
            shortDescription: 'Tägliche Stunden direkter Sonneneinstrahlung bei optimaler Solarmodul-Effizienz',
            source: 'Berechnungen der Sonneneinstrahlung basierend auf astronomischen Daten',
            title: 'Spitzen-Sonnenstunden pro Tag',
          },
        },
        title: 'Solaranlagen-Installation',
        yearlyTotal: {
          label: 'Gesamtjahr',
          tooltip: {
            calculation: 'Monatsdurchschnitt × 365 Tage',
            importance: 'Hilft bei der Schätzung des jährlichen Solarenergieproduktionspotenzials für die Systemdimensionierung und Kosten-Nutzen-Analyse',
            limitations: 'Dies stellt die theoretische Obergrenze unter perfekten Klarwetterbedingungen dar. Reale Werte sind typischerweise 30-50 % niedriger aufgrund von Wettermustern, saisonalen Variationen und atmosphärischen Bedingungen.',
            shortDescription: 'Gesamte erwartete Spitzen-Sonnenstunden im gesamten Jahr',
            source: 'Berechnungen der Sonneneinstrahlung basierend auf astronomischen Daten',
            title: 'Gesamtjahr',
          },
        },
      },
    },
    states: {
      error: 'Fehler beim Laden der Sonnenlichtdaten',
      errorDescription: 'Sonnenlicht-Analysedaten können nicht geladen werden. Bitte versuchen Sie es später erneut.',
      loading: 'Sonnenlichtdaten werden geladen...',
      noData: 'Keine Sonnenlichtdaten verfügbar',
      noDataDescription: 'Sonnenlicht-Analysedaten sind für diesen Standort nicht verfügbar.',
    },
    sunPath: {
      dawn: 'Morgendämmerung',
      dusk: 'Abenddämmerung',
      noon: 'Mittag',
    },
    tabs: {
      overview: 'Übersicht',
      seasonal: 'Saisonal',
      solar: 'Solarpotenzial',
      yearly: 'Jahresanalyse',
    },
    today: {
      badge: 'Nahe dem Sommer-Maximum',
      dayDuration: 'Tageslänge',
      sunrise: 'Sonnenaufgang',
      sunset: 'Sonnenuntergang',
      title: 'Heute - {{date}}',
    },
    yearly: {
      bestMonths: {
        averagePeak: 'Durchschnittlicher Höchststand',
        excellent: 'Ausgezeichnet',
        peakPeriod: 'Mai - August',
        peakSeason: 'Hauptsaison',
        qualityRating: 'Qualitätsbewertung',
        title: 'Beste Monate',
      },
      challengingMonths: {
        averageLow: 'Durchschnittliches Tief',
        limited: 'Begrenzt',
        lowPeriod: 'Nov - Februar',
        lowSeason: 'Nebensaison',
        title: 'Schwierige Monate',
      },
      chartTitle: 'Tageslichtstunden im Jahresverlauf',
      daylightHours: 'Tageslichtstunden',
      months: {
        apr: 'Apr',
        aug: 'Aug',
        dec: 'Dez',
        feb: 'Feb',
        jan: 'Jan',
        jul: 'Jul',
        jun: 'Jun',
        mar: 'Mär',
        may: 'Mai',
        nov: 'Nov',
        oct: 'Okt',
        sep: 'Sep',
      },
      variation: {
        leastSunlight: 'Wenigstes Sonnenlicht',
        maxVariation: 'Maximale Variation',
        mostSunlight: 'Meistes Sonnenlicht',
        title: 'Variationsanalyse',
      },
    },
  },
  taxes: {
    calculatorLink: {
      description: 'Verwenden Sie den offiziellen Schweizer Steuerrechner, um Steuern basierend auf einer bestimmten Situation zu schätzen.',
      title: 'Eine personalisierte Steuer berechnen',
    },
    charts: {
      noData: 'Keine Daten verfügbar',
      taxAmountEvolution: {
        axis: {
          amount: 'Steuerbetrag (CHF)',
        },
        subtitle: 'Historische Steuerbeträge in CHF nach Profil',
        summary: {
          title: 'Veränderungen ({{startYear}}-{{endYear}})',
        },
        title: 'Entwicklung des jährlichen Steuerbetrags',
      },
      taxBurdenEvolution: {
        axis: {
          burden: 'Steuerbelastung (%)',
        },
        subtitle: 'Historischer Steuerbelastungsprozentsatz nach Profil',
        summary: {
          avgChange: 'Durchschnittliche Veränderung',
          decreasing: 'Abnehmend - Steuern sinken',
          increasing: 'Zunehmend - Steuern steigen',
          stable: 'Stabil - Steuern bleiben relativ konstant',
          title: 'Trendanalyse ({{startYear}}-{{endYear}})',
          trend: 'Trend',
        },
        title: 'Entwicklung der Steuerbelastung',
      },
      taxRateEvolution: {
        subtitle: 'Kantonale und kommunale Satzkoeffizienten im Zeitverlauf',
        summary: {
          title: 'Satzänderungen ({{startYear}}-{{endYear}})',
        },
        title: 'Entwicklung der Steuersätze',
      },
    },
    common: {
      downloadChart: 'Diagramm herunterladen',
    },
    comparison: {
      aboveCantonAvg: 'über dem Kantonsdurchschnitt',
      aboveNationalAvg: 'über dem Landesdurchschnitt',
      belowCantonAvg: 'unter dem Kantonsdurchschnitt',
      belowNationalAvg: 'unter dem Landesdurchschnitt',
      canton: 'Kanton',
      profileFamily: 'Steuerbelastung (Familie - {{income}} Einkommen)',
      profileMarried: 'Steuerbelastung (Verheiratet - {{income}} Einkommen)',
      profileSingle: 'Steuerbelastung (Ledig - {{income}} Einkommen)',
      switzerland: 'Schweiz',
      thisLocation: 'Dieser Standort',
      title: 'Geografischer Vergleich',
    },
    efficiency: {
      high: 'Hoch',
      low: 'Niedrig',
      medium: 'Mittel',
    },
    filters: {
      location: 'Standort',
      year: 'Jahr',
    },
    insights: {
      highEfficiency: 'Dieser Standort bietet niedrigere Steuern als der Kantons- und Landesdurchschnitt, was ihn zu einer attraktiven Wahl für steuerbewusste Käufer macht.',
      lowEfficiency: 'Die Steuerbelastung an diesem Standort liegt über dem Kantons- und Landesdurchschnitt. Berücksichtigen Sie diesen Faktor bei der Bewertung der Gesamtkosten.',
      mediumEfficiency: 'Die Steuersätze an diesem Standort zeigen gemischte Ergebnisse im Vergleich zu Kantons- und Landesdurchschnitt. Die Steuern sind auf einer Ebene günstig, aber nicht auf beiden.',
      title: 'Steuereffizienz-Bewertung',
    },
    metrics: {
      annualTax: {
        subtitle: 'Durchschnittliche Gesamtsteuern',
        title: 'Jahressteuer',
      },
      taxBurden: {
        subtitle: 'Durchschnitt aller Profile',
        title: 'Steuerbelastung',
      },
      taxFreedomDay: {
        subtitle: 'Durchschnittsdatum',
        title: 'Steuerzahlergedenktag',
      },
    },
    profileDetails: {
      annualTax: 'Jahressteuer',
      profile: 'Profil',
      taxBurden: 'Steuerbelastung',
      taxFreedomDay: 'Steuerzahlergedenktag',
      title: 'Profildetails',
    },
    profiles: {
      all: 'Alle Profile',
      family: 'Familie',
      married: 'Verheiratet',
      single: 'Ledig',
    },
    states: {
      error: 'Fehler beim Laden der Steuerdaten: {{error}}',
      fetchError: 'Steuerdaten konnten nicht geladen werden',
      loading: 'Steuerdaten werden geladen...',
      noData: 'Für diesen Standort sind keine Steuerdaten verfügbar.',
      noHistoricalData: 'Keine historischen Steuerdaten verfügbar',
    },
    subtitle: 'Steuerbelastungsanalyse für diesen Standort',
    tabs: {
      overview: 'Übersicht',
      trends: 'Historische Entwicklung',
    },
    taxRates: {
      canton: 'Kanton',
      cantonRate: 'Kantonssatz',
      churchChrist: 'Christkatholisch',
      churchNote: 'Kirchensteuern (optional)',
      churchProtestant: 'Reformiert',
      churchRoman: 'Römisch-katholisch',
      city: 'Gemeinde',
      cityRank: 'Gemeinderang',
      cityRate: 'Gemeindesatz',
      cityRateComparison: 'Gemeindesatz unter {{total}} Gemeinden in {{canton}}',
      inCanton: 'in {{canton}}',
      ofCities: 'von {{total}} Gemeinden',
      rateAxis: 'Satz (%)',
      subtitle: 'Angewandte Multiplikatoren auf die kantonale Grundsteuer',
      title: 'Steuersatzkoeffizienten',
    },
    title: 'Steuern',
    tooltips: {
      annualTax: {
        calculation: "Summe aus direkter Bundessteuer + kantonaler Einkommenssteuer + Gemeindeeinkommenssteuer. Profile: Alleinstehend = CHF 84'000 (Schweizer Medianlohn), Verheiratet = Paar ohne Kinder bei CHF 168'000, Familie = Ehepaar mit 2 Kindern bei CHF 168'000.",
        importance: "Der absolute CHF-Betrag hilft Kunden, reale Kostenunterschiede zwischen Standorten zu verstehen. Ein jährlicher Unterschied von CHF 5'000 stellt erhebliche Einsparungen über die Eigentumsdauer dar.",
        limitations: "Beinhaltet keine Vermögenssteuer, Grundsteuern oder andere indirekte Steuern. Basierend auf standardisierten Profilen (Alleinstehend: CHF 84'000, Verheiratet/Familie: CHF 168'000) ohne individuelle Abzüge.",
        shortDescription: 'Gesamte jährlich gezahlte Steuern einschliesslich Bundes-, Kantons- und Gemeindesteuern',
        source: 'Eidgenössische Steuerverwaltung (ESTV) - Jährliche Steuerbelastungsstatistiken',
        title: 'Jahressteuer',
      },
      taxBurden: {
        calculation: "Jährliche Gesamtsteuer / Bruttojahreseinkommen × 100. Profile: Alleinstehend = CHF 84'000 (Schweizer Medianlohn), Verheiratet = Paar ohne Kinder bei CHF 168'000, Familie = Ehepaar mit 2 Kindern bei CHF 168'000.",
        calculation_family: "Jährliche Gesamtsteuer / Bruttojahreseinkommen × 100. Basierend auf einem Ehepaar mit 2 Kindern mit einem kombinierten Bruttoeinkommen von CHF 168'000.",
        calculation_married: "Jährliche Gesamtsteuer / Bruttojahreseinkommen × 100. Basierend auf einem verheirateten Paar ohne Kinder mit einem kombinierten Bruttoeinkommen von CHF 168'000.",
        calculation_single: "Jährliche Gesamtsteuer / Bruttojahreseinkommen × 100. Basierend auf einer alleinstehenden Person mit einem Bruttoeinkommen von CHF 84'000 (Schweizer Medianlohn).",
        importance: 'Direkter Einfluss auf Kaufkraft und verfügbares Einkommen. Eine niedrigere Steuerbelastung bedeutet mehr Geld für Hypothekenzahlungen und Lebenshaltungskosten. Schlüsselfaktor für Immobilieninvestitionsentscheidungen.',
        limitations: "Basierend auf standardisierten Einkommensprofilen (Alleinstehend: CHF 84'000, Verheiratet/Familie: CHF 168'000). Die tatsächliche Steuerbelastung kann je nach individuellen Umständen, Abzügen und Vermögen variieren.",
        limitations_family: "Basierend auf einem standardisierten kombinierten Einkommen von CHF 168'000 für ein Ehepaar mit 2 Kindern. Die tatsächliche Steuerbelastung kann je nach individuellen Umständen, Abzügen und Vermögen variieren.",
        limitations_married: "Basierend auf einem standardisierten kombinierten Einkommen von CHF 168'000 für ein Paar ohne Kinder. Die tatsächliche Steuerbelastung kann je nach individuellen Umständen, Abzügen und Vermögen variieren.",
        limitations_single: "Basierend auf einem standardisierten Einkommen von CHF 84'000. Die tatsächliche Steuerbelastung kann je nach individuellen Umständen, Abzügen und Vermögen variieren.",
        shortDescription: 'Prozentsatz des Bruttoeinkommens, der als Steuern gezahlt wird (Bund, Kanton, Gemeinde)',
        source: 'Eidgenössische Steuerverwaltung (ESTV) - Jährliche Steuerbelastungsstatistiken',
        title: 'Steuerbelastung',
      },
      taxFreedomDay: {
        calculation: 'Steuerbelastung × 365 Tage. Bei 18,9% Steuerbelastung = Tag 69 (10. März). Früheres Datum = niedrigere Steuern.',
        importance: "Intuitive Art, die Steuerbelastung den Kunden zu kommunizieren. 'Sie arbeiten bis zum 10. März, um Steuern zu zahlen' ist greifbarer als '18,9% Steuerbelastung'. Weit verbreitete Kennzahl in der Schweiz.",
        limitations: 'Symbolische Darstellung. Tatsächliche Steuerzahlungen sind über das Jahr verteilt. Berücksichtigt keine obligatorischen Sozialabgaben.',
        shortDescription: 'Der Tag im Jahr, an dem Sie aufhören, für Steuern zu arbeiten, und anfangen, für sich selbst zu verdienen',
        source: 'Eidgenössische Steuerverwaltung (ESTV) - Steuerzahlergedenktag-Publikation',
        title: 'Steuerzahlergedenktag',
      },
    },
  },
  transactions: {
    actions: {
      removeFromSaved: 'Aus Gespeicherten entfernen',
      saveTransaction: 'Transaktion speichern',
    },
    aiFilter: {
      description: 'Beschreiben Sie die Transaktionen, die Sie suchen, und ich helfe Ihnen dabei, sie zu finden.',
      examplePrompts: {
        '0': 'Kauftransaktionen der letzten 12 Monate über 5 Millionen CHF',
        '1': 'Transaktionen mit nur einem Käufer',
      },
      placeholder: 'Zeigen Sie mir Kauftransaktionen der letzten Monate',
      title: 'Transaktions-Filter-Assistent',
    },
    columns: {
      address: 'Adresse',
      area: 'Fläche',
      buyers: 'Käufer',
      buyersCount: 'Käufer #',
      date: 'Datum',
      ownershipType: 'Eigentumstyp',
      parcel: 'Parzelle {{number}}',
      previousTransaction: 'Vorherige Transaktion',
      price: 'Preis',
      pricePerM2: 'Preis/m²',
      reason: 'Grund',
      sellers: 'Verkäufer',
      sellersCount: 'Verkäufer #',
      transactionId: 'Transaktions-ID',
    },
    dataSources: {
      label: 'Quellen:',
      list: 'Grundbuch • Staat Genf • Auszug aus dem Mutationsregister',
    },
    detail: {
      backToList: 'Zurück zur Liste',
      description: 'Beschreibung',
      details: 'Details',
      landInfo: 'Informationen zum Grundstück',
      multipleLotsWarning: 'Diese Transaktion betrifft mehrere Grundstücke',
      parcel: 'Parzelle',
      propertiesInvolved: 'Betroffene Immobilien',
      transaction: 'Transaktion',
      transactionInfo: 'Transaktionsinformationen',
    },
    detailPanel: {
      initializingMap: 'Karte wird initialisiert...',
      labels: {
        buyers: 'Käufer',
        capacity: 'Kapazität',
        floors: 'Stockwerke',
        land: 'Grundstück',
        landArea: 'Grundstücksfläche',
        language: 'Sprache',
        location: 'Standort',
        officialId: 'Offizielle ID',
        participants: 'Teilnehmer',
        previous: 'Vorherige',
        properties: 'Immobilien',
        property: 'Immobilie {{index}}',
        publicationDate: 'Veröffentlichungsdatum',
        region: 'Region',
        sellers: 'Verkäufer',
        share: 'Anteil',
        stepPrice: 'Schrittpreis',
        surface: 'Fläche',
        totalPrice: 'Gesamtpreis',
        totalSurface: 'Gesamtfläche',
        transactionDate: 'Transaktionsdatum',
        transactionId: 'Transaktions-ID',
        units: 'Einheiten',
        unitsCount: 'Einheiten ({{count}})',
      },
      legalTypes: {
        BF: 'B-F - Grundstück',
        COP: 'COP - Miteigentum',
        DDP: 'DDP - Dauerbaurecht',
        DP: 'DP - öffentlicher Grund',
        PPE: 'PPE - Stockwerkeigentum',
      },
      loading: 'Transaktionsdetails werden geladen...',
      loadingMap: 'Karte wird geladen...',
      locationsNotAvailable: 'Genaue Immobilienstandorte nicht verfügbar',
      mapPopup: {
        land: 'Grundstück: {{area}} m²',
        propertiesAtLocation: '{{count}} Immobilien an diesem Standort',
        propertyNumber: 'Immobilie {{index}}',
        surface: 'Fläche: {{area}} m²',
      },
      mapTokenNotConfigured: 'Kartentoken nicht konfiguriert',
      notFound: 'Transaktion nicht gefunden',
      participantTypes: {
        company: 'Unternehmen',
        estate: 'Nachlass',
        individual: 'Privatperson',
        nonProfit: 'Gemeinnützig',
        other: 'Sonstige',
        publicBody: 'Öffentliche Einrichtung',
        unknown: 'Unbekannt',
      },
      removeFromSaved: 'Von Gespeicherten entfernen',
      saveTransaction: 'Transaktion speichern',
      sections: {
        participants: 'Teilnehmer',
        properties: 'Immobilien',
        propertiesCount: 'Immobilien ({{count}})',
        rawTransactionData: 'Rohe Transaktionsdaten',
        transactionDescription: 'Transaktionsbeschreibung',
        transactionDetails: 'Transaktionsdetails',
      },
      title: 'Details',
      transactionNumber: 'Transaktion Nr. {{id}}',
      type: 'Transaktion',
      unitTypes: {
        appartement: 'Wohnung',
        balcon: 'Balkon',
        box: 'Lagerbox',
        cave: 'Keller',
        garage: 'Garage',
        loggia: 'Loggia',
        privateGarage: 'Privatgarage',
        singleFamily: 'Einfamilienhaus',
      },
    },
    empty: {
      message: 'Versuchen Sie, Ihre Filter anzupassen, um mehr Ergebnisse zu sehen',
      title: 'Keine Transaktionen gefunden',
    },
    errors: {
      loadFailed: 'Laden der Transaktionen fehlgeschlagen',
      tryAgain: 'Bitte versuchen Sie es später erneut',
    },
    fields: {
      assignmentArea: 'Zuweisungsgebiet',
      buildingClassification: 'Gebäudetyp',
      buyers: 'Käufer',
      landInfo: 'Grundstücksinformation',
      livingArea: 'Wohnfläche',
      numberOfBuyers: 'Anzahl Käufer',
      numberOfSellers: 'Anzahl Verkäufer',
      numberOfUnits: 'Anzahl Einheiten',
      parcelNumber: 'Parzellennummer',
      parties: 'Parteien',
      previousTransaction: 'Vorherige Transaktion',
      price: 'Preis',
      pricePerM2: 'Preis pro m²',
      propertyType: 'Eigentumstyp',
      publishedOn: 'Veröffentlicht am',
      reason: 'Grund',
      sellers: 'Verkäufer',
      transactionDate: 'Transaktionsdatum',
      transactionOn: 'Transaktion am',
    },
    filter: {
      additionalFilters: 'Zusätzliche Filter',
      advancedFilters: 'Erweiterte Filter',
      allLocations: 'Alle Standorte',
      clearAll: 'Alle löschen',
      hideFilters: 'Filter ausblenden',
      landArea: 'Grundstücksfläche (m²)',
      legalTypeBF: 'B-F',
      legalTypeCOP: 'COP',
      legalTypeDDP: 'DDP',
      legalTypeDP: 'DP',
      legalTypeOther: 'Andere',
      legalTypePPE: 'PPE',
      numberOfBuyers: 'Anzahl Käufer',
      numberOfSellers: 'Anzahl Verkäufer',
      others: 'Andere',
      participantAssociation: 'Verein',
      participantCompany: 'Unternehmen',
      participantCooperative: 'Genossenschaft',
      participantFoundation: 'Stiftung',
      participantIndividual: 'Privatperson',
      participantOther: 'Andere',
      participantPublicEntity: 'Öffentliche Einrichtung',
      participants: 'Teilnehmer',
      participantType: 'Teilnehmertyp',
      propertyLegalType: 'Rechtlicher Eigentumstyp',
      radius: 'Radius',
      showFilters: 'Filter anzeigen',
      stepTransactionPrice: 'Transaktionspreis (CHF)',
      transactionDate: 'Transaktionsdatum',
      transactionType: 'Transaktionstyp',
      typeAreaPrice: 'Typ, Fläche & Preis',
      unitApartment: 'Wohnung',
      unitCommercial: 'Gewerbe',
      unitHouse: 'Haus',
      unitLand: 'Grundstück',
      unitOther: 'Andere',
      unitParking: 'Parkplatz',
      unitType: 'Einheitentyp',
    },
    filterPanel: {
      appliedFilter: 'Filter angewendet: {{name}}',
      clearAllFilters: 'Alle Filter löschen',
      closeFilters: 'Filter schliessen',
      failedToSave: 'Filter konnte nicht gespeichert werden',
      loadSavedFilters: 'Gespeicherte Filter laden',
      saveCurrentFilters: 'Aktuelle Filter speichern',
      savedFilter: 'Filter gespeichert: {{name}}',
      savedOn: 'Gespeichert am {{date}}',
      title: 'Transaktionsfilter',
    },
    filters: {
      any: 'Alle',
      apply: 'Anwenden',
      area: 'Wohnfläche',
      areaQuickOptions: {
        '100to150': '100-150m²',
        '50to100': '50-100m²',
        over150: 'Über 150m²',
        under50: 'Unter 50m²',
      },
      areaRange: 'Wohnfläche (m²)',
      clear: 'Löschen',
      clearAll: 'Alle Filter löschen',
      labels: {
        buyers: 'Käufer',
        city: 'Stadt',
        district: 'Bezirk',
        floors: 'Stockwerke',
        landArea: 'Grundstücksfläche',
        legalType: 'Rechtstyp',
        mapSearchLocation: 'Kartenstandortsuche',
        municipality: 'Gemeinde',
        npa: 'PLZ (Postleitzahl)',
        numberOfBuyers: 'Anzahl Käufer',
        numberOfFloors: 'Anzahl Stockwerke',
        numberOfProperties: 'Anzahl Immobilien',
        numberOfRooms: 'Anzahl Zimmer',
        numberOfSellers: 'Anzahl Verkäufer',
        participantLegalForm: 'Rechtsform des Teilnehmers',
        participantName: 'Name des Teilnehmers',
        participantType: 'Teilnehmertyp',
        propertyPrice: 'Immobilienpreis',
        publicationDate: 'Veröffentlichungsdatum',
        reason: 'Grund',
        region: 'Region',
        rooms: 'Zimmer',
        sellers: 'Verkäufer',
        stepPrice: 'Schrittpreis',
        stepTransactionPrice: 'Schritt-Transaktionspreis',
        surfaceArea: 'Fläche',
        totalPrice: 'Gesamtpreis',
        totalSurfaceArea: 'Gesamtfläche',
        totalTransactionPrice: 'Gesamttransaktionspreis',
        transactionDate: 'Transaktionsdatum',
        unitArea: 'Einheitenfläche',
        unitType: 'Einheitentyp',
      },
      legalTypes: {
        BF: 'B-F - Grundstück',
        COP: 'COP - Miteigentum',
        DDP: 'DDP - Dauerbaurecht',
        DP: 'DP - öffentlicher Grund',
        PPE: 'PPE - Stockwerkeigentum',
      },
      lessFilters: 'Weniger Filter',
      location: 'Standort',
      locationOptions: {
        geneva1205: '1205 Genf',
        genevaCanton: 'Kanton Genf',
        genevaCity: 'Stadt Genf',
        within100m: 'Innerhalb 100m',
        within1km: 'Innerhalb 1km',
        within2km: 'Innerhalb 2km',
        within300m: 'Innerhalb 300m',
        within500m: 'Innerhalb 500m',
      },
      locationSections: {
        location: 'Standort',
        radius: 'Radius von der Immobilie',
      },
      max: 'MAX',
      min: 'MIN',
      moreFilters: 'Mehr Filter',
      participantTypes: {
        company: 'Unternehmen',
        estate: 'Nachlass',
        individual: 'Privatperson',
        nonProfit: 'Gemeinnützig',
        other: 'Sonstige',
        others: 'Andere',
        publicBody: 'Öffentliche Einrichtung',
      },
      placeholders: {
        enterCity: 'Stadtnamen eingeben...',
        enterDistrict: 'Bezirksnamen eingeben...',
        enterLegalForm: 'Rechtsform eingeben...',
        enterMunicipality: 'Gemeindenamen eingeben...',
        enterNpa: 'PLZ eingeben...',
        enterRegion: 'Regionsnamen eingeben...',
        from: 'Von',
        max: 'Max',
        min: 'Min',
        searchParticipants: 'Teilnehmernamen suchen...',
        to: 'Bis',
      },
      price: 'Preis (CHF)',
      priceQuickOptions: {
        '1MTo2M': '1M - 2M',
        '500kTo1M': '500k - 1M',
        over2M: 'Über 2M',
        under500k: 'Unter 500k',
      },
      priceRange: 'Preisspanne (CHF)',
      propertyType: 'Eigentumstyp',
      propertyTypeOptions: {
        bienFonds: 'Grundstücksparzellen',
        ppe: 'Wohnungseigentum',
      },
      reason: 'Transaktionsart',
      reasonOptions: {
        achat: 'Kauftransaktionen',
        donation: 'Schenkungsübertragungen',
        heritage: 'Erbschaftsübertragungen',
        vente: 'Verkaufstransaktionen',
      },
      sections: {
        locationDate: 'Standort & Datum',
        participants: 'Teilnehmer',
        price: 'Preis',
        properties: 'Immobilien',
        propertyLocation: 'Immobilienstandort',
        transactionDetails: 'Transaktionsdetails',
        units: 'Einheiten',
      },
      unitTypes: {
        apartment: 'Wohnung',
        balcony: 'Balkon',
        cellar: 'Keller',
        garage: 'Garage',
        loggia: 'Loggia',
        privateGarage: 'Privatgarage',
        singleFamily: 'Einfamilienhaus',
        storageBox: 'Lagerbox',
      },
      year: 'Jahr',
      yearOptions: {
        all: 'Alle Zeit',
        last10Years: 'Letzten 10 Jahre',
        last2Years: 'Letzten 2 Jahre',
        last5Years: 'Letzten 5 Jahre',
        lastYear: 'Letztes Jahr',
      },
    },
    placeholders: {
      searchBuyers: 'Käufer suchen...',
      searchSellers: 'Verkäufer suchen...',
    },
    print: {
      cover: {
        generatedOn: 'Erstellt am {{date}}',
        subtitle: 'Umfassende Marktanalyse',
        title: 'Transaktionsstatistik-Bericht',
      },
      dataSource: {
        description: 'Die in diesem Bericht präsentierten Transaktionsstatistiken stammen aus umfassenden Immobilientransaktionsregistern, die aus offiziellen Quellen gesammelt wurden. Die Daten umfassen alle erfassten Immobilientransaktionen im ausgewählten geografischen Gebiet und Zeitraum.',
        lastUpdated: 'Zuletzt aktualisiert: {{date}} | Datenquellen: Öffentliche Register, Regierungsdatenbanken',
        title: 'Über diese Daten',
      },
      disclaimer: {
        dataAccuracy: {
          description: 'Obwohl alle Anstrengungen unternommen wurden, um die Genauigkeit der in diesem Bericht präsentierten Informationen zu gewährleisten, kann Popety.io die Vollständigkeit oder Genauigkeit aller Daten nicht garantieren. Die Statistiken und Analysen basieren auf den zum Zeitpunkt der Erstellung verfügbaren Daten und können Änderungen unterliegen.',
          title: 'Datengenauigkeit',
        },
        dataSources: {
          description: 'Dieser Bericht basiert auf Transaktionsdaten aus verschiedenen öffentlichen und privaten Quellen, darunter:',
          items: {
            databases: 'Immobilienmarkt-Datenbanken',
            records: 'Öffentliche Transaktionsaufzeichnungen',
            registries: 'Offizielle Immobilienregister',
            statistical: 'Statistische Ämter',
          },
          title: 'Datenquellen',
        },
        footer: '© {{year}} Popety.io - Alle Rechte vorbehalten | www.popety.io',
        intellectualProperty: {
          description: 'Alle Inhalte dieses Berichts, einschliesslich, aber nicht beschränkt auf Text, Grafiken, Diagramme und Datenvisualisierungen, sind Eigentum von Popety.io und durch Urheberrechtsgesetze geschützt. Eine Vervielfältigung oder Verbreitung ohne schriftliche Genehmigung ist untersagt.',
          title: 'Geistiges Eigentum',
        },
        title: 'Rechtlicher Hinweis und Datenquellen',
        usageLimitations: {
          description: 'Dieser Bericht dient nur zu Informationszwecken und sollte nicht als Folgendes angesehen werden:',
          items: {
            complete: 'Eine vollständige Darstellung aller Markttransaktionen',
            guarantee: 'Eine Garantie für zukünftige Marktentwicklung',
            investment: 'Anlageberatung oder -empfehlungen',
            legal: 'Rechts- oder Finanzberatung',
          },
          title: 'Nutzungsbeschränkungen',
        },
      },
    },
    propertyTypeBadges: {
      bienFonds: 'Grundstück',
      commune: 'Erbengemeinschaft',
      individuelle: 'Einzeleigentum',
      ppe: 'Wohnungseigentum',
    },
    propertyTypes: {
      all: 'Alle Immobilien',
      bienFonds: 'Grundstück',
      commune: 'Erbengemeinschaft',
      individuelle: 'Einzeleigentum',
      ppe: 'WEG',
    },
    quickFilters: {
      buyers: 'Käufer',
      city: 'Stadt',
      district: 'Bezirk',
      floors: 'Stockwerke',
      landArea: 'Grundstücksfläche',
      legalForm: 'Rechtsform',
      legalType: 'Rechtstyp',
      municipality: 'Gemeinde',
      npa: 'PLZ',
      participant: 'Teilnehmer',
      participantType: 'Teilnehmertyp',
      properties: 'Immobilien',
      propertyPrice: 'Immobilienpreis',
      publicationDate: 'Veröffentlichungsdatum',
      reason: 'Grund',
      region: 'Region',
      rooms: 'Zimmer',
      sellers: 'Verkäufer',
      stepPrice: 'Schrittpreis',
      surfaceArea: 'Fläche',
      totalPrice: 'Gesamtpreis',
      transactionDate: 'Transaktionsdatum',
      unitArea: 'Einheitenfläche',
      unitType: 'Einheitentyp',
    },
    resultsCount: '{{count}} Transaktionen gefunden {{location}} {{timeframe}}',
    sections: {
      parties: 'Parteien',
      propertyDetails: 'Immobiliendetails',
      transactionInfo: 'Transaktionsinformationen',
    },
    sorting: {
      distance: 'Entfernung',
      priceHigh: 'Preis: Hoch zu Niedrig',
      priceLow: 'Preis: Niedrig zu Hoch',
      recent: 'Neueste',
      sortBy: 'Sortieren nach:',
    },
    stats: {
      charts: {
        geographicDistribution: {
          activeCantons: 'Aktive Kantone',
          avg: 'Durchschn.',
          avgTransactionPrice: 'Durchschn. Transaktionspreis',
          noData: 'Keine Daten verfügbar',
          topCitiesByVolume: 'Top-Städte nach Transaktionsvolumen',
          totalMarketVolume: 'Gesamtmarktvolumen',
          totalTransactions: 'Gesamttransaktionen',
          transactions: 'Transaktionen',
          transactionsByCanton: 'Transaktionen nach Kanton',
        },
        inheritanceAnalysis: {
          donation: 'Schenkung',
          flowAnalysis: 'Erbschaftsflussanalyse',
          flowAnalysisSubtext: 'Vermögensübertragung von Verkäufern zu Käufern nach Immobilientyp',
          heritage: 'Erbschaft',
          inheritanceOverTime: 'Erbschaftstransaktionen im Zeitverlauf',
          inheritanceOverTimeSubtext: 'Quartalstrends nach Transaktionsart',
          noData: 'Keine Erbschaftsdaten verfügbar',
          partage: 'Teilung',
          shareDistribution: 'Analyse der Anteilsverteilung',
          shareDistributionSubtext: 'Eigentumsanteilsmuster bei Übertragungen',
          transactionCount: 'Anzahl der Transaktionen',
          transactions: 'Transaktionen',
        },
        marketTiming: {
          activityCalendar: 'Marktaktivitätskalender',
          activityCalendarSubtext: 'Transaktionsvolumen nach Tag',
          avgLagDays: 'Durchschnittliche Verzögerung (Tage)',
          monthlyActivity: 'Monatliche Transaktionsaktivität',
          monthlyActivitySubtext: 'Transaktionsvolumen im Zeitverlauf',
          noActivity: 'Keine Aktivität',
          noData: 'Keine Markttiming-Daten verfügbar',
          numberOfTransactions: 'Anzahl der Transaktionen',
          publicationLag: 'Analyse der Veröffentlichungsverzögerung',
          publicationLagSubtext: 'Durchschnittliche Tage zwischen Transaktion und Veröffentlichung',
          totalTransactions: 'Gesamttransaktionen',
          transactions: 'Transaktionen',
        },
        participantDemographics: {
          buyersByGender: 'Käufer nach Geschlecht',
          companies: 'Unternehmen',
          companyParticipants: 'Unternehmen',
          female: 'Weiblich',
          genderDistributionOverTime: 'Geschlechterverteilung der Käufer im Zeitverlauf',
          genderParity: '50% Geschlechterparität',
          individualParticipants: 'Einzelpersonen',
          individuals: 'Privatpersonen',
          male: 'Männlich',
          noData: 'Keine Daten verfügbar',
          participantTypesByLegalForm: 'Teilnehmertypen nach Rechtsform',
          personVsCompany: 'Privatpersonen vs Unternehmen',
          sellersByGender: 'Verkäufer nach Geschlecht',
          totalBuyers: 'Gesamtzahl Käufer',
          totalSellers: 'Gesamtzahl Verkäufer',
        },
        priceDynamics: {
          avgTransactionPrice: 'Durchschnittlicher Transaktionspreis',
          mom: 'MüM',
          noData: 'Keine Daten verfügbar',
          priceByPropertyType: 'Preis nach Immobilientyp',
          priceDistribution: 'Preisverteilung',
          priceVelocityIndex: 'Preisgeschwindigkeitsindex',
          totalMarketVolume: 'Gesamtmarktvolumen',
          yearlyMarketVolume: 'Jährliches Marktvolumen',
          yoy: 'JüJ',
        },
        propertyCharacteristics: {
          avgPrice: 'Durchschnittspreis',
          avgSurfaceArea: 'Durchschnittliche Fläche (m²)',
          avgSurfaceAreaM2: 'Durchschnittliche Fläche (m²)',
          complexityIndex: 'Gebäudekomplexitätsindex',
          complexityIndexSubtext: 'Preis und Fläche nach Anzahl der Stockwerke',
          noData: 'Keine Immobilieneigenschaften verfügbar',
          numberOfFloors: 'Anzahl der Stockwerke',
          performanceMatrix: 'Leistungsmatrix nach Immobilientyp',
          performanceMatrixSubtext: 'Durchschnittliche Fläche vs Durchschnittspreis',
          transactions: 'Transaktionen',
        },
        seasonalPatterns: {
          averageTransactionCount: 'Durchschnittliche Transaktionsanzahl',
          month: 'Monat',
          monthlyActivity: 'Monatliche Transaktionsaktivität',
          monthlyActivitySubtext: 'Volumen- und Werttrends nach Monat',
          noData: 'Keine saisonalen Musterdaten verfügbar',
          quarterlyComparison: 'Quartalsvergleich',
          quarterlyComparisonSubtext: 'Transaktionsvolumen nach Quartal',
          seasonalPatterns: 'Saisonale Muster',
          seasonalPatternsSubtext: 'Durchschnittliche Aktivität nach Monat über alle Jahre',
          totalValue: 'Gesamtwert',
          transactionCount: 'Anzahl der Transaktionen',
          transactions: 'Transaktionen',
        },
        transactionTypes: {
          averageValue: 'Durchschnittswert',
          distributionTitle: 'Verteilung nach Transaktionsart',
          dominantType: 'Dominanter Typ',
          totalTransactions: 'Gesamttransaktionen',
          totalVolume: 'Gesamtvolumen',
          trendsTitle: 'Zeitliche Entwicklung',
        },
        unitComposition: {
          averageArea: 'Durchschnittliche Fläche',
          noData: 'Keine Einheitenzusammensetzungsdaten verfügbar',
          numberOfRooms: 'Anzahl der Räume',
          numberOfUnits: 'Anzahl der Einheiten',
          room: 'Raum',
          roomDistribution: 'Raumverteilung',
          roomDistributionSubtext: 'Anzahl der Einheiten nach Raumanzahl',
          rooms: 'Räume',
          units: 'Einheiten',
          unitTypeComposition: 'Zusammensetzung nach Einheitentyp',
          unitTypeCompositionSubtext: 'Grösse = Anzahl der Einheiten, Farbe = durchschnittliche Fläche',
        },
      },
      description: 'Transaktionsstatistiken und -analysen werden hier bald verfügbar sein.',
      errors: {
        loadFailed: 'Laden der Statistiken fehlgeschlagen',
        loginRequired: 'Bitte melden Sie sich an, um Transaktionsstatistiken anzuzeigen',
        noData: 'Keine Daten für die ausgewählten Kriterien verfügbar',
        noTransactionData: 'Keine Transaktionsdaten verfügbar',
        retryError: 'Laden der Statistiken fehlgeschlagen. Bitte versuchen Sie es erneut.',
      },
      indicators: {
        allProperties: 'Alle Immobilien',
        allSwitzerland: 'Ganze Schweiz',
        location: 'Standort',
        type: 'Typ',
      },
      periods: {
        all: 'Vollständiger Verlauf',
        last12Months: 'Letzte 12 Monate',
        since2022: 'Seit Januar 2022',
      },
      sections: {
        geographicDistribution: {
          description: 'Erkunden Sie Transaktionsmuster in verschiedenen Regionen und Gemeinden.',
          title: 'Geografische Verteilung',
        },
        inheritanceAnalysis: {
          description: 'Analysieren Sie Erbschafts-, Schenkungs- und Vermögensübertragungsmuster einschliesslich Flussanalyse und Eigentumsanteilen.',
          title: 'Erbschaft und Vermögensübertragung',
        },
        marketTiming: {
          description: 'Analysieren Sie Publikationsverzögerung, Marktaktivitätsmuster und Transaktionsgeschwindigkeit im Zeitverlauf.',
          title: 'Markttiming und Geschwindigkeit',
        },
        participantDemographics: {
          description: 'Verstehen Sie Käufer- und Verkäuferprofile, Demografie und Transaktionsmuster.',
          title: 'Teilnehmerdemografie',
        },
        priceDynamics: {
          description: 'Verfolgen Sie wichtige Preismetriken einschliesslich durchschnittlicher Transaktionspreise, Preis pro Quadratmeter und Marktvolumentrends.',
          title: 'Preisdynamik',
        },
        propertyCharacteristics: {
          description: 'Analysieren Sie Immobilientypen, Gebäudekomplexität, Einheitenverteilung und physische Eigenschaften.',
          title: 'Immobilieneigenschaften',
        },
        seasonalPatterns: {
          description: 'Erkunden Sie saisonale Trends, monatliche Aktivitätsmuster und Quartalsvergleiche im Zeitverlauf.',
          title: 'Saisonale und zeitliche Muster',
        },
        transactionTypes: {
          description: 'Analysieren Sie die Verteilung verschiedener Transaktionsarten, um Marktdynamik und -muster zu verstehen.',
          title: 'Transaktionsarten',
        },
        unitComposition: {
          description: 'Erkunden Sie Einheitentypen, Raumverteilung und Etagenanalyse von Wohnimmobilien.',
          title: 'Einheitenzusammensetzung',
        },
      },
    },
    subtitle: 'Historische Immobilientransaktionen im Quartier gefunden',
    title: 'Transaktionen',
    tooltip: {
      additionalProperties: '(+{{count}} Immobilien)',
      area: 'Fläche',
      buyersSellers: '{{buyers}} Käufer / {{sellers}} Verkäufer',
      date: 'Datum',
      parcel: 'Parzelle {{code}} {{city}}',
      parties: 'Parteien',
      price: 'Preis',
      pricePerM2: 'Preis/m²',
      properties: '{{count}} Immobilien',
      property: '1 Immobilie',
      transactionNumber: 'Transaktion Nr. {{id}}',
      type: 'Typ',
      unknownLocation: 'Unbekannter Standort',
    },
    transactionTypes: {
      abandon: 'Verzicht',
      'abandon-cession': 'Verzicht / Abtretung',
      absorption: 'Absorption',
      achat: 'Kauf',
      'achat cession': 'Kauf / Abtretung',
      'achat et cession': 'Kauf / Abtretung',
      'achat et donation-achat': 'Kauf / Schenkung',
      'achat et partage': 'Kauf / Teilung',
      'achat partiel': 'Kauf / Teilweise',
      'achat*': 'Kauf',
      'achat*-achat': 'Kauf',
      'achat*-cession': 'Kauf / Abtretung',
      'achat*-complement-de-prix': 'Kauf / Preisergänzung',
      'achat*-rectification': 'Kauf / Berichtigung',
      'achat*-vente': 'Kauf / Verkauf',
      'achat-a': 'Kauf',
      'achat-ac': 'Kauf',
      'achat-ach': 'Kauf',
      'achat-acha': 'Kauf',
      'achat-acha-achat': 'Kauf',
      'achat-attribution': 'Kauf / Zuweisung',
      'achat-attribution-partage': 'Kauf / Zuweisung / Teilung',
      'achat-cession': 'Kauf / Abtretung',
      'achat-cession en lieu de partage': 'Kauf / Abtretung anstelle einer Teilung',
      'achat-cession-achat': 'Kauf / Abtretung',
      'achat-cession-partage': 'Kauf / Abtretung / Teilung',
      'achat-cession-succession': 'Kauf / Abtretung / Erbfolge',
      'achat-cessions et achat': 'Kauf / Abtretung',
      'achat-changement de regime': 'Kauf / Wechsel des Güterstands',
      'achat-changement de regime-achat': 'Kauf / Wechsel des Güterstands',
      'achat-constitution de parts de copropriété et attribution de part': 'Kauf / Begründung / Anteile / Miteigentum / Zuweisung',
      'achat-constitution de ppe': 'Kauf / Begründung / PPE',
      'achat-constitution de ppe et attribution de lot': 'Kauf / Begründung / PPE / Zuweisung / Lose',
      'achat-delivrance de legs': 'Kauf / Vermächtniserfüllung',
      'achat-division de bien-fonds': 'Kauf / Teilung / Grundstück',
      'achat-division de bien-fonds-succession': 'Kauf / Teilung / Grundstück / Erbfolge',
      'achat-dona': 'Kauf / Schenkung',
      'achat-donation': 'Kauf / Schenkung',
      'achat-donation mixte': 'Kauf / Gemischte Schenkung',
      'achat-donation-cession': 'Kauf / Schenkung / Abtretung',
      "achat-donation-modification d'intitule": 'Kauf / Schenkung / Änderung der Bezeichnung',
      'achat-donation-realisation forcee': 'Kauf / Schenkung / Zwangsverwertung',
      'achat-donation-succession': 'Kauf / Schenkung / Erbfolge',
      'achat-echange': 'Kauf / Tausch',
      'achat-echange-cession': 'Kauf / Tausch / Abtretung',
      'achat-expropriation': 'Kauf / Enteignung',
      'achat-fusion': 'Kauf / Fusion',
      'achat-fusion-succession': 'Kauf / Fusion / Erbfolge',
      'achat-groupement de bien-fonds': 'Kauf / Zusammenlegung / Grundstück',
      'achat-immatriculation de ddp-succession et partage-succession': 'Kauf / Eintragung / DDP / Erbfolge / Teilung',
      'achat-modification d intitule': 'Kauf / Änderung der Bezeichnung',
      "achat-modification d'intitule": 'Kauf / Änderung der Bezeichnung',
      "achat-modification d'intitule-donation": 'Kauf / Änderung der Bezeichnung / Schenkung',
      "achat-modification d'intitule-transfert": 'Kauf / Änderung der Bezeichnung / Übertragung',
      'achat-modification dintitule': 'Kauf / Änderung der Bezeichnung',
      'achat-modification dintitule-donation': 'Kauf / Änderung der Bezeichnung / Schenkung',
      'achat-octroi': 'Kauf / Gewährung',
      'achat-partage': 'Kauf / Teilung',
      'achat-partage-succession': 'Kauf / Teilung / Erbfolge',
      'achat-partages': 'Kauf / Teilung',
      'achat-radiation du ddp': 'Kauf / Löschung / DDP',
      'achat-realisation forcee': 'Kauf / Zwangsverwertung',
      'achat-rectificatif': 'Kauf / Berichtigung',
      'achat-rectification-de-l-affaire': 'Kauf / Berichtigung / Sache',
      'achat-remaniement parcellaire': 'Kauf / Umlegung',
      'achat-succession': 'Kauf / Erbfolge',
      'achat-succession et partage': 'Kauf / Erbfolge / Teilung',
      'achat-succession-achat': 'Kauf / Erbfolge',
      'achat-succession-cession': 'Kauf / Erbfolge / Abtretung',
      'achat-succession-cessions': 'Kauf / Erbfolge / Abtretung',
      'achat-succession-changement de regime': 'Kauf / Erbfolge / Wechsel des Güterstands',
      'achat-succession-donation': 'Kauf / Erbfolge / Schenkung',
      "achat-succession-modification d'intitule": 'Kauf / Erbfolge / Änderung der Bezeichnung',
      'achat-succession-partage': 'Kauf / Erbfolge / Teilung',
      'achat-transfert': 'Kauf / Übertragung',
      'achat-transfert de part indivise': 'Kauf / Übertragung / Ideeller Anteil',
      'achat-transfert-donation': 'Kauf / Übertragung / Schenkung',
      'achat-transfert-succession': 'Kauf / Übertragung / Erbfolge',
      'achat-vente': 'Kauf / Verkauf',
      acquisition: 'Erwerb',
      'acquisition-de-bien-sans-maitre': 'Erwerb / Herrenloses Gut',
      'acte rectificatif': 'Berichtigungsurkunde',
      adjducation: 'Zuschlag',
      adjucation: 'Zuschlag',
      adjudication: 'Zuschlag',
      'adjudication-achat': 'Zuschlag / Kauf',
      'adjudication-volontaire': 'Freiwilliger Zuschlag',
      adjuducation: 'Zuschlag',
      adjuidication: 'Zuschlag',
      administrative: 'Verwaltung',
      'adoption-du-contrat-de-communaute-universelle-des-biens': 'Übernahme / Vertrag / Universelle Gütergemeinschaft',
      'adoption-du-regime-matrimonial-de-la-communaute-universelle': 'Übernahme / Güterstand / Universelle Gütergemeinschaft',
      affectation: 'Widmung',
      all: 'Alle Arten',
      annulation: 'Aufhebung',
      'annulation-achat': 'Aufhebung / Kauf',
      apport: 'Einlage',
      'apport-depot': 'Einlage / Hinterlegung',
      'apport-donation': 'Einlage / Schenkung',
      'apport-dotation': 'Einlage / Ausstattung',
      'apport-en-nature': 'Sacheinlage',
      "apport-modification d'intitule": 'Einlage / Änderung der Bezeichnung',
      'apres-fusion': 'Nach Fusion',
      attribution: 'Zuweisung',
      'attribution de bien-fonds': 'Zuweisung / Grundstück',
      'attribution de lots': 'Zuweisung / Lose',
      'attribution de parts-succession-changement de régime et délivrance de legs': 'Zuweisung / Anteile / Erbfolge / Wechsel des Güterstands / Vermächtniserfüllung',
      'attribution-a-titre-de-partage': 'Zuweisung / Als Teilung',
      'attribution-cession': 'Zuweisung / Abtretung',
      'attribution-de-lots': 'Zuweisung / Lose',
      'attribution-de-parts': 'Zuweisung / Anteile',
      'attribution-donation': 'Zuweisung / Schenkung',
      'attribution-donation-cession': 'Zuweisung / Schenkung / Abtretung',
      'attribution-gratuite': 'Zuweisung / Unentgeltlich',
      'attribution-jugement': 'Zuweisung / Urteil',
      'attribution-liquidation-du-regime-matrimonial': 'Zuweisung / Liquidation des Güterstands',
      'attribution-partage': 'Zuweisung / Teilung',
      'attribution-partage-cession': 'Zuweisung / Teilung / Abtretung',
      'attribution-rectification': 'Zuweisung / Berichtigung',
      'attribution-sans-soulte': 'Zuweisung / Ohne Ausgleichszahlung',
      'attribution-suite-a-division': 'Zuweisung / Teilung',
      attributions: 'Zuweisung',
      'attributions-partage': 'Zuweisung / Teilung',
      'cessation-indivision': 'Beendigung / Gesamteigentum',
      cession: 'Abtretung',
      'cession de part indivise': 'Abtretung / Ideeller Anteil',
      'cession de parts': 'Abtretung / Anteile',
      'cession en lieu de partage': 'Abtretung anstelle einer Teilung',
      'cession en lieu de partage et donation': 'Abtretung anstelle einer Teilung / Schenkung',
      'cession en lieu de partage-donation': 'Abtretung anstelle einer Teilung / Schenkung',
      'cession et achat': 'Abtretung / Kauf',
      'cession et changement de regime': 'Abtretung / Wechsel des Güterstands',
      'cession et donation': 'Abtretung / Schenkung',
      'cession et modification d intitule': 'Abtretung / Änderung der Bezeichnung',
      'cession et modification d intitule cadastral': 'Abtretung / Änderung der Bezeichnung / Katastral',
      "cession et modification d'intitule": 'Abtretung / Änderung der Bezeichnung',
      'cession et partage-partage': 'Abtretung / Teilung',
      'cession-a-titre-d-echange': 'Abtretung als Tausch',
      'cession-a-titre-de-dotation': 'Abtretung / Als Ausstattung',
      'cession-a-titre-de-liquidation-du-regime-matrimonial': 'Abtretung / Titel / Liquidation des Güterstands',
      'cession-a-titre-de-partage': 'Abtretung anstelle einer Teilung',
      'cession-a-titre-de-partage-liquidation-du-regime-matrimonial': 'Abtretung anstelle einer Teilung / Liquidation des Güterstands',
      'cession-a-titre-dechange': 'Abtretung als Tausch',
      'cession-a-titre-gratuit': 'Unentgeltliche Übertragung',
      'cession-a-titre-universel': 'Abtretung / Als Universalsukzession',
      'cession-abandonnements': 'Abtretung / Verzicht',
      'cession-achat': 'Abtretung / Kauf',
      'cession-achat-cession': 'Abtretung / Kauf',
      'cession-achat-changement de régime': 'Abtretung / Kauf / Wechsel des Güterstands',
      'cession-achat-donation': 'Abtretung / Kauf / Schenkung',
      'cession-achat-modification dintitule': 'Abtretung / Kauf / Änderung der Bezeichnung',
      'cession-achat-succession': 'Abtretung / Kauf / Erbfolge',
      'cession-attribution': 'Abtretung / Zuweisung',
      'cession-cession et changement de regime': 'Abtretung / Wechsel des Güterstands',
      "cession-cession et modification d'intitule cadastral": 'Abtretung / Änderung der Bezeichnung / Katastral',
      'cession-changement de regime': 'Abtretung / Wechsel des Güterstands',
      'cession-delivrance de legs': 'Abtretung / Vermächtniserfüllung',
      'cession-desaffectation': 'Abtretung / Entwidmung',
      'cession-division de bien-fonds': 'Abtretung / Teilung / Grundstück',
      'cession-donation': 'Abtretung / Schenkung',
      'cession-donation-achat': 'Abtretung / Schenkung / Kauf',
      'cession-donation-cession': 'Abtretung / Schenkung',
      'cession-donation-succession': 'Abtretung / Schenkung / Erbfolge',
      'cession-dotaion': 'Abtretung / Ausstattung',
      'cession-echange': 'Abtretung / Tausch',
      'cession-echange-gratuit': 'Abtretung / Tausch / Unentgeltlich',
      'cession-echange-partage': 'Abtretung / Tausch / Teilung',
      'cession-en-compensation-de-creance': 'Abtretung / Verrechnung von Forderungen',
      'cession-en-compensation-de-créance': 'Abtretung / Verrechnung von Forderungen',
      'cession-et-donation': 'Abtretung / Schenkung',
      'cession-fixation de parts': 'Abtretung / Festlegung der Anteile',
      'cession-gratuit': 'Unentgeltliche Übertragung',
      'cession-gratuite': 'Unentgeltliche Übertragung',
      'cession-gratuite-a-titre-fiduciaire': 'Unentgeltliche Übertragung / Titel / Treuhänderisch',
      'cession-gratuite-echange': 'Unentgeltliche Übertragung / Tausch',
      'cession-heritage-partage': 'Abtretung / Erbteilung',
      'cession-liquidation de regime matrimonial': 'Abtretung / Liquidation des Güterstands',
      'cession-liquidation du regime matrimonial': 'Abtretung / Liquidation des Güterstands',
      "cession-modification d'intitule": 'Abtretung / Änderung der Bezeichnung',
      'cession-modification dintitule': 'Abtretung / Änderung der Bezeichnung',
      'cession-par-hoirie': 'Abtretung / Erbengemeinschaft',
      'cession-partage': 'Abtretung / Teilung',
      'cession-partage-attribution': 'Abtretung / Teilung / Zuweisung',
      'cession-partage-compensation de creance': 'Abtretung / Teilung / Verrechnung von Forderungen',
      'cession-partage-echange': 'Abtretung / Teilung / Tausch',
      'cession-partage-liquidatio': 'Abtretung / Teilung / Liquidation',
      'cession-partage-liquidation du regime matrimonial': 'Abtretung / Teilung / Liquidation des Güterstands',
      'cession-partage-liquidation-du-regime-matrimonial': 'Abtretung / Teilung / Liquidation des Güterstands',
      'cession-partage-matrimonial': 'Abtretung / Teilung / Güterrechtlich',
      'cession-partge': 'Abtretung / Teilung',
      'cession-realisation forcee': 'Abtretung / Zwangsverwertung',
      'cession-reciproques': 'Abtretung / Gegenseitig',
      'cession-rectificative': 'Abtretung / Berichtigend',
      'cession-remaniement parcellaire': 'Abtretung / Umlegung',
      'cession-succession': 'Abtretung / Erbfolge',
      'cession-succession-achat': 'Abtretung / Erbfolge / Kauf',
      'cession-succession-achat-succession': 'Abtretung / Erbfolge / Kauf',
      'cession-succession-cession-succession-achat': 'Abtretung / Erbfolge / Kauf',
      "cession-succession-modification d'intitule": 'Abtretung / Erbfolge / Änderung der Bezeichnung',
      'cession-succession-partage': 'Abtretung / Erbfolge / Teilung',
      'cession-transfert': 'Abtretung / Übertragung',
      'cession-vente': 'Abtretung / Verkauf',
      cessions: 'Abtretung',
      'cessions-diverses': 'Abtretung / Verschiedene',
      'cessions-gratuites': 'Unentgeltliche Übertragung',
      'cessions-reciproques': 'Abtretung / Gegenseitig',
      'changement de prenom': 'Namensänderung',
      'changement de regime': 'Wechsel des Güterstands',
      'changement de regime et partage-changement de regime': 'Wechsel des Güterstands / Teilung',
      'changement de regime-achat': 'Wechsel des Güterstands / Kauf',
      'changement de regime-achat-cession': 'Wechsel des Güterstands / Kauf / Abtretung',
      'changement de regime-cession': 'Wechsel des Güterstands / Abtretung',
      'changement de regime-delivrance de legs': 'Wechsel des Güterstands / Vermächtniserfüllung',
      'changement de regime-donation': 'Wechsel des Güterstands / Schenkung',
      'changement de regime-donation et changement de regime': 'Wechsel des Güterstands / Schenkung',
      'changement de regime-donation-achat': 'Wechsel des Güterstands / Schenkung / Kauf',
      'changement de regime-echange': 'Wechsel des Güterstands / Tausch',
      'changement de regime-partage': 'Wechsel des Güterstands / Teilung',
      'changement de regime-transfert et changement de regime': 'Wechsel des Güterstands / Übertragung',
      'changement de régime-cession': 'Wechsel des Güterstands / Abtretung',
      'changement-de-regime-achat': 'Wechsel des Güterstands / Kauf',
      compensation: 'Entschädigung',
      'compensation-de-creance': 'Verrechnung von Forderungen',
      'compensation-de-creance-transfert': 'Verrechnung von Forderungen / Übertragung',
      constitution: 'Begründung',
      "constitution d'un ddp": 'Begründung / DDP',
      'constitution de ddp': 'Begründung / DDP',
      'constitution de ddp-donation-achat': 'Begründung / DDP / Schenkung / Kauf',
      'constitution de dependance': 'Begründung / Zugehör',
      'constitution de dependence': 'Begründung / Zugehör',
      'constitution de parts de copropriete': 'Begründung / Anteile / Miteigentum',
      'constitution de parts de copropriete-achat': 'Begründung / Anteile / Miteigentum / Kauf',
      'constitution de parts de copropriete-donation': 'Begründung / Anteile / Miteigentum / Schenkung',
      'constitution de parts de copropriété': 'Begründung / Anteile / Miteigentum',
      'constitution de ppe': 'Begründung / PPE',
      'constitution de ppe-donation': 'Begründung / PPE / Schenkung',
      'constitution de ppe-partage': 'Begründung / PPE / Teilung',
      'constitution de ppe-partage-modification dintitule': 'Begründung / PPE / Teilung / Änderung der Bezeichnung',
      'constitution du ddp': 'Begründung / DDP',
      'constitution ppe-partage': 'Begründung / PPE / Teilung',
      'constitution-ddp': 'Begründung / DDP',
      'constitution-de-ddp': 'Begründung / DDP',
      'constitution-de-ddp-cession': 'Begründung / DDP / Abtretung',
      'constitution-de-dependance': 'Begründung / Zugehör',
      'constitution-du-ddp': 'Begründung / DDP',
      'contrat de mariage': 'Ehevertrag',
      'contrat de mariage-cession': 'Ehevertrag / Abtretung',
      'contrat de mariage-modification du regime matrimonial': 'Ehevertrag / Änderung / Güterstand',
      'contrat-de-mariage': 'Ehevertrag',
      corporate_restructuring: 'Unternehmensumstrukturierung',
      'creation-de-copropriete': 'Begründung / Miteigentum',
      'datation-en-paiement': 'Leistung an Erfüllungs statt',
      dation: 'Leistung an Erfüllungs statt',
      'dation de paiement': 'Leistung an Erfüllungs statt',
      'dation en paiement': 'Leistung an Erfüllungs statt',
      'dation-a-titre-de-paiement': 'Leistung an Erfüllungs statt',
      'dation-de-paiement': 'Leistung an Erfüllungs statt',
      'dation-en-paiement': 'Leistung an Erfüllungs statt',
      'dation-en-paiement-donation': 'Leistung an Erfüllungs statt / Schenkung',
      'delivrance de legs': 'Vermächtniserfüllung',
      'delivrance de legs - succession': 'Vermächtniserfüllung / Erbfolge',
      'delivrance de legs et cessions-changement de regime': 'Vermächtniserfüllung / Abtretung / Wechsel des Güterstands',
      'delivrance de legs et donation': 'Vermächtniserfüllung / Schenkung',
      'delivrance de legs-achat': 'Vermächtniserfüllung / Kauf',
      'delivrance de legs-cession': 'Vermächtniserfüllung / Abtretung',
      'delivrance de legs-changement de regime': 'Vermächtniserfüllung / Wechsel des Güterstands',
      'delivrance de legs-donation': 'Vermächtniserfüllung / Schenkung',
      'delivrance de legs-succession': 'Vermächtniserfüllung / Erbfolge',
      'delivrance de legs-succession-echange': 'Vermächtniserfüllung / Erbfolge / Tausch',
      'delivrance-de-leg': 'Vermächtniserfüllung',
      'delivrance-de-legs': 'Vermächtniserfüllung',
      'delivrance-de-legs-partage': 'Vermächtniserfüllung / Teilung',
      'delivrances-de-legs': 'Vermächtniserfüllung',
      'delivrane-de-legs': 'Vermächtniserfüllung',
      depot: 'Hinterlegung',
      'depot-partage': 'Hinterlegung / Teilung',
      dereliction: 'Dereliktion',
      desaffectation: 'Entwidmung',
      'desaffectation-incorporation': 'Entwidmung / Einverleibung',
      'dissolution-de-lindivision-de-famille': 'Auflösung / Familiengesamteigentum',
      division: 'Teilung',
      'division biens-fonds-achat': 'Teilung / Güter / Grund / Kauf',
      'division de bien-fonds': 'Teilung / Grundstück',
      'division de bien-fonds-achat': 'Teilung / Grundstück / Kauf',
      'division de bien-fonds-achat-achat et groupement de bf-achat': 'Teilung / Grundstück / Kauf / Zusammenlegung',
      'division de bien-fonds-cession': 'Teilung / Grundstück / Abtretung',
      'division de bien-fonds-delivrance de legs-achat': 'Teilung / Grundstück / Vermächtniserfüllung / Kauf',
      'division de bien-fonds-donation': 'Teilung / Grundstück / Schenkung',
      "division de bien-fonds-fusion-echange-achat-modification d'intitule": 'Teilung / Grundstück / Fusion / Tausch / Kauf / Änderung der Bezeichnung',
      'division de bien-fonds-partage': 'Teilung / Grundstück / Teilung',
      'division de bien-fonds/achat': 'Teilung / Grundstück / Kauf',
      'division-et-reunion-d-immeubles': 'Teilung / Vereinigung / Liegenschaften',
      'division-reunion': 'Teilung / Vereinigung',
      donation: 'Schenkung',
      'donation et achat': 'Schenkung / Kauf',
      'donation et cession': 'Schenkung / Abtretung',
      'donation et cession en lieu de partage': 'Schenkung / Abtretung anstelle einer Teilung',
      'donation et cessions': 'Schenkung / Abtretung',
      'donation et changement de regime': 'Schenkung / Wechsel des Güterstands',
      'donation et partage': 'Schenkung / Teilung',
      'donation et partages': 'Schenkung / Teilung',
      'donation mixte': 'Gemischte Schenkung',
      'donation mixte-achat': 'Gemischte Schenkung / Kauf',
      'donation-abandon': 'Schenkung / Verzicht',
      'donation-achat': 'Schenkung / Kauf',
      'donation-achat-changement de regime': 'Schenkung / Kauf / Wechsel des Güterstands',
      'donation-achat-division de bien-fonds': 'Schenkung / Kauf / Teilung / Grundstück',
      'donation-achat-division de bien-fonds-achat': 'Schenkung / Kauf / Teilung / Grundstück',
      'donation-achat-donation': 'Schenkung / Kauf',
      'donation-achat-echange': 'Schenkung / Kauf / Tausch',
      'donation-achat-partage': 'Schenkung / Kauf / Teilung',
      'donation-apport': 'Schenkung / Einlage',
      'donation-attribution': 'Schenkung / Zuweisung',
      'donation-cession': 'Schenkung / Abtretung',
      'donation-cession en lieu de partage': 'Schenkung / Abtretung anstelle einer Teilung',
      "donation-cession-achat-modification d'intitule-rectification": 'Schenkung / Abtretung / Kauf / Änderung der Bezeichnung / Berichtigung',
      'donation-cession-partage': 'Schenkung / Abtretung / Teilung',
      'donation-cession-succession': 'Schenkung / Abtretung / Erbfolge',
      'donation-cession-succession-division de bien-fonds': 'Schenkung / Abtretung / Erbfolge / Teilung / Grundstück',
      'donation-changement de regime': 'Schenkung / Wechsel des Güterstands',
      'donation-changement de regime de propriete': 'Schenkung / Wechsel des Güterstands / Eigentum',
      'donation-changement de regime-achat': 'Schenkung / Wechsel des Güterstands / Kauf',
      'donation-changement de regime-achat-succession': 'Schenkung / Wechsel des Güterstands / Kauf / Erbfolge',
      'donation-changement de regime-succession-achat': 'Schenkung / Wechsel des Güterstands / Erbfolge / Kauf',
      'donation-changement de régime': 'Schenkung / Wechsel des Güterstands',
      'donation-constitution de parts de copropriete': 'Schenkung / Begründung / Anteile / Miteigentum',
      'donation-constitution de ppe': 'Schenkung / Begründung / PPE',
      'donation-constitution de ppe et attribution de lots': 'Schenkung / Begründung / PPE / Zuweisung / Lose',
      'donation-constitution de ppe-donation-donation': 'Schenkung / Begründung / PPE',
      'donation-dissolution de la communaute hereditaire': 'Schenkung / Auflösung / Erbengemeinschaft',
      'donation-div': 'Schenkung / Verschiedene',
      'donation-division de bien-fonds': 'Schenkung / Teilung / Grundstück',
      'donation-dona': 'Schenkung',
      "donation-donat-modification d'intitule": 'Schenkung / Änderung der Bezeichnung',
      'donation-donati': 'Schenkung',
      'donation-echange': 'Schenkung / Tausch',
      'donation-fixation de parts-cession-attribution': 'Schenkung / Festlegung der Anteile / Abtretung / Zuweisung',
      'donation-mixte': 'Gemischte Schenkung',
      "donation-modification d'intitule": 'Schenkung / Änderung der Bezeichnung',
      "donation-modification d'intitulé-achat": 'Schenkung / Änderung der Bezeichnung / Kauf',
      'donation-modification dintitule': 'Schenkung / Änderung der Bezeichnung',
      'donation-nue-propriete': 'Schenkung / Blosses Eigentum',
      'donation-partage': 'Schenkung / Teilung',
      'donation-partage-cession': 'Schenkung / Teilung / Abtretung',
      'donation-partage-changement de regime': 'Schenkung / Teilung / Wechsel des Güterstands',
      'donation-partage-division de bien-fonds-echange': 'Schenkung / Teilung / Teilung / Grundstück / Tausch',
      'donation-partage-succession': 'Schenkung / Teilung / Erbfolge',
      'donation-partage-succession-transfert-achat': 'Schenkung / Teilung / Erbfolge / Übertragung / Kauf',
      'donation-realisation forcee': 'Schenkung / Zwangsverwertung',
      'donation-rectification': 'Schenkung / Berichtigung',
      'donation-succession': 'Schenkung / Erbfolge',
      'donation-succession-achat': 'Schenkung / Erbfolge / Kauf',
      'donation-succession-achat-cession': 'Schenkung / Erbfolge / Kauf / Abtretung',
      'donation-succession-cession-cession en lieu de partage': 'Schenkung / Erbfolge / Abtretung / Abtretung anstelle einer Teilung',
      'donation-succession-cession-partage': 'Schenkung / Erbfolge / Abtretung / Teilung',
      'donation-succession-donation': 'Schenkung / Erbfolge',
      "donation-succession-donation-succession-succession-modification d'intitule": 'Schenkung / Erbfolge / Änderung der Bezeichnung',
      "donation-succession-modification d'intitule": 'Schenkung / Erbfolge / Änderung der Bezeichnung',
      'donation-succession-modification dintitule-transfert-cession-partage-delivrance de legs-achat': 'Schenkung / Erbfolge / Änderung der Bezeichnung / Übertragung / Abtretung / Teilung / Vermächtniserfüllung / Kauf',
      'donation-succession-partage': 'Schenkung / Erbfolge / Teilung',
      'donation-transfert': 'Schenkung / Übertragung',
      'donation-transfert-achat': 'Schenkung / Übertragung / Kauf',
      'donation-transfert-donation': 'Schenkung / Übertragung',
      'donation-vente': 'Schenkung / Verkauf',
      dotation: 'Ausstattung',
      'délivrance de legs': 'Vermächtniserfüllung',
      'délivrance-de-legs': 'Vermächtniserfüllung',
      dérection: 'Dereliktion',
      easement_right: 'Dienstbarkeitsrecht',
      echange: 'Tausch',
      'echange-achat': 'Tausch / Kauf',
      'echange-cession': 'Tausch / Abtretung',
      'echange-cession-partage-achat': 'Tausch / Abtretung / Teilung / Kauf',
      'echange-division de bien-fonds': 'Tausch / Teilung / Grundstück',
      'echange-donation': 'Tausch / Schenkung',
      'echange-donation-succession': 'Tausch / Schenkung / Erbfolge',
      'echange-echan': 'Tausch',
      'echange-gratuit': 'Tausch / Unentgeltlich',
      'echange-partage': 'Tausch / Teilung',
      'echange-partage-cession': 'Tausch / Teilung / Abtretung',
      'echange-rectification': 'Tausch / Berichtigung',
      'echange-succession': 'Tausch / Erbfolge',
      ehevertrag: 'Ehevertrag',
      'encheres volontaires': 'Freiwillige Versteigerung',
      'envoi-en-possession': 'Besitzeinweisung',
      erbschaft: 'Erbschaft',
      'erbschaft-handaenderung': 'Handänderung - Erbschaft',
      'erbschaft-handaenderung-schenkung': 'Erbschaft / Handänderung / Schenkung',
      'erbschaft-liquidation': 'Erbschaft / Liquidation',
      erbteilung: 'Erbteilung',
      eridaenderung: 'Handänderung',
      exchange: 'Tausch',
      "exercice d'emption": 'Ausübung des Kaufrechts',
      'exercice de droit de retour': 'Ausübung des Heimfallrechts',
      'exercice droit de remere': 'Ausübung des Rückkaufsrechts',
      "exercice du droit d'emption": 'Ausübung des Kaufrechts',
      'exercice du droit de preemption': 'Ausübung des Vorkaufsrechts',
      'exercice du droit de preemption legal': 'Ausübung des Vorkaufsrechts / Gesetzlich',
      'exercice du droit de preemption-achat': 'Ausübung des Vorkaufsrechts / Kauf',
      'exercice du droit de préemption': 'Ausübung des Vorkaufsrechts',
      'exercice du droit de remere': 'Ausübung des Rückkaufsrechts',
      'exercice du droit de remere-transfert': 'Ausübung des Rückkaufsrechts / Übertragung',
      'exercice du droit de retour': 'Ausübung des Heimfallrechts',
      'exercice du droit de retour anticipe': 'Ausübung des Heimfallrechts / Vorzeitig',
      'exercice du droit demption': 'Ausübung des Kaufrechts',
      'exercice-d-un-droit-de-remere': 'Ausübung des Rückkaufsrechts',
      'exercice-de-droit-de-preemption': 'Ausübung des Vorkaufsrechts',
      'exercice-de-droit-de-remere': 'Ausübung des Rückkaufsrechts',
      'exercice-de-droit-preemption': 'Ausübung des Vorkaufsrechts',
      'exercice-demption': 'Ausübung des Kaufrechts',
      'exercice-demption-vente': 'Ausübung des Kaufrechts / Verkauf',
      'exercice-droit-de-preemption': 'Ausübung des Vorkaufsrechts',
      'exercice-droit-de-remere': 'Ausübung des Rückkaufsrechts',
      'exercice-droit-remere': 'Ausübung des Rückkaufsrechts',
      'exercice-dts-demption-reciproques': 'Ausübung des Kaufrechts / Gegenseitig',
      'exercice-du-droit-de-preemption': 'Ausübung des Vorkaufsrechts',
      'exercice-du-droit-de-preemption-rectification': 'Ausübung des Vorkaufsrechts / Berichtigung',
      'exercice-du-droit-de-remere': 'Ausübung des Rückkaufsrechts',
      'exercice-du-droit-de-retour': 'Ausübung des Heimfallrechts',
      'exercice-du-droit-de-retour-donation': 'Ausübung des Heimfallrechts / Schenkung',
      'exercice-du-droit-de-retour-transfert': 'Ausübung des Heimfallrechts / Übertragung',
      'exercice-du-droit-demption': 'Ausübung des Kaufrechts',
      'exercice-du-droit-demption-achat': 'Ausübung des Kaufrechts / Kauf',
      'exercice-preemption': 'Ausübung des Vorkaufsrechts',
      'exercice-remere': 'Ausübung des Rückkaufsrechts',
      expropriation: 'Enteignung',
      'expropriation-incorporation': 'Enteignung / Einverleibung',
      'fixation de part': 'Festlegung der Anteile',
      'fixation de parts': 'Festlegung der Anteile',
      'fixation de parts-liquidation de regime matrimonial': 'Festlegung der Anteile / Liquidation des Güterstands',
      'fixation de parts-partage': 'Festlegung der Anteile / Teilung',
      'fixation des parts': 'Festlegung der Anteile',
      'fixation-de-part': 'Festlegung der Anteile',
      'fixation-de-parts': 'Festlegung der Anteile',
      'fixation-de-parts-de-lhoirie': 'Festlegung der Anteile / Erbengemeinschaft',
      'fixation-de-parts-partage': 'Festlegung der Anteile / Teilung',
      'fixation-des-parts': 'Festlegung der Anteile',
      'fixations de parts': 'Festlegung der Anteile',
      'fixations-de-parts': 'Festlegung der Anteile',
      'fixations-des-parts-partage': 'Festlegung der Anteile / Teilung',
      forced_sale: 'Zwangsverkauf',
      fusion: 'Fusion',
      'fusion-achat': 'Fusion / Kauf',
      'fusion-par-absorption': 'Fusion durch Absorption',
      gratuit: 'Unentgeltlich',
      gratuite: 'Unentgeltlich',
      'gratuite-et-reciproque': 'Unentgeltlich und gegenseitig',
      gratuitous_transfer: 'Unentgeltliche Übertragung',
      'groupement de bien-fonds': 'Zusammenlegung / Grundstück',
      handaenderung: 'Handänderung',
      'handaenderung-erbschaft': 'Handänderung - Erbschaft',
      'handaenderung-schenkung': 'Handänderung - Schenkung',
      handoenderung: 'Handänderung',
      'hdlnd änderung': 'Handänderung',
      heretage: 'Erbschaft',
      heritage: 'Erbschaft',
      'heritage-cession': 'Erbschaft / Abtretung',
      'heritage-cession-partage': 'Erbschaft / Abtretung / Teilung',
      'heritage-delivrance de legs': 'Erbschaft / Vermächtniserfüllung',
      'heritage-delivrance de legs-partage': 'Erbschaft / Vermächtniserfüllung / Teilung',
      'heritage-delivrance-de-legs': 'Erbschaft / Vermächtniserfüllung',
      'heritage-depot': 'Erbschaft / Hinterlegung',
      'heritage-donation-partage': 'Erbschaft / Schenkung / Teilung',
      'heritage-fixation de parts-partage': 'Erbschaft / Festlegung der Anteile / Teilung',
      'heritage-fixation-de-parts': 'Erbschaft / Festlegung der Anteile',
      'heritage-paratge': 'Erbteilung',
      'heritage-partage': 'Erbteilung',
      'heritage-partage-achat': 'Erbteilung / Kauf',
      'heritage-partage-attribution': 'Erbteilung / Zuweisung',
      'heritage-partage-cession': 'Erbteilung / Abtretung',
      'heritage-partage-cession-donation': 'Erbteilung / Abtretung / Schenkung',
      'heritage-partage-donation': 'Erbteilung / Schenkung',
      'heritage-partage-fixation-de-parts': 'Erbteilung / Festlegung der Anteile',
      'heritage-partage-liquidation du regime matrimonial': 'Erbteilung / Liquidation des Güterstands',
      'heritage-partgae': 'Erbteilung',
      hoirie: 'Erbengemeinschaft',
      héritage: 'Erbschaft',
      'héritage-partage': 'Erbteilung',
      'héritage-partage-attribution-donation': 'Erbteilung / Zuweisung / Schenkung',
      immatriculation: 'Eintragung',
      'immatriculation de ddp': 'Eintragung / DDP',
      'immatriculation de ddp-achat': 'Eintragung / DDP / Kauf',
      'immeubles-radies-immeuble-cree': 'Löschung von Liegenschaften, Erstellung eines Gebäudes',
      incorporation: 'Einverleibung',
      'indivision de famille': 'Familiengesamteigentum',
      'indivision-de-famille': 'Familiengesamteigentum',
      inheritance: 'Erbschaft',
      judgment: 'Urteil',
      jugement: 'Urteil',
      'jugement-achat': 'Urteil / Kauf',
      'jugement-attribution': 'Urteil / Zuweisung',
      'jugement-de-divorce': 'Scheidungsurteil',
      'jugement-liquidation-du-regime-matrimonial': 'Urteil / Liquidation des Güterstands',
      kauf: 'Kauf',
      legat: 'Vermächtnis',
      liquidation: 'Liquidation',
      "liquidation de l'indivision": 'Liquidation / Gesamteigentum',
      'liquidation de regime': 'Liquidation des Güterstands',
      'liquidation de regime matrimonial': 'Liquidation des Güterstands',
      'liquidation de regime matrimonial-partage': 'Liquidation des Güterstands / Teilung',
      'liquidation du regime matrimonial': 'Liquidation des Güterstands',
      'liquidation du regime matrimonial-attribution': 'Liquidation des Güterstands / Zuweisung',
      'liquidation du regime matrimonial-cession': 'Liquidation des Güterstands / Abtretung',
      'liquidation du regime matrimonial-cession-partage': 'Liquidation des Güterstands / Abtretung / Teilung',
      'liquidation du regime matrimonial-compensation de creance': 'Liquidation des Güterstands / Verrechnung von Forderungen',
      'liquidation du regime matrimonial-heritage': 'Liquidation des Güterstands / Erbschaft',
      'liquidation du regime matrimonial-heritage-partage-donation': 'Liquidation des Güterstands / Erbteilung / Schenkung',
      'liquidation du regime matrimonial-jugement': 'Liquidation des Güterstands / Urteil',
      'liquidation du regime matrimonial-partage': 'Liquidation des Güterstands / Teilung',
      'liquidation du regime matrimonial-transfert': 'Liquidation des Güterstands / Übertragung',
      'liquidation du regime matrimoniale': 'Liquidation des Güterstands',
      'liquidation du regimen matrimonial': 'Liquidation des Güterstands',
      'liquidation du régime matrimonial': 'Liquidation des Güterstands',
      'liquidation regime matrimonial': 'Liquidation des Güterstands',
      'liquidation-de-la-societe-simple': 'Liquidation / Einfache Gesellschaft',
      'liquidation-de-lindivision': 'Liquidation / Gesamteigentum',
      'liquidation-de-lindivision-de-famille': 'Liquidation / Familiengesamteigentum',
      'liquidation-de-regime-matrimonial': 'Liquidation des Güterstands',
      'liquidation-de-regime-matrimonial-partage': 'Liquidation des Güterstands / Teilung',
      'liquidation-du-regime-de-la-participation-aux-acquets': 'Liquidation des Güterstands / Errungenschaftsbeteiligung',
      'liquidation-du-regime-matrimonial': 'Liquidation des Güterstands',
      'liquidation-du-regime-matrimonial-cession': 'Liquidation des Güterstands / Abtretung',
      'liquidation-du-regime-matrimonial-partage': 'Liquidation des Güterstands / Teilung',
      'liquidation-erbschaft': 'Liquidation / Erbschaft',
      'liquidation-indivision-de-famille': 'Liquidation / Familiengesamteigentum',
      'liquidation-indivision-famille': 'Liquidation / Familiengesamteigentum',
      'liquidation-partielle-de-regime-matrimoniale': 'Teilweise Liquidation des Güterstands',
      'liquidation-regime-matrimonial': 'Liquidation des Güterstands',
      'liquidation-societe-simple-partage': 'Liquidation / Einfache Gesellschaft / Teilung',
      marital_regime: 'Güterstand',
      'mise-en-ppe': 'Umwandlung in Stockwerkeigentum',
      'mission-permanente': 'Auftrag / Dauernd',
      mixed: 'Gemischt',
      modification: 'Änderung',
      'modification d intitule': 'Änderung der Bezeichnung',
      'modification d intitule-achat': 'Änderung der Bezeichnung / Kauf',
      'modification d intitule-donation': 'Änderung der Bezeichnung / Schenkung',
      "modification d'intitule": 'Änderung der Bezeichnung',
      "modification d'intitule - partage": 'Änderung der Bezeichnung / Teilung',
      "modification d'intitule et transfert": 'Änderung der Bezeichnung / Übertragung',
      "modification d'intitule-achat": 'Änderung der Bezeichnung / Kauf',
      "modification d'intitule-cession": 'Änderung der Bezeichnung / Abtretung',
      "modification d'intitule-cession-donation": 'Änderung der Bezeichnung / Abtretung / Schenkung',
      "modification d'intitule-donation": 'Änderung der Bezeichnung / Schenkung',
      "modification d'intitule-donation-succession": 'Änderung der Bezeichnung / Schenkung / Erbfolge',
      "modification d'intitule-fusion": 'Änderung der Bezeichnung / Fusion',
      "modification d'intitule-jugement": 'Änderung der Bezeichnung / Urteil',
      "modification d'intitule-modification de ppe-cession": 'Änderung der Bezeichnung / Änderung / PPE / Abtretung',
      "modification d'intitule-succession-donation de part indivise": 'Änderung der Bezeichnung / Erbfolge / Schenkung / Ideeller Anteil',
      "modification d'intitule-transfert": 'Änderung der Bezeichnung / Übertragung',
      'modification d_intitule-achat': 'Änderung der Bezeichnung / Kauf',
      'modification de copropriete': 'Änderung / Miteigentum',
      'modification de ddp': 'Änderung / DDP',
      'modification de dependance': 'Änderung / Zugehör',
      'modification de ppe-cession': 'Änderung / PPE / Abtretung',
      'modification dintitule': 'Änderung der Bezeichnung',
      'modification dintitule-donation': 'Änderung der Bezeichnung / Schenkung',
      'modification dintitule-transfert': 'Änderung der Bezeichnung / Übertragung',
      'modification du type de communaute': 'Änderung / Art der Gütergemeinschaft',
      'modification-de-ddp': 'Änderung / DDP',
      'modification-de-dependance': 'Änderung / Zugehör',
      'modification-de-lindivision-de-famille': 'Änderung / Familiengesamteigentum',
      'modification-de-parts': 'Änderung / Anteile',
      'modification-de-ppe': 'Änderung / PPE',
      'modification-de-regime-de-propriete': 'Änderung / Eigentumsregime',
      'modification-de-siege': 'Änderung / Sitz',
      'modification-dintitule-achat': 'Änderung der Bezeichnung / Kauf',
      'modification-du-prix': 'Änderung / Preis',
      'modification-du-regime-matrimonial': 'Änderung / Güterstand',
      'modification-du-type-de-communaute': 'Änderung / Art der Gütergemeinschaft',
      'modification-etat-civil': 'Änderung / Zivilstand',
      other: 'Sonstige',
      others: 'Sonstige',
      'par-absorption': 'Absorption',
      paratge: 'Teilung',
      partage: 'Teilung',
      'partage et achat': 'Teilung / Kauf',
      'partage et cession': 'Teilung / Abtretung',
      'partage et changement de regime': 'Teilung / Wechsel des Güterstands',
      'partage et changement de regime-donation': 'Teilung / Wechsel des Güterstands / Schenkung',
      'partage et donation': 'Teilung / Schenkung',
      "partage et modification d'intitule": 'Teilung / Änderung der Bezeichnung',
      'partage et modification de regime': 'Teilung / Änderung / Güterstand',
      'partage successoral': 'Erbteilung',
      'partage-achat': 'Teilung / Kauf',
      'partage-achat-delivrance de legs': 'Teilung / Kauf / Vermächtniserfüllung',
      'partage-achat-donation': 'Teilung / Kauf / Schenkung',
      'partage-achat-remaniement parcellaire privé': 'Teilung / Kauf / Umlegung / Privat',
      'partage-achat-succession': 'Teilung / Kauf / Erbfolge',
      'partage-anticipe': 'Vorzeitige Teilung',
      'partage-attibution': 'Teilung / Zuweisung',
      'partage-attribution': 'Teilung / Zuweisung',
      'partage-attribution-cession': 'Teilung / Zuweisung / Abtretung',
      'partage-attribution-dation': 'Teilung / Zuweisung / Leistung an Erfüllungs statt',
      'partage-attribution-donation': 'Teilung / Zuweisung / Schenkung',
      'partage-attribution-liquidation-du-regime-matrimonial': 'Teilung / Zuweisung / Liquidation des Güterstands',
      'partage-attributions': 'Teilung / Zuweisung',
      'partage-cession': 'Teilung / Abtretung',
      'partage-cession-attribution': 'Teilung / Abtretung / Zuweisung',
      'partage-cession-en-compensation-de-creance': 'Teilung / Abtretung / Verrechnung von Forderungen',
      'partage-changement de regime': 'Teilung / Wechsel des Güterstands',
      'partage-changement de regime-achat-donation': 'Teilung / Wechsel des Güterstands / Kauf / Schenkung',
      'partage-compensation-de-creance': 'Teilung / Verrechnung von Forderungen',
      'partage-constitution de ppe-succession': 'Teilung / Begründung / PPE / Erbfolge',
      'partage-dation': 'Teilung / Leistung an Erfüllungs statt',
      'partage-de-liquidation-de-communaute-hereditare': 'Teilung / Liquidation / Erbengemeinschaft',
      'partage-delivrance de legs': 'Teilung / Vermächtniserfüllung',
      'partage-delivrance-de-legs': 'Teilung / Vermächtniserfüllung',
      'partage-division de bien-fonds': 'Teilung / Teilung / Grundstück',
      'partage-division et groupement de bien-fonds avec partage': 'Teilung / Teilung / Zusammenlegung / Grundstück',
      'partage-donation': 'Teilung / Schenkung',
      'partage-donation-achat': 'Teilung / Schenkung / Kauf',
      'partage-donation-achat-succession': 'Teilung / Schenkung / Kauf / Erbfolge',
      'partage-donation-changement de regime': 'Teilung / Schenkung / Wechsel des Güterstands',
      'partage-donation-succession': 'Teilung / Schenkung / Erbfolge',
      'partage-echange': 'Teilung / Tausch',
      'partage-et-attribution': 'Teilung / Zuweisung',
      'partage-expropriation-achat': 'Teilung / Enteignung / Kauf',
      'partage-fixation de parts': 'Teilung / Festlegung der Anteile',
      'partage-fixation-de-part': 'Teilung / Festlegung der Anteile',
      'partage-fixation-de-parts': 'Teilung / Festlegung der Anteile',
      'partage-fixation-de-parts-liquidation-de-communaute-hereditaire': 'Teilung / Festlegung der Anteile / Liquidation / Erbengemeinschaft',
      'partage-fixation-des-parts': 'Teilung / Festlegung der Anteile',
      'partage-liquidation du regime matrimonial': 'Teilung / Liquidation des Güterstands',
      'partage-liquidation indivision de famille': 'Teilung / Liquidation / Familiengesamteigentum',
      'partage-liquidation-du-regime-matrimonial': 'Teilung / Liquidation des Güterstands',
      'partage-matrimonial-partiel': 'Teilung / Güterrechtlich / Teilweise',
      "partage-modification d'intitule": 'Teilung / Änderung der Bezeichnung',
      "partage-modification d'intitule-succession": 'Teilung / Änderung der Bezeichnung / Erbfolge',
      'partage-partiel': 'Teilweise Teilung',
      'partage-rectification': 'Teilung / Berichtigung',
      'partage-succession': 'Teilung / Erbfolge',
      'partage-succession et partage': 'Teilung / Erbfolge',
      'partage-succession-achat': 'Teilung / Erbfolge / Kauf',
      'partage-succession-achat-transfert': 'Teilung / Erbfolge / Kauf / Übertragung',
      'partage-succession-delivrance de legs': 'Teilung / Erbfolge / Vermächtniserfüllung',
      'partage-transfert': 'Teilung / Übertragung',
      partahe: 'Teilung',
      partition: 'Teilung',
      preemption: 'Vorkauf',
      'prescription-acquisitive': 'Ersitzung',
      'realisation forcee': 'Zwangsverwertung',
      "realisation forcee et modification d'intitule": 'Zwangsverwertung / Änderung der Bezeichnung',
      'realisation forcee-cession': 'Zwangsverwertung / Abtretung',
      'realisation forcee-donation': 'Zwangsverwertung / Schenkung',
      'realisation-forcee': 'Zwangsverwertung',
      rectification: 'Berichtigung',
      'rectification-de-limite': 'Grenzberichtigung',
      'rectification-de-limites': 'Grenzberichtigung',
      'rectification-de-prix': 'Berichtigung / Preis',
      'rectification-par-jugement': 'Berichtigung / Urteil',
      'regime-matrimonial': 'Güterstand',
      'remaniement parcellaire': 'Umlegung',
      'remaniement parcellaire-cession': 'Umlegung / Abtretung',
      'remaniement parcellaire-delivrance de legs': 'Umlegung / Vermächtniserfüllung',
      'remaniement parcellaire-donation': 'Umlegung / Schenkung',
      'remaniement-parcellaire-cession': 'Umlegung / Abtretung',
      reprise: 'Übernahme',
      'reprise-de-bien-effective': 'Übernahme / Gut / Effektiv',
      "requête-vente d'appartement": 'Antrag auf Wohnungsverkauf',
      "requête-vente d'appartement-abandonne": 'Antrag auf Wohnungsverkauf / Aufgegeben',
      "requête-vente d'appartement-accepte": 'Antrag auf Wohnungsverkauf / Akzeptiert',
      "requête-vente d'appartement-archive": 'Antrag auf Wohnungsverkauf / Archiviert',
      "requête-vente d'appartement-autorisation annulee": 'Antrag auf Wohnungsverkauf / Bewilligung annulliert',
      "requête-vente d'appartement-ediscan": 'Antrag auf Wohnungsverkauf / eDiscan',
      "requête-vente d'appartement-en suspens": 'Antrag auf Wohnungsverkauf / Hängig',
      "requête-vente d'appartement-enregistre": 'Antrag auf Wohnungsverkauf / Eingetragen',
      "requête-vente d'appartement-enregistrement": 'Antrag auf Wohnungsverkauf / Registrierung',
      "requête-vente d'appartement-non assujetti": 'Antrag auf Wohnungsverkauf / Nicht steuerpflichtig',
      "requête-vente d'appartement-recours": 'Antrag auf Wohnungsverkauf / Beschwerde',
      "requête-vente d'appartement-refuse": 'Antrag auf Wohnungsverkauf / Abgelehnt',
      "requête-vente d'appartement-termine": 'Antrag auf Wohnungsverkauf / Abgeschlossen',
      "requête-vente d'appartement-va": 'Antrag auf Wohnungsverkauf / VA',
      'retour anticipe': 'Heimfall / Vorzeitig',
      retrocession: 'Rückübertragung',
      'revocation-de-donation': 'Widerruf / Schenkung',
      sale: 'Verkauf',
      schenkung: 'Schenkung',
      'schenkung-handaenderung': 'Schenkung / Handänderung',
      scission: 'Spaltung',
      'scission-par-separation': 'Spaltung / Trennung',
      soulte: 'Ausgleichszahlung',
      'substitution-dacquereur': 'Substitution des Erwerbers',
      'substitution-fedeicommissaire': 'Fideikommissarische Substitution',
      'substitution-fideicommissaire': 'Fideikommissarische Substitution',
      succession: 'Erbfolge',
      'succession de legs': 'Erbfolge / Vermächtnis',
      'succession de legs-achat': 'Erbfolge / Vermächtnis / Kauf',
      'succession de legs-partage': 'Erbfolge / Vermächtnis / Teilung',
      'succession de legs-succession': 'Erbfolge / Vermächtnis',
      'succession et cession': 'Erbfolge / Abtretung',
      'succession et cession en lieu de partage': 'Erbfolge / Abtretung anstelle einer Teilung',
      'succession et cession-achat': 'Erbfolge / Abtretung / Kauf',
      'succession et delivrance de legs': 'Erbfolge / Vermächtniserfüllung',
      'succession et modification de regime': 'Erbfolge / Änderung / Güterstand',
      'succession et partage': 'Erbfolge / Teilung',
      'succession et partage-modification d’intitulé': 'Erbfolge / Teilung / Änderung der Bezeichnung',
      'succession et partage-succession': 'Erbfolge / Teilung',
      'succession et partages-donation': 'Erbfolge / Teilung / Schenkung',
      'succession-achat': 'Erbfolge / Kauf',
      "succession-achat-modification d'intitule": 'Erbfolge / Kauf / Änderung der Bezeichnung',
      'succession-achat-remaniement parcellaire': 'Erbfolge / Kauf / Umlegung',
      'succession-achat-succession': 'Erbfolge / Kauf',
      'succession-cession': 'Erbfolge / Abtretung',
      'succession-cession de parts': 'Erbfolge / Abtretung / Anteile',
      'succession-cession en lieu de partage': 'Erbfolge / Abtretung anstelle einer Teilung',
      'succession-cession en lieu de partage-donation': 'Erbfolge / Abtretung anstelle einer Teilung / Schenkung',
      'succession-cession-achat': 'Erbfolge / Abtretung / Kauf',
      'succession-cession-achat-donation': 'Erbfolge / Abtretung / Kauf / Schenkung',
      'succession-cession-donation': 'Erbfolge / Abtretung / Schenkung',
      "succession-cession-modification d'intitule": 'Erbfolge / Abtretung / Änderung der Bezeichnung',
      'succession-cession-succession': 'Erbfolge / Abtretung',
      "succession-cession-succession-modification d'intitule-succession-cession": 'Erbfolge / Abtretung / Änderung der Bezeichnung',
      'succession-cession-transfert': 'Erbfolge / Abtretung / Übertragung',
      'succession-changement de regime et delivrance de legs': 'Erbfolge / Wechsel des Güterstands / Vermächtniserfüllung',
      'succession-changement de regime-cession': 'Erbfolge / Wechsel des Güterstands / Abtretung',
      'succession-delivrance de legs': 'Erbfolge / Vermächtniserfüllung',
      'succession-delivrance de legs-donation': 'Erbfolge / Vermächtniserfüllung / Schenkung',
      'succession-delivrance de legs-partage': 'Erbfolge / Vermächtniserfüllung / Teilung',
      'succession-donation': 'Erbfolge / Schenkung',
      'succession-donation et changement de regime': 'Erbfolge / Schenkung / Wechsel des Güterstands',
      'succession-donation-cession': 'Erbfolge / Schenkung / Abtretung',
      'succession-donation-cession-achat': 'Erbfolge / Schenkung / Abtretung / Kauf',
      'succession-donation-partage': 'Erbfolge / Schenkung / Teilung',
      'succession-donation-realisation forcee': 'Erbfolge / Schenkung / Zwangsverwertung',
      'succession-donation-succession': 'Erbfolge / Schenkung',
      'succession-donation-transfert': 'Erbfolge / Schenkung / Übertragung',
      'succession-délivrance de legs': 'Erbfolge / Vermächtniserfüllung',
      'succession-et-achat': 'Erbfolge / Kauf',
      "succession-modification d'intitule": 'Erbfolge / Änderung der Bezeichnung',
      'succession-partage': 'Erbfolge / Teilung',
      'succession-partage-achat': 'Erbfolge / Teilung / Kauf',
      'succession-partage-changement de regime': 'Erbfolge / Teilung / Wechsel des Güterstands',
      'succession-partage-donation': 'Erbfolge / Teilung / Schenkung',
      "succession-partage-modification d'intitule": 'Erbfolge / Teilung / Änderung der Bezeichnung',
      'succession-partage-transfert': 'Erbfolge / Teilung / Übertragung',
      'succession-partages': 'Erbfolge / Teilung',
      'succession-realisation forcee': 'Erbfolge / Zwangsverwertung',
      'succession-transfert': 'Erbfolge / Übertragung',
      'succession-universelle-par-transfert-de-patrimoine': 'Universalsukzession / Übertragung von Vermögen',
      'successions et donation': 'Erbfolge / Schenkung',
      'successions-partage': 'Erbfolge / Teilung',
      suppression: 'Aufhebung',
      tausch: 'Tausch',
      transfer: 'Übertragung',
      transfert: 'Übertragung',
      'transfert de part indivise': 'Übertragung / Ideeller Anteil',
      'transfert de patrimoine': 'Übertragung von Vermögen',
      'transfert ensuite de fusion': 'Übertragung / Fusion',
      'transfert ensuite de realisation forcee': 'Übertragung / Zwangsverwertung',
      'transfert-achat': 'Übertragung / Kauf',
      'transfert-achat-donation': 'Übertragung / Kauf / Schenkung',
      'transfert-achat-groupement de bien-fonds': 'Übertragung / Kauf / Zusammenlegung / Grundstück',
      "transfert-achat-modification d'intitule-succession": 'Übertragung / Kauf / Änderung der Bezeichnung / Erbfolge',
      'transfert-attribution': 'Übertragung / Zuweisung',
      'transfert-attribution de parts': 'Übertragung / Zuweisung / Anteile',
      'transfert-au-titre-de-liquidation-du-regime-matrimonial': 'Übertragung / Titel / Liquidation des Güterstands',
      'transfert-cession': 'Übertragung / Abtretung',
      'transfert-cession-achat': 'Übertragung / Abtretung / Kauf',
      'transfert-cessions': 'Übertragung / Abtretung',
      'transfert-changement de regime': 'Übertragung / Wechsel des Güterstands',
      'transfert-changement de regime-achat': 'Übertragung / Wechsel des Güterstands / Kauf',
      'transfert-changement-de-regime-matrimonial': 'Übertragung / Wechsel des Güterstands',
      'transfert-de-patrimoine': 'Übertragung von Vermögen',
      'transfert-deherence': 'Übertragung / Heimfall',
      'transfert-desherance': 'Übertragung / Heimfall',
      'transfert-desherence': 'Übertragung / Heimfall',
      'transfert-donation': 'Übertragung / Schenkung',
      'transfert-donation-cession': 'Übertragung / Schenkung / Abtretung',
      'transfert-donation-changement de regime': 'Übertragung / Schenkung / Wechsel des Güterstands',
      'transfert-dotation': 'Übertragung / Ausstattung',
      'transfert-du-ddp': 'Übertragung / DDP',
      'transfert-fusion': 'Übertragung / Fusion',
      'transfert-heritage': 'Übertragung / Erbschaft',
      'transfert-jugement': 'Übertragung / Urteil',
      'transfert-liquidation-du-regime-matrimonial': 'Übertragung / Liquidation des Güterstands',
      "transfert-modification d'intitule": 'Übertragung / Änderung der Bezeichnung',
      "transfert-modification d'intitule-immatriculation de ddp": 'Übertragung / Änderung der Bezeichnung / Eintragung / DDP',
      'transfert-par-substitution-fedeicommissaire': 'Übertragung / Fideikommissarische Substitution',
      'transfert-scission': 'Übertragung / Spaltung',
      'transfert-succession': 'Übertragung / Erbfolge',
      "transfert-succession-modification d'intitule": 'Übertragung / Erbfolge / Änderung der Bezeichnung',
      transformation: 'Umwandlung',
      vente: 'Verkauf',
      'vente de gre a gre': 'Freihändiger Verkauf',
      'vente-aux-encheres': 'Versteigerung',
      'vente-de-gre-a-gre': 'Freihändiger Verkauf',
      'vente-forcee-de-gre-a-gre': 'Zwangsverkauf im freihändigen Verfahren',
      zwangsverwertung: 'Zwangsverwertung',
      échange: 'Tausch',
    },
  },
  transport: {
    emptyStates: {
      noBuilding: 'Keine Gebäudedaten verfügbar',
      noEstimate: 'Keine Gebäudedaten für die Verkehrs- und Erreichbarkeitsanalyse verfügbar',
      noLand: 'Keine Grundstücksdaten verfügbar',
    },
    evCharging: {
      charger: {
        plural: 'Ladepunkte',
        singular: 'Ladepunkt',
      },
      chargingTypes: {
        fast: 'Schnellladung',
        medium: 'Mittlere Ladung',
        standard: 'Standardladung',
      },
      metrics: {
        fastCharging: {
          title: 'Schnellladung',
        },
        freeAccess: {
          title: 'Freier Zugang',
        },
        nearestStation: {
          title: 'Nächste Station',
        },
        totalStations5km: {
          title: 'Gesamte Stationen (5km)',
        },
      },
      more: '+{{count}} weitere',
      nearbyStations: 'Nahegelegene Ladestationen',
      overview: 'Übersicht E-Ladestationen',
      plugTypes: {
        ccsCombo2: 'CCS Combo 2 Stecker (Kabel angeschlossen)',
        chademo: 'CHAdeMO',
        schuko: 'Schuko',
        type1Connector: 'Typ 1 Anschluss (Kabel angeschlossen)',
        type1Outlet: 'Typ 1 Steckdose',
        type2Connector: 'Typ 2 Anschluss (Kabel angeschlossen)',
        type2Outlet: 'Typ 2 Steckdose',
        unknown: 'Unbekannt',
      },
      unknownOperator: 'Unbekannter Betreiber',
    },
    header: {
      scoreLabel: 'ÖV-Score',
      scoreTooltip: 'Gesamtbewertung der Verkehrserreichbarkeit basierend auf öffentlichem Verkehr, Strassenzugang und aktiven Mobilitätsoptionen',
      subtitle: 'Umfassende Analyse der Verkehrsinfrastruktur und Erreichbarkeit',
      title: 'Verkehr & Erreichbarkeit',
    },
    overview: {
      class: 'Klasse',
      keyMetrics: 'Schlüsselkennzahlen',
      metrics: {
        cyclingRoutes: {
          subtext: 'Im Umkreis von 2km',
          title: 'Radwege',
        },
        evCharging: {
          title: 'E-Ladestationen',
        },
        highwayAccess: {
          title: 'Autobahnzugang',
        },
        mainRoad: {
          title: 'Hauptstrasse',
        },
        nearestBusStop: {
          title: 'Nächste Bushaltestelle',
        },
        nearestTrainStation: {
          title: 'Nächster Bahnhof',
        },
        ptQualityClass: {
          title: 'ÖV-Güteklasse',
        },
        stopsWithin500m: {
          subtext: 'Haltestellen des öffentlichen Verkehrs',
          title: 'Haltestellen im 500m-Radius',
        },
      },
    },
    publicTransport: {
      everyMinutes_one: 'jede Minute',
      everyMinutes_other: 'alle {{minutes}} Min.',
      metrics: {
        busStops: {
          title: 'Bushaltestellen',
        },
        qualityClass: {
          none: 'Keine Güteklasse',
          title: 'Güteklasse',
        },
        stopsUnder500m: {
          title: 'Haltestellen < 500m',
        },
        totalStops1km: {
          title: 'Gesamte Haltestellen (1km)',
        },
        trainStations: {
          title: 'Bahnhöfe',
        },
        tramStops: {
          title: 'Tramhaltestellen',
        },
      },
      nearbyStops: 'Nahegelegene Haltestellen',
      noStopsFound: 'Keine öffentlichen Verkehrshaltestellen im Umkreis von 1,5km gefunden',
      overview: 'Übersicht öffentlicher Verkehr',
      stopTypes: {
        bus: 'Bus',
        other: 'Andere',
        train: 'Zug',
        tram: 'Tram',
      },
      unknownOperator: 'Unbekannter Betreiber',
      unknownStop: 'Unbekannte Haltestelle',
    },
    scores: {
      activeMobility: {
        description: 'Bewertet die Fuss- und Veloinfrastruktur sowie E-Mobilitätsangebote (Ladestationen, Veloverleih) rund um die Liegenschaft.',
        title: 'Aktive Mobilität',
        tooltip: {
          shortDescription: 'Wertung der aktiven Mobilität',
        },
      },
      common: {
        calculation: 'Gewichteter Durchschnitt mehrerer Faktoren',
        importance: 'Höhere Werte zeigen bessere Erreichbarkeit an',
        outOf100: '/ 100',
        source: 'Swiss Geo Admin & Mapbox APIs',
      },
      details: {
        cycling: 'Radfahren',
        diversity: 'Vielfalt',
        eMobility: 'E-Mobilität',
        frequency: 'Häufigkeit',
        highwayAccess: 'Autobahnzugang',
        mainRoadDistance: 'Hauptstrassenentfernung',
        proximity: 'Nähe',
      },
      publicTransport: {
        title: 'Öffentlicher Verkehr',
        tooltip: {
          shortDescription: 'Erreichbarkeitswertung des öffentlichen Verkehrs',
        },
      },
      qualityClassDescriptions: {
        A: 'Sehr gute ÖV-Anbindung',
        B: 'Gute ÖV-Anbindung',
        C: 'Mässige ÖV-Anbindung',
        D: 'Grundlegende ÖV-Anbindung',
        E: 'Eingeschränkte ÖV-Anbindung',
        F: 'Schlechte oder keine ÖV-Anbindung',
        unknown: 'Keine Daten verfügbar',
      },
      qualityClassLabels: {
        A: 'Ausgezeichnet',
        B: 'Gut',
        C: 'Mässig',
        D: 'Grundlegend',
        E: 'Eingeschränkt',
        F: 'Schlecht',
        unknown: 'Unbekannt',
      },
      roadAccess: {
        title: 'Strassenzugang',
        tooltip: {
          shortDescription: 'Strassenzugang-Wertung',
        },
      },
      scoreLabels: {
        basic: 'Grundlegend',
        excellent: 'Ausgezeichnet',
        good: 'Gut',
        limited: 'Eingeschränkt',
        moderate: 'Mässig',
        poor: 'Schlecht',
        unknown: 'Unbekannt',
      },
    },
    states: {
      error: 'Fehler beim Laden der Verkehrsdaten. Bitte versuchen Sie es erneut.',
      loading: 'Verkehrsdaten werden geladen...',
      noData: 'Keine Verkehrsdaten verfügbar',
    },
    tabs: {
      evCharging: 'E-Ladestationen',
      overview: 'Übersicht',
      publicTransport: 'Öffentlicher Verkehr',
    },
    units: {
      kilometers: 'km',
      kw: 'kW',
      meters: 'm',
      na: 'K.A.',
    },
  },
  valuations: {
    chart: {
      estimated_value: 'Geschätzter Wert',
      final_value: 'Endwert',
      hide_from_chart: 'Aus Diagramm ausblenden',
      range: 'Bereich',
      show_in_chart: 'Im Diagramm anzeigen',
      value: 'Wert',
      value_range: 'Wertbereich',
      variance: 'Varianz',
    },
    confidence: {
      high: 'Hoch',
      high_confidence: 'Hohe Vertrauenswürdigkeit',
      low: 'Niedrig',
      low_confidence: 'Niedrige Vertrauenswürdigkeit',
      medium: 'Mittel',
      medium_confidence: 'Mittlere Vertrauenswürdigkeit',
    },
    fields: {
      automated_valuation: 'Automatisierte Bewertung',
      average_estimate: 'Durchschnittliche Schätzung',
      avm: 'AVM',
      building_year: 'Baujahr',
      confidence_level: 'Vertrauensniveau',
      confidence_score: 'Vertrauensscore',
      conservative: 'Konservativ',
      conservative_estimate: 'Konservative Schätzung',
      currency: 'Währung',
      data_range: 'Datenbereich',
      deal_type: 'Transaktionstyp',
      listings_count: 'Anzahl Angebote',
      living_area: 'Wohnfläche',
      market_value_type: 'Marktwerttyp',
      method: 'Methode',
      model_version: 'Modellversion',
      number_of_rooms: 'Anzahl Zimmer',
      optimistic: 'Optimistisch',
      optimistic_estimate: 'Optimistische Schätzung',
      price_per_sqm: 'Preis pro m²',
      property_type: 'Immobilientyp',
      scenario: 'Szenario',
      status: 'Status',
      value_before_correction: 'Wert vor Korrektur',
    },
    loading: 'Bewertungen werden geladen...',
    no_data: 'Keine Bewertungsdaten verfügbar',
    no_valuations: 'Keine Bewertungen verfügbar',
    providers: {
      manual: {
        name: 'Benutzerdefinierte Bewertung',
      },
      popety_io: {
        description: 'Automatisierte Bewertung basierend auf Popety.ios proprietärem Algorithmus, der Immobilieneigenschaften, aktuelle Markttransaktionen und standortspezifische Faktoren analysiert.',
        name: 'Popety.io Bewertung',
      },
      pricehubble: {
        description: 'Automatisierte Bewertung mit der PriceHubble AVM-Methode basierend auf maschinellen Lernalgorithmen und umfassenden Marktdaten.',
        name: 'PriceHubble Bewertung',
      },
      wuest_partner: {
        conservative_description: 'Konservative automatisierte Bewertung mit Wüest Partner Methodik.',
        description: 'Automatisierte Bewertung mit Wüest Partner Methodik mit Marktspanne von konservativen zu optimistischen Szenarien.',
        name: 'Wüest Partner Bewertung',
        optimistic_description: 'Optimistische automatisierte Bewertung mit Wüest Partner Methodik.',
      },
    },
  },
  zoning: {
    buildable: 'Bebaubar',
    cancel: 'Abbrechen',
    developingArea: 'Entwicklungsgebiet',
    documents: {
      clearSearchAriaLabel: 'Suche löschen',
      documentTypes: {
        map: 'Karte',
        rule: 'Reglement',
      },
      important: 'Wichtig',
      loading: 'Dokumente werden geladen...',
      modalTitle: 'Zonendokumente',
      noDocuments: 'Keine Dokumente verfügbar',
      noDocumentSelected: 'Kein Dokument ausgewählt',
      noPreviewAvailable: 'Keine Vorschau verfügbar',
      noPreviewHint: 'Für dieses Dokument ist keine PDF-Vorschau-URL verfügbar',
      searchAriaLabel: 'Dokumente suchen',
      searchPlaceholder: 'Dokumente suchen...',
      selectDocumentHint: 'Wählen Sie ein Dokument aus der Liste, um dessen Inhalt anzuzeigen',
      sourceLabels: {
        country: 'Bundesweit',
        lup: 'Gemeindeplan',
        lupa: 'Lokalplan',
        lupc: 'Kantonsplan',
        lupo: 'Überlagerungsplan',
        region: 'Kantonal',
      },
      sourceTitles: {
        country: 'Bundesweite Dokumente (Schweiz)',
        lup: 'Gemeindeplan-Dokumente',
        lupa: 'Lokalplan-Dokumente',
        lupc: 'Kantonsplan-Dokumente',
        lupo: 'Überlagerungsplan-Dokumente',
        region: 'Kantonale Dokumente',
      },
      title: 'Dokumente',
      view: 'Ansehen',
    },
    edit: 'Bearbeiten',
    header: {
      abrogated: 'Aufgehoben',
      adopted: 'Angenommen',
      buildingArea: 'Baugebiet',
      constructionArrangement: 'Bebauungsweise',
      constructionArrangementValues: {
        C: 'Geschlossen',
        'C / NC': 'Geschlossen / Offen',
        NC: 'Offen',
      },
      nonBuildingArea: 'Nichtbaugebiet',
      plotCoverage: 'des Grundstücks',
      purpose: 'Zweck',
    },
    legalNotice: {
      blackText: 'Schwarzer Text zeigt genaue Werte an, die direkt aus dem PGA oder dem Grundbuch extrahiert wurden.',
      blueText: 'Blauer Text zeigt geschätzte Werte an, die von PROPETY.IO-Algorithmen berechnet wurden.',
      disclaimer: 'Obwohl wir bestrebt sind, die genauesten Daten zu liefern, sollten alle Informationen unabhängig überprüft werden. Bitte konsultieren Sie die offiziellen Dokumente und wenden Sie sich an die Planungsabteilung der betreffenden Gemeinde für eine offizielle Bestätigung.',
      greenText: 'Grüner Text zeigt Werte an, die von Ihnen geändert wurden.',
      title: 'Datenquellen:',
    },
    legend: {
      agreement: {
        conflict: 'Quellen im Konflikt',
        conflictNote: '(durchgestrichen = nicht übernommener Wert)',
        identical: 'Identische Quellen',
        title: 'Quellenübereinstimmung',
        unique: 'Einzelquelle',
      },
      authorizedValues: {
        clickForDetails: 'Klicken für Details',
        notAvailable: 'Nicht verfügbar',
        title: 'Zulässige Werte',
      },
      difference: {
        exceeded: 'Überschritten',
        remaining: 'Verbleibendes Potenzial',
        title: 'Differenz',
      },
      sources: {
        algorithm: 'Algorithmische Schätzung',
        geoportal: 'Offizielles Geoportal',
        manual: 'Manuell ersetzt',
        regulation: 'Aus Reglement extrahiert',
        title: 'Datenquellen',
        userEdit: 'Vom Benutzer ersetzt',
      },
      title: 'Legende',
    },
    messages: {
      error: 'Fehler beim Laden der Zonierungsdaten',
      loading: 'Zonierungsdaten werden geladen...',
      noData: 'Keine Zonierungsdaten für dieses Grundstück verfügbar',
      noZonesForType: 'Keine Zonen für diesen Typ gefunden',
      sectionDescription: 'Zonierungsvorschriften und Entwicklungspotenzial für dieses Grundstück',
    },
    metricLabels: {
      altitude: 'Höhe',
      atticFloors: 'Dachgeschosse',
      bigSetback: 'Grosser Grenzabstand',
      buildingDepth: 'Gebäudetiefe',
      commercialRatio: 'Gewerbequote',
      constructionArrangement: 'Bebauungsweise',
      cos: 'Überbauungskoeffizient',
      cus: 'Ausnützungskoeffizient',
      density: 'Dichte',
      distanceLimit: 'Abstandsgrenze',
      greenRatio: 'Grünflächenquote',
      heightWithoutRoof: 'Höhe ohne Dach',
      ibus: 'Geschossflächenziffer (GFZ)',
      im: 'Baumassenziffer (BMZ)',
      ios: 'Überbauungsziffer (ÜZ)',
      ius: 'Ausnützungsziffer (AZ)',
      livingRatio: 'Wohnquote',
      mainFloors: 'Hauptgeschosse',
      maxLength: 'Max. Länge',
      noiseSensitivityLevel: 'Lärmempfindlichkeitsstufe',
      numberOfUnits: 'Anzahl Einheiten',
      officeRatio: 'Büroquote',
      openSpaceRatio: 'Freiflächenquote',
      roofHeight: 'Dachhöhe',
      roofSlope: 'Dachneigung',
      smallSetback: 'Kleiner Grenzabstand',
      totalFloors: 'Gesamtgeschosse',
      totalHeight: 'Gesamthöhe',
      undergroundFloors: 'Untergeschosse',
      vbr: 'Gebäudevolumen (GV)',
    },
    metrics: {
      authorised: 'Genehmigt',
      current: 'Aktuell',
      determiningBuiltArea: 'Anrechenbare Gebäudefläche (aGbF)',
      determiningBuiltAreaInfo: 'Anrechenbare Gebäudefläche',
      determiningFloorArea: 'Anrechenbare Geschossfläche (aGF)',
      determiningFloorAreaInfo: 'Anrechenbare Geschossfläche',
      determiningSurfaceArea: 'Anrechenbare Grundstücksfläche (aGSF)',
      difference: 'Unterschied',
      landOccupationIndex: 'Überbauungsziffer (ÜZ)',
      landOccupationIndexInfo: 'Überbauungsziffer',
      landUseIndex: 'Ausnützungsziffer (AZ)',
      landUseIndexInfo: 'Ausnützungsziffer',
    },
    metricsTable: {
      confirmReset: 'Sind Sie sicher, dass Sie alle Werte auf die Standardwerte zurücksetzen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
      derivedSurfaces: {
        builtArea: 'Gebäudefläche (GbF)',
        builtAreaDesc: 'Gebäudefläche',
        builtVolume: 'Gebäudevolumen (GV)',
        builtVolumeDesc: 'Gebäudevolumen',
        determiningBuiltArea: 'Anrechenbare Gebäudefläche (aGbF)',
        determiningBuiltAreaDesc: 'Anrechenbare Gebäudefläche',
        determiningFloorArea: 'Anrechenbare Geschossfläche (aGF)',
        determiningFloorAreaDesc: 'Anrechenbare Geschossfläche',
        floorArea: 'Geschossfläche (GF)',
        floorAreaDesc: 'Geschossfläche',
        grossUsefulFloorArea: 'Bruttogeschossfläche (BGF)',
        grossUsefulFloorAreaDesc: 'Bruttogeschossfläche',
      },
      editAuthorizedValues: 'Genehmigte Werte bearbeiten',
      groups: {
        environmental: 'UMWELT',
        floors: 'GESCHOSSE',
        heights: 'HÖHEN',
        other: 'SONSTIGE',
        setbacks: 'ABSTÄNDE & DIMENSIONEN',
        usageRatios: 'NUTZUNGSQUOTEN',
      },
      headers: {
        authorized: 'Genehmigt',
        current: 'Aktuell',
        difference: 'Unterschied',
        indices: 'Indizes',
      },
      noneOption: 'Keine (diese Metrik ausblenden)',
      resetToDefault: 'Auf Standard zurücksetzen',
      saveChanges: 'Änderungen speichern',
      title: 'Zonierungskennzahlen',
      unitLabels: {
        floors: 'Geschosse',
        units: 'Einheiten',
      },
    },
    metricsTitle: 'Oberflächen und Indizes',
    parameters: {
      limitDistances: 'Grenzabstände',
      maxFloor: 'Max. Geschoss',
      maxHeight: 'Max. Höhe',
      noiseSensibilityLevel: 'Lärmempfindlichkeitsstufe',
    },
    planDetails: {
      affectationName: 'Zuweisungsname',
      part: 'Teil',
      planName: 'Planname',
      planType: 'Plantyp',
    },
    progressBar: {
      authorized: 'Genehmigt',
      available: 'Verfügbar',
      currentSituation: 'Aktuelle Situation',
      remainingPotential: 'Verbleibendes Potenzial',
      used: 'Genutzt',
      utilization: 'Auslastung',
    },
    purpose: 'Zweck',
    save: 'Speichern',
    sourceLabels: {
      estimate: 'Geschätzt',
      geoportal: 'Geoportal',
      llm: 'KI-generiert',
      manual: 'Manuell',
      old: 'Altbestand',
    },
    specialPlans: 'Spezialplan(e)',
    status: {
      current: 'Aktuell',
      future: 'Zukünftig',
      past: 'Vergangen',
    },
    subtitle: 'Aktuelle Zonierungsbestimmungen und Entwicklungspotential für',
    title: 'Zonierung & Regeln',
    underExploited: 'Unterausgenutzt',
    underExploitedInfo: 'Berechnung basierend auf einer informierten Ausnützungsziffer',
    underExploitedScore: 'Unterausgenutzte Bewertung',
    unknownZone: 'Unbekannte Zone',
    viewDocuments: 'Dokumente ansehen',
    zoneDescriptions: {
      cantonal: 'Kantonale Zonierungsvorschriften (PAC, Kantonaler Nutzungsplan) der regionalen Behörden. Diese Regeln haben absoluten Vorrang vor allen Gemeindeplänen und definieren übergreifende Entwicklungsbeschränkungen wie Schutzgebiete, regionale Infrastrukturkorridore und kantonale Interessen.',
      general: 'Kommunale Grundzonierung (PGA, PAL, BZO, Nutzungszonenplan), die die grundlegende Landnutzungskategorie für dieses Grundstück festlegt und definiert, ob es für Wohn-, Gewerbe-, Industrie-, Landwirtschaftsnutzung oder als Nichtbauzone vorgesehen ist.',
      local: 'Detaillierte Quartierentwicklungspläne (PQ, PLQ, Quartierplan, Gestaltungsplan), die genaue Bauanforderungen festlegen, einschliesslich Gebäudeplatzierung, Dimensionen, Zugang und Gestaltungsrichtlinien für bestimmte Quartiere innerhalb der Gemeinde.',
      partial: 'Spezielle Überlagerungszonen (PPA, Sondernutzungsplan, GFZ-Zonen), die zusätzliche Einschränkungen oder Änderungen zur Grundzonierung hinzufügen. Diese können Denkmalschutz, geänderte Dichteindizes, Umweltauflagen oder spezifische Entwicklungsanforderungen umfassen.',
    },
    zonePriorityLabels: {
      cantonal: 'Kantonale Behörde - Übergeordnet',
      general: 'Grundzonierung - Grundlegende Landnutzung',
      local: 'Detailplanung - Quartierregeln',
      partial: 'Sonderzonen - Zusätzliche Einschränkungen',
    },
    zoneTypes: {
      cantonal: 'Kantonal',
      general: 'Kommunal',
      local: 'Lokal',
      partial: 'Teilweise',
    },
  },
} satisfies AppTranslations
